import { Matchday } from "../interfaces/match-day";

interface MatchdaysData {
  [country: string]: {
    [year: string]: Array<Matchday>;
  };
}

const matchdays: MatchdaysData = {
  england: {
    "2019": [
      {
        endDate: "2019-08-11T11:59:59.999+01:00",
        fixtures: {
          "259d2393-2b1d-497c-8d60-f4257632e2e0": {
            awayTeamId: "e96fbd1c-bbd5-4d69-a7c7-2e45f5b579cb",
            goalsAway: 3,
            goalsHome: 0,
            homeTeamId: "479aa6bf-67ec-4320-a1dc-2d5b77c2f1a4",
            id: "259d2393-2b1d-497c-8d60-f4257632e2e0",
            kickOffTime: "2019-08-10T15:00:00.000+01:00",
          },
          "29504633-db15-4393-9715-56704c0d950f": {
            awayTeamId: "5696bf7b-3256-4937-9d6d-952da49ddee9",
            goalsAway: 1,
            goalsHome: 0,
            homeTeamId: "8368521e-502a-4302-86d3-cf728550d1bd",
            id: "29504633-db15-4393-9715-56704c0d950f",
            kickOffTime: "2019-08-11T14:00:00.000+01:00",
          },
          "65a0285f-050a-439a-9d98-32558367b04c": {
            awayTeamId: "8ecf419b-9fde-46e5-960b-9c5f7f14dc3d",
            goalsAway: 1,
            goalsHome: 3,
            homeTeamId: "18de8ce2-736d-4c83-b4db-c473f1a03101",
            id: "65a0285f-050a-439a-9d98-32558367b04c",
            kickOffTime: "2019-08-10T19:30:00.000+01:00",
          },
          "a538e953-4379-46e6-b5fa-cf0006c0397f": {
            awayTeamId: "9ad2bac0-8e7e-44cf-924e-75add32d8e5d",
            goalsAway: 0,
            goalsHome: 0,
            homeTeamId: "053980d1-9205-4f90-b581-a403851c32e0",
            id: "a538e953-4379-46e6-b5fa-cf0006c0397f",
            kickOffTime: "2019-08-11T14:00:00.000+01:00",
          },
          "a9d6c871-7f4b-4eca-85eb-484f665a519c": {
            awayTeamId: "91c704f0-77ac-4898-a8bd-9539c66ef301",
            goalsAway: 0,
            goalsHome: 0,
            homeTeamId: "3d8b2af7-a43f-43a1-9fcb-0b9c7c9b8fad",
            id: "a9d6c871-7f4b-4eca-85eb-484f665a519c",
            kickOffTime: "2019-08-10T15:00:00.000+01:00",
          },
          "ad7884e0-48cf-4616-879f-c773acc7102c": {
            awayTeamId: "f9c15363-34ad-4156-a273-12ec0f212df6",
            goalsAway: 0,
            goalsHome: 4,
            homeTeamId: "f29e61a2-23f0-462b-b9c7-420b09fec5d9",
            id: "ad7884e0-48cf-4616-879f-c773acc7102c",
            kickOffTime: "2019-08-11T16:30:00.000+01:00",
          },
          "d7884059-9b89-4997-8845-ffc67f171b22": {
            awayTeamId: "1d97c20b-b36c-4307-b227-f11de588c955",
            goalsAway: 1,
            goalsHome: 1,
            homeTeamId: "79ee152d-e7ee-4511-8d8f-f1632d7570ec",
            id: "d7884059-9b89-4997-8845-ffc67f171b22",
            kickOffTime: "2019-08-10T15:00:00.000+01:00",
          },
          "de920872-2455-4080-ae8f-b69cdfb83e30": {
            awayTeamId: "4303d6fc-7c8d-4f19-aab7-37e4c64195cf",
            goalsAway: 5,
            goalsHome: 0,
            homeTeamId: "4e34107f-ccd8-4c94-a04f-5eb8d8637533",
            id: "de920872-2455-4080-ae8f-b69cdfb83e30",
            kickOffTime: "2019-08-10T12:30:00.000+01:00",
          },
          "e6f42988-d346-497b-950f-5162674af3f4": {
            awayTeamId: "4f30eb3c-4f9d-4506-a62f-e6021429e6de",
            goalsAway: 1,
            goalsHome: 4,
            homeTeamId: "14a47cb1-f497-4d71-879b-b7e82c85e804",
            id: "e6f42988-d346-497b-950f-5162674af3f4",
            kickOffTime: "2019-08-09T16:00:00.000+01:00",
          },
          "f99152cf-8ff8-4c93-adaa-4731ce81caa9": {
            awayTeamId: "432b8777-b474-4ff9-bdd0-7dc41bd24e80",
            goalsAway: 0,
            goalsHome: 3,
            homeTeamId: "906ce93b-8e71-409c-b459-4259fd3d35ad",
            id: "f99152cf-8ff8-4c93-adaa-4731ce81caa9",
            kickOffTime: "2019-08-10T15:00:00.000+01:00",
          },
        },
        id: "e44dc484-922b-48f0-be00-1876c268dfd9",
        matchday: 1,
        startDate: "2019-08-09T00:00:00.000+01:00",
      },
      {
        endDate: "2019-08-19T11:59:59.999+01:00",
        fixtures: {
          "19552cec-829c-4df8-a08b-c67e85431a95": {
            awayTeamId: "14a47cb1-f497-4d71-879b-b7e82c85e804",
            goalsAway: 2,
            goalsHome: 1,
            homeTeamId: "432b8777-b474-4ff9-bdd0-7dc41bd24e80",
            id: "19552cec-829c-4df8-a08b-c67e85431a95",
            kickOffTime: "2019-08-17T15:00:00.000+01:00",
          },
          "2f061dcb-c9a1-4283-b76d-89a20ea90387": {
            awayTeamId: "3d8b2af7-a43f-43a1-9fcb-0b9c7c9b8fad",
            goalsAway: 0,
            goalsHome: 1,
            homeTeamId: "1d97c20b-b36c-4307-b227-f11de588c955",
            id: "2f061dcb-c9a1-4283-b76d-89a20ea90387",
            kickOffTime: "2019-08-18T14:00:00.000+01:00",
          },
          "34c50e9e-2e6b-4c67-bb37-7c0cff3f8691": {
            awayTeamId: "8368521e-502a-4302-86d3-cf728550d1bd",
            goalsAway: 1,
            goalsHome: 3,
            homeTeamId: "4f30eb3c-4f9d-4506-a62f-e6021429e6de",
            id: "34c50e9e-2e6b-4c67-bb37-7c0cff3f8691",
            kickOffTime: "2019-08-17T15:00:00.000+01:00",
          },
          "4b755525-2863-4121-a848-1763a43f3cc2": {
            awayTeamId: "18de8ce2-736d-4c83-b4db-c473f1a03101",
            goalsAway: 2,
            goalsHome: 2,
            homeTeamId: "4303d6fc-7c8d-4f19-aab7-37e4c64195cf",
            id: "4b755525-2863-4121-a848-1763a43f3cc2",
            kickOffTime: "2019-08-17T17:30:00.000+01:00",
          },
          "50227b0d-518f-40ce-91d0-c2ccb7c6c8f4": {
            awayTeamId: "4e34107f-ccd8-4c94-a04f-5eb8d8637533",
            goalsAway: 1,
            goalsHome: 1,
            homeTeamId: "e96fbd1c-bbd5-4d69-a7c7-2e45f5b579cb",
            id: "50227b0d-518f-40ce-91d0-c2ccb7c6c8f4",
            kickOffTime: "2019-08-17T15:00:00.000+01:00",
          },
          "918e014b-9b3e-482c-8921-c5c70e88e9ea": {
            awayTeamId: "f29e61a2-23f0-462b-b9c7-420b09fec5d9",
            goalsAway: 1,
            goalsHome: 1,
            homeTeamId: "9ad2bac0-8e7e-44cf-924e-75add32d8e5d",
            id: "918e014b-9b3e-482c-8921-c5c70e88e9ea",
            kickOffTime: "2019-08-19T08:00:00.000+01:00",
          },
          "94533a4a-a9bd-4d46-b4d0-29add0a9d4c0": {
            awayTeamId: "053980d1-9205-4f90-b581-a403851c32e0",
            goalsAway: 1,
            goalsHome: 1,
            homeTeamId: "f9c15363-34ad-4156-a273-12ec0f212df6",
            id: "94533a4a-a9bd-4d46-b4d0-29add0a9d4c0",
            kickOffTime: "2019-08-18T16:30:00.000+01:00",
          },
          "9b08610c-0a82-4b6d-95aa-34623f014eec": {
            awayTeamId: "906ce93b-8e71-409c-b459-4259fd3d35ad",
            goalsAway: 1,
            goalsHome: 2,
            homeTeamId: "5696bf7b-3256-4937-9d6d-952da49ddee9",
            id: "9b08610c-0a82-4b6d-95aa-34623f014eec",
            kickOffTime: "2019-08-17T12:30:00.000+01:00",
          },
          "a2d1ce0d-83e2-4b30-b97a-8b8d84f99001": {
            awayTeamId: "479aa6bf-67ec-4320-a1dc-2d5b77c2f1a4",
            goalsAway: 0,
            goalsHome: 1,
            homeTeamId: "91c704f0-77ac-4898-a8bd-9539c66ef301",
            id: "a2d1ce0d-83e2-4b30-b97a-8b8d84f99001",
            kickOffTime: "2019-08-17T15:00:00.000+01:00",
          },
          "d6f8a795-7935-4633-a2fe-a62d9dd9f1d7": {
            awayTeamId: "79ee152d-e7ee-4511-8d8f-f1632d7570ec",
            goalsAway: 2,
            goalsHome: 1,
            homeTeamId: "8ecf419b-9fde-46e5-960b-9c5f7f14dc3d",
            id: "d6f8a795-7935-4633-a2fe-a62d9dd9f1d7",
            kickOffTime: "2019-08-17T15:00:00.000+01:00",
          },
        },
        id: "c4aed566-66ca-44ca-8461-287ac1feed12",
        matchday: 2,
        startDate: "2019-08-17T00:00:00.000+01:00",
      },
      {
        endDate: "2019-08-25T11:59:59.999+01:00",
        fixtures: {
          "1b6634fa-426b-4590-ae32-abce625b4335": {
            awayTeamId: "91c704f0-77ac-4898-a8bd-9539c66ef301",
            goalsAway: 0,
            goalsHome: 2,
            homeTeamId: "8ecf419b-9fde-46e5-960b-9c5f7f14dc3d",
            id: "1b6634fa-426b-4590-ae32-abce625b4335",
            kickOffTime: "2019-08-23T20:00:00.000+01:00",
          },
          "24ffe73b-9df0-4cb9-885e-ced788a6bbb1": {
            awayTeamId: "4e34107f-ccd8-4c94-a04f-5eb8d8637533",
            goalsAway: 3,
            goalsHome: 1,
            homeTeamId: "479aa6bf-67ec-4320-a1dc-2d5b77c2f1a4",
            id: "24ffe73b-9df0-4cb9-885e-ced788a6bbb1",
            kickOffTime: "2019-08-24T15:00:00.000+01:00",
          },
          "427db962-b64b-4f0f-9713-1cd164c986da": {
            awayTeamId: "3d8b2af7-a43f-43a1-9fcb-0b9c7c9b8fad",
            goalsAway: 2,
            goalsHome: 1,
            homeTeamId: "f29e61a2-23f0-462b-b9c7-420b09fec5d9",
            id: "427db962-b64b-4f0f-9713-1cd164c986da",
            kickOffTime: "2019-08-24T15:00:00.000+01:00",
          },
          "432e7b0c-bb9c-4397-9255-120d33ef5ee7": {
            awayTeamId: "f9c15363-34ad-4156-a273-12ec0f212df6",
            goalsAway: 3,
            goalsHome: 2,
            homeTeamId: "4f30eb3c-4f9d-4506-a62f-e6021429e6de",
            id: "432e7b0c-bb9c-4397-9255-120d33ef5ee7",
            kickOffTime: "2019-08-24T12:30:00.000+01:00",
          },
          "686a584a-eb3c-413f-8515-042016c3f566": {
            awayTeamId: "4303d6fc-7c8d-4f19-aab7-37e4c64195cf",
            goalsAway: 3,
            goalsHome: 1,
            homeTeamId: "79ee152d-e7ee-4511-8d8f-f1632d7570ec",
            id: "686a584a-eb3c-413f-8515-042016c3f566",
            kickOffTime: "2019-08-25T14:00:00.000+01:00",
          },
          "a7e02c84-4013-4820-91ea-1c017bc92b6f": {
            awayTeamId: "906ce93b-8e71-409c-b459-4259fd3d35ad",
            goalsAway: 1,
            goalsHome: 1,
            homeTeamId: "9ad2bac0-8e7e-44cf-924e-75add32d8e5d",
            id: "a7e02c84-4013-4820-91ea-1c017bc92b6f",
            kickOffTime: "2019-08-25T16:30:00.000+01:00",
          },
          "c633346f-139f-42f6-88a5-dbdab47da663": {
            awayTeamId: "432b8777-b474-4ff9-bdd0-7dc41bd24e80",
            goalsAway: 2,
            goalsHome: 0,
            homeTeamId: "e96fbd1c-bbd5-4d69-a7c7-2e45f5b579cb",
            id: "c633346f-139f-42f6-88a5-dbdab47da663",
            kickOffTime: "2019-08-24T15:00:00.000+01:00",
          },
          "d2ae5c17-a8ea-4d24-9baa-755f0cbe9adf": {
            awayTeamId: "053980d1-9205-4f90-b581-a403851c32e0",
            goalsAway: 2,
            goalsHome: 1,
            homeTeamId: "1d97c20b-b36c-4307-b227-f11de588c955",
            id: "d2ae5c17-a8ea-4d24-9baa-755f0cbe9adf",
            kickOffTime: "2019-08-24T15:00:00.000+01:00",
          },
          "e4e1671e-5a14-4926-a550-0498f0f604f1": {
            awayTeamId: "8368521e-502a-4302-86d3-cf728550d1bd",
            goalsAway: 1,
            goalsHome: 0,
            homeTeamId: "18de8ce2-736d-4c83-b4db-c473f1a03101",
            id: "e4e1671e-5a14-4926-a550-0498f0f604f1",
            kickOffTime: "2019-08-25T16:30:00.000+01:00",
          },
          "f6f0a53c-77dc-4d6c-98b9-5bbdb237928e": {
            awayTeamId: "5696bf7b-3256-4937-9d6d-952da49ddee9",
            goalsAway: 1,
            goalsHome: 3,
            homeTeamId: "14a47cb1-f497-4d71-879b-b7e82c85e804",
            id: "f6f0a53c-77dc-4d6c-98b9-5bbdb237928e",
            kickOffTime: "2019-08-24T17:30:00.000+01:00",
          },
        },
        id: "ee4c92d6-ac68-498f-b55f-71021e594caa",
        matchday: 3,
        startDate: "2019-08-23T00:00:00.000+01:00",
      },
      {
        endDate: "2019-09-01T11:59:59.999+01:00",
        fixtures: {
          "04010664-78fe-4034-b081-e8831243aae2": {
            awayTeamId: "9ad2bac0-8e7e-44cf-924e-75add32d8e5d",
            goalsAway: 2,
            goalsHome: 3,
            homeTeamId: "91c704f0-77ac-4898-a8bd-9539c66ef301",
            id: "04010664-78fe-4034-b081-e8831243aae2",
            kickOffTime: "2019-09-01T14:00:00.000+01:00",
          },
          "1a2a6470-310a-45ad-802f-fec2ab709d8d": {
            awayTeamId: "14a47cb1-f497-4d71-879b-b7e82c85e804",
            goalsAway: 3,
            goalsHome: 0,
            homeTeamId: "906ce93b-8e71-409c-b459-4259fd3d35ad",
            id: "1a2a6470-310a-45ad-802f-fec2ab709d8d",
            kickOffTime: "2019-08-31T17:30:00.000+01:00",
          },
          "25cb5528-770c-44c1-b252-3c7a7806e54a": {
            awayTeamId: "f29e61a2-23f0-462b-b9c7-420b09fec5d9",
            goalsAway: 1,
            goalsHome: 1,
            homeTeamId: "432b8777-b474-4ff9-bdd0-7dc41bd24e80",
            id: "25cb5528-770c-44c1-b252-3c7a7806e54a",
            kickOffTime: "2019-08-31T12:30:00.000+01:00",
          },
          "3962423a-f878-42e1-876e-bf280d01c0e5": {
            awayTeamId: "479aa6bf-67ec-4320-a1dc-2d5b77c2f1a4",
            goalsAway: 1,
            goalsHome: 1,
            homeTeamId: "8368521e-502a-4302-86d3-cf728550d1bd",
            id: "3962423a-f878-42e1-876e-bf280d01c0e5",
            kickOffTime: "2019-08-31T15:00:00.000+01:00",
          },
          "5184b412-abab-44b8-b641-62bac9d2a4d3": {
            awayTeamId: "1d97c20b-b36c-4307-b227-f11de588c955",
            goalsAway: 2,
            goalsHome: 2,
            homeTeamId: "f9c15363-34ad-4156-a273-12ec0f212df6",
            id: "5184b412-abab-44b8-b641-62bac9d2a4d3",
            kickOffTime: "2019-08-31T15:00:00.000+01:00",
          },
          "791e3a89-d41e-4dec-ac42-31c326e729d7": {
            awayTeamId: "e96fbd1c-bbd5-4d69-a7c7-2e45f5b579cb",
            goalsAway: 0,
            goalsHome: 4,
            homeTeamId: "4303d6fc-7c8d-4f19-aab7-37e4c64195cf",
            id: "791e3a89-d41e-4dec-ac42-31c326e729d7",
            kickOffTime: "2019-08-31T15:00:00.000+01:00",
          },
          "8bb751ee-57cd-4509-8f69-1b4adeed910e": {
            awayTeamId: "18de8ce2-736d-4c83-b4db-c473f1a03101",
            goalsAway: 2,
            goalsHome: 2,
            homeTeamId: "5696bf7b-3256-4937-9d6d-952da49ddee9",
            id: "8bb751ee-57cd-4509-8f69-1b4adeed910e",
            kickOffTime: "2019-09-01T16:30:00.000+01:00",
          },
          "9dc68584-6345-4ebd-98cb-3d9d9596281b": {
            awayTeamId: "4f30eb3c-4f9d-4506-a62f-e6021429e6de",
            goalsAway: 0,
            goalsHome: 2,
            homeTeamId: "4e34107f-ccd8-4c94-a04f-5eb8d8637533",
            id: "9dc68584-6345-4ebd-98cb-3d9d9596281b",
            kickOffTime: "2019-08-31T15:00:00.000+01:00",
          },
          "ad5076ab-bd65-4abf-8fa9-ae17f9746d5c": {
            awayTeamId: "8ecf419b-9fde-46e5-960b-9c5f7f14dc3d",
            goalsAway: 0,
            goalsHome: 1,
            homeTeamId: "3d8b2af7-a43f-43a1-9fcb-0b9c7c9b8fad",
            id: "ad5076ab-bd65-4abf-8fa9-ae17f9746d5c",
            kickOffTime: "2019-08-31T15:00:00.000+01:00",
          },
          "c285031a-6871-4d94-8e35-728e060e5692": {
            awayTeamId: "79ee152d-e7ee-4511-8d8f-f1632d7570ec",
            goalsAway: 1,
            goalsHome: 3,
            homeTeamId: "053980d1-9205-4f90-b581-a403851c32e0",
            id: "c285031a-6871-4d94-8e35-728e060e5692",
            kickOffTime: "2019-08-31T15:00:00.000+01:00",
          },
        },
        id: "9a5c53a8-d5c9-4968-bb36-53a065cda9a5",
        matchday: 4,
        startDate: "2019-08-31T00:00:00.000+01:00",
      },
      {
        endDate: "2019-09-16T11:59:59.999+01:00",
        fixtures: {
          "1132ea4c-bdee-498a-8213-13b102951765": {
            awayTeamId: "4303d6fc-7c8d-4f19-aab7-37e4c64195cf",
            goalsAway: 2,
            goalsHome: 3,
            homeTeamId: "4f30eb3c-4f9d-4506-a62f-e6021429e6de",
            id: "1132ea4c-bdee-498a-8213-13b102951765",
            kickOffTime: "2019-09-14T17:30:00.000+01:00",
          },
          "2a81dbdc-87c1-441f-b8d8-3eaa1fbfb0da": {
            awayTeamId: "91c704f0-77ac-4898-a8bd-9539c66ef301",
            goalsAway: 1,
            goalsHome: 3,
            homeTeamId: "79ee152d-e7ee-4511-8d8f-f1632d7570ec",
            id: "2a81dbdc-87c1-441f-b8d8-3eaa1fbfb0da",
            kickOffTime: "2019-09-15T14:00:00.000+01:00",
          },
          "3d5a7066-7b0a-4849-aa83-cfbadcbccc3a": {
            awayTeamId: "432b8777-b474-4ff9-bdd0-7dc41bd24e80",
            goalsAway: 1,
            goalsHome: 0,
            homeTeamId: "1d97c20b-b36c-4307-b227-f11de588c955",
            id: "3d5a7066-7b0a-4849-aa83-cfbadcbccc3a",
            kickOffTime: "2019-09-14T15:00:00.000+01:00",
          },
          "405b0f42-e78f-4bf2-9c12-ba32d5f5c1f2": {
            awayTeamId: "8368521e-502a-4302-86d3-cf728550d1bd",
            goalsAway: 1,
            goalsHome: 3,
            homeTeamId: "14a47cb1-f497-4d71-879b-b7e82c85e804",
            id: "405b0f42-e78f-4bf2-9c12-ba32d5f5c1f2",
            kickOffTime: "2019-09-14T12:30:00.000+01:00",
          },
          "4d5d8653-ad68-4e5d-9733-e0cb7fb1d972": {
            awayTeamId: "3d8b2af7-a43f-43a1-9fcb-0b9c7c9b8fad",
            goalsAway: 0,
            goalsHome: 4,
            homeTeamId: "18de8ce2-736d-4c83-b4db-c473f1a03101",
            id: "4d5d8653-ad68-4e5d-9733-e0cb7fb1d972",
            kickOffTime: "2019-09-14T15:00:00.000+01:00",
          },
          "66d62cdb-eb0f-48a6-a391-3c2c09b9a5be": {
            awayTeamId: "053980d1-9205-4f90-b581-a403851c32e0",
            goalsAway: 0,
            goalsHome: 1,
            homeTeamId: "f29e61a2-23f0-462b-b9c7-420b09fec5d9",
            id: "66d62cdb-eb0f-48a6-a391-3c2c09b9a5be",
            kickOffTime: "2019-09-14T15:00:00.000+01:00",
          },
          "71b58f46-d390-448e-8d96-ec710f6b343c": {
            awayTeamId: "5696bf7b-3256-4937-9d6d-952da49ddee9",
            goalsAway: 2,
            goalsHome: 2,
            homeTeamId: "479aa6bf-67ec-4320-a1dc-2d5b77c2f1a4",
            id: "71b58f46-d390-448e-8d96-ec710f6b343c",
            kickOffTime: "2019-09-15T16:30:00.000+01:00",
          },
          "74ce2c5e-ec44-4fec-b9e3-5fcd07987b48": {
            awayTeamId: "f9c15363-34ad-4156-a273-12ec0f212df6",
            goalsAway: 5,
            goalsHome: 2,
            homeTeamId: "9ad2bac0-8e7e-44cf-924e-75add32d8e5d",
            id: "74ce2c5e-ec44-4fec-b9e3-5fcd07987b48",
            kickOffTime: "2019-09-14T15:00:00.000+01:00",
          },
          "cc20f5a2-d873-4859-9990-42b4a5fca7fb": {
            awayTeamId: "4e34107f-ccd8-4c94-a04f-5eb8d8637533",
            goalsAway: 0,
            goalsHome: 0,
            homeTeamId: "8ecf419b-9fde-46e5-960b-9c5f7f14dc3d",
            id: "cc20f5a2-d873-4859-9990-42b4a5fca7fb",
            kickOffTime: "2019-09-16T20:00:00.000+01:00",
          },
          "d5972005-d253-4ad5-b188-25254121288f": {
            awayTeamId: "906ce93b-8e71-409c-b459-4259fd3d35ad",
            goalsAway: 1,
            goalsHome: 1,
            homeTeamId: "e96fbd1c-bbd5-4d69-a7c7-2e45f5b579cb",
            id: "d5972005-d253-4ad5-b188-25254121288f",
            kickOffTime: "2019-09-14T15:00:00.000+01:00",
          },
        },
        id: "e2161156-fa95-4023-aa30-092a85b547f6",
        matchday: 5,
        startDate: "2019-09-14T00:00:00.000+01:00",
      },
      {
        endDate: "2019-09-22T11:59:59.999+01:00",
        fixtures: {
          "06cfcea6-a257-4dd6-a170-9d5e37efe18b": {
            awayTeamId: "9ad2bac0-8e7e-44cf-924e-75add32d8e5d",
            goalsAway: 1,
            goalsHome: 1,
            homeTeamId: "3d8b2af7-a43f-43a1-9fcb-0b9c7c9b8fad",
            id: "06cfcea6-a257-4dd6-a170-9d5e37efe18b",
            kickOffTime: "2019-09-22T14:00:00.000+01:00",
          },
          "140f960f-7d08-495f-98a6-0a33a2281fd3": {
            awayTeamId: "1d97c20b-b36c-4307-b227-f11de588c955",
            goalsAway: 2,
            goalsHome: 0,
            homeTeamId: "91c704f0-77ac-4898-a8bd-9539c66ef301",
            id: "140f960f-7d08-495f-98a6-0a33a2281fd3",
            kickOffTime: "2019-09-21T15:00:00.000+01:00",
          },
          "666148dc-4adf-478a-a0f2-1bd13a2d4502": {
            awayTeamId: "18de8ce2-736d-4c83-b4db-c473f1a03101",
            goalsAway: 1,
            goalsHome: 2,
            homeTeamId: "053980d1-9205-4f90-b581-a403851c32e0",
            id: "666148dc-4adf-478a-a0f2-1bd13a2d4502",
            kickOffTime: "2019-09-21T12:30:00.000+01:00",
          },
          "69a271e3-fa10-475c-af4b-9fb961395dae": {
            awayTeamId: "4f30eb3c-4f9d-4506-a62f-e6021429e6de",
            goalsAway: 0,
            goalsHome: 2,
            homeTeamId: "906ce93b-8e71-409c-b459-4259fd3d35ad",
            id: "69a271e3-fa10-475c-af4b-9fb961395dae",
            kickOffTime: "2019-09-21T15:00:00.000+01:00",
          },
          "72407241-253a-4e30-9467-d3b198dce051": {
            awayTeamId: "e96fbd1c-bbd5-4d69-a7c7-2e45f5b579cb",
            goalsAway: 0,
            goalsHome: 0,
            homeTeamId: "8368521e-502a-4302-86d3-cf728550d1bd",
            id: "72407241-253a-4e30-9467-d3b198dce051",
            kickOffTime: "2019-09-21T17:30:00.000+01:00",
          },
          "8c2e4f07-7858-4efb-b56a-bf09abc1a463": {
            awayTeamId: "479aa6bf-67ec-4320-a1dc-2d5b77c2f1a4",
            goalsAway: 0,
            goalsHome: 8,
            homeTeamId: "4303d6fc-7c8d-4f19-aab7-37e4c64195cf",
            id: "8c2e4f07-7858-4efb-b56a-bf09abc1a463",
            kickOffTime: "2019-09-21T15:00:00.000+01:00",
          },
          "9bb20d38-b472-4bd2-b925-35698feab2ff": {
            awayTeamId: "14a47cb1-f497-4d71-879b-b7e82c85e804",
            goalsAway: 2,
            goalsHome: 1,
            homeTeamId: "f9c15363-34ad-4156-a273-12ec0f212df6",
            id: "9bb20d38-b472-4bd2-b925-35698feab2ff",
            kickOffTime: "2019-09-22T16:30:00.000+01:00",
          },
          "9dd7b583-ce93-42cc-8813-39dc1e55113f": {
            awayTeamId: "8ecf419b-9fde-46e5-960b-9c5f7f14dc3d",
            goalsAway: 2,
            goalsHome: 3,
            homeTeamId: "5696bf7b-3256-4937-9d6d-952da49ddee9",
            id: "9dd7b583-ce93-42cc-8813-39dc1e55113f",
            kickOffTime: "2019-09-22T16:30:00.000+01:00",
          },
          "9f60c08a-2a9e-43ac-af00-ca06b100f179": {
            awayTeamId: "79ee152d-e7ee-4511-8d8f-f1632d7570ec",
            goalsAway: 3,
            goalsHome: 1,
            homeTeamId: "432b8777-b474-4ff9-bdd0-7dc41bd24e80",
            id: "9f60c08a-2a9e-43ac-af00-ca06b100f179",
            kickOffTime: "2019-09-20T20:00:00.000+01:00",
          },
          "ec78f08f-b9dd-47ef-8e81-ac7cee8cadcb": {
            awayTeamId: "f29e61a2-23f0-462b-b9c7-420b09fec5d9",
            goalsAway: 0,
            goalsHome: 2,
            homeTeamId: "4e34107f-ccd8-4c94-a04f-5eb8d8637533",
            id: "ec78f08f-b9dd-47ef-8e81-ac7cee8cadcb",
            kickOffTime: "2019-09-22T14:00:00.000+01:00",
          },
        },
        id: "b32aca5a-609c-49fb-89b7-5625860689dd",
        matchday: 6,
        startDate: "2019-09-20T00:00:00.000+01:00",
      },
      {
        endDate: "2019-09-30T22:00:00.000+01:00",
        fixtures: {
          "32592bad-1f4f-47b3-9c00-16abef91deb9": {
            awayTeamId: "5696bf7b-3256-4937-9d6d-952da49ddee9",
            goalsAway: 1,
            goalsHome: 1,
            homeTeamId: "f29e61a2-23f0-462b-b9c7-420b09fec5d9",
            kickOffTime: "2019-09-30T20:00:00.000+01:00",
          },
          "5e0de7db-f550-4cd6-8e14-486c9415dc1a": {
            awayTeamId: "4e34107f-ccd8-4c94-a04f-5eb8d8637533",
            goalsAway: 2,
            goalsHome: 2,
            homeTeamId: "79ee152d-e7ee-4511-8d8f-f1632d7570ec",
            kickOffTime: "2019-09-28T15:00:00.000+01:00",
          },
          "6ae9930e-db4e-449d-9b10-3aa3e16799a7": {
            awayTeamId: "4303d6fc-7c8d-4f19-aab7-37e4c64195cf",
            goalsAway: 3,
            goalsHome: 1,
            homeTeamId: "91c704f0-77ac-4898-a8bd-9539c66ef301",
            kickOffTime: "2019-09-28T17:30:00.000+01:00",
          },
          "7b8012eb-8225-46dd-a4f1-36d53239939f": {
            awayTeamId: "479aa6bf-67ec-4320-a1dc-2d5b77c2f1a4",
            goalsAway: 0,
            goalsHome: 2,
            homeTeamId: "9ad2bac0-8e7e-44cf-924e-75add32d8e5d",
            kickOffTime: "2019-09-28T15:00:00.000+01:00",
          },
          "9ff4e482-6bae-4ed1-8470-638a7afdb89a": {
            awayTeamId: "14a47cb1-f497-4d71-879b-b7e82c85e804",
            goalsAway: 1,
            goalsHome: 0,
            homeTeamId: "1d97c20b-b36c-4307-b227-f11de588c955",
            kickOffTime: "2019-09-28T12:30:00.000+01:00",
          },
          "a861bd49-1c3a-48b4-bf03-d747262c501d": {
            awayTeamId: "432b8777-b474-4ff9-bdd0-7dc41bd24e80",
            goalsAway: 1,
            goalsHome: 2,
            homeTeamId: "18de8ce2-736d-4c83-b4db-c473f1a03101",
            kickOffTime: "2019-09-28T15:00:00.000+01:00",
          },
          "aac8d527-9301-4044-a207-a9250c110c4f": {
            awayTeamId: "e96fbd1c-bbd5-4d69-a7c7-2e45f5b579cb",
            goalsAway: 0,
            goalsHome: 2,
            homeTeamId: "f9c15363-34ad-4156-a273-12ec0f212df6",
            kickOffTime: "2019-09-28T15:00:00.000+01:00",
          },
          "ad73d478-4ad3-405b-b63a-f4df5c26dea1": {
            awayTeamId: "8368521e-502a-4302-86d3-cf728550d1bd",
            goalsAway: 0,
            goalsHome: 5,
            homeTeamId: "053980d1-9205-4f90-b581-a403851c32e0",
            kickOffTime: "2019-09-29T16:30:00.000+01:00",
          },
          "cd809315-e521-429d-986a-1cc0074a0cd2": {
            awayTeamId: "4f30eb3c-4f9d-4506-a62f-e6021429e6de",
            goalsAway: 0,
            goalsHome: 2,
            homeTeamId: "3d8b2af7-a43f-43a1-9fcb-0b9c7c9b8fad",
            kickOffTime: "2019-09-28T15:00:00.000+01:00",
          },
          "d4c614ba-d783-47dd-9a88-a45c3cc22300": {
            awayTeamId: "906ce93b-8e71-409c-b459-4259fd3d35ad",
            goalsAway: 2,
            goalsHome: 2,
            homeTeamId: "8ecf419b-9fde-46e5-960b-9c5f7f14dc3d",
            kickOffTime: "2019-09-28T15:00:00.000+01:00",
          },
        },
        id: "b66b0de3-f8dc-4df0-bf97-0f003eab1a00",
        matchday: 7,
        startDate: "2019-09-28T12:30:00.000+01:00",
      },
      {
        endDate: "2019-10-06T18:30:00.000+01:00",
        fixtures: {
          "1095a053-bd23-41a0-adcd-6c1245c0cff5": {
            awayTeamId: "91c704f0-77ac-4898-a8bd-9539c66ef301",
            goalsAway: 0,
            goalsHome: 1,
            homeTeamId: "906ce93b-8e71-409c-b459-4259fd3d35ad",
            kickOffTime: "2019-10-05T15:00:00.000+01:00",
          },
          "130d79b1-3c39-40bb-b093-e14ff1ebad9e": {
            awayTeamId: "8ecf419b-9fde-46e5-960b-9c5f7f14dc3d",
            goalsAway: 5,
            goalsHome: 1,
            homeTeamId: "4f30eb3c-4f9d-4506-a62f-e6021429e6de",
            kickOffTime: "2019-10-05T15:00:00.000+01:00",
          },
          "41c95da3-5f20-44fd-a736-91b9abcd857b": {
            awayTeamId: "f29e61a2-23f0-462b-b9c7-420b09fec5d9",
            goalsAway: 0,
            goalsHome: 1,
            homeTeamId: "8368521e-502a-4302-86d3-cf728550d1bd",
            kickOffTime: "2019-10-06T16:30:00.000+01:00",
          },
          "60427818-2e2c-4edc-8de6-8d139847eb6a": {
            awayTeamId: "f9c15363-34ad-4156-a273-12ec0f212df6",
            goalsAway: 4,
            goalsHome: 1,
            homeTeamId: "432b8777-b474-4ff9-bdd0-7dc41bd24e80",
            kickOffTime: "2019-10-06T14:00:00.000+01:00",
          },
          "61b28066-3009-4d3c-bd86-664b8a064ea2": {
            awayTeamId: "053980d1-9205-4f90-b581-a403851c32e0",
            goalsAway: 1,
            goalsHome: 2,
            homeTeamId: "14a47cb1-f497-4d71-879b-b7e82c85e804",
            kickOffTime: "2019-10-05T15:00:00.000+01:00",
          },
          "798ca222-a696-42ce-aabf-9876a4b21636": {
            awayTeamId: "18de8ce2-736d-4c83-b4db-c473f1a03101",
            goalsAway: 0,
            goalsHome: 3,
            homeTeamId: "e96fbd1c-bbd5-4d69-a7c7-2e45f5b579cb",
            kickOffTime: "2019-10-05T12:30:00.000+01:00",
          },
          "8451e540-3310-4f42-ba62-1e2f4e6c01b9": {
            awayTeamId: "1d97c20b-b36c-4307-b227-f11de588c955",
            goalsAway: 0,
            goalsHome: 0,
            homeTeamId: "479aa6bf-67ec-4320-a1dc-2d5b77c2f1a4",
            kickOffTime: "2019-10-05T15:00:00.000+01:00",
          },
          "cc2b13eb-bf00-4d38-9b51-5329ef734bf6": {
            awayTeamId: "3d8b2af7-a43f-43a1-9fcb-0b9c7c9b8fad",
            goalsAway: 2,
            goalsHome: 1,
            homeTeamId: "4e34107f-ccd8-4c94-a04f-5eb8d8637533",
            kickOffTime: "2019-10-05T17:30:00.000+01:00",
          },
          "dc18f85b-3349-4c7a-aeea-4d6695121709": {
            awayTeamId: "79ee152d-e7ee-4511-8d8f-f1632d7570ec",
            goalsAway: 0,
            goalsHome: 1,
            homeTeamId: "5696bf7b-3256-4937-9d6d-952da49ddee9",
            kickOffTime: "2019-10-06T14:00:00.000+01:00",
          },
          "fa5273d3-cb80-4a2e-af23-3d0d7bf84ef0": {
            awayTeamId: "9ad2bac0-8e7e-44cf-924e-75add32d8e5d",
            goalsAway: 2,
            goalsHome: 0,
            homeTeamId: "4303d6fc-7c8d-4f19-aab7-37e4c64195cf",
            kickOffTime: "2019-10-06T14:00:00.000+01:00",
          },
        },
        id: "169189e0-0779-4db1-bdc8-f856aeeef83e",
        matchday: 8,
        startDate: "2019-10-05T12:30:00.000+01:00",
      },
      {
        endDate: "2019-10-21T22:00:00.000+01:00",
        fixtures: {
          "0a9e0dd2-c4a9-497d-baad-7cf9df3f7d23": {
            awayTeamId: "4303d6fc-7c8d-4f19-aab7-37e4c64195cf",
            goalsAway: 2,
            goalsHome: 0,
            homeTeamId: "3d8b2af7-a43f-43a1-9fcb-0b9c7c9b8fad",
            kickOffTime: "2019-10-19T17:30:00.000+01:00",
          },
          "1eb09617-5a40-42a9-9395-d54ba0300897": {
            awayTeamId: "479aa6bf-67ec-4320-a1dc-2d5b77c2f1a4",
            goalsAway: 1,
            goalsHome: 1,
            homeTeamId: "18de8ce2-736d-4c83-b4db-c473f1a03101",
            kickOffTime: "2019-10-19T15:00:00.000+01:00",
          },
          "23b9b5a3-f3da-42ae-bca1-b5239d59900d": {
            awayTeamId: "4e34107f-ccd8-4c94-a04f-5eb8d8637533",
            goalsAway: 0,
            goalsHome: 2,
            homeTeamId: "91c704f0-77ac-4898-a8bd-9539c66ef301",
            kickOffTime: "2019-10-19T12:30:00.000+01:00",
          },
          "40b6527d-a53f-465e-b9f1-5dcbd0eeb042": {
            awayTeamId: "432b8777-b474-4ff9-bdd0-7dc41bd24e80",
            goalsAway: 1,
            goalsHome: 1,
            homeTeamId: "9ad2bac0-8e7e-44cf-924e-75add32d8e5d",
            kickOffTime: "2019-10-19T15:00:00.000+01:00",
          },
          "4deda330-d6e4-4865-a262-43b7d336fd0d": {
            awayTeamId: "8368521e-502a-4302-86d3-cf728550d1bd",
            goalsAway: 0,
            goalsHome: 1,
            homeTeamId: "f9c15363-34ad-4156-a273-12ec0f212df6",
            kickOffTime: "2019-10-19T15:00:00.000+01:00",
          },
          "5569a6f1-82b7-4afd-98e3-c01906ddae1a": {
            awayTeamId: "14a47cb1-f497-4d71-879b-b7e82c85e804",
            goalsAway: 1,
            goalsHome: 1,
            homeTeamId: "f29e61a2-23f0-462b-b9c7-420b09fec5d9",
            kickOffTime: "2019-10-20T16:30:00.000+01:00",
          },
          "8a304cca-0a31-470c-b35f-0d64e783c638": {
            awayTeamId: "5696bf7b-3256-4937-9d6d-952da49ddee9",
            goalsAway: 0,
            goalsHome: 1,
            homeTeamId: "1d97c20b-b36c-4307-b227-f11de588c955",
            kickOffTime: "2019-10-21T20:00:00.000+01:00",
          },
          "a5873fef-a6c9-404d-8508-ad86da39668a": {
            awayTeamId: "e96fbd1c-bbd5-4d69-a7c7-2e45f5b579cb",
            goalsAway: 1,
            goalsHome: 2,
            homeTeamId: "8ecf419b-9fde-46e5-960b-9c5f7f14dc3d",
            kickOffTime: "2019-10-19T15:00:00.000+01:00",
          },
          "a894fd62-e6cf-41e8-acea-35475e7360a4": {
            awayTeamId: "906ce93b-8e71-409c-b459-4259fd3d35ad",
            goalsAway: 1,
            goalsHome: 2,
            homeTeamId: "053980d1-9205-4f90-b581-a403851c32e0",
            kickOffTime: "2019-10-19T15:00:00.000+01:00",
          },
          "f9211ce8-3aa4-4e21-97bc-b49182a30c9e": {
            awayTeamId: "4f30eb3c-4f9d-4506-a62f-e6021429e6de",
            goalsAway: 0,
            goalsHome: 0,
            homeTeamId: "79ee152d-e7ee-4511-8d8f-f1632d7570ec",
            kickOffTime: "2019-10-19T15:00:00.000+01:00",
          },
        },
        id: "0c66c21f-62e3-4692-9270-14f0a07dbbe1",
        matchday: 9,
        startDate: "2019-10-19T12:30:00.000+01:00",
      },
      {
        endDate: "2019-10-27T18:30:00.000Z",
        fixtures: {
          "061f8aa3-2805-4a61-93c3-1c408e81d078": {
            awayTeamId: "91c704f0-77ac-4898-a8bd-9539c66ef301",
            goalsAway: 2,
            goalsHome: 3,
            homeTeamId: "e96fbd1c-bbd5-4d69-a7c7-2e45f5b579cb",
            kickOffTime: "2019-10-26T15:00:00.000+01:00",
          },
          "3c6c67fa-c120-4fdd-b206-c8407591d6ec": {
            awayTeamId: "1d97c20b-b36c-4307-b227-f11de588c955",
            goalsAway: 1,
            goalsHome: 1,
            homeTeamId: "4e34107f-ccd8-4c94-a04f-5eb8d8637533",
            kickOffTime: "2019-10-26T15:00:00.000+01:00",
          },
          "615dedf9-c4f9-4ed6-9dcd-a70dd0a08021": {
            awayTeamId: "053980d1-9205-4f90-b581-a403851c32e0",
            goalsAway: 9,
            goalsHome: 0,
            homeTeamId: "432b8777-b474-4ff9-bdd0-7dc41bd24e80",
            kickOffTime: "2019-10-25T20:00:00.000+01:00",
          },
          "79a53a28-251c-4e63-be1d-0457cbb831b5": {
            awayTeamId: "f9c15363-34ad-4156-a273-12ec0f212df6",
            goalsAway: 4,
            goalsHome: 2,
            homeTeamId: "906ce93b-8e71-409c-b459-4259fd3d35ad",
            kickOffTime: "2019-10-26T17:30:00.000+01:00",
          },
          "a910fd69-136a-46d3-baa9-715b9b920fb9": {
            awayTeamId: "79ee152d-e7ee-4511-8d8f-f1632d7570ec",
            goalsAway: 0,
            goalsHome: 0,
            homeTeamId: "479aa6bf-67ec-4320-a1dc-2d5b77c2f1a4",
            kickOffTime: "2019-10-26T15:00:00.000+01:00",
          },
          "affc1f99-2fc9-40d8-90f2-30125c5ff31e": {
            awayTeamId: "9ad2bac0-8e7e-44cf-924e-75add32d8e5d",
            goalsAway: 1,
            goalsHome: 1,
            homeTeamId: "8368521e-502a-4302-86d3-cf728550d1bd",
            kickOffTime: "2019-10-27T14:00:00.000Z",
          },
          "c839b783-f664-4b02-a527-5f186000a1da": {
            awayTeamId: "8ecf419b-9fde-46e5-960b-9c5f7f14dc3d",
            goalsAway: 0,
            goalsHome: 3,
            homeTeamId: "4303d6fc-7c8d-4f19-aab7-37e4c64195cf",
            kickOffTime: "2019-10-26T12:30:00.000+01:00",
          },
          "d5887862-7853-4e11-9470-dfafe4c91c0c": {
            awayTeamId: "f29e61a2-23f0-462b-b9c7-420b09fec5d9",
            goalsAway: 3,
            goalsHome: 1,
            homeTeamId: "4f30eb3c-4f9d-4506-a62f-e6021429e6de",
            kickOffTime: "2019-10-27T16:30:00.000Z",
          },
          "f168cc57-f89f-4630-88f3-7a4fa2d9426e": {
            awayTeamId: "18de8ce2-736d-4c83-b4db-c473f1a03101",
            goalsAway: 1,
            goalsHome: 2,
            homeTeamId: "14a47cb1-f497-4d71-879b-b7e82c85e804",
            kickOffTime: "2019-10-27T16:30:00.000Z",
          },
          "f3e7ca38-1c2b-45f7-bf30-576c3555690c": {
            awayTeamId: "3d8b2af7-a43f-43a1-9fcb-0b9c7c9b8fad",
            goalsAway: 2,
            goalsHome: 2,
            homeTeamId: "5696bf7b-3256-4937-9d6d-952da49ddee9",
            kickOffTime: "2019-10-27T16:30:00.000Z",
          },
        },
        id: "040c5b03-27d7-434d-8187-4a620a80ef89",
        matchday: 10,
        startDate: "2019-10-25T20:00:00.000+01:00",
      },
      {
        endDate: "2019-11-03T18:30:00.000Z",
        fixtures: {
          "304645b4-b1cc-44c5-9a96-ee6a85cd3eff": {
            awayTeamId: "432b8777-b474-4ff9-bdd0-7dc41bd24e80",
            goalsAway: 1,
            goalsHome: 2,
            homeTeamId: "4303d6fc-7c8d-4f19-aab7-37e4c64195cf",
            kickOffTime: "2019-11-02T15:00:00.000Z",
          },
          "3bbc5a31-a323-432a-9070-4300686334d0": {
            awayTeamId: "4f30eb3c-4f9d-4506-a62f-e6021429e6de",
            goalsAway: 0,
            goalsHome: 2,
            homeTeamId: "e96fbd1c-bbd5-4d69-a7c7-2e45f5b579cb",
            kickOffTime: "2019-11-02T15:00:00.000Z",
          },
          "425b3f7d-c1ad-4c56-b896-107fa1e08d3c": {
            awayTeamId: "906ce93b-8e71-409c-b459-4259fd3d35ad",
            goalsAway: 0,
            goalsHome: 3,
            homeTeamId: "1d97c20b-b36c-4307-b227-f11de588c955",
            kickOffTime: "2019-11-02T15:00:00.000Z",
          },
          "622b3d00-b36d-4993-9b9d-4bec22fc4b52": {
            awayTeamId: "053980d1-9205-4f90-b581-a403851c32e0",
            goalsAway: 2,
            goalsHome: 0,
            homeTeamId: "3d8b2af7-a43f-43a1-9fcb-0b9c7c9b8fad",
            kickOffTime: "2019-11-03T14:00:00.000Z",
          },
          "a1c7b8d6-e849-48b6-953f-60e3901b1c4f": {
            awayTeamId: "18de8ce2-736d-4c83-b4db-c473f1a03101",
            goalsAway: 1,
            goalsHome: 1,
            homeTeamId: "91c704f0-77ac-4898-a8bd-9539c66ef301",
            kickOffTime: "2019-11-03T16:30:00.000Z",
          },
          "ba383e53-0d54-493f-8024-e4209f451f0e": {
            awayTeamId: "f29e61a2-23f0-462b-b9c7-420b09fec5d9",
            goalsAway: 0,
            goalsHome: 1,
            homeTeamId: "79ee152d-e7ee-4511-8d8f-f1632d7570ec",
            kickOffTime: "2019-11-02T12:30:00.000Z",
          },
          "c271a62b-ecb1-4d9d-9ec3-f6fcffe27004": {
            awayTeamId: "8368521e-502a-4302-86d3-cf728550d1bd",
            goalsAway: 3,
            goalsHome: 2,
            homeTeamId: "4e34107f-ccd8-4c94-a04f-5eb8d8637533",
            kickOffTime: "2019-11-02T15:00:00.000Z",
          },
          "cc2476fd-ee1d-43c1-b65f-ad2621321dfa": {
            awayTeamId: "14a47cb1-f497-4d71-879b-b7e82c85e804",
            goalsAway: 2,
            goalsHome: 1,
            homeTeamId: "8ecf419b-9fde-46e5-960b-9c5f7f14dc3d",
            kickOffTime: "2019-11-02T15:00:00.000Z",
          },
          "e025b3cf-e1f9-4a8b-bd12-057ff17d12d9": {
            awayTeamId: "f9c15363-34ad-4156-a273-12ec0f212df6",
            goalsAway: 2,
            goalsHome: 1,
            homeTeamId: "479aa6bf-67ec-4320-a1dc-2d5b77c2f1a4",
            kickOffTime: "2019-11-02T17:30:00.000Z",
          },
          "f215d8c4-6d09-4d39-a6be-4fc8dc253f58": {
            awayTeamId: "9ad2bac0-8e7e-44cf-924e-75add32d8e5d",
            goalsAway: 1,
            goalsHome: 1,
            homeTeamId: "5696bf7b-3256-4937-9d6d-952da49ddee9",
            kickOffTime: "2019-11-02T15:00:00.000Z",
          },
        },
        id: "2a70f890-b3c0-4a90-9ba8-29ba0c6e6896",
        matchday: 11,
        startDate: "2019-11-02T12:30:00.000Z",
      },
      {
        endDate: "2019-11-10T18:30:00.000Z",
        fixtures: {
          "44f4077b-1b95-451b-985e-c07a0b7be359": {
            awayTeamId: "e96fbd1c-bbd5-4d69-a7c7-2e45f5b579cb",
            goalsAway: 1,
            goalsHome: 3,
            homeTeamId: "f29e61a2-23f0-462b-b9c7-420b09fec5d9",
            kickOffTime: "2019-11-10T14:00:00.000Z",
          },
          "484426c9-3723-4248-b36f-c80c9a043b3f": {
            awayTeamId: "4e34107f-ccd8-4c94-a04f-5eb8d8637533",
            goalsAway: 0,
            goalsHome: 3,
            homeTeamId: "906ce93b-8e71-409c-b459-4259fd3d35ad",
            kickOffTime: "2019-11-09T15:00:00.000Z",
          },
          "6faa5911-a2aa-4240-8088-2e92147db30e": {
            awayTeamId: "4303d6fc-7c8d-4f19-aab7-37e4c64195cf",
            goalsAway: 1,
            goalsHome: 3,
            homeTeamId: "14a47cb1-f497-4d71-879b-b7e82c85e804",
            kickOffTime: "2019-11-10T16:30:00.000Z",
          },
          "831d1559-bc6f-400b-9fb2-95003bd3cfd4": {
            awayTeamId: "8ecf419b-9fde-46e5-960b-9c5f7f14dc3d",
            goalsAway: 1,
            goalsHome: 2,
            homeTeamId: "9ad2bac0-8e7e-44cf-924e-75add32d8e5d",
            kickOffTime: "2019-11-10T14:00:00.000Z",
          },
          "9abf7798-ad07-46ec-ae02-59999c1d046d": {
            awayTeamId: "3d8b2af7-a43f-43a1-9fcb-0b9c7c9b8fad",
            goalsAway: 0,
            goalsHome: 2,
            homeTeamId: "f9c15363-34ad-4156-a273-12ec0f212df6",
            kickOffTime: "2019-11-09T12:30:00.000Z",
          },
          "a9bc8e12-0040-41d4-a91d-6b0a2906ec7e": {
            awayTeamId: "5696bf7b-3256-4937-9d6d-952da49ddee9",
            goalsAway: 0,
            goalsHome: 2,
            homeTeamId: "053980d1-9205-4f90-b581-a403851c32e0",
            kickOffTime: "2019-11-09T17:30:00.000Z",
          },
          "b2671314-8462-419f-8584-c65c30d0d4e7": {
            awayTeamId: "91c704f0-77ac-4898-a8bd-9539c66ef301",
            goalsAway: 2,
            goalsHome: 1,
            homeTeamId: "432b8777-b474-4ff9-bdd0-7dc41bd24e80",
            kickOffTime: "2019-11-09T15:00:00.000Z",
          },
          "ee019fb9-31fc-43ef-a56f-125cee012432": {
            awayTeamId: "79ee152d-e7ee-4511-8d8f-f1632d7570ec",
            goalsAway: 1,
            goalsHome: 2,
            homeTeamId: "8368521e-502a-4302-86d3-cf728550d1bd",
            kickOffTime: "2019-11-09T15:00:00.000Z",
          },
          "f3244a80-917f-42f2-98c2-f19676f3f3b4": {
            awayTeamId: "1d97c20b-b36c-4307-b227-f11de588c955",
            goalsAway: 1,
            goalsHome: 1,
            homeTeamId: "18de8ce2-736d-4c83-b4db-c473f1a03101",
            kickOffTime: "2019-11-09T15:00:00.000Z",
          },
          "fe243232-046c-4a0e-b3ac-84eb1054f7ec": {
            awayTeamId: "479aa6bf-67ec-4320-a1dc-2d5b77c2f1a4",
            goalsAway: 2,
            goalsHome: 0,
            homeTeamId: "4f30eb3c-4f9d-4506-a62f-e6021429e6de",
            kickOffTime: "2019-11-08T20:00:00.000Z",
          },
        },
        id: "7f4c10bf-9d06-4622-b523-ae52bbce74cc",
        matchday: 12,
        startDate: "2019-11-08T20:00:00.000Z",
      },
      {
        endDate: "2019-11-25T24:00:00.000Z",
        fixtures: {
          "035a67d8-df27-4c94-9d9f-dd4b502c90ec": {
            awayTeamId: "9ad2bac0-8e7e-44cf-924e-75add32d8e5d",
            goalsAway: 2,
            goalsHome: 1,
            homeTeamId: "79ee152d-e7ee-4511-8d8f-f1632d7570ec",
            kickOffTime: "2019-11-23T15:00:00.000Z",
          },
          "18f9e0c7-6571-4910-8272-bb96ee77d256": {
            awayTeamId: "432b8777-b474-4ff9-bdd0-7dc41bd24e80",
            goalsAway: 2,
            goalsHome: 2,
            homeTeamId: "5696bf7b-3256-4937-9d6d-952da49ddee9",
            kickOffTime: "2019-11-23T15:00:00.000Z",
          },
          "352f5a50-83e1-4c98-81ee-7b1148e6a454": {
            awayTeamId: "f9c15363-34ad-4156-a273-12ec0f212df6",
            goalsAway: 1,
            goalsHome: 2,
            homeTeamId: "4303d6fc-7c8d-4f19-aab7-37e4c64195cf",
            kickOffTime: "2019-11-23T17:30:00.000Z",
          },
          "38c1dd85-92de-4e65-a024-810de6aaf1de": {
            awayTeamId: "14a47cb1-f497-4d71-879b-b7e82c85e804",
            goalsAway: 2,
            goalsHome: 1,
            homeTeamId: "3d8b2af7-a43f-43a1-9fcb-0b9c7c9b8fad",
            kickOffTime: "2019-11-23T15:00:00.000Z",
          },
          "4d6ab33e-bfca-46e8-a349-486a8e20ca2a": {
            awayTeamId: "8368521e-502a-4302-86d3-cf728550d1bd",
            goalsAway: 0,
            goalsHome: 2,
            homeTeamId: "8ecf419b-9fde-46e5-960b-9c5f7f14dc3d",
            kickOffTime: "2019-11-25T22:00:00.000Z",
          },
          "5854fb65-362c-4885-9159-859b7dc5a8a9": {
            awayTeamId: "906ce93b-8e71-409c-b459-4259fd3d35ad",
            goalsAway: 3,
            goalsHome: 0,
            homeTeamId: "479aa6bf-67ec-4320-a1dc-2d5b77c2f1a4",
            kickOffTime: "2019-11-23T15:00:00.000Z",
          },
          "5a135bdc-32b5-45cd-97d6-1977c095abca": {
            awayTeamId: "053980d1-9205-4f90-b581-a403851c32e0",
            goalsAway: 2,
            goalsHome: 0,
            homeTeamId: "e96fbd1c-bbd5-4d69-a7c7-2e45f5b579cb",
            kickOffTime: "2019-11-23T15:00:00.000Z",
          },
          "6e33af49-3c44-4488-afb8-0930d9bf4671": {
            awayTeamId: "f29e61a2-23f0-462b-b9c7-420b09fec5d9",
            goalsAway: 3,
            goalsHome: 3,
            homeTeamId: "1d97c20b-b36c-4307-b227-f11de588c955",
            kickOffTime: "2019-11-24T16:30:00.000Z",
          },
          "bf347f9b-ecb2-4953-867a-bc1a1278c2ff": {
            awayTeamId: "18de8ce2-736d-4c83-b4db-c473f1a03101",
            goalsAway: 3,
            goalsHome: 2,
            homeTeamId: "4e34107f-ccd8-4c94-a04f-5eb8d8637533",
            kickOffTime: "2019-11-23T12:30:00.000Z",
          },
          "fb75dd3f-ec61-45f6-b323-2507e253f311": {
            awayTeamId: "4f30eb3c-4f9d-4506-a62f-e6021429e6de",
            goalsAway: 2,
            goalsHome: 0,
            homeTeamId: "91c704f0-77ac-4898-a8bd-9539c66ef301",
            kickOffTime: "2019-11-23T15:00:00.000Z",
          },
        },
        id: "51992121-33a9-4119-bc60-f1ebf6873c1f",
        matchday: 13,
        startDate: "2019-11-23T12:30:00.000Z",
      },
      {
        endDate: "2019-12-01T18:30:00.000Z",
        fixtures: {
          "2465a9bd-5479-44b6-acfc-b4ce214f14a1": {
            awayTeamId: "3d8b2af7-a43f-43a1-9fcb-0b9c7c9b8fad",
            goalsAway: 2,
            goalsHome: 0,
            homeTeamId: "906ce93b-8e71-409c-b459-4259fd3d35ad",
            kickOffTime: "2019-11-30T15:00:00.000Z",
          },
          "5a58eebc-5c67-41d1-936f-05a1ddb7ad6b": {
            awayTeamId: "4e34107f-ccd8-4c94-a04f-5eb8d8637533",
            goalsAway: 1,
            goalsHome: 0,
            homeTeamId: "f9c15363-34ad-4156-a273-12ec0f212df6",
            kickOffTime: "2019-11-30T15:00:00.000Z",
          },
          "5ab11639-cd39-48b5-9197-c30f4896340a": {
            awayTeamId: "4303d6fc-7c8d-4f19-aab7-37e4c64195cf",
            goalsAway: 2,
            goalsHome: 2,
            homeTeamId: "8368521e-502a-4302-86d3-cf728550d1bd",
            kickOffTime: "2019-11-30T12:30:00.000Z",
          },
          "747c990b-681d-4151-811b-44b22f444206": {
            awayTeamId: "8ecf419b-9fde-46e5-960b-9c5f7f14dc3d",
            goalsAway: 2,
            goalsHome: 2,
            homeTeamId: "f29e61a2-23f0-462b-b9c7-420b09fec5d9",
            kickOffTime: "2019-12-01T16:30:00.000Z",
          },
          "7e0460c0-724d-4ee9-9902-6e6afc990c1a": {
            awayTeamId: "91c704f0-77ac-4898-a8bd-9539c66ef301",
            goalsAway: 1,
            goalsHome: 2,
            homeTeamId: "053980d1-9205-4f90-b581-a403851c32e0",
            kickOffTime: "2019-12-01T16:30:00.000Z",
          },
          "a733828c-21ad-4c27-98bb-3fd43ae992c2": {
            awayTeamId: "5696bf7b-3256-4937-9d6d-952da49ddee9",
            goalsAway: 2,
            goalsHome: 2,
            homeTeamId: "4f30eb3c-4f9d-4506-a62f-e6021429e6de",
            kickOffTime: "2019-12-01T14:00:00.000Z",
          },
          "e24ff15d-2d14-4095-9f73-393f5a4f006e": {
            awayTeamId: "1d97c20b-b36c-4307-b227-f11de588c955",
            goalsAway: 1,
            goalsHome: 1,
            homeTeamId: "9ad2bac0-8e7e-44cf-924e-75add32d8e5d",
            kickOffTime: "2019-12-01T14:00:00.000Z",
          },
          "e7fee008-f20b-4ba7-a801-dc791728a5db": {
            awayTeamId: "479aa6bf-67ec-4320-a1dc-2d5b77c2f1a4",
            goalsAway: 1,
            goalsHome: 2,
            homeTeamId: "432b8777-b474-4ff9-bdd0-7dc41bd24e80",
            kickOffTime: "2019-11-30T17:30:00.000Z",
          },
          "ece11dbe-e37a-4ec9-8bfa-462400e8fea4": {
            awayTeamId: "e96fbd1c-bbd5-4d69-a7c7-2e45f5b579cb",
            goalsAway: 1,
            goalsHome: 2,
            homeTeamId: "14a47cb1-f497-4d71-879b-b7e82c85e804",
            kickOffTime: "2019-11-30T15:00:00.000Z",
          },
          "f8cfb741-f4ec-4c77-85e6-0e926d0edbff": {
            awayTeamId: "79ee152d-e7ee-4511-8d8f-f1632d7570ec",
            goalsAway: 2,
            goalsHome: 3,
            homeTeamId: "18de8ce2-736d-4c83-b4db-c473f1a03101",
            kickOffTime: "2019-11-30T15:00:00.000Z",
          },
        },
        id: "96f62377-68ab-4f3d-b00a-a3bbdfc44ec8",
        matchday: 14,
        startDate: "2019-11-30T12:30:00.000Z",
      },
      {
        endDate: "2019-12-05T22:15:00.000Z",
        fixtures: {
          "05059f65-29a3-4d40-ad0d-507c41f9746b": {
            awayTeamId: "79ee152d-e7ee-4511-8d8f-f1632d7570ec",
            goalsAway: 0,
            goalsHome: 1,
            homeTeamId: "3d8b2af7-a43f-43a1-9fcb-0b9c7c9b8fad",
            kickOffTime: "2019-12-03T19:30:00.000Z",
          },
          "14aff8a9-8ed2-49ab-a311-31c4f8aabd16": {
            awayTeamId: "479aa6bf-67ec-4320-a1dc-2d5b77c2f1a4",
            goalsAway: 0,
            goalsHome: 2,
            homeTeamId: "053980d1-9205-4f90-b581-a403851c32e0",
            kickOffTime: "2019-12-04T19:30:00.000Z",
          },
          "1bfa3581-7c00-45df-b860-2c9f4b67a2f7": {
            awayTeamId: "e96fbd1c-bbd5-4d69-a7c7-2e45f5b579cb",
            goalsAway: 2,
            goalsHome: 1,
            homeTeamId: "5696bf7b-3256-4937-9d6d-952da49ddee9",
            kickOffTime: "2019-12-05T13:15:00.000Z",
          },
          "1f82a3c6-967b-4e8e-867d-8474588338ca": {
            awayTeamId: "4e34107f-ccd8-4c94-a04f-5eb8d8637533",
            goalsAway: 0,
            goalsHome: 2,
            homeTeamId: "9ad2bac0-8e7e-44cf-924e-75add32d8e5d",
            kickOffTime: "2019-12-04T19:30:00.000Z",
          },
          "20b0ff7c-c309-4a3f-8408-a124dc9c7cbe": {
            awayTeamId: "4f30eb3c-4f9d-4506-a62f-e6021429e6de",
            goalsAway: 1,
            goalsHome: 2,
            homeTeamId: "432b8777-b474-4ff9-bdd0-7dc41bd24e80",
            kickOffTime: "2019-12-04T19:30:00.000Z",
          },
          "3a28b51e-ca00-4367-9579-23ba3a460802": {
            awayTeamId: "8368521e-502a-4302-86d3-cf728550d1bd",
            goalsAway: 2,
            goalsHome: 0,
            homeTeamId: "1d97c20b-b36c-4307-b227-f11de588c955",
            kickOffTime: "2019-12-05T20:30:00.000Z",
          },
          "3bd54eb4-a1a4-44b3-a845-0935b615e1d7": {
            awayTeamId: "91c704f0-77ac-4898-a8bd-9539c66ef301",
            goalsAway: 2,
            goalsHome: 5,
            homeTeamId: "14a47cb1-f497-4d71-879b-b7e82c85e804",
            kickOffTime: "2019-12-04T20:15:00.000Z",
          },
          "7a83ea42-9234-418d-b860-46937bb7f9cc": {
            awayTeamId: "4303d6fc-7c8d-4f19-aab7-37e4c64195cf",
            goalsAway: 4,
            goalsHome: 1,
            homeTeamId: "906ce93b-8e71-409c-b459-4259fd3d35ad",
            kickOffTime: "2019-12-03T20:15:00.000Z",
          },
          "98629c05-5a34-46d9-b9de-26cc589579a8": {
            awayTeamId: "18de8ce2-736d-4c83-b4db-c473f1a03101",
            goalsAway: 1,
            goalsHome: 2,
            homeTeamId: "f29e61a2-23f0-462b-b9c7-420b09fec5d9",
            kickOffTime: "2019-12-04T19:30:00.000Z",
          },
          "c26cb7c9-886d-47f5-9cd7-8f6437a11303": {
            awayTeamId: "8ecf419b-9fde-46e5-960b-9c5f7f14dc3d",
            goalsAway: 1,
            goalsHome: 2,
            homeTeamId: "f9c15363-34ad-4156-a273-12ec0f212df6",
            kickOffTime: "2019-12-04T19:30:00.000Z",
          },
        },
        id: "37cc1518-2c19-4c26-87d5-49b2d0c1078a",
        matchday: 15,
        startDate: "2019-12-03T19:30:00.000Z",
      },
      {
        endDate: "2019-12-09T15:00:00.000Z",
        fixtures: {
          "24e522e5-bfb9-4512-9e67-c2e32cf2179f": {
            awayTeamId: "1d97c20b-b36c-4307-b227-f11de588c955",
            goalsAway: 2,
            goalsHome: 1,
            homeTeamId: "4f30eb3c-4f9d-4506-a62f-e6021429e6de",
            kickOffTime: "2019-12-08T14:00:00.000Z",
          },
          "2890b8d4-f5c3-4687-90f5-3d5badeda914": {
            awayTeamId: "14a47cb1-f497-4d71-879b-b7e82c85e804",
            goalsAway: 3,
            goalsHome: 0,
            homeTeamId: "79ee152d-e7ee-4511-8d8f-f1632d7570ec",
            kickOffTime: "2019-12-07T15:00:00.000Z",
          },
          "4e23d18f-7f66-49c5-85e9-bfd89eec174f": {
            awayTeamId: "f9c15363-34ad-4156-a273-12ec0f212df6",
            goalsAway: 1,
            goalsHome: 3,
            homeTeamId: "91c704f0-77ac-4898-a8bd-9539c66ef301",
            kickOffTime: "2019-12-07T12:30:00.000Z",
          },
          "55b932ab-b0a1-4f27-b8d1-67c5f4747901": {
            awayTeamId: "f29e61a2-23f0-462b-b9c7-420b09fec5d9",
            goalsAway: 2,
            goalsHome: 1,
            homeTeamId: "4303d6fc-7c8d-4f19-aab7-37e4c64195cf",
            kickOffTime: "2019-12-07T17:30:00.000Z",
          },
          "92b23095-0f5c-4abf-b800-6aa11c0cce6e": {
            awayTeamId: "5696bf7b-3256-4937-9d6d-952da49ddee9",
            goalsAway: 3,
            goalsHome: 1,
            homeTeamId: "4e34107f-ccd8-4c94-a04f-5eb8d8637533",
            kickOffTime: "2019-12-09T21:00:00.000Z",
          },
          "99a6ff80-aa26-4f09-86b3-6d2bb1a11130": {
            awayTeamId: "053980d1-9205-4f90-b581-a403851c32e0",
            goalsAway: 4,
            goalsHome: 1,
            homeTeamId: "8ecf419b-9fde-46e5-960b-9c5f7f14dc3d",
            kickOffTime: "2019-12-08T14:00:00.000Z",
          },
          "b89c6c35-b684-4f9b-a1ff-08b147e861b9": {
            awayTeamId: "3d8b2af7-a43f-43a1-9fcb-0b9c7c9b8fad",
            goalsAway: 0,
            goalsHome: 0,
            homeTeamId: "479aa6bf-67ec-4320-a1dc-2d5b77c2f1a4",
            kickOffTime: "2019-12-07T15:00:00.000Z",
          },
          "c8299003-0d0b-42e1-8b6e-23b857f2a852": {
            awayTeamId: "906ce93b-8e71-409c-b459-4259fd3d35ad",
            goalsAway: 0,
            goalsHome: 5,
            homeTeamId: "18de8ce2-736d-4c83-b4db-c473f1a03101",
            kickOffTime: "2019-12-07T15:00:00.000Z",
          },
          "ecf72bc6-8eac-4238-afb3-53f590147931": {
            awayTeamId: "9ad2bac0-8e7e-44cf-924e-75add32d8e5d",
            goalsAway: 2,
            goalsHome: 2,
            homeTeamId: "e96fbd1c-bbd5-4d69-a7c7-2e45f5b579cb",
            kickOffTime: "2019-12-08T16:30:00.000Z",
          },
          "fa207fcf-ff1d-43a1-b80f-c701b45ed3e0": {
            awayTeamId: "432b8777-b474-4ff9-bdd0-7dc41bd24e80",
            goalsAway: 1,
            goalsHome: 2,
            homeTeamId: "8368521e-502a-4302-86d3-cf728550d1bd",
            kickOffTime: "2019-12-08T14:00:00.000Z",
          },
        },
        id: "38ba90f4-821a-4693-856e-0ff485287257",
        matchday: 16,
        startDate: "2019-12-07T12:30:00.000Z",
      },
      {
        endDate: "",
        fixtures: {
          "0d9e3426-7586-4bc4-b1b2-5c89b47d6bd8": {
            awayTeamId: "79ee152d-e7ee-4511-8d8f-f1632d7570ec",
            goalsAway: 1,
            goalsHome: 0,
            homeTeamId: "f9c15363-34ad-4156-a273-12ec0f212df6",
            id: "0d9e3426-7586-4bc4-b1b2-5c89b47d6bd8",
            kickOffTime: "2019-12-14T15:00:41.471Z",
          },
          "270cf32c-eedb-4367-a735-d6146e60f940": {
            awayTeamId: "e96fbd1c-bbd5-4d69-a7c7-2e45f5b579cb",
            goalsAway: 1,
            goalsHome: 1,
            homeTeamId: "3d8b2af7-a43f-43a1-9fcb-0b9c7c9b8fad",
            id: "270cf32c-eedb-4367-a735-d6146e60f940",
            kickOffTime: "2019-12-16T19:45:20.158Z",
          },
          "2c537dcc-3eee-4dc5-8fe9-ac465500e0f0": {
            awayTeamId: "4303d6fc-7c8d-4f19-aab7-37e4c64195cf",
            goalsAway: 3,
            goalsHome: 0,
            homeTeamId: "5696bf7b-3256-4937-9d6d-952da49ddee9",
            id: "2c537dcc-3eee-4dc5-8fe9-ac465500e0f0",
            kickOffTime: "2019-12-15T16:30:36.142Z",
          },
          "40e1e5d2-ba32-4ebe-b533-7f901ba7f60f": {
            awayTeamId: "91c704f0-77ac-4898-a8bd-9539c66ef301",
            goalsAway: 1,
            goalsHome: 1,
            homeTeamId: "f29e61a2-23f0-462b-b9c7-420b09fec5d9",
            id: "40e1e5d2-ba32-4ebe-b533-7f901ba7f60f",
            kickOffTime: "2019-12-15T14:00:36.141Z",
          },
          "51b3623e-b0e3-40af-8073-baaf8a909415": {
            awayTeamId: "8ecf419b-9fde-46e5-960b-9c5f7f14dc3d",
            goalsAway: 0,
            goalsHome: 2,
            homeTeamId: "1d97c20b-b36c-4307-b227-f11de588c955",
            id: "51b3623e-b0e3-40af-8073-baaf8a909415",
            kickOffTime: "2019-12-14T15:00:41.467Z",
          },
          "7cc7a91e-503a-4843-b189-3e9d7bb7d4b4": {
            awayTeamId: "4e34107f-ccd8-4c94-a04f-5eb8d8637533",
            goalsAway: 1,
            goalsHome: 0,
            homeTeamId: "432b8777-b474-4ff9-bdd0-7dc41bd24e80",
            id: "7cc7a91e-503a-4843-b189-3e9d7bb7d4b4",
            kickOffTime: "2019-12-14T17:30:41.472Z",
          },
          "9acc7069-c5d8-4ced-8617-7aa7f429bd03": {
            awayTeamId: "4f30eb3c-4f9d-4506-a62f-e6021429e6de",
            goalsAway: 1,
            goalsHome: 1,
            homeTeamId: "053980d1-9205-4f90-b581-a403851c32e0",
            id: "9acc7069-c5d8-4ced-8617-7aa7f429bd03",
            kickOffTime: "2019-12-14T15:00:41.468Z",
          },
          "a6d6a962-3535-434d-939d-090f9f7a8328": {
            awayTeamId: "8368521e-502a-4302-86d3-cf728550d1bd",
            goalsAway: 0,
            goalsHome: 1,
            homeTeamId: "906ce93b-8e71-409c-b459-4259fd3d35ad",
            id: "a6d6a962-3535-434d-939d-090f9f7a8328",
            kickOffTime: "2019-12-14T15:00:41.470Z",
          },
          "ad84090f-3880-4cbc-b6ac-2b9c844836a4": {
            awayTeamId: "479aa6bf-67ec-4320-a1dc-2d5b77c2f1a4",
            goalsAway: 0,
            goalsHome: 2,
            homeTeamId: "14a47cb1-f497-4d71-879b-b7e82c85e804",
            id: "ad84090f-3880-4cbc-b6ac-2b9c844836a4",
            kickOffTime: "2019-12-14T12:30:41.466Z",
          },
          "fb959fb5-d3fd-48c2-aa5f-66809e5d2a07": {
            awayTeamId: "18de8ce2-736d-4c83-b4db-c473f1a03101",
            goalsAway: 2,
            goalsHome: 1,
            homeTeamId: "9ad2bac0-8e7e-44cf-924e-75add32d8e5d",
            id: "fb959fb5-d3fd-48c2-aa5f-66809e5d2a07",
            kickOffTime: "2019-12-15T14:00:36.140Z",
          },
        },
        id: "c3a24e9b-b211-44bd-9ba8-ff8ec5ba7739",
        matchday: 17,
        startDate: "",
      },
      {
        endDate: "",
        fixtures: {
          "0fbbfe9d-0965-4796-b10c-dc846fe1f93a": {
            awayTeamId: "906ce93b-8e71-409c-b459-4259fd3d35ad",
            goalsAway: 1,
            goalsHome: 0,
            homeTeamId: "79ee152d-e7ee-4511-8d8f-f1632d7570ec",
            id: "0fbbfe9d-0965-4796-b10c-dc846fe1f93a",
            kickOffTime: "2019-12-21T15:00:02.756Z",
          },
          "1d21b2e1-f4b8-40df-8e42-a13ddd66b19a": {
            awayTeamId: "14a47cb1-f497-4d71-879b-b7e82c85e804",
            goalsAway: 2,
            goalsHome: 0,
            homeTeamId: "4e34107f-ccd8-4c94-a04f-5eb8d8637533",
            id: "1d21b2e1-f4b8-40df-8e42-a13ddd66b19a",
            kickOffTime: "2020-01-29T19:45:52.501Z",
          },
          "38745ed9-f840-4ada-aaa7-8f1346727c2e": {
            awayTeamId: "9ad2bac0-8e7e-44cf-924e-75add32d8e5d",
            goalsAway: 2,
            goalsHome: 1,
            homeTeamId: "4f30eb3c-4f9d-4506-a62f-e6021429e6de",
            id: "38745ed9-f840-4ada-aaa7-8f1346727c2e",
            kickOffTime: "2019-12-21T15:00:02.755Z",
          },
          "59afb21d-2a87-4636-b74a-8c72774426b4": {
            awayTeamId: "5696bf7b-3256-4937-9d6d-952da49ddee9",
            goalsAway: 0,
            goalsHome: 0,
            homeTeamId: "91c704f0-77ac-4898-a8bd-9539c66ef301",
            id: "59afb21d-2a87-4636-b74a-8c72774426b4",
            kickOffTime: "2019-12-21T12:30:02.748Z",
          },
          "7316f11d-5890-4d8a-9e3e-332abf5de3bc": {
            awayTeamId: "053980d1-9205-4f90-b581-a403851c32e0",
            goalsAway: 1,
            goalsHome: 3,
            homeTeamId: "4303d6fc-7c8d-4f19-aab7-37e4c64195cf",
            id: "7316f11d-5890-4d8a-9e3e-332abf5de3bc",
            kickOffTime: "2019-12-21T17:30:02.760Z",
          },
          "784bf4a2-f503-435d-9ebe-22de92c02502": {
            awayTeamId: "1d97c20b-b36c-4307-b227-f11de588c955",
            goalsAway: 1,
            goalsHome: 0,
            homeTeamId: "e96fbd1c-bbd5-4d69-a7c7-2e45f5b579cb",
            id: "784bf4a2-f503-435d-9ebe-22de92c02502",
            kickOffTime: "2019-12-21T15:00:02.755Z",
          },
          "92bba3cd-422c-492f-8dc7-f46065c8f970": {
            awayTeamId: "f9c15363-34ad-4156-a273-12ec0f212df6",
            goalsAway: 2,
            goalsHome: 0,
            homeTeamId: "18de8ce2-736d-4c83-b4db-c473f1a03101",
            kickOffTime: "2019-12-22T16:30:00.000Z",
          },
          "a77979de-e34e-49d7-b5ff-63a48eff4423": {
            awayTeamId: "f29e61a2-23f0-462b-b9c7-420b09fec5d9",
            goalsAway: 0,
            goalsHome: 2,
            homeTeamId: "479aa6bf-67ec-4320-a1dc-2d5b77c2f1a4",
            kickOffTime: "2019-12-22T14:00:00.000Z",
          },
          "eb8b44ab-8fed-4acf-bcd7-99a340daca1f": {
            awayTeamId: "3d8b2af7-a43f-43a1-9fcb-0b9c7c9b8fad",
            goalsAway: 0,
            goalsHome: 1,
            homeTeamId: "8368521e-502a-4302-86d3-cf728550d1bd",
            id: "eb8b44ab-8fed-4acf-bcd7-99a340daca1f",
            kickOffTime: "2019-12-21T15:00:02.754Z",
          },
          "f2cf250c-f2dc-4a0d-919c-c91d859ee4a5": {
            awayTeamId: "432b8777-b474-4ff9-bdd0-7dc41bd24e80",
            goalsAway: 3,
            goalsHome: 1,
            homeTeamId: "8ecf419b-9fde-46e5-960b-9c5f7f14dc3d",
            id: "f2cf250c-f2dc-4a0d-919c-c91d859ee4a5",
            kickOffTime: "2019-12-21T15:00:02.759Z",
          },
        },
        id: "ddeb50ef-7340-442e-814f-9d70c5e843f4",
        matchday: 18,
        startDate: "",
      },
      {
        endDate: "",
        fixtures: {
          "0fb6a986-6913-4a2f-b166-fa070411dcbd": {
            awayTeamId: "4303d6fc-7c8d-4f19-aab7-37e4c64195cf",
            goalsAway: 2,
            goalsHome: 3,
            homeTeamId: "9ad2bac0-8e7e-44cf-924e-75add32d8e5d",
            id: "0fb6a986-6913-4a2f-b166-fa070411dcbd",
            kickOffTime: "2019-12-27T19:45:52.029Z",
          },
          "183fb0f3-ecbf-4330-a342-e8e71b36cea7": {
            awayTeamId: "4f30eb3c-4f9d-4506-a62f-e6021429e6de",
            goalsAway: 0,
            goalsHome: 1,
            homeTeamId: "8ecf419b-9fde-46e5-960b-9c5f7f14dc3d",
            id: "183fb0f3-ecbf-4330-a342-e8e71b36cea7",
            kickOffTime: "2019-12-26T15:01:03.861Z",
          },
          "2e87c0c7-4317-42c2-be37-732799b248e1": {
            awayTeamId: "14a47cb1-f497-4d71-879b-b7e82c85e804",
            goalsAway: 4,
            goalsHome: 0,
            homeTeamId: "053980d1-9205-4f90-b581-a403851c32e0",
            id: "2e87c0c7-4317-42c2-be37-732799b248e1",
            kickOffTime: "2019-12-26T20:00:59.859Z",
          },
          "3522831e-785d-4d3e-865b-ec475f9b3a45": {
            awayTeamId: "4e34107f-ccd8-4c94-a04f-5eb8d8637533",
            goalsAway: 1,
            goalsHome: 2,
            homeTeamId: "3d8b2af7-a43f-43a1-9fcb-0b9c7c9b8fad",
            id: "3522831e-785d-4d3e-865b-ec475f9b3a45",
            kickOffTime: "2019-12-26T15:01:03.861Z",
          },
          "64cc5686-598d-49a1-a2be-c10a305f9b2f": {
            awayTeamId: "906ce93b-8e71-409c-b459-4259fd3d35ad",
            goalsAway: 0,
            goalsHome: 1,
            homeTeamId: "91c704f0-77ac-4898-a8bd-9539c66ef301",
            id: "64cc5686-598d-49a1-a2be-c10a305f9b2f",
            kickOffTime: "2019-12-26T15:01:03.861Z",
          },
          "76213062-919a-4433-a1f2-7c96435317e6": {
            awayTeamId: "8368521e-502a-4302-86d3-cf728550d1bd",
            goalsAway: 1,
            goalsHome: 4,
            homeTeamId: "f29e61a2-23f0-462b-b9c7-420b09fec5d9",
            id: "76213062-919a-4433-a1f2-7c96435317e6",
            kickOffTime: "2019-12-26T17:31:01.456Z",
          },
          "867535f9-257c-40ce-8f1b-45b91806543e": {
            awayTeamId: "479aa6bf-67ec-4320-a1dc-2d5b77c2f1a4",
            goalsAway: 1,
            goalsHome: 1,
            homeTeamId: "1d97c20b-b36c-4307-b227-f11de588c955",
            id: "867535f9-257c-40ce-8f1b-45b91806543e",
            kickOffTime: "2019-12-26T15:15:59.262Z",
          },
          "8e1c22b0-4409-420c-b289-bd4eb1c82afd": {
            awayTeamId: "432b8777-b474-4ff9-bdd0-7dc41bd24e80",
            goalsAway: 2,
            goalsHome: 0,
            homeTeamId: "f9c15363-34ad-4156-a273-12ec0f212df6",
            id: "8e1c22b0-4409-420c-b289-bd4eb1c82afd",
            kickOffTime: "2019-12-26T15:01:03.860Z",
          },
          "d3b0ae99-c432-47be-9a09-ae9ca5751959": {
            awayTeamId: "e96fbd1c-bbd5-4d69-a7c7-2e45f5b579cb",
            goalsAway: 1,
            goalsHome: 2,
            homeTeamId: "18de8ce2-736d-4c83-b4db-c473f1a03101",
            id: "d3b0ae99-c432-47be-9a09-ae9ca5751959",
            kickOffTime: "2019-12-26T12:31:02.857Z",
          },
          "e3d46d23-df2a-4cea-bd83-262244e02481": {
            awayTeamId: "5696bf7b-3256-4937-9d6d-952da49ddee9",
            goalsAway: 1,
            goalsHome: 1,
            homeTeamId: "79ee152d-e7ee-4511-8d8f-f1632d7570ec",
            id: "e3d46d23-df2a-4cea-bd83-262244e02481",
            kickOffTime: "2019-12-26T15:01:03.860Z",
          },
        },
        id: "54178081-e2ae-4630-b8e7-b7bf23d0e2f4",
        matchday: 19,
        startDate: "",
      },
      {
        endDate: "",
        fixtures: {
          "4a197426-0ba0-4299-8feb-befbb1a67f8f": {
            awayTeamId: "f29e61a2-23f0-462b-b9c7-420b09fec5d9",
            goalsAway: 2,
            goalsHome: 0,
            homeTeamId: "906ce93b-8e71-409c-b459-4259fd3d35ad",
            id: "4a197426-0ba0-4299-8feb-befbb1a67f8f",
            kickOffTime: "2019-12-28T19:45:55.520Z",
          },
          "5dab3034-8e5c-4610-9d1a-1165706453c9": {
            awayTeamId: "3d8b2af7-a43f-43a1-9fcb-0b9c7c9b8fad",
            goalsAway: 1,
            goalsHome: 1,
            homeTeamId: "432b8777-b474-4ff9-bdd0-7dc41bd24e80",
            id: "5dab3034-8e5c-4610-9d1a-1165706453c9",
            kickOffTime: "2019-12-28T15:01:03.589Z",
          },
          "602c3502-fb87-4622-9e81-264d0f08b1e8": {
            awayTeamId: "053980d1-9205-4f90-b581-a403851c32e0",
            goalsAway: 2,
            goalsHome: 1,
            homeTeamId: "4e34107f-ccd8-4c94-a04f-5eb8d8637533",
            id: "602c3502-fb87-4622-9e81-264d0f08b1e8",
            kickOffTime: "2019-12-28T17:31:02.678Z",
          },
          "7133443e-30a4-4e75-a3d9-e7bc5b5d7e22": {
            awayTeamId: "18de8ce2-736d-4c83-b4db-c473f1a03101",
            goalsAway: 2,
            goalsHome: 2,
            homeTeamId: "4f30eb3c-4f9d-4506-a62f-e6021429e6de",
            id: "7133443e-30a4-4e75-a3d9-e7bc5b5d7e22",
            kickOffTime: "2019-12-28T17:31:02.678Z",
          },
          "8737f511-ee31-4535-a723-fe0395808a25": {
            awayTeamId: "91c704f0-77ac-4898-a8bd-9539c66ef301",
            goalsAway: 2,
            goalsHome: 1,
            homeTeamId: "8368521e-502a-4302-86d3-cf728550d1bd",
            id: "8737f511-ee31-4535-a723-fe0395808a25",
            kickOffTime: "2019-12-28T15:01:03.676Z",
          },
          "8af97a95-0605-468c-8667-7007ddd4deb9": {
            awayTeamId: "8ecf419b-9fde-46e5-960b-9c5f7f14dc3d",
            goalsAway: 0,
            goalsHome: 3,
            homeTeamId: "479aa6bf-67ec-4320-a1dc-2d5b77c2f1a4",
            id: "8af97a95-0605-468c-8667-7007ddd4deb9",
            kickOffTime: "2019-12-28T15:01:03.589Z",
          },
          "bca05f23-dd67-4381-ac1e-ea57f74cc5bb": {
            awayTeamId: "1d97c20b-b36c-4307-b227-f11de588c955",
            goalsAway: 0,
            goalsHome: 2,
            homeTeamId: "4303d6fc-7c8d-4f19-aab7-37e4c64195cf",
            id: "bca05f23-dd67-4381-ac1e-ea57f74cc5bb",
            kickOffTime: "2019-12-29T18:01:04.451Z",
          },
          "da6d4559-918c-45b5-afd3-341095abcb34": {
            awayTeamId: "f9c15363-34ad-4156-a273-12ec0f212df6",
            goalsAway: 2,
            goalsHome: 1,
            homeTeamId: "5696bf7b-3256-4937-9d6d-952da49ddee9",
            id: "da6d4559-918c-45b5-afd3-341095abcb34",
            kickOffTime: "2019-12-29T14:01:04.145Z",
          },
          "da909113-fe18-4993-a397-aca61f770600": {
            awayTeamId: "9ad2bac0-8e7e-44cf-924e-75add32d8e5d",
            goalsAway: 0,
            goalsHome: 1,
            homeTeamId: "14a47cb1-f497-4d71-879b-b7e82c85e804",
            id: "da909113-fe18-4993-a397-aca61f770600",
            kickOffTime: "2019-12-29T16:30:59.695Z",
          },
          "e8594527-87e6-4a4f-8bfb-8d73cbc3a6aa": {
            awayTeamId: "79ee152d-e7ee-4511-8d8f-f1632d7570ec",
            goalsAway: 0,
            goalsHome: 2,
            homeTeamId: "e96fbd1c-bbd5-4d69-a7c7-2e45f5b579cb",
            id: "e8594527-87e6-4a4f-8bfb-8d73cbc3a6aa",
            kickOffTime: "2019-12-28T12:30:58.427Z",
          },
        },
        id: "968aef8b-f9e2-449b-bdc0-6ef10c39c305",
        matchday: 20,
        startDate: "",
      },
      {
        endDate: "",
        fixtures: {
          "23f2bfac-251e-4d1b-9884-f2bce1c2f0bd": {
            awayTeamId: "8ecf419b-9fde-46e5-960b-9c5f7f14dc3d",
            goalsAway: 2,
            goalsHome: 1,
            homeTeamId: "906ce93b-8e71-409c-b459-4259fd3d35ad",
            id: "23f2bfac-251e-4d1b-9884-f2bce1c2f0bd",
            kickOffTime: "2020-01-01T12:31:17.046Z",
          },
          "246fc1b0-22cf-4e51-8367-1cf184365254": {
            awayTeamId: "79ee152d-e7ee-4511-8d8f-f1632d7570ec",
            goalsAway: 0,
            goalsHome: 4,
            homeTeamId: "4e34107f-ccd8-4c94-a04f-5eb8d8637533",
            id: "246fc1b0-22cf-4e51-8367-1cf184365254",
            kickOffTime: "2020-01-01T17:31:02.741Z",
          },
          "5e5f8db4-0a58-421c-b736-34b3b9c8f7b9": {
            awayTeamId: "18de8ce2-736d-4c83-b4db-c473f1a03101",
            goalsAway: 0,
            goalsHome: 1,
            homeTeamId: "432b8777-b474-4ff9-bdd0-7dc41bd24e80",
            id: "5e5f8db4-0a58-421c-b736-34b3b9c8f7b9",
            kickOffTime: "2020-01-01T15:01:04.945Z",
          },
          "749cf010-7099-4f3a-809d-4a2da23cb85e": {
            awayTeamId: "9ad2bac0-8e7e-44cf-924e-75add32d8e5d",
            goalsAway: 1,
            goalsHome: 2,
            homeTeamId: "479aa6bf-67ec-4320-a1dc-2d5b77c2f1a4",
            id: "749cf010-7099-4f3a-809d-4a2da23cb85e",
            kickOffTime: "2020-01-01T15:01:04.944Z",
          },
          "75b2dffa-55ab-42de-8216-6557d2871c1e": {
            awayTeamId: "053980d1-9205-4f90-b581-a403851c32e0",
            goalsAway: 3,
            goalsHome: 0,
            homeTeamId: "8368521e-502a-4302-86d3-cf728550d1bd",
            id: "75b2dffa-55ab-42de-8216-6557d2871c1e",
            kickOffTime: "2020-01-01T15:01:04.945Z",
          },
          "824f03e0-169d-41a2-b769-c68f18a1fe79": {
            awayTeamId: "f29e61a2-23f0-462b-b9c7-420b09fec5d9",
            goalsAway: 0,
            goalsHome: 2,
            homeTeamId: "5696bf7b-3256-4937-9d6d-952da49ddee9",
            id: "824f03e0-169d-41a2-b769-c68f18a1fe79",
            kickOffTime: "2020-01-01T20:01:01.443Z",
          },
          "8784848c-399f-424b-badb-643fa8246239": {
            awayTeamId: "f9c15363-34ad-4156-a273-12ec0f212df6",
            goalsAway: 1,
            goalsHome: 1,
            homeTeamId: "e96fbd1c-bbd5-4d69-a7c7-2e45f5b579cb",
            id: "8784848c-399f-424b-badb-643fa8246239",
            kickOffTime: "2020-01-01T12:31:17.046Z",
          },
          "f1234b3d-c3d8-4886-9614-961aca77ebbb": {
            awayTeamId: "1d97c20b-b36c-4307-b227-f11de588c955",
            goalsAway: 0,
            goalsHome: 2,
            homeTeamId: "14a47cb1-f497-4d71-879b-b7e82c85e804",
            id: "f1234b3d-c3d8-4886-9614-961aca77ebbb",
            kickOffTime: "2020-01-02T20:01:00.739Z",
          },
          "f64417ef-c189-4784-88b6-31401ea661b2": {
            awayTeamId: "3d8b2af7-a43f-43a1-9fcb-0b9c7c9b8fad",
            goalsAway: 1,
            goalsHome: 1,
            homeTeamId: "4f30eb3c-4f9d-4506-a62f-e6021429e6de",
            id: "f64417ef-c189-4784-88b6-31401ea661b2",
            kickOffTime: "2020-01-01T17:31:02.741Z",
          },
          "fbfb49fa-c7bc-48c6-8ae9-0605e50dd6a1": {
            awayTeamId: "91c704f0-77ac-4898-a8bd-9539c66ef301",
            goalsAway: 1,
            goalsHome: 2,
            homeTeamId: "4303d6fc-7c8d-4f19-aab7-37e4c64195cf",
            id: "fbfb49fa-c7bc-48c6-8ae9-0605e50dd6a1",
            kickOffTime: "2020-01-01T17:31:02.741Z",
          },
        },
        id: "231fc3c4-bf51-4b60-ae6f-7376c1fc367a",
        matchday: 21,
        startDate: "",
      },
      {
        endDate: "",
        fixtures: {
          "34869817-ae0a-4b46-9f59-b615dd0ae442": {
            awayTeamId: "906ce93b-8e71-409c-b459-4259fd3d35ad",
            goalsAway: 0,
            goalsHome: 3,
            homeTeamId: "f9c15363-34ad-4156-a273-12ec0f212df6",
            id: "34869817-ae0a-4b46-9f59-b615dd0ae442",
            kickOffTime: "2020-01-11T15:01:03.175Z",
          },
          "6ea139d6-31a0-4471-8a26-124cb6178a4b": {
            awayTeamId: "479aa6bf-67ec-4320-a1dc-2d5b77c2f1a4",
            goalsAway: 3,
            goalsHome: 0,
            homeTeamId: "79ee152d-e7ee-4511-8d8f-f1632d7570ec",
            id: "6ea139d6-31a0-4471-8a26-124cb6178a4b",
            kickOffTime: "2020-01-12T14:01:01.687Z",
          },
          "7b2fec07-8b2f-4082-87c3-f5dc8da86e13": {
            awayTeamId: "4e34107f-ccd8-4c94-a04f-5eb8d8637533",
            goalsAway: 0,
            goalsHome: 1,
            homeTeamId: "1d97c20b-b36c-4307-b227-f11de588c955",
            id: "7b2fec07-8b2f-4082-87c3-f5dc8da86e13",
            kickOffTime: "2020-01-10T21:01:08.721Z",
          },
          "92ce121a-9062-470a-a54b-364120118ea4": {
            awayTeamId: "5696bf7b-3256-4937-9d6d-952da49ddee9",
            goalsAway: 1,
            goalsHome: 1,
            homeTeamId: "3d8b2af7-a43f-43a1-9fcb-0b9c7c9b8fad",
            id: "92ce121a-9062-470a-a54b-364120118ea4",
            kickOffTime: "2020-01-11T12:31:02.886Z",
          },
          "9549d6be-2ab3-4f02-a5d1-48e8ee66cc33": {
            awayTeamId: "432b8777-b474-4ff9-bdd0-7dc41bd24e80",
            goalsAway: 2,
            goalsHome: 1,
            homeTeamId: "053980d1-9205-4f90-b581-a403851c32e0",
            id: "9549d6be-2ab3-4f02-a5d1-48e8ee66cc33",
            kickOffTime: "2020-01-11T15:01:03.175Z",
          },
          "a8f5dd13-3066-4855-b6ba-613b0a15185f": {
            awayTeamId: "4f30eb3c-4f9d-4506-a62f-e6021429e6de",
            goalsAway: 0,
            goalsHome: 4,
            homeTeamId: "f29e61a2-23f0-462b-b9c7-420b09fec5d9",
            id: "a8f5dd13-3066-4855-b6ba-613b0a15185f",
            kickOffTime: "2020-01-11T15:01:03.174Z",
          },
          "d38451de-4b90-419a-a701-c99f23e0221e": {
            awayTeamId: "8368521e-502a-4302-86d3-cf728550d1bd",
            goalsAway: 1,
            goalsHome: 1,
            homeTeamId: "9ad2bac0-8e7e-44cf-924e-75add32d8e5d",
            id: "d38451de-4b90-419a-a701-c99f23e0221e",
            kickOffTime: "2020-01-11T15:01:03.174Z",
          },
          "d8948d5f-1211-4146-b88e-2a5cdf6e4989": {
            awayTeamId: "4303d6fc-7c8d-4f19-aab7-37e4c64195cf",
            goalsAway: 6,
            goalsHome: 1,
            homeTeamId: "8ecf419b-9fde-46e5-960b-9c5f7f14dc3d",
            id: "d8948d5f-1211-4146-b88e-2a5cdf6e4989",
            kickOffTime: "2020-01-12T16:31:01.977Z",
          },
          "ea1ea6f8-ecdd-4af8-a28d-49b58042b8f6": {
            awayTeamId: "14a47cb1-f497-4d71-879b-b7e82c85e804",
            goalsAway: 1,
            goalsHome: 0,
            homeTeamId: "18de8ce2-736d-4c83-b4db-c473f1a03101",
            id: "ea1ea6f8-ecdd-4af8-a28d-49b58042b8f6",
            kickOffTime: "2020-01-11T17:31:06.493Z",
          },
          "ec4ef38d-6eb7-479d-b3b4-5a091a2e4c8e": {
            awayTeamId: "e96fbd1c-bbd5-4d69-a7c7-2e45f5b579cb",
            goalsAway: 0,
            goalsHome: 1,
            homeTeamId: "91c704f0-77ac-4898-a8bd-9539c66ef301",
            id: "ec4ef38d-6eb7-479d-b3b4-5a091a2e4c8e",
            kickOffTime: "2020-01-11T15:01:03.175Z",
          },
        },
        id: "2ae1098a-7269-4dd4-b2b2-72fda9400421",
        matchday: 22,
        startDate: "",
      },
      {
        endDate: "",
        fixtures: {
          "16ba9d2d-c1e4-405f-9105-e2fcb273f8fa": {
            awayTeamId: "3d8b2af7-a43f-43a1-9fcb-0b9c7c9b8fad",
            goalsAway: 2,
            goalsHome: 2,
            homeTeamId: "4303d6fc-7c8d-4f19-aab7-37e4c64195cf",
            id: "16ba9d2d-c1e4-405f-9105-e2fcb273f8fa",
            kickOffTime: "2020-01-18T15:01:06.145Z",
          },
          "64189a18-3735-4e51-bc21-0946569702a5": {
            awayTeamId: "79ee152d-e7ee-4511-8d8f-f1632d7570ec",
            goalsAway: 0,
            goalsHome: 1,
            homeTeamId: "4f30eb3c-4f9d-4506-a62f-e6021429e6de",
            id: "64189a18-3735-4e51-bc21-0946569702a5",
            kickOffTime: "2020-01-18T15:01:06.145Z",
          },
          "81f8a18f-ba2c-4100-aed3-0b7a139180ff": {
            awayTeamId: "18de8ce2-736d-4c83-b4db-c473f1a03101",
            goalsAway: 0,
            goalsHome: 0,
            homeTeamId: "479aa6bf-67ec-4320-a1dc-2d5b77c2f1a4",
            id: "81f8a18f-ba2c-4100-aed3-0b7a139180ff",
            kickOffTime: "2020-01-18T12:31:03.544Z",
          },
          "877f3095-4518-4124-ae29-c54958dd0c08": {
            awayTeamId: "053980d1-9205-4f90-b581-a403851c32e0",
            goalsAway: 1,
            goalsHome: 2,
            homeTeamId: "906ce93b-8e71-409c-b459-4259fd3d35ad",
            id: "877f3095-4518-4124-ae29-c54958dd0c08",
            kickOffTime: "2020-01-19T14:01:02.543Z",
          },
          "8f80c7e5-9c39-4600-a562-c9b55348365f": {
            awayTeamId: "91c704f0-77ac-4898-a8bd-9539c66ef301",
            goalsAway: 1,
            goalsHome: 1,
            homeTeamId: "4e34107f-ccd8-4c94-a04f-5eb8d8637533",
            id: "8f80c7e5-9c39-4600-a562-c9b55348365f",
            kickOffTime: "2020-01-18T15:01:06.143Z",
          },
          "9f1eaadc-65b8-4eec-8618-da81103b74ec": {
            awayTeamId: "1d97c20b-b36c-4307-b227-f11de588c955",
            goalsAway: 1,
            goalsHome: 1,
            homeTeamId: "5696bf7b-3256-4937-9d6d-952da49ddee9",
            id: "9f1eaadc-65b8-4eec-8618-da81103b74ec",
            kickOffTime: "2020-01-18T15:01:06.145Z",
          },
          "cae25a26-63a7-4e8b-be9c-dd46979f2107": {
            awayTeamId: "9ad2bac0-8e7e-44cf-924e-75add32d8e5d",
            goalsAway: 3,
            goalsHome: 2,
            homeTeamId: "432b8777-b474-4ff9-bdd0-7dc41bd24e80",
            id: "cae25a26-63a7-4e8b-be9c-dd46979f2107",
            kickOffTime: "2020-01-18T15:01:06.144Z",
          },
          "ee7ba5f6-c172-4117-b497-1311127a75b8": {
            awayTeamId: "8ecf419b-9fde-46e5-960b-9c5f7f14dc3d",
            goalsAway: 1,
            goalsHome: 1,
            homeTeamId: "e96fbd1c-bbd5-4d69-a7c7-2e45f5b579cb",
            id: "ee7ba5f6-c172-4117-b497-1311127a75b8",
            kickOffTime: "2020-01-18T15:01:06.145Z",
          },
          "f36d91b3-4c67-4565-8a13-4a3b7b35890a": {
            awayTeamId: "f29e61a2-23f0-462b-b9c7-420b09fec5d9",
            goalsAway: 0,
            goalsHome: 2,
            homeTeamId: "14a47cb1-f497-4d71-879b-b7e82c85e804",
            id: "f36d91b3-4c67-4565-8a13-4a3b7b35890a",
            kickOffTime: "2020-01-19T16:31:03.639Z",
          },
          "fc78459f-cfa7-4809-bbe8-e10250bd4303": {
            awayTeamId: "f9c15363-34ad-4156-a273-12ec0f212df6",
            goalsAway: 0,
            goalsHome: 1,
            homeTeamId: "8368521e-502a-4302-86d3-cf728550d1bd",
            id: "fc78459f-cfa7-4809-bbe8-e10250bd4303",
            kickOffTime: "2020-01-18T17:31:06.847Z",
          },
        },
        id: "e503cf20-5af6-456d-8f2f-6324ff7161b2",
        matchday: 23,
        startDate: "",
      },
      {
        endDate: "",
        fixtures: {
          "222397a0-9b60-454f-b132-35823b73e37c": {
            awayTeamId: "8368521e-502a-4302-86d3-cf728550d1bd",
            goalsAway: 2,
            goalsHome: 2,
            homeTeamId: "91c704f0-77ac-4898-a8bd-9539c66ef301",
            id: "222397a0-9b60-454f-b132-35823b73e37c",
            kickOffTime: "2020-01-21T19:30:58.616Z",
          },
          "397b2323-e825-4618-887d-8172a594c887": {
            awayTeamId: "479aa6bf-67ec-4320-a1dc-2d5b77c2f1a4",
            goalsAway: 1,
            goalsHome: 2,
            homeTeamId: "8ecf419b-9fde-46e5-960b-9c5f7f14dc3d",
            id: "397b2323-e825-4618-887d-8172a594c887",
            kickOffTime: "2020-01-21T19:30:58.615Z",
          },
          "72859743-37ef-46c9-ac08-cac9ecdc0334": {
            awayTeamId: "14a47cb1-f497-4d71-879b-b7e82c85e804",
            goalsAway: 2,
            goalsHome: 1,
            homeTeamId: "9ad2bac0-8e7e-44cf-924e-75add32d8e5d",
            id: "72859743-37ef-46c9-ac08-cac9ecdc0334",
            kickOffTime: "2020-01-23T20:00:58.121Z",
          },
          "7b3daf34-6d93-4aa6-9156-67b902f45964": {
            awayTeamId: "906ce93b-8e71-409c-b459-4259fd3d35ad",
            goalsAway: 2,
            goalsHome: 0,
            homeTeamId: "f29e61a2-23f0-462b-b9c7-420b09fec5d9",
            id: "7b3daf34-6d93-4aa6-9156-67b902f45964",
            kickOffTime: "2020-01-22T20:16:00.046Z",
          },
          "a991eb32-ec47-4004-af8b-3dded3c2c478": {
            awayTeamId: "4f30eb3c-4f9d-4506-a62f-e6021429e6de",
            goalsAway: 1,
            goalsHome: 2,
            homeTeamId: "18de8ce2-736d-4c83-b4db-c473f1a03101",
            id: "a991eb32-ec47-4004-af8b-3dded3c2c478",
            kickOffTime: "2020-01-22T19:30:57.365Z",
          },
          "aaf1cbfb-fcfe-499a-9c61-f9c59cfcf0f8": {
            awayTeamId: "432b8777-b474-4ff9-bdd0-7dc41bd24e80",
            goalsAway: 2,
            goalsHome: 0,
            homeTeamId: "3d8b2af7-a43f-43a1-9fcb-0b9c7c9b8fad",
            id: "aaf1cbfb-fcfe-499a-9c61-f9c59cfcf0f8",
            kickOffTime: "2020-01-21T20:00:59.215Z",
          },
          "ac1c0886-a8d1-4691-83f5-dd81675fc286": {
            awayTeamId: "e96fbd1c-bbd5-4d69-a7c7-2e45f5b579cb",
            goalsAway: 1,
            goalsHome: 3,
            homeTeamId: "79ee152d-e7ee-4511-8d8f-f1632d7570ec",
            id: "ac1c0886-a8d1-4691-83f5-dd81675fc286",
            kickOffTime: "2020-01-21T19:30:58.615Z",
          },
          "b44c4e9d-06aa-402c-b2d5-a9b06ca0a94f": {
            awayTeamId: "4e34107f-ccd8-4c94-a04f-5eb8d8637533",
            goalsAway: 1,
            goalsHome: 4,
            homeTeamId: "053980d1-9205-4f90-b581-a403851c32e0",
            id: "b44c4e9d-06aa-402c-b2d5-a9b06ca0a94f",
            kickOffTime: "2020-01-22T19:30:57.364Z",
          },
          "c13e2af2-f986-400c-b888-aba92aecfda7": {
            awayTeamId: "4303d6fc-7c8d-4f19-aab7-37e4c64195cf",
            goalsAway: 1,
            goalsHome: 0,
            homeTeamId: "1d97c20b-b36c-4307-b227-f11de588c955",
            id: "c13e2af2-f986-400c-b888-aba92aecfda7",
            kickOffTime: "2020-01-21T19:30:58.518Z",
          },
          "e1b32eba-9246-4d71-b333-fae3c9197eff": {
            awayTeamId: "5696bf7b-3256-4937-9d6d-952da49ddee9",
            goalsAway: 2,
            goalsHome: 2,
            homeTeamId: "f9c15363-34ad-4156-a273-12ec0f212df6",
            kickOffTime: "2020-01-21T20:15:00.000Z",
          },
        },
        id: "bb557ca4-c0d7-48cf-8c5a-b61b88732a52",
        matchday: 24,
        startDate: "",
      },
      {
        endDate: "",
        fixtures: {
          "01c12d67-fce8-43fa-9b3e-4a3b5641137d": {
            awayTeamId: "5696bf7b-3256-4937-9d6d-952da49ddee9",
            goalsAway: 0,
            goalsHome: 0,
            homeTeamId: "906ce93b-8e71-409c-b459-4259fd3d35ad",
            id: "01c12d67-fce8-43fa-9b3e-4a3b5641137d",
            kickOffTime: "2020-02-02T14:01:01.547Z",
          },
          "09eb3275-dda5-44f8-918d-5163209dde30": {
            awayTeamId: "432b8777-b474-4ff9-bdd0-7dc41bd24e80",
            goalsAway: 0,
            goalsHome: 4,
            homeTeamId: "14a47cb1-f497-4d71-879b-b7e82c85e804",
            id: "09eb3275-dda5-44f8-918d-5163209dde30",
            kickOffTime: "2020-02-01T15:01:06.105Z",
          },
          "28f9deba-1f59-4c45-b2af-7105fe165f41": {
            awayTeamId: "9ad2bac0-8e7e-44cf-924e-75add32d8e5d",
            goalsAway: 0,
            goalsHome: 0,
            homeTeamId: "f29e61a2-23f0-462b-b9c7-420b09fec5d9",
            id: "28f9deba-1f59-4c45-b2af-7105fe165f41",
            kickOffTime: "2020-02-01T17:31:12.802Z",
          },
          "2a5a0a9b-60f8-43bd-811f-018655988ffe": {
            awayTeamId: "91c704f0-77ac-4898-a8bd-9539c66ef301",
            goalsAway: 3,
            goalsHome: 2,
            homeTeamId: "479aa6bf-67ec-4320-a1dc-2d5b77c2f1a4",
            id: "2a5a0a9b-60f8-43bd-811f-018655988ffe",
            kickOffTime: "2020-02-01T15:01:06.106Z",
          },
          "4d982574-e7a2-4e4e-85b6-ec06f6eb0185": {
            awayTeamId: "4303d6fc-7c8d-4f19-aab7-37e4c64195cf",
            goalsAway: 0,
            goalsHome: 2,
            homeTeamId: "18de8ce2-736d-4c83-b4db-c473f1a03101",
            id: "4d982574-e7a2-4e4e-85b6-ec06f6eb0185",
            kickOffTime: "2020-02-02T16:31:02.547Z",
          },
          "829bac0a-e204-4a20-bfcd-7f1fe02ead3f": {
            awayTeamId: "1d97c20b-b36c-4307-b227-f11de588c955",
            goalsAway: 1,
            goalsHome: 0,
            homeTeamId: "3d8b2af7-a43f-43a1-9fcb-0b9c7c9b8fad",
            id: "829bac0a-e204-4a20-bfcd-7f1fe02ead3f",
            kickOffTime: "2020-02-01T15:01:06.107Z",
          },
          "a58a840b-9ee0-4bab-9010-d28bd83f8b6b": {
            awayTeamId: "8ecf419b-9fde-46e5-960b-9c5f7f14dc3d",
            goalsAway: 1,
            goalsHome: 2,
            homeTeamId: "79ee152d-e7ee-4511-8d8f-f1632d7570ec",
            id: "a58a840b-9ee0-4bab-9010-d28bd83f8b6b",
            kickOffTime: "2020-02-01T15:01:06.105Z",
          },
          "c15780a5-e412-46cc-8a7d-98de536fcc6c": {
            awayTeamId: "f9c15363-34ad-4156-a273-12ec0f212df6",
            goalsAway: 2,
            goalsHome: 2,
            homeTeamId: "053980d1-9205-4f90-b581-a403851c32e0",
            id: "c15780a5-e412-46cc-8a7d-98de536fcc6c",
            kickOffTime: "2020-02-01T12:31:00.322Z",
          },
          "c6dd6e0b-a231-4c38-a03d-8f926e76bc7e": {
            awayTeamId: "e96fbd1c-bbd5-4d69-a7c7-2e45f5b579cb",
            goalsAway: 3,
            goalsHome: 3,
            homeTeamId: "4e34107f-ccd8-4c94-a04f-5eb8d8637533",
            id: "c6dd6e0b-a231-4c38-a03d-8f926e76bc7e",
            kickOffTime: "2020-02-01T15:01:06.106Z",
          },
          "eb946ab8-43c8-43e8-b85d-c17055ea6759": {
            awayTeamId: "4f30eb3c-4f9d-4506-a62f-e6021429e6de",
            goalsAway: 0,
            goalsHome: 0,
            homeTeamId: "8368521e-502a-4302-86d3-cf728550d1bd",
            id: "eb946ab8-43c8-43e8-b85d-c17055ea6759",
            kickOffTime: "2020-02-01T15:01:06.106Z",
          },
        },
        id: "d57e119f-b3a1-403a-8246-68d2623205aa",
        matchday: 25,
        startDate: "",
      },
      {
        endDate: "",
        fixtures: {
          "14c81ed2-52ea-4e62-89e1-af96e8d7a053": {
            awayTeamId: "18de8ce2-736d-4c83-b4db-c473f1a03101",
            goalsAway: 3,
            goalsHome: 2,
            homeTeamId: "8ecf419b-9fde-46e5-960b-9c5f7f14dc3d",
            id: "14c81ed2-52ea-4e62-89e1-af96e8d7a053",
            kickOffTime: "2020-02-16T14:01:06.802Z",
          },
          "1918ae57-4ed5-437e-825d-a8b51354d8ba": {
            awayTeamId: "79ee152d-e7ee-4511-8d8f-f1632d7570ec",
            goalsAway: 1,
            goalsHome: 2,
            homeTeamId: "1d97c20b-b36c-4307-b227-f11de588c955",
            id: "1918ae57-4ed5-437e-825d-a8b51354d8ba",
            kickOffTime: "2020-02-09T14:00:57.056Z",
          },
          "44a05ad6-4185-4dfe-8732-71e4305ea104": {
            awayTeamId: "479aa6bf-67ec-4320-a1dc-2d5b77c2f1a4",
            goalsAway: 1,
            goalsHome: 1,
            homeTeamId: "e96fbd1c-bbd5-4d69-a7c7-2e45f5b579cb",
            id: "44a05ad6-4185-4dfe-8732-71e4305ea104",
            kickOffTime: "2020-02-08T17:31:03.361Z",
          },
          "4e466175-09e8-4cda-846b-eada941a124a": {
            awayTeamId: "f29e61a2-23f0-462b-b9c7-420b09fec5d9",
            goalsAway: 2,
            goalsHome: 0,
            homeTeamId: "f9c15363-34ad-4156-a273-12ec0f212df6",
            id: "4e466175-09e8-4cda-846b-eada941a124a",
            kickOffTime: "2020-02-17T20:00:57.522Z",
          },
          "5b94cded-9c83-496f-ac5b-8950258f8a60": {
            awayTeamId: "14a47cb1-f497-4d71-879b-b7e82c85e804",
            goalsAway: 1,
            goalsHome: 0,
            homeTeamId: "4f30eb3c-4f9d-4506-a62f-e6021429e6de",
            id: "5b94cded-9c83-496f-ac5b-8950258f8a60",
            kickOffTime: "2020-02-15T17:31:03.902Z",
          },
          "84ae1848-7b7b-4614-9878-2210290479a7": {
            awayTeamId: "906ce93b-8e71-409c-b459-4259fd3d35ad",
            goalsAway: 2,
            goalsHome: 1,
            homeTeamId: "432b8777-b474-4ff9-bdd0-7dc41bd24e80",
            id: "84ae1848-7b7b-4614-9878-2210290479a7",
            kickOffTime: "2020-02-15T12:31:03.499Z",
          },
          "96ee1b94-ae1a-4611-86a4-77fe728f4705": {
            awayTeamId: "8368521e-502a-4302-86d3-cf728550d1bd",
            goalsAway: 0,
            goalsHome: 4,
            homeTeamId: "5696bf7b-3256-4937-9d6d-952da49ddee9",
            id: "96ee1b94-ae1a-4611-86a4-77fe728f4705",
            kickOffTime: "2020-02-16T16:31:08.416Z",
          },
          "b8607b60-6cef-4c9f-8a78-0f4328f4812b": {
            awayTeamId: "053980d1-9205-4f90-b581-a403851c32e0",
            goalsAway: 0,
            goalsHome: 0,
            homeTeamId: "9ad2bac0-8e7e-44cf-924e-75add32d8e5d",
            id: "b8607b60-6cef-4c9f-8a78-0f4328f4812b",
            kickOffTime: "2020-02-14T20:00:58.455Z",
          },
          "b9af2f09-09c4-43f6-a2d8-db4317f4fc3b": {
            awayTeamId: "3d8b2af7-a43f-43a1-9fcb-0b9c7c9b8fad",
            goalsAway: 1,
            goalsHome: 3,
            homeTeamId: "91c704f0-77ac-4898-a8bd-9539c66ef301",
            id: "b9af2f09-09c4-43f6-a2d8-db4317f4fc3b",
            kickOffTime: "2020-02-08T12:31:05.223Z",
          },
          "e2c80319-2c1a-45fa-9ea5-3a258d102f03": {
            awayTeamId: "4e34107f-ccd8-4c94-a04f-5eb8d8637533",
            goalsAway: 0,
            goalsHome: 2,
            homeTeamId: "4303d6fc-7c8d-4f19-aab7-37e4c64195cf",
            id: "e2c80319-2c1a-45fa-9ea5-3a258d102f03",
            kickOffTime: "2020-02-19T20:00:52.511Z",
          },
        },
        id: "5419e8d6-86a8-470c-b323-ba78b931062d",
        matchday: 26,
        startDate: "",
      },
      {
        endDate: "",
        fixtures: {
          "009f03b1-9be5-4ad0-b1cd-b3a3ba581804": {
            awayTeamId: "79ee152d-e7ee-4511-8d8f-f1632d7570ec",
            goalsAway: 0,
            goalsHome: 3,
            homeTeamId: "906ce93b-8e71-409c-b459-4259fd3d35ad",
            id: "009f03b1-9be5-4ad0-b1cd-b3a3ba581804",
            kickOffTime: "2020-02-22T15:00:56.497Z",
          },
          "19af9b4f-d1de-495c-8684-b407bcd31f27": {
            awayTeamId: "4303d6fc-7c8d-4f19-aab7-37e4c64195cf",
            goalsAway: 1,
            goalsHome: 0,
            homeTeamId: "053980d1-9205-4f90-b581-a403851c32e0",
            id: "19af9b4f-d1de-495c-8684-b407bcd31f27",
            kickOffTime: "2020-02-22T17:30:58.656Z",
          },
          "21ebb812-88fd-412e-8407-1ae1537cd751": {
            awayTeamId: "18de8ce2-736d-4c83-b4db-c473f1a03101",
            goalsAway: 1,
            goalsHome: 2,
            homeTeamId: "f9c15363-34ad-4156-a273-12ec0f212df6",
            id: "21ebb812-88fd-412e-8407-1ae1537cd751",
            kickOffTime: "2020-02-22T12:30:55.558Z",
          },
          "35c7c078-4d36-4891-8d98-2237a8aeb0fe": {
            awayTeamId: "8368521e-502a-4302-86d3-cf728550d1bd",
            goalsAway: 0,
            goalsHome: 1,
            homeTeamId: "3d8b2af7-a43f-43a1-9fcb-0b9c7c9b8fad",
            id: "35c7c078-4d36-4891-8d98-2237a8aeb0fe",
            kickOffTime: "2020-02-22T15:00:56.496Z",
          },
          "6e2e2352-d633-40da-8b80-7550eacee409": {
            awayTeamId: "4e34107f-ccd8-4c94-a04f-5eb8d8637533",
            goalsAway: 2,
            goalsHome: 3,
            homeTeamId: "14a47cb1-f497-4d71-879b-b7e82c85e804",
            id: "6e2e2352-d633-40da-8b80-7550eacee409",
            kickOffTime: "2020-02-24T20:30:56.921Z",
          },
          "7e869e33-6a0c-4b4c-b765-5d1590591700": {
            awayTeamId: "e96fbd1c-bbd5-4d69-a7c7-2e45f5b579cb",
            goalsAway: 1,
            goalsHome: 1,
            homeTeamId: "1d97c20b-b36c-4307-b227-f11de588c955",
            id: "7e869e33-6a0c-4b4c-b765-5d1590591700",
            kickOffTime: "2020-02-22T15:00:56.496Z",
          },
          "80d979eb-dd8c-476d-8ee9-d43dcde16ca9": {
            awayTeamId: "4f30eb3c-4f9d-4506-a62f-e6021429e6de",
            goalsAway: 0,
            goalsHome: 3,
            homeTeamId: "9ad2bac0-8e7e-44cf-924e-75add32d8e5d",
            id: "80d979eb-dd8c-476d-8ee9-d43dcde16ca9",
            kickOffTime: "2020-02-23T14:00:58.048Z",
          },
          "968d57a8-a3ba-499d-8c01-e45ccc7ec156": {
            awayTeamId: "8ecf419b-9fde-46e5-960b-9c5f7f14dc3d",
            goalsAway: 0,
            goalsHome: 2,
            homeTeamId: "432b8777-b474-4ff9-bdd0-7dc41bd24e80",
            id: "968d57a8-a3ba-499d-8c01-e45ccc7ec156",
            kickOffTime: "2020-02-22T15:00:56.497Z",
          },
          "a181539a-2918-4168-ac2d-609df3fa537c": {
            awayTeamId: "91c704f0-77ac-4898-a8bd-9539c66ef301",
            goalsAway: 2,
            goalsHome: 3,
            homeTeamId: "5696bf7b-3256-4937-9d6d-952da49ddee9",
            id: "a181539a-2918-4168-ac2d-609df3fa537c",
            kickOffTime: "2020-02-23T17:30:57.312Z",
          },
          "de67011d-a349-4de8-8514-0aff1b24625c": {
            awayTeamId: "479aa6bf-67ec-4320-a1dc-2d5b77c2f1a4",
            goalsAway: 0,
            goalsHome: 3,
            homeTeamId: "f29e61a2-23f0-462b-b9c7-420b09fec5d9",
            id: "de67011d-a349-4de8-8514-0aff1b24625c",
            kickOffTime: "2020-02-23T14:00:58.048Z",
          },
        },
        id: "f669db2f-de53-41d5-81c3-330129dc3bfd",
        matchday: 27,
        startDate: "",
      },
      {
        endDate: "",
        fixtures: {
          "08d8fcec-880f-497e-a505-cf183299c084": {
            awayTeamId: "14a47cb1-f497-4d71-879b-b7e82c85e804",
            goalsAway: 0,
            goalsHome: 3,
            homeTeamId: "479aa6bf-67ec-4320-a1dc-2d5b77c2f1a4",
            id: "08d8fcec-880f-497e-a505-cf183299c084",
            kickOffTime: "2020-02-29T17:31:06.121Z",
          },
          "1d5b1e2a-54d6-4017-8e63-dcf58dd5f212": {
            awayTeamId: "f9c15363-34ad-4156-a273-12ec0f212df6",
            goalsAway: 2,
            goalsHome: 2,
            homeTeamId: "79ee152d-e7ee-4511-8d8f-f1632d7570ec",
            id: "1d5b1e2a-54d6-4017-8e63-dcf58dd5f212",
            kickOffTime: "2020-02-29T15:01:10.902Z",
          },
          "34d77b7b-5d64-4c29-81a5-5303938ce888": {
            awayTeamId: "906ce93b-8e71-409c-b459-4259fd3d35ad",
            goalsAway: 0,
            goalsHome: 0,
            homeTeamId: "8368521e-502a-4302-86d3-cf728550d1bd",
            id: "34d77b7b-5d64-4c29-81a5-5303938ce888",
            kickOffTime: "2020-02-29T15:01:10.902Z",
          },
          "48cdb52c-e046-44a5-87fd-44e20a4682d1": {
            awayTeamId: "f29e61a2-23f0-462b-b9c7-420b09fec5d9",
            goalsAway: 1,
            goalsHome: 1,
            homeTeamId: "91c704f0-77ac-4898-a8bd-9539c66ef301",
            id: "48cdb52c-e046-44a5-87fd-44e20a4682d1",
            kickOffTime: "2020-03-01T14:01:02.053Z",
          },
          "7678efd5-9843-4bbc-a986-270ae46a4b36": {
            awayTeamId: "3d8b2af7-a43f-43a1-9fcb-0b9c7c9b8fad",
            goalsAway: 1,
            goalsHome: 0,
            homeTeamId: "e96fbd1c-bbd5-4d69-a7c7-2e45f5b579cb",
            id: "7678efd5-9843-4bbc-a986-270ae46a4b36",
            kickOffTime: "2020-02-29T12:31:01.690Z",
          },
          "7d44ce22-1e28-4ff3-8a98-f41186294a42": {
            awayTeamId: "053980d1-9205-4f90-b581-a403851c32e0",
            goalsAway: 0,
            goalsHome: 1,
            homeTeamId: "4f30eb3c-4f9d-4506-a62f-e6021429e6de",
            id: "7d44ce22-1e28-4ff3-8a98-f41186294a42",
            kickOffTime: "2020-02-28T20:00:58.696Z",
          },
          "be978f46-89ca-4e91-b5a0-6b3cd568aef2": {
            awayTeamId: "9ad2bac0-8e7e-44cf-924e-75add32d8e5d",
            goalsAway: 3,
            goalsHome: 2,
            homeTeamId: "18de8ce2-736d-4c83-b4db-c473f1a03101",
            id: "be978f46-89ca-4e91-b5a0-6b3cd568aef2",
            kickOffTime: "2020-03-01T14:01:02.053Z",
          },
          "bea53ebf-04be-47bf-a84d-b04dc61dd816": {
            awayTeamId: "1d97c20b-b36c-4307-b227-f11de588c955",
            goalsAway: 0,
            goalsHome: 0,
            homeTeamId: "8ecf419b-9fde-46e5-960b-9c5f7f14dc3d",
            id: "bea53ebf-04be-47bf-a84d-b04dc61dd816",
            kickOffTime: "2020-06-17T17:00:22.019Z",
          },
          "d48aa5aa-830a-4c06-b9e2-6e1f21c083e9": {
            awayTeamId: "432b8777-b474-4ff9-bdd0-7dc41bd24e80",
            goalsAway: 1,
            goalsHome: 3,
            homeTeamId: "4e34107f-ccd8-4c94-a04f-5eb8d8637533",
            id: "d48aa5aa-830a-4c06-b9e2-6e1f21c083e9",
            kickOffTime: "2020-02-29T15:01:10.902Z",
          },
          "f98c15c7-aa9e-42c2-aeb3-999b521fe959": {
            awayTeamId: "5696bf7b-3256-4937-9d6d-952da49ddee9",
            goalsAway: 0,
            goalsHome: 3,
            homeTeamId: "4303d6fc-7c8d-4f19-aab7-37e4c64195cf",
            id: "f98c15c7-aa9e-42c2-aeb3-999b521fe959",
            kickOffTime: "2020-06-17T19:30:13.436Z",
          },
        },
        id: "8564ffe0-4388-466b-b848-0c2e43c2932f",
        matchday: 28,
        startDate: "",
      },
      {
        endDate: "",
        fixtures: {
          "1b4ed1ff-2b3b-459c-86f7-a602f48086c5": {
            awayTeamId: "4e34107f-ccd8-4c94-a04f-5eb8d8637533",
            goalsAway: 0,
            goalsHome: 1,
            homeTeamId: "5696bf7b-3256-4937-9d6d-952da49ddee9",
            id: "1b4ed1ff-2b3b-459c-86f7-a602f48086c5",
            kickOffTime: "2020-03-07T15:01:16.148Z",
          },
          "31c438cd-c44d-4215-bbbb-cb32d65783a0": {
            awayTeamId: "4303d6fc-7c8d-4f19-aab7-37e4c64195cf",
            goalsAway: 0,
            goalsHome: 2,
            homeTeamId: "f29e61a2-23f0-462b-b9c7-420b09fec5d9",
            id: "31c438cd-c44d-4215-bbbb-cb32d65783a0",
            kickOffTime: "2020-03-08T16:31:04.722Z",
          },
          "33d1a729-4940-41b7-97aa-974930cc9255": {
            awayTeamId: "18de8ce2-736d-4c83-b4db-c473f1a03101",
            goalsAway: 1,
            goalsHome: 1,
            homeTeamId: "906ce93b-8e71-409c-b459-4259fd3d35ad",
            id: "33d1a729-4940-41b7-97aa-974930cc9255",
            kickOffTime: "2020-03-07T17:31:05.637Z",
          },
          "460a44c9-2b40-4754-84d7-1c4ff9e4f8b2": {
            awayTeamId: "79ee152d-e7ee-4511-8d8f-f1632d7570ec",
            goalsAway: 1,
            goalsHome: 2,
            homeTeamId: "14a47cb1-f497-4d71-879b-b7e82c85e804",
            id: "460a44c9-2b40-4754-84d7-1c4ff9e4f8b2",
            kickOffTime: "2020-03-07T12:31:04.552Z",
          },
          "7130637d-0634-4d76-a5ab-b2de1da32290": {
            awayTeamId: "4f30eb3c-4f9d-4506-a62f-e6021429e6de",
            goalsAway: 0,
            goalsHome: 1,
            homeTeamId: "1d97c20b-b36c-4307-b227-f11de588c955",
            id: "7130637d-0634-4d76-a5ab-b2de1da32290",
            kickOffTime: "2020-03-07T15:01:16.148Z",
          },
          "9648f350-50e3-4c17-bc71-fd1aa5a889b9": {
            awayTeamId: "e96fbd1c-bbd5-4d69-a7c7-2e45f5b579cb",
            goalsAway: 0,
            goalsHome: 0,
            homeTeamId: "9ad2bac0-8e7e-44cf-924e-75add32d8e5d",
            id: "9648f350-50e3-4c17-bc71-fd1aa5a889b9",
            kickOffTime: "2020-03-07T15:01:16.149Z",
          },
          "c1c917ef-4400-405b-9e86-af47f16b8798": {
            awayTeamId: "8368521e-502a-4302-86d3-cf728550d1bd",
            goalsAway: 1,
            goalsHome: 0,
            homeTeamId: "432b8777-b474-4ff9-bdd0-7dc41bd24e80",
            id: "c1c917ef-4400-405b-9e86-af47f16b8798",
            kickOffTime: "2020-03-07T15:01:16.149Z",
          },
          "ecb85cdd-fc69-4c46-bc62-1305dec0cb36": {
            awayTeamId: "479aa6bf-67ec-4320-a1dc-2d5b77c2f1a4",
            goalsAway: 0,
            goalsHome: 1,
            homeTeamId: "3d8b2af7-a43f-43a1-9fcb-0b9c7c9b8fad",
            id: "ecb85cdd-fc69-4c46-bc62-1305dec0cb36",
            kickOffTime: "2020-03-07T15:01:16.148Z",
          },
          "effb0967-9b4f-4477-afc6-7c8bfb525ce6": {
            awayTeamId: "91c704f0-77ac-4898-a8bd-9539c66ef301",
            goalsAway: 0,
            goalsHome: 4,
            homeTeamId: "f9c15363-34ad-4156-a273-12ec0f212df6",
            id: "effb0967-9b4f-4477-afc6-7c8bfb525ce6",
            kickOffTime: "2020-03-08T14:01:02.121Z",
          },
          "f1e24314-9707-40df-ab08-7ad41d5bfccc": {
            awayTeamId: "8ecf419b-9fde-46e5-960b-9c5f7f14dc3d",
            goalsAway: 0,
            goalsHome: 4,
            homeTeamId: "053980d1-9205-4f90-b581-a403851c32e0",
            id: "f1e24314-9707-40df-ab08-7ad41d5bfccc",
            kickOffTime: "2020-03-09T20:00:58.827Z",
          },
        },
        id: "e9571fec-dbda-4dd5-b670-bc5f37870d76",
        matchday: 29,
        startDate: "",
      },
      {
        endDate: "",
        fixtures: {
          "2a963d62-3d40-446f-94ec-4476b98c2744": {
            awayTeamId: "432b8777-b474-4ff9-bdd0-7dc41bd24e80",
            goalsAway: 3,
            goalsHome: 0,
            homeTeamId: "4f30eb3c-4f9d-4506-a62f-e6021429e6de",
            id: "2a963d62-3d40-446f-94ec-4476b98c2744",
            kickOffTime: "2020-06-19T17:00:21.442Z",
          },
          "3ba68614-28ab-46e9-be73-bbd37cef1805": {
            awayTeamId: "14a47cb1-f497-4d71-879b-b7e82c85e804",
            goalsAway: 0,
            goalsHome: 0,
            homeTeamId: "91c704f0-77ac-4898-a8bd-9539c66ef301",
            id: "3ba68614-28ab-46e9-be73-bbd37cef1805",
            kickOffTime: "2020-06-21T18:00:20.025Z",
          },
          "6ec1fc34-8280-4e77-b1fc-0f48eb0bfb25": {
            awayTeamId: "f29e61a2-23f0-462b-b9c7-420b09fec5d9",
            goalsAway: 1,
            goalsHome: 1,
            homeTeamId: "18de8ce2-736d-4c83-b4db-c473f1a03101",
            id: "6ec1fc34-8280-4e77-b1fc-0f48eb0bfb25",
            kickOffTime: "2020-06-19T19:15:12.356Z",
          },
          "7245ae62-df95-4975-a0c0-5d1b38930a91": {
            awayTeamId: "9ad2bac0-8e7e-44cf-924e-75add32d8e5d",
            goalsAway: 2,
            goalsHome: 0,
            homeTeamId: "4e34107f-ccd8-4c94-a04f-5eb8d8637533",
            id: "7245ae62-df95-4975-a0c0-5d1b38930a91",
            kickOffTime: "2020-06-20T16:30:15.436Z",
          },
          "76becb16-bde1-4c01-b1e6-4b52bacc1b43": {
            awayTeamId: "053980d1-9205-4f90-b581-a403851c32e0",
            goalsAway: 1,
            goalsHome: 1,
            homeTeamId: "479aa6bf-67ec-4320-a1dc-2d5b77c2f1a4",
            id: "76becb16-bde1-4c01-b1e6-4b52bacc1b43",
            kickOffTime: "2020-06-20T11:30:16.818Z",
          },
          "8334ce49-f96c-44e3-8753-6a5a0e7f245e": {
            awayTeamId: "5696bf7b-3256-4937-9d6d-952da49ddee9",
            goalsAway: 1,
            goalsHome: 2,
            homeTeamId: "e96fbd1c-bbd5-4d69-a7c7-2e45f5b579cb",
            id: "8334ce49-f96c-44e3-8753-6a5a0e7f245e",
            kickOffTime: "2020-06-20T14:00:21.441Z",
          },
          "8c146d61-cc0d-410c-b2e5-96e11e9c2743": {
            awayTeamId: "1d97c20b-b36c-4307-b227-f11de588c955",
            goalsAway: 0,
            goalsHome: 3,
            homeTeamId: "8368521e-502a-4302-86d3-cf728550d1bd",
            id: "8c146d61-cc0d-410c-b2e5-96e11e9c2743",
            kickOffTime: "2020-06-21T13:00:16.517Z",
          },
          "bc9cad44-99bb-47e5-ba8c-928a1a9a09ab": {
            awayTeamId: "3d8b2af7-a43f-43a1-9fcb-0b9c7c9b8fad",
            goalsAway: 2,
            goalsHome: 0,
            homeTeamId: "79ee152d-e7ee-4511-8d8f-f1632d7570ec",
            id: "bc9cad44-99bb-47e5-ba8c-928a1a9a09ab",
            kickOffTime: "2020-06-20T18:45:17.252Z",
          },
          "c6d4f770-a370-4f43-a35c-7a3fe373df1f": {
            awayTeamId: "f9c15363-34ad-4156-a273-12ec0f212df6",
            goalsAway: 2,
            goalsHome: 1,
            homeTeamId: "8ecf419b-9fde-46e5-960b-9c5f7f14dc3d",
            id: "c6d4f770-a370-4f43-a35c-7a3fe373df1f",
            kickOffTime: "2020-06-21T15:15:19.240Z",
          },
          "eed8566f-0512-4cae-88a4-4582c51f8781": {
            awayTeamId: "906ce93b-8e71-409c-b459-4259fd3d35ad",
            goalsAway: 0,
            goalsHome: 5,
            homeTeamId: "4303d6fc-7c8d-4f19-aab7-37e4c64195cf",
            id: "eed8566f-0512-4cae-88a4-4582c51f8781",
            kickOffTime: "2020-06-22T19:00:12.811Z",
          },
        },
        id: "99696b7e-cfd2-49bb-8544-2efdac1cbb23",
        matchday: 30,
        startDate: "",
      },
      {
        endDate: "",
        fixtures: {
          "0ed01eb7-b2e4-4b2e-8036-f87f449def1b": {
            awayTeamId: "1d97c20b-b36c-4307-b227-f11de588c955",
            goalsAway: 0,
            goalsHome: 3,
            homeTeamId: "f29e61a2-23f0-462b-b9c7-420b09fec5d9",
            id: "0ed01eb7-b2e4-4b2e-8036-f87f449def1b",
            kickOffTime: "2020-06-24T17:00:17.553Z",
          },
          "1fe3b106-5948-4f46-93c9-6b59543211e8": {
            awayTeamId: "79ee152d-e7ee-4511-8d8f-f1632d7570ec",
            goalsAway: 0,
            goalsHome: 1,
            homeTeamId: "9ad2bac0-8e7e-44cf-924e-75add32d8e5d",
            id: "1fe3b106-5948-4f46-93c9-6b59543211e8",
            kickOffTime: "2020-06-24T17:00:17.553Z",
          },
          "98506405-9de6-4233-92d8-3c6fc5cd565b": {
            awayTeamId: "91c704f0-77ac-4898-a8bd-9539c66ef301",
            goalsAway: 1,
            goalsHome: 0,
            homeTeamId: "4f30eb3c-4f9d-4506-a62f-e6021429e6de",
            id: "98506405-9de6-4233-92d8-3c6fc5cd565b",
            kickOffTime: "2020-06-24T17:00:17.553Z",
          },
          "a209ef5f-6f9a-4b77-a002-d546e93330e6": {
            awayTeamId: "3d8b2af7-a43f-43a1-9fcb-0b9c7c9b8fad",
            goalsAway: 0,
            goalsHome: 4,
            homeTeamId: "14a47cb1-f497-4d71-879b-b7e82c85e804",
            id: "a209ef5f-6f9a-4b77-a002-d546e93330e6",
            kickOffTime: "2020-06-24T19:15:16.586Z",
          },
          "b7341f6f-8153-443f-9108-9aad7d6a4cd1": {
            awayTeamId: "e96fbd1c-bbd5-4d69-a7c7-2e45f5b579cb",
            goalsAway: 0,
            goalsHome: 0,
            homeTeamId: "053980d1-9205-4f90-b581-a403851c32e0",
            id: "b7341f6f-8153-443f-9108-9aad7d6a4cd1",
            kickOffTime: "2020-06-23T17:00:17.323Z",
          },
          "be1db807-d6fb-4f4e-bb49-3c642718d2c9": {
            awayTeamId: "4e34107f-ccd8-4c94-a04f-5eb8d8637533",
            goalsAway: 0,
            goalsHome: 2,
            homeTeamId: "18de8ce2-736d-4c83-b4db-c473f1a03101",
            id: "be1db807-d6fb-4f4e-bb49-3c642718d2c9",
            kickOffTime: "2020-06-23T19:15:15.673Z",
          },
          "c0eadd1c-2021-4f63-9b27-e1cbb853845c": {
            awayTeamId: "479aa6bf-67ec-4320-a1dc-2d5b77c2f1a4",
            goalsAway: 0,
            goalsHome: 1,
            homeTeamId: "906ce93b-8e71-409c-b459-4259fd3d35ad",
            id: "c0eadd1c-2021-4f63-9b27-e1cbb853845c",
            kickOffTime: "2020-06-25T17:30:11.106Z",
          },
          "c35f926d-a90c-435c-ae85-b3263ec0222d": {
            awayTeamId: "4303d6fc-7c8d-4f19-aab7-37e4c64195cf",
            goalsAway: 1,
            goalsHome: 2,
            homeTeamId: "f9c15363-34ad-4156-a273-12ec0f212df6",
            id: "c35f926d-a90c-435c-ae85-b3263ec0222d",
            kickOffTime: "2020-06-25T19:15:12.309Z",
          },
          "c8f42761-8642-4d44-987b-531491041649": {
            awayTeamId: "5696bf7b-3256-4937-9d6d-952da49ddee9",
            goalsAway: 2,
            goalsHome: 0,
            homeTeamId: "432b8777-b474-4ff9-bdd0-7dc41bd24e80",
            id: "c8f42761-8642-4d44-987b-531491041649",
            kickOffTime: "2020-06-25T17:30:11.107Z",
          },
          "df2887a9-4eea-44be-8a4c-574b812296ff": {
            awayTeamId: "8ecf419b-9fde-46e5-960b-9c5f7f14dc3d",
            goalsAway: 1,
            goalsHome: 1,
            homeTeamId: "8368521e-502a-4302-86d3-cf728550d1bd",
            id: "df2887a9-4eea-44be-8a4c-574b812296ff",
            kickOffTime: "2020-06-24T17:00:17.552Z",
          },
        },
        id: "a573d9ae-a6fa-4870-8984-6163731b3193",
        matchday: 31,
        startDate: "",
      },
      {
        endDate: "",
        fixtures: {
          "2055d573-b0cc-4b52-b98b-09f5c31d9d02": {
            awayTeamId: "906ce93b-8e71-409c-b459-4259fd3d35ad",
            goalsAway: 1,
            goalsHome: 0,
            homeTeamId: "3d8b2af7-a43f-43a1-9fcb-0b9c7c9b8fad",
            kickOffTime: "2020-06-29T20:00:00.000Z",
          },
          "36bab3c1-b7e9-4267-a565-f16eb7b229de": {
            awayTeamId: "f29e61a2-23f0-462b-b9c7-420b09fec5d9",
            goalsAway: 3,
            goalsHome: 0,
            homeTeamId: "e96fbd1c-bbd5-4d69-a7c7-2e45f5b579cb",
            id: "36bab3c1-b7e9-4267-a565-f16eb7b229de",
            kickOffTime: "2020-06-30T19:15:16.345Z",
          },
          "3c5dbe76-c158-4a8d-a515-bfd7e031b355": {
            awayTeamId: "053980d1-9205-4f90-b581-a403851c32e0",
            goalsAway: 1,
            goalsHome: 2,
            homeTeamId: "91c704f0-77ac-4898-a8bd-9539c66ef301",
            id: "3c5dbe76-c158-4a8d-a515-bfd7e031b355",
            kickOffTime: "2020-07-01T17:00:16.857Z",
          },
          "4f33770a-0235-4831-bece-3e1d151c0199": {
            awayTeamId: "18de8ce2-736d-4c83-b4db-c473f1a03101",
            goalsAway: 1,
            goalsHome: 3,
            homeTeamId: "1d97c20b-b36c-4307-b227-f11de588c955",
            id: "4f33770a-0235-4831-bece-3e1d151c0199",
            kickOffTime: "2020-07-02T17:00:18.804Z",
          },
          "523e4901-a1f3-4a70-af11-2724bfa8124b": {
            awayTeamId: "f9c15363-34ad-4156-a273-12ec0f212df6",
            goalsAway: 2,
            goalsHome: 3,
            homeTeamId: "4e34107f-ccd8-4c94-a04f-5eb8d8637533",
            id: "523e4901-a1f3-4a70-af11-2724bfa8124b",
            kickOffTime: "2020-07-01T19:15:16.319Z",
          },
          "713dc487-12bc-499b-a51d-bba4c8103931": {
            awayTeamId: "8368521e-502a-4302-86d3-cf728550d1bd",
            goalsAway: 4,
            goalsHome: 1,
            homeTeamId: "79ee152d-e7ee-4511-8d8f-f1632d7570ec",
            id: "713dc487-12bc-499b-a51d-bba4c8103931",
            kickOffTime: "2020-07-01T17:00:16.856Z",
          },
          "826e6821-55db-42f0-96f8-35928570e6d0": {
            awayTeamId: "14a47cb1-f497-4d71-879b-b7e82c85e804",
            goalsAway: 0,
            goalsHome: 4,
            homeTeamId: "4303d6fc-7c8d-4f19-aab7-37e4c64195cf",
            id: "826e6821-55db-42f0-96f8-35928570e6d0",
            kickOffTime: "2020-07-02T19:15:14.219Z",
          },
          "cd9b86af-8d3b-44ef-910b-e7d7da6b4e9e": {
            awayTeamId: "4f30eb3c-4f9d-4506-a62f-e6021429e6de",
            goalsAway: 0,
            goalsHome: 4,
            homeTeamId: "5696bf7b-3256-4937-9d6d-952da49ddee9",
            id: "cd9b86af-8d3b-44ef-910b-e7d7da6b4e9e",
            kickOffTime: "2020-07-01T17:00:16.855Z",
          },
          "e24395ea-8407-4bda-b81c-d0fadf604237": {
            awayTeamId: "432b8777-b474-4ff9-bdd0-7dc41bd24e80",
            goalsAway: 3,
            goalsHome: 1,
            homeTeamId: "479aa6bf-67ec-4320-a1dc-2d5b77c2f1a4",
            id: "e24395ea-8407-4bda-b81c-d0fadf604237",
            kickOffTime: "2020-06-28T15:30:16.751Z",
          },
          "eec1209d-509a-416d-9820-0f06716236cd": {
            awayTeamId: "9ad2bac0-8e7e-44cf-924e-75add32d8e5d",
            goalsAway: 1,
            goalsHome: 0,
            homeTeamId: "8ecf419b-9fde-46e5-960b-9c5f7f14dc3d",
            id: "eec1209d-509a-416d-9820-0f06716236cd",
            kickOffTime: "2020-06-27T11:45:17.526Z",
          },
        },
        id: "fb8839fa-28db-4858-bfcf-6b1ca31cdea5",
        matchday: 32,
        startDate: "",
      },
      {
        endDate: "",
        fixtures: {
          "19a03b38-f3b6-435b-9fc2-4953553c803c": {
            awayTeamId: "79ee152d-e7ee-4511-8d8f-f1632d7570ec",
            goalsAway: 2,
            goalsHome: 5,
            homeTeamId: "f29e61a2-23f0-462b-b9c7-420b09fec5d9",
            id: "19a03b38-f3b6-435b-9fc2-4953553c803c",
            kickOffTime: "2020-07-04T14:00:15.454Z",
          },
          "1fa4ab4f-a30f-446a-85a2-e7adc1add6fc": {
            awayTeamId: "3d8b2af7-a43f-43a1-9fcb-0b9c7c9b8fad",
            goalsAway: 0,
            goalsHome: 3,
            homeTeamId: "053980d1-9205-4f90-b581-a403851c32e0",
            id: "1fa4ab4f-a30f-446a-85a2-e7adc1add6fc",
            kickOffTime: "2020-07-04T14:00:15.454Z",
          },
          "2f028d98-780e-4686-9f1a-178cdc9df42a": {
            awayTeamId: "5696bf7b-3256-4937-9d6d-952da49ddee9",
            goalsAway: 2,
            goalsHome: 0,
            homeTeamId: "9ad2bac0-8e7e-44cf-924e-75add32d8e5d",
            id: "2f028d98-780e-4686-9f1a-178cdc9df42a",
            kickOffTime: "2020-07-04T16:30:18.069Z",
          },
          "49498d17-84c3-40ce-a98a-080fb66141dc": {
            awayTeamId: "1d97c20b-b36c-4307-b227-f11de588c955",
            goalsAway: 1,
            goalsHome: 1,
            homeTeamId: "906ce93b-8e71-409c-b459-4259fd3d35ad",
            id: "49498d17-84c3-40ce-a98a-080fb66141dc",
            kickOffTime: "2020-07-05T19:45:17.253Z",
          },
          "7ad77a42-84fc-4f82-bec3-b42673651e4c": {
            awayTeamId: "4e34107f-ccd8-4c94-a04f-5eb8d8637533",
            goalsAway: 2,
            goalsHome: 2,
            homeTeamId: "8368521e-502a-4302-86d3-cf728550d1bd",
            id: "7ad77a42-84fc-4f82-bec3-b42673651e4c",
            kickOffTime: "2020-07-05T19:45:17.254Z",
          },
          "9ea4563e-952c-44a1-8ae3-0752b40f24c6": {
            awayTeamId: "91c704f0-77ac-4898-a8bd-9539c66ef301",
            goalsAway: 0,
            goalsHome: 1,
            homeTeamId: "18de8ce2-736d-4c83-b4db-c473f1a03101",
            id: "9ea4563e-952c-44a1-8ae3-0752b40f24c6",
            kickOffTime: "2020-07-06T19:15:13.544Z",
          },
          "af1aacb1-7460-406d-9bde-76676f739e82": {
            awayTeamId: "8ecf419b-9fde-46e5-960b-9c5f7f14dc3d",
            goalsAway: 0,
            goalsHome: 2,
            homeTeamId: "14a47cb1-f497-4d71-879b-b7e82c85e804",
            id: "af1aacb1-7460-406d-9bde-76676f739e82",
            kickOffTime: "2020-07-05T19:45:17.254Z",
          },
          "c433c787-945d-4c4a-948d-3fee38783786": {
            awayTeamId: "e96fbd1c-bbd5-4d69-a7c7-2e45f5b579cb",
            goalsAway: 1,
            goalsHome: 0,
            homeTeamId: "4f30eb3c-4f9d-4506-a62f-e6021429e6de",
            id: "c433c787-945d-4c4a-948d-3fee38783786",
            kickOffTime: "2020-07-04T11:30:16.668Z",
          },
          "d29c17d1-769a-4130-ad84-3cde44daaec3": {
            awayTeamId: "479aa6bf-67ec-4320-a1dc-2d5b77c2f1a4",
            goalsAway: 0,
            goalsHome: 3,
            homeTeamId: "f9c15363-34ad-4156-a273-12ec0f212df6",
            id: "d29c17d1-769a-4130-ad84-3cde44daaec3",
            kickOffTime: "2020-07-04T20:00:15.454Z",
          },
          "e1dab524-ea5d-4234-969f-97745f6b694e": {
            awayTeamId: "4303d6fc-7c8d-4f19-aab7-37e4c64195cf",
            goalsAway: 0,
            goalsHome: 1,
            homeTeamId: "432b8777-b474-4ff9-bdd0-7dc41bd24e80",
            id: "e1dab524-ea5d-4234-969f-97745f6b694e",
            kickOffTime: "2020-07-05T19:45:17.254Z",
          },
        },
        id: "1f58e7e4-a6f2-4b80-beab-52ffcf66692a",
        matchday: 33,
        startDate: "",
      },
      {
        endDate: "",
        fixtures: {
          "04acf696-179b-4f71-a2b1-06a534b15bbf": {
            awayTeamId: "906ce93b-8e71-409c-b459-4259fd3d35ad",
            goalsAway: 1,
            goalsHome: 0,
            homeTeamId: "4e34107f-ccd8-4c94-a04f-5eb8d8637533",
            id: "04acf696-179b-4f71-a2b1-06a534b15bbf",
            kickOffTime: "2020-07-08T17:00:19.837Z",
          },
          "1e798ffa-d91f-4f3d-941a-721f39fc65f6": {
            awayTeamId: "432b8777-b474-4ff9-bdd0-7dc41bd24e80",
            goalsAway: 1,
            goalsHome: 1,
            homeTeamId: "91c704f0-77ac-4898-a8bd-9539c66ef301",
            id: "1e798ffa-d91f-4f3d-941a-721f39fc65f6",
            kickOffTime: "2020-07-09T17:15:14.439Z",
          },
          "2a9f9668-b287-4800-ab65-93c46878e5e1": {
            awayTeamId: "f9c15363-34ad-4156-a273-12ec0f212df6",
            goalsAway: 3,
            goalsHome: 2,
            homeTeamId: "3d8b2af7-a43f-43a1-9fcb-0b9c7c9b8fad",
            id: "2a9f9668-b287-4800-ab65-93c46878e5e1",
            kickOffTime: "2020-07-07T17:00:14.735Z",
          },
          "33871b9c-f41a-4bc7-8085-a1a4b8bf79b4": {
            awayTeamId: "8368521e-502a-4302-86d3-cf728550d1bd",
            goalsAway: 0,
            goalsHome: 5,
            homeTeamId: "4303d6fc-7c8d-4f19-aab7-37e4c64195cf",
            id: "33871b9c-f41a-4bc7-8085-a1a4b8bf79b4",
            kickOffTime: "2020-07-08T17:00:19.837Z",
          },
          "4e15546a-52de-46c9-8e44-025b153330ba": {
            awayTeamId: "9ad2bac0-8e7e-44cf-924e-75add32d8e5d",
            goalsAway: 0,
            goalsHome: 1,
            homeTeamId: "1d97c20b-b36c-4307-b227-f11de588c955",
            id: "4e15546a-52de-46c9-8e44-025b153330ba",
            kickOffTime: "2020-07-08T17:00:19.838Z",
          },
          "90b652f7-7c64-4080-8f23-59fdacaaf980": {
            awayTeamId: "053980d1-9205-4f90-b581-a403851c32e0",
            goalsAway: 1,
            goalsHome: 1,
            homeTeamId: "5696bf7b-3256-4937-9d6d-952da49ddee9",
            id: "90b652f7-7c64-4080-8f23-59fdacaaf980",
            kickOffTime: "2020-07-07T19:15:12.499Z",
          },
          "a6bc2d83-2a5e-4daf-bb13-f124cd63a1a1": {
            awayTeamId: "f29e61a2-23f0-462b-b9c7-420b09fec5d9",
            goalsAway: 3,
            goalsHome: 0,
            homeTeamId: "8ecf419b-9fde-46e5-960b-9c5f7f14dc3d",
            id: "a6bc2d83-2a5e-4daf-bb13-f124cd63a1a1",
            kickOffTime: "2020-07-09T19:15:14.624Z",
          },
          "d4f63437-ef55-4c4e-b732-18898828b688": {
            awayTeamId: "18de8ce2-736d-4c83-b4db-c473f1a03101",
            goalsAway: 0,
            goalsHome: 0,
            homeTeamId: "79ee152d-e7ee-4511-8d8f-f1632d7570ec",
            id: "d4f63437-ef55-4c4e-b732-18898828b688",
            kickOffTime: "2020-07-09T17:15:14.439Z",
          },
          "f040e211-7bd1-453c-a975-752ebd4462ea": {
            awayTeamId: "4f30eb3c-4f9d-4506-a62f-e6021429e6de",
            goalsAway: 1,
            goalsHome: 2,
            homeTeamId: "479aa6bf-67ec-4320-a1dc-2d5b77c2f1a4",
            id: "f040e211-7bd1-453c-a975-752ebd4462ea",
            kickOffTime: "2020-07-07T17:00:14.736Z",
          },
          "fc2a6037-7ab0-4a8e-b92b-8aa70caf7979": {
            awayTeamId: "14a47cb1-f497-4d71-879b-b7e82c85e804",
            goalsAway: 3,
            goalsHome: 1,
            homeTeamId: "e96fbd1c-bbd5-4d69-a7c7-2e45f5b579cb",
            id: "fc2a6037-7ab0-4a8e-b92b-8aa70caf7979",
            kickOffTime: "2020-07-08T19:15:15.330Z",
          },
        },
        id: "ad1c3a28-06f6-4be0-b31f-85ab2a763837",
        matchday: 34,
        startDate: "",
      },
      {
        endDate: "",
        fixtures: {
          "13ec9b45-0cda-4018-a99e-b57e2c10d0c7": {
            awayTeamId: "4303d6fc-7c8d-4f19-aab7-37e4c64195cf",
            goalsAway: 5,
            goalsHome: 0,
            homeTeamId: "e96fbd1c-bbd5-4d69-a7c7-2e45f5b579cb",
            id: "13ec9b45-0cda-4018-a99e-b57e2c10d0c7",
            kickOffTime: "2020-07-11T19:00:18.548Z",
          },
          "1e9121c8-5bc7-45be-901c-2c375a54b8e9": {
            awayTeamId: "f9c15363-34ad-4156-a273-12ec0f212df6",
            goalsAway: 0,
            goalsHome: 3,
            homeTeamId: "1d97c20b-b36c-4307-b227-f11de588c955",
            id: "1e9121c8-5bc7-45be-901c-2c375a54b8e9",
            kickOffTime: "2020-07-11T16:30:18.003Z",
          },
          "28abe94b-5243-4d25-8c11-dda8392d3a2b": {
            awayTeamId: "053980d1-9205-4f90-b581-a403851c32e0",
            goalsAway: 1,
            goalsHome: 4,
            homeTeamId: "79ee152d-e7ee-4511-8d8f-f1632d7570ec",
            id: "28abe94b-5243-4d25-8c11-dda8392d3a2b",
            kickOffTime: "2020-07-12T18:00:17.247Z",
          },
          "2e53a45c-bb7f-4244-b8d4-9ecea3afba3d": {
            awayTeamId: "432b8777-b474-4ff9-bdd0-7dc41bd24e80",
            goalsAway: 2,
            goalsHome: 2,
            homeTeamId: "f29e61a2-23f0-462b-b9c7-420b09fec5d9",
            id: "2e53a45c-bb7f-4244-b8d4-9ecea3afba3d",
            kickOffTime: "2020-07-13T19:00:13.755Z",
          },
          "57e5fdb3-0766-4959-972e-4b1c8db31fb0": {
            awayTeamId: "8368521e-502a-4302-86d3-cf728550d1bd",
            goalsAway: 1,
            goalsHome: 2,
            homeTeamId: "479aa6bf-67ec-4320-a1dc-2d5b77c2f1a4",
            id: "57e5fdb3-0766-4959-972e-4b1c8db31fb0",
            kickOffTime: "2020-07-11T11:30:15.369Z",
          },
          "65e3895a-a9cb-4015-9aab-979502128ae8": {
            awayTeamId: "91c704f0-77ac-4898-a8bd-9539c66ef301",
            goalsAway: 0,
            goalsHome: 3,
            homeTeamId: "9ad2bac0-8e7e-44cf-924e-75add32d8e5d",
            id: "65e3895a-a9cb-4015-9aab-979502128ae8",
            kickOffTime: "2020-07-12T11:00:14.849Z",
          },
          "a7154b89-bb35-433f-bdf2-9bb8906bd1cc": {
            awayTeamId: "906ce93b-8e71-409c-b459-4259fd3d35ad",
            goalsAway: 1,
            goalsHome: 1,
            homeTeamId: "14a47cb1-f497-4d71-879b-b7e82c85e804",
            id: "a7154b89-bb35-433f-bdf2-9bb8906bd1cc",
            kickOffTime: "2020-07-11T14:00:15.372Z",
          },
          "ba82d7d0-6dcd-4043-b053-829deb864ecc": {
            awayTeamId: "5696bf7b-3256-4937-9d6d-952da49ddee9",
            goalsAway: 1,
            goalsHome: 2,
            homeTeamId: "18de8ce2-736d-4c83-b4db-c473f1a03101",
            id: "ba82d7d0-6dcd-4043-b053-829deb864ecc",
            kickOffTime: "2020-07-12T17:45:19.328Z",
          },
          "bbec7ded-b4a0-423c-8f5c-dc06f349efdf": {
            awayTeamId: "3d8b2af7-a43f-43a1-9fcb-0b9c7c9b8fad",
            goalsAway: 0,
            goalsHome: 2,
            homeTeamId: "8ecf419b-9fde-46e5-960b-9c5f7f14dc3d",
            id: "bbec7ded-b4a0-423c-8f5c-dc06f349efdf",
            kickOffTime: "2020-07-12T13:30:14.561Z",
          },
          "f7e003bd-1d24-4c6f-a9d4-fdee3b4bd9f9": {
            awayTeamId: "4e34107f-ccd8-4c94-a04f-5eb8d8637533",
            goalsAway: 4,
            goalsHome: 0,
            homeTeamId: "4f30eb3c-4f9d-4506-a62f-e6021429e6de",
            id: "f7e003bd-1d24-4c6f-a9d4-fdee3b4bd9f9",
            kickOffTime: "2020-07-11T11:30:15.370Z",
          },
        },
        id: "07f47f52-7b65-482f-8708-fee9034187cd",
        matchday: 35,
        startDate: "",
      },
      {
        endDate: "",
        fixtures: {
          "10f022bd-b519-4e5e-bc42-a0663bf74a09": {
            awayTeamId: "14a47cb1-f497-4d71-879b-b7e82c85e804",
            goalsAway: 1,
            goalsHome: 2,
            homeTeamId: "5696bf7b-3256-4937-9d6d-952da49ddee9",
            id: "10f022bd-b519-4e5e-bc42-a0663bf74a09",
            kickOffTime: "2020-07-15T19:15:20.363Z",
          },
          "16d27f91-0155-4bef-80bc-ff21dad8012c": {
            awayTeamId: "8ecf419b-9fde-46e5-960b-9c5f7f14dc3d",
            goalsAway: 1,
            goalsHome: 1,
            homeTeamId: "91c704f0-77ac-4898-a8bd-9539c66ef301",
            id: "16d27f91-0155-4bef-80bc-ff21dad8012c",
            kickOffTime: "2020-07-16T17:00:13.749Z",
          },
          "1d171e37-4745-453a-bb3a-26864bce5614": {
            awayTeamId: "e96fbd1c-bbd5-4d69-a7c7-2e45f5b579cb",
            goalsAway: 1,
            goalsHome: 1,
            homeTeamId: "432b8777-b474-4ff9-bdd0-7dc41bd24e80",
            id: "1d171e37-4745-453a-bb3a-26864bce5614",
            kickOffTime: "2020-07-16T19:45:11.541Z",
          },
          "33f8fb44-82f2-4291-8323-7d610044910e": {
            awayTeamId: "f29e61a2-23f0-462b-b9c7-420b09fec5d9",
            goalsAway: 2,
            goalsHome: 0,
            homeTeamId: "3d8b2af7-a43f-43a1-9fcb-0b9c7c9b8fad",
            id: "33f8fb44-82f2-4291-8323-7d610044910e",
            kickOffTime: "2020-07-16T19:45:11.542Z",
          },
          "45a73503-81f8-45c1-8aa3-f454b0d40aaf": {
            awayTeamId: "79ee152d-e7ee-4511-8d8f-f1632d7570ec",
            goalsAway: 1,
            goalsHome: 2,
            homeTeamId: "4303d6fc-7c8d-4f19-aab7-37e4c64195cf",
            id: "45a73503-81f8-45c1-8aa3-f454b0d40aaf",
            kickOffTime: "2020-07-15T17:00:16.271Z",
          },
          "58ad22ee-fb99-4d43-ab39-d4e5f1c20063": {
            awayTeamId: "479aa6bf-67ec-4320-a1dc-2d5b77c2f1a4",
            goalsAway: 1,
            goalsHome: 3,
            homeTeamId: "4e34107f-ccd8-4c94-a04f-5eb8d8637533",
            id: "58ad22ee-fb99-4d43-ab39-d4e5f1c20063",
            kickOffTime: "2020-07-17T19:00:16.036Z",
          },
          "9e48dbb9-052f-4e63-aa2c-d650134cf582": {
            awayTeamId: "9ad2bac0-8e7e-44cf-924e-75add32d8e5d",
            goalsAway: 1,
            goalsHome: 1,
            homeTeamId: "906ce93b-8e71-409c-b459-4259fd3d35ad",
            id: "9e48dbb9-052f-4e63-aa2c-d650134cf582",
            kickOffTime: "2020-07-15T17:00:16.269Z",
          },
          "b5235044-969f-4258-acac-703e81dc939c": {
            awayTeamId: "1d97c20b-b36c-4307-b227-f11de588c955",
            goalsAway: 0,
            goalsHome: 2,
            homeTeamId: "053980d1-9205-4f90-b581-a403851c32e0",
            id: "b5235044-969f-4258-acac-703e81dc939c",
            kickOffTime: "2020-07-16T17:00:13.747Z",
          },
          "bce9eae3-0c4e-4162-85b1-75606f173f47": {
            awayTeamId: "4f30eb3c-4f9d-4506-a62f-e6021429e6de",
            goalsAway: 0,
            goalsHome: 1,
            homeTeamId: "f9c15363-34ad-4156-a273-12ec0f212df6",
            id: "bce9eae3-0c4e-4162-85b1-75606f173f47",
            kickOffTime: "2020-07-14T19:15:13.761Z",
          },
          "c79f16d1-81f2-4252-a302-1707bbd052a8": {
            awayTeamId: "18de8ce2-736d-4c83-b4db-c473f1a03101",
            goalsAway: 3,
            goalsHome: 1,
            homeTeamId: "8368521e-502a-4302-86d3-cf728550d1bd",
            id: "c79f16d1-81f2-4252-a302-1707bbd052a8",
            kickOffTime: "2020-07-15T17:00:16.271Z",
          },
        },
        id: "d455c2e0-c310-4d89-8bf3-877fcb8f878c",
        matchday: 36,
        startDate: "",
      },
      {
        endDate: "",
        fixtures: {
          "0094d75f-c97a-4905-88f2-12bac6c97fbc": {
            awayTeamId: "8368521e-502a-4302-86d3-cf728550d1bd",
            goalsAway: 0,
            goalsHome: 0,
            homeTeamId: "e96fbd1c-bbd5-4d69-a7c7-2e45f5b579cb",
            id: "0094d75f-c97a-4905-88f2-12bac6c97fbc",
            kickOffTime: "2020-07-20T17:00:14.150Z",
          },
          "032bbd78-d4aa-4664-90ee-617f06e1a949": {
            awayTeamId: "906ce93b-8e71-409c-b459-4259fd3d35ad",
            goalsAway: 2,
            goalsHome: 0,
            homeTeamId: "4f30eb3c-4f9d-4506-a62f-e6021429e6de",
            id: "032bbd78-d4aa-4664-90ee-617f06e1a949",
            kickOffTime: "2020-07-18T16:30:20.643Z",
          },
          "31a35bc7-5fd6-4775-95da-483ed26f1a62": {
            awayTeamId: "3d8b2af7-a43f-43a1-9fcb-0b9c7c9b8fad",
            goalsAway: 0,
            goalsHome: 2,
            homeTeamId: "9ad2bac0-8e7e-44cf-924e-75add32d8e5d",
            id: "31a35bc7-5fd6-4775-95da-483ed26f1a62",
            kickOffTime: "2020-07-20T19:15:12.968Z",
          },
          "4ac9f6e9-d179-4663-9746-3665577bed98": {
            awayTeamId: "f9c15363-34ad-4156-a273-12ec0f212df6",
            goalsAway: 3,
            goalsHome: 5,
            homeTeamId: "14a47cb1-f497-4d71-879b-b7e82c85e804",
            id: "4ac9f6e9-d179-4663-9746-3665577bed98",
            kickOffTime: "2020-07-22T19:15:15.683Z",
          },
          "79f64ab9-9432-437f-a547-f5bebc1720aa": {
            awayTeamId: "432b8777-b474-4ff9-bdd0-7dc41bd24e80",
            goalsAway: 2,
            goalsHome: 0,
            homeTeamId: "79ee152d-e7ee-4511-8d8f-f1632d7570ec",
            id: "79f64ab9-9432-437f-a547-f5bebc1720aa",
            kickOffTime: "2020-07-19T13:00:19.184Z",
          },
          "9b002adc-b6c2-4ff4-8ba8-8e117340be9d": {
            awayTeamId: "053980d1-9205-4f90-b581-a403851c32e0",
            goalsAway: 0,
            goalsHome: 3,
            homeTeamId: "18de8ce2-736d-4c83-b4db-c473f1a03101",
            id: "9b002adc-b6c2-4ff4-8ba8-8e117340be9d",
            kickOffTime: "2020-07-19T15:00:20.725Z",
          },
          "aa73336b-dbc0-4ce5-b1e6-2075f14c03be": {
            awayTeamId: "5696bf7b-3256-4937-9d6d-952da49ddee9",
            goalsAway: 0,
            goalsHome: 1,
            homeTeamId: "8ecf419b-9fde-46e5-960b-9c5f7f14dc3d",
            id: "aa73336b-dbc0-4ce5-b1e6-2075f14c03be",
            kickOffTime: "2020-07-21T19:15:09.171Z",
          },
          "bfe7b70c-3bfc-4cdc-b398-262298a5c74f": {
            awayTeamId: "4303d6fc-7c8d-4f19-aab7-37e4c64195cf",
            goalsAway: 4,
            goalsHome: 0,
            homeTeamId: "479aa6bf-67ec-4320-a1dc-2d5b77c2f1a4",
            id: "bfe7b70c-3bfc-4cdc-b398-262298a5c74f",
            kickOffTime: "2020-07-21T17:00:11.378Z",
          },
          "d6d09c54-37c4-4642-b1da-7cb1aa31392a": {
            awayTeamId: "4e34107f-ccd8-4c94-a04f-5eb8d8637533",
            goalsAway: 1,
            goalsHome: 1,
            homeTeamId: "f29e61a2-23f0-462b-b9c7-420b09fec5d9",
            id: "d6d09c54-37c4-4642-b1da-7cb1aa31392a",
            kickOffTime: "2020-07-22T17:00:11.586Z",
          },
          "ecc8ad5c-74f8-40b2-8290-815f0974f562": {
            awayTeamId: "91c704f0-77ac-4898-a8bd-9539c66ef301",
            goalsAway: 1,
            goalsHome: 0,
            homeTeamId: "1d97c20b-b36c-4307-b227-f11de588c955",
            id: "ecc8ad5c-74f8-40b2-8290-815f0974f562",
            kickOffTime: "2020-07-20T17:00:14.148Z",
          },
        },
        id: "8dcf188d-ff19-45e6-9c4a-cdcd205e644c",
        matchday: 37,
        startDate: "",
      },
      {
        endDate: "",
        fixtures: {
          "09874b0c-2e3e-4a54-8535-c0f08a60798d": {
            awayTeamId: "1d97c20b-b36c-4307-b227-f11de588c955",
            goalsAway: 1,
            goalsHome: 3,
            homeTeamId: "432b8777-b474-4ff9-bdd0-7dc41bd24e80",
            id: "09874b0c-2e3e-4a54-8535-c0f08a60798d",
            kickOffTime: "2020-07-26T15:00:17.778Z",
          },
          "13535ee2-6bad-47e4-99bd-12fcf78bad84": {
            awayTeamId: "f29e61a2-23f0-462b-b9c7-420b09fec5d9",
            goalsAway: 2,
            goalsHome: 0,
            homeTeamId: "053980d1-9205-4f90-b581-a403851c32e0",
            id: "13535ee2-6bad-47e4-99bd-12fcf78bad84",
            kickOffTime: "2020-07-26T15:15:15.978Z",
          },
          "5c2ed8b2-b86e-4812-ae49-00f25a267a7c": {
            awayTeamId: "9ad2bac0-8e7e-44cf-924e-75add32d8e5d",
            goalsAway: 0,
            goalsHome: 2,
            homeTeamId: "f9c15363-34ad-4156-a273-12ec0f212df6",
            id: "5c2ed8b2-b86e-4812-ae49-00f25a267a7c",
            kickOffTime: "2020-07-26T15:00:17.779Z",
          },
          "70f3e56a-e18b-43e0-b523-1d72167ccb26": {
            awayTeamId: "479aa6bf-67ec-4320-a1dc-2d5b77c2f1a4",
            goalsAway: 2,
            goalsHome: 3,
            homeTeamId: "5696bf7b-3256-4937-9d6d-952da49ddee9",
            id: "70f3e56a-e18b-43e0-b523-1d72167ccb26",
            kickOffTime: "2020-07-26T15:15:15.978Z",
          },
          "79be7b2f-9c8a-48e5-ad07-315abcec8823": {
            awayTeamId: "14a47cb1-f497-4d71-879b-b7e82c85e804",
            goalsAway: 3,
            goalsHome: 1,
            homeTeamId: "8368521e-502a-4302-86d3-cf728550d1bd",
            id: "79be7b2f-9c8a-48e5-ad07-315abcec8823",
            kickOffTime: "2020-07-26T15:00:17.779Z",
          },
          "8dcd2a74-4fd7-45a6-884f-dcc7ab2b0749": {
            awayTeamId: "e96fbd1c-bbd5-4d69-a7c7-2e45f5b579cb",
            goalsAway: 2,
            goalsHome: 1,
            homeTeamId: "906ce93b-8e71-409c-b459-4259fd3d35ad",
            id: "8dcd2a74-4fd7-45a6-884f-dcc7ab2b0749",
            kickOffTime: "2020-07-26T15:15:15.979Z",
          },
          "9cdd63ef-81cc-49fb-b36f-fb1bd4fcf3dc": {
            awayTeamId: "8ecf419b-9fde-46e5-960b-9c5f7f14dc3d",
            goalsAway: 1,
            goalsHome: 1,
            homeTeamId: "4e34107f-ccd8-4c94-a04f-5eb8d8637533",
            id: "9cdd63ef-81cc-49fb-b36f-fb1bd4fcf3dc",
            kickOffTime: "2020-07-26T15:00:17.779Z",
          },
          "a8a56396-c225-404b-8814-faf07e740ed2": {
            awayTeamId: "18de8ce2-736d-4c83-b4db-c473f1a03101",
            goalsAway: 1,
            goalsHome: 1,
            homeTeamId: "3d8b2af7-a43f-43a1-9fcb-0b9c7c9b8fad",
            id: "a8a56396-c225-404b-8814-faf07e740ed2",
            kickOffTime: "2020-07-26T15:00:17.779Z",
          },
          "aee7524d-6e9a-416d-af8d-56e89bf48be9": {
            awayTeamId: "79ee152d-e7ee-4511-8d8f-f1632d7570ec",
            goalsAway: 3,
            goalsHome: 1,
            homeTeamId: "91c704f0-77ac-4898-a8bd-9539c66ef301",
            id: "aee7524d-6e9a-416d-af8d-56e89bf48be9",
            kickOffTime: "2020-07-26T15:00:17.778Z",
          },
          "fe17e06b-1c29-4895-baad-f9ae7bcb5347": {
            awayTeamId: "4f30eb3c-4f9d-4506-a62f-e6021429e6de",
            goalsAway: 0,
            goalsHome: 5,
            homeTeamId: "4303d6fc-7c8d-4f19-aab7-37e4c64195cf",
            id: "fe17e06b-1c29-4895-baad-f9ae7bcb5347",
            kickOffTime: "2020-07-26T15:00:17.778Z",
          },
        },
        id: "d86e3007-fef9-495e-87a1-f3526e4fbaf7",
        matchday: 38,
        startDate: "",
      },
    ],
  },
  france: {
    "2019": [
      {
        endDate: "2019-08-11T23:00:00.000+02:00",
        fixtures: {
          "1ebeffba-3344-44dc-9038-39141143540a": {
            awayTeamId: "e3c68260-df86-4fc4-b5b2-40db66cee51d",
            goalsAway: 0,
            goalsHome: 3,
            homeTeamId: "7e6c61aa-3e8c-4a3e-8520-523e8608070c",
            kickOffTime: "2019-08-11T21:00:00.000+02:00",
          },
          "520c80ad-93a8-4bfb-904b-5d0f8747ff19": {
            awayTeamId: "3ba8e3a3-ba20-4ec8-b01a-a5945a56a93b",
            goalsAway: 2,
            goalsHome: 1,
            homeTeamId: "2507719b-e3f6-4763-a012-b3c302b2b4b8",
            kickOffTime: "2019-08-10T20:00:00.000+02:00",
          },
          "585b315d-3013-454c-8119-14874114893c": {
            awayTeamId: "4b2a1635-9a3d-42ca-afb1-f46766b7b179",
            goalsAway: 3,
            goalsHome: 0,
            homeTeamId: "3e6520d5-8a18-4bd6-8ad4-5e00f7add2e0",
            kickOffTime: "2019-08-09T20:45:00.000+02:00",
          },
          "5f03fcee-e2d6-4a6c-910f-f7d05202b3a4": {
            awayTeamId: "883b4940-1fb9-4714-9fd1-418c8ea7ed65",
            goalsAway: 1,
            goalsHome: 3,
            homeTeamId: "fee996ac-2454-425a-97f9-09c35f28a65f",
            kickOffTime: "2019-08-10T20:00:00.000+02:00",
          },
          "88ff9b51-5ce2-4a8f-b6d6-baf7aeef8845": {
            awayTeamId: "21274b2b-3500-4a49-971b-0a6ae9cafb58",
            goalsAway: 1,
            goalsHome: 2,
            homeTeamId: "2dc5c094-9b90-4f1b-911a-3f68294dad99",
            kickOffTime: "2019-08-11T15:00:00.000+02:00",
          },
          "9640988a-54e2-4117-a7a4-0d0c887c2240": {
            awayTeamId: "2b3249eb-5868-4700-8d55-cb5985e34339",
            goalsAway: 1,
            goalsHome: 1,
            homeTeamId: "cdfaf7f7-8d7c-4d35-8173-d67e238c8a71",
            kickOffTime: "2019-08-11T17:00:00.000+02:00",
          },
          "99bc7527-f043-4254-8eb0-52d97912c907": {
            awayTeamId: "64b2a17a-aa75-4171-b2b6-dfabd6083d48",
            goalsAway: 1,
            goalsHome: 1,
            homeTeamId: "fd5fa7bb-3211-41ce-b66f-49b074c2aab8",
            kickOffTime: "2019-08-10T20:00:00.000+02:00",
          },
          "9a2679dc-cd54-47e6-a846-23040ce17064": {
            awayTeamId: "a0497862-8645-4890-a4f1-10d83941ecb8",
            goalsAway: 1,
            goalsHome: 0,
            homeTeamId: "f4aceb89-a8ac-4ff8-b13c-9f230ed85d56",
            kickOffTime: "2019-08-10T20:00:00.000+02:00",
          },
          "b223182f-79fd-4cea-85b3-f20b0ec5347c": {
            awayTeamId: "a0a38e6c-30e3-4ec9-9dd9-02b524217df2",
            goalsAway: 1,
            goalsHome: 2,
            homeTeamId: "a7edfa0f-eb3d-4484-8437-3886cee7a3c5",
            kickOffTime: "2019-08-10T20:00:00.000+02:00",
          },
          "b4cdb656-5633-41ef-aa3a-a1ec6f1aa104": {
            awayTeamId: "5e7d0f28-97c0-46f4-b733-2073f02065ef",
            goalsAway: 2,
            goalsHome: 0,
            homeTeamId: "ae1b5cf9-73b2-41ef-bc92-4715dd6a4af0",
            kickOffTime: "2019-08-10T17:30:00.000+02:00",
          },
        },
        id: "7689a2c8-0af6-4d46-9cc7-05b8b51ea3f4",
        matchday: 1,
        startDate: "2019-08-09T20:45:00.000+02:00",
      },
      {
        endDate: "2019-08-18T23:00:00.000+02:00",
        fixtures: {
          "07f508fb-bf21-4e7a-bce0-7e34a52eba07": {
            awayTeamId: "a7edfa0f-eb3d-4484-8437-3886cee7a3c5",
            goalsAway: 2,
            goalsHome: 1,
            homeTeamId: "e3c68260-df86-4fc4-b5b2-40db66cee51d",
            kickOffTime: "2019-08-17T20:00:00.000+02:00",
          },
          "22b590cf-b115-48a1-b2e5-a74db0d873fd": {
            awayTeamId: "ae1b5cf9-73b2-41ef-bc92-4715dd6a4af0",
            goalsAway: 0,
            goalsHome: 0,
            homeTeamId: "21274b2b-3500-4a49-971b-0a6ae9cafb58",
            kickOffTime: "2019-08-17T17:30:00.000+02:00",
          },
          "4877cec1-62b3-4bfb-8eb8-1dfc558904e3": {
            awayTeamId: "3e6520d5-8a18-4bd6-8ad4-5e00f7add2e0",
            goalsAway: 0,
            goalsHome: 3,
            homeTeamId: "2b3249eb-5868-4700-8d55-cb5985e34339",
            kickOffTime: "2019-08-17T20:00:00.000+02:00",
          },
          "772eb5d0-3946-4b04-bf1f-6b3b57644eb8": {
            awayTeamId: "fee996ac-2454-425a-97f9-09c35f28a65f",
            goalsAway: 0,
            goalsHome: 6,
            homeTeamId: "4b2a1635-9a3d-42ca-afb1-f46766b7b179",
            kickOffTime: "2019-08-16T20:45:00.000+02:00",
          },
          "835e4e90-836c-4aa7-bde1-deac990ed6d8": {
            awayTeamId: "fd5fa7bb-3211-41ce-b66f-49b074c2aab8",
            goalsAway: 1,
            goalsHome: 1,
            homeTeamId: "3ba8e3a3-ba20-4ec8-b01a-a5945a56a93b",
            kickOffTime: "2019-08-18T15:00:00.000+02:00",
          },
          "b4536b58-51ca-4936-932e-1243fdb783a4": {
            awayTeamId: "2507719b-e3f6-4763-a012-b3c302b2b4b8",
            goalsAway: 0,
            goalsHome: 1,
            homeTeamId: "64b2a17a-aa75-4171-b2b6-dfabd6083d48",
            kickOffTime: "2019-08-17T20:00:00.000+02:00",
          },
          "b4a7861c-5f09-49f8-91c9-c85d8aa5e3c7": {
            awayTeamId: "f4aceb89-a8ac-4ff8-b13c-9f230ed85d56",
            goalsAway: 1,
            goalsHome: 1,
            homeTeamId: "883b4940-1fb9-4714-9fd1-418c8ea7ed65",
            kickOffTime: "2019-08-17T20:00:00.000+02:00",
          },
          "c8770c33-0a01-428e-b276-c91776a1650f": {
            awayTeamId: "2dc5c094-9b90-4f1b-911a-3f68294dad99",
            goalsAway: 0,
            goalsHome: 1,
            homeTeamId: "a0a38e6c-30e3-4ec9-9dd9-02b524217df2",
            kickOffTime: "2019-08-17T20:00:00.000+02:00",
          },
          "ec38f795-a81d-4175-93db-e8658e11512a": {
            awayTeamId: "7e6c61aa-3e8c-4a3e-8520-523e8608070c",
            goalsAway: 1,
            goalsHome: 2,
            homeTeamId: "a0497862-8645-4890-a4f1-10d83941ecb8",
            kickOffTime: "2019-08-18T21:00:00.000+02:00",
          },
          "fe39be20-4f1c-4472-ae42-e93022abb0f2": {
            awayTeamId: "cdfaf7f7-8d7c-4d35-8173-d67e238c8a71",
            goalsAway: 0,
            goalsHome: 0,
            homeTeamId: "5e7d0f28-97c0-46f4-b733-2073f02065ef",
            kickOffTime: "2019-08-18T17:00:00.000+02:00",
          },
        },
        id: "66e7a42a-b62b-412f-9179-eec6a5997830",
        matchday: 2,
        startDate: "2019-08-16T20:45:00.000+02:00",
      },
      {
        endDate: "2019-08-28T23:00:00.000+02:00",
        fixtures: {
          "239bf554-412b-4503-b38b-9cfdf4666f84": {
            awayTeamId: "4b2a1635-9a3d-42ca-afb1-f46766b7b179",
            goalsAway: 0,
            goalsHome: 1,
            homeTeamId: "f4aceb89-a8ac-4ff8-b13c-9f230ed85d56",
            kickOffTime: "2019-08-27T19:00:00.000+02:00",
          },
          "3cb71a54-68f5-49bb-969f-1134f192de6c": {
            awayTeamId: "21274b2b-3500-4a49-971b-0a6ae9cafb58",
            goalsAway: 2,
            goalsHome: 1,
            homeTeamId: "a0a38e6c-30e3-4ec9-9dd9-02b524217df2",
            kickOffTime: "2019-08-24T20:00:00.000+02:00",
          },
          "498b9145-377d-44c7-88e0-2d0e0b3fdad5": {
            awayTeamId: "2b3249eb-5868-4700-8d55-cb5985e34339",
            goalsAway: 0,
            goalsHome: 3,
            homeTeamId: "fee996ac-2454-425a-97f9-09c35f28a65f",
            kickOffTime: "2019-08-24T20:00:00.000+02:00",
          },
          "514893ce-f6d9-4a59-9e16-07b34ac4eb92": {
            awayTeamId: "ae1b5cf9-73b2-41ef-bc92-4715dd6a4af0",
            goalsAway: 2,
            goalsHome: 1,
            homeTeamId: "a7edfa0f-eb3d-4484-8437-3886cee7a3c5",
            kickOffTime: "2019-08-28T21:00:00.000+02:00",
          },
          "5678d3bd-35e5-4f1a-8f95-43097b9e01bd": {
            awayTeamId: "3ba8e3a3-ba20-4ec8-b01a-a5945a56a93b",
            goalsAway: 0,
            goalsHome: 3,
            homeTeamId: "2dc5c094-9b90-4f1b-911a-3f68294dad99",
            kickOffTime: "2019-08-28T19:00:00.000+02:00",
          },
          "6642a640-2acd-43b9-8545-7240b6657d6b": {
            awayTeamId: "64b2a17a-aa75-4171-b2b6-dfabd6083d48",
            goalsAway: 0,
            goalsHome: 4,
            homeTeamId: "7e6c61aa-3e8c-4a3e-8520-523e8608070c",
            kickOffTime: "2019-08-25T21:00:00.000+02:00",
          },
          "69e92c48-d851-4a60-b1aa-ccd7d32c5782": {
            awayTeamId: "a0497862-8645-4890-a4f1-10d83941ecb8",
            goalsAway: 2,
            goalsHome: 0,
            homeTeamId: "cdfaf7f7-8d7c-4d35-8173-d67e238c8a71",
            kickOffTime: "2019-08-25T17:00:00.000+02:00",
          },
          "b15f4c17-3e89-45ec-b54a-39ea9025ad7b": {
            awayTeamId: "5e7d0f28-97c0-46f4-b733-2073f02065ef",
            goalsAway: 0,
            goalsHome: 1,
            homeTeamId: "fd5fa7bb-3211-41ce-b66f-49b074c2aab8",
            kickOffTime: "2019-08-24T20:00:00.000+02:00",
          },
          "c0419acb-bfda-4a54-a0a9-3c1991e0cb98": {
            awayTeamId: "e3c68260-df86-4fc4-b5b2-40db66cee51d",
            goalsAway: 2,
            goalsHome: 2,
            homeTeamId: "3e6520d5-8a18-4bd6-8ad4-5e00f7add2e0",
            kickOffTime: "2019-08-25T15:00:00.000+02:00",
          },
          "c54f954e-4017-4171-9441-8fdeeb7ab331": {
            awayTeamId: "883b4940-1fb9-4714-9fd1-418c8ea7ed65",
            goalsAway: 2,
            goalsHome: 0,
            homeTeamId: "2507719b-e3f6-4763-a012-b3c302b2b4b8",
            kickOffTime: "2019-08-24T20:00:00.000+02:00",
          },
        },
        id: "fd3443dc-d360-44db-af22-065da097b8c5",
        matchday: 3,
        startDate: "2019-08-24T20:00:00.000+02:00",
      },
      {
        endDate: "2019-09-01T23:00:00.000+02:00",
        fixtures: {
          "2ec98faf-b636-49c4-b091-d0f4380bc201": {
            awayTeamId: "3ba8e3a3-ba20-4ec8-b01a-a5945a56a93b",
            goalsAway: 0,
            goalsHome: 1,
            homeTeamId: "ae1b5cf9-73b2-41ef-bc92-4715dd6a4af0",
            kickOffTime: "2019-09-01T21:00:00.000+02:00",
          },
          "363a72a3-6a6a-4961-9548-919fb567c066": {
            awayTeamId: "2507719b-e3f6-4763-a012-b3c302b2b4b8",
            goalsAway: 0,
            goalsHome: 2,
            homeTeamId: "fee996ac-2454-425a-97f9-09c35f28a65f",
            kickOffTime: "2019-08-31T20:00:00.000+02:00",
          },
          "723e79f3-7fbf-4ff3-a02a-431affd56bc6": {
            awayTeamId: "a0a38e6c-30e3-4ec9-9dd9-02b524217df2",
            goalsAway: 0,
            goalsHome: 2,
            homeTeamId: "64b2a17a-aa75-4171-b2b6-dfabd6083d48",
            kickOffTime: "2019-08-31T20:00:00.000+02:00",
          },
          "acb9b860-be19-43b3-b14e-16da650119a9": {
            awayTeamId: "a7edfa0f-eb3d-4484-8437-3886cee7a3c5",
            goalsAway: 2,
            goalsHome: 1,
            homeTeamId: "a0497862-8645-4890-a4f1-10d83941ecb8",
            kickOffTime: "2019-09-01T15:00:00.000+02:00",
          },
          "b5e3f6ee-d3a9-4c90-a789-4cffd8e53d9d": {
            awayTeamId: "fd5fa7bb-3211-41ce-b66f-49b074c2aab8",
            goalsAway: 0,
            goalsHome: 3,
            homeTeamId: "e3c68260-df86-4fc4-b5b2-40db66cee51d",
            kickOffTime: "2019-08-31T20:00:00.000+02:00",
          },
          "beb9b0eb-6afc-45cc-92e4-208004a7268f": {
            awayTeamId: "f4aceb89-a8ac-4ff8-b13c-9f230ed85d56",
            goalsAway: 0,
            goalsHome: 1,
            homeTeamId: "21274b2b-3500-4a49-971b-0a6ae9cafb58",
            kickOffTime: "2019-08-31T20:00:00.000+02:00",
          },
          "c923c857-371c-4658-a1a7-810f2d134764": {
            awayTeamId: "883b4940-1fb9-4714-9fd1-418c8ea7ed65",
            goalsAway: 1,
            goalsHome: 1,
            homeTeamId: "4b2a1635-9a3d-42ca-afb1-f46766b7b179",
            kickOffTime: "2019-08-31T17:30:00.000+02:00",
          },
          "da295e0d-3412-4923-a27f-5b002d0b73d1": {
            awayTeamId: "2dc5c094-9b90-4f1b-911a-3f68294dad99",
            goalsAway: 0,
            goalsHome: 2,
            homeTeamId: "5e7d0f28-97c0-46f4-b733-2073f02065ef",
            kickOffTime: "2019-09-01T15:00:00.000+02:00",
          },
          "dd18c5ac-48f3-4591-9a3d-b23b82fbe211": {
            awayTeamId: "7e6c61aa-3e8c-4a3e-8520-523e8608070c",
            goalsAway: 2,
            goalsHome: 0,
            homeTeamId: "2b3249eb-5868-4700-8d55-cb5985e34339",
            kickOffTime: "2019-08-30T20:45:00.000+02:00",
          },
          "e82220f6-ab00-4732-9fc8-2a8e88a529cf": {
            awayTeamId: "3e6520d5-8a18-4bd6-8ad4-5e00f7add2e0",
            goalsAway: 2,
            goalsHome: 2,
            homeTeamId: "cdfaf7f7-8d7c-4d35-8173-d67e238c8a71",
            kickOffTime: "2019-09-01T17:00:00.000+02:00",
          },
        },
        id: "5a6d2c44-38ec-4bd2-9fd5-1fac1f934ad1",
        matchday: 4,
        startDate: "2019-08-30T20:45:00.000+02:00",
      },
      {
        endDate: "2019-09-15T23:00:00.000+02:00",
        fixtures: {
          "3ba62010-ecc3-4af2-80e7-dc33626761ea": {
            awayTeamId: "ae1b5cf9-73b2-41ef-bc92-4715dd6a4af0",
            goalsAway: 4,
            goalsHome: 3,
            homeTeamId: "3e6520d5-8a18-4bd6-8ad4-5e00f7add2e0",
            kickOffTime: "2019-09-15T21:00:00.000+02:00",
          },
          "3f73d476-96ee-4fff-8f8f-7adbb228406b": {
            awayTeamId: "e3c68260-df86-4fc4-b5b2-40db66cee51d",
            goalsAway: 0,
            goalsHome: 0,
            homeTeamId: "2507719b-e3f6-4763-a012-b3c302b2b4b8",
            kickOffTime: "2019-09-14T20:00:00.000+02:00",
          },
          "636b76fb-d759-44d2-9a91-996ab83c62ba": {
            awayTeamId: "64b2a17a-aa75-4171-b2b6-dfabd6083d48",
            goalsAway: 2,
            goalsHome: 2,
            homeTeamId: "3ba8e3a3-ba20-4ec8-b01a-a5945a56a93b",
            kickOffTime: "2019-09-15T17:00:00.000+02:00",
          },
          "63d6b95b-6cf1-4293-a6dd-78eb191a4bbe": {
            awayTeamId: "5e7d0f28-97c0-46f4-b733-2073f02065ef",
            goalsAway: 0,
            goalsHome: 1,
            homeTeamId: "21274b2b-3500-4a49-971b-0a6ae9cafb58",
            kickOffTime: "2019-09-15T15:00:00.000+02:00",
          },
          "70fa2034-a575-4c9f-a203-610b33641f33": {
            awayTeamId: "fee996ac-2454-425a-97f9-09c35f28a65f",
            goalsAway: 1,
            goalsHome: 2,
            homeTeamId: "2dc5c094-9b90-4f1b-911a-3f68294dad99",
            kickOffTime: "2019-09-13T19:00:00.000+02:00",
          },
          "7ea544b1-41d7-4477-acd8-5f13cf5f92d6": {
            awayTeamId: "a7edfa0f-eb3d-4484-8437-3886cee7a3c5",
            goalsAway: 1,
            goalsHome: 2,
            homeTeamId: "f4aceb89-a8ac-4ff8-b13c-9f230ed85d56",
            kickOffTime: "2019-09-14T20:00:00.000+02:00",
          },
          "93fd9cf5-1a54-4041-9600-7641e716fb65": {
            awayTeamId: "cdfaf7f7-8d7c-4d35-8173-d67e238c8a71",
            goalsAway: 0,
            goalsHome: 1,
            homeTeamId: "7e6c61aa-3e8c-4a3e-8520-523e8608070c",
            kickOffTime: "2019-09-14T17:30:00.000+02:00",
          },
          "9c15921b-552d-48b4-901b-28e903ecdd59": {
            awayTeamId: "2b3249eb-5868-4700-8d55-cb5985e34339",
            goalsAway: 0,
            goalsHome: 2,
            homeTeamId: "883b4940-1fb9-4714-9fd1-418c8ea7ed65",
            kickOffTime: "2019-09-14T20:00:00.000+02:00",
          },
          "d24b8aaf-3c22-4321-8443-5df26c6fbfaf": {
            awayTeamId: "4b2a1635-9a3d-42ca-afb1-f46766b7b179",
            goalsAway: 2,
            goalsHome: 2,
            homeTeamId: "a0a38e6c-30e3-4ec9-9dd9-02b524217df2",
            kickOffTime: "2019-09-13T20:45:00.000+02:00",
          },
          "df2ee57a-335f-45c1-831d-ecdfa91b8cd2": {
            awayTeamId: "a0497862-8645-4890-a4f1-10d83941ecb8",
            goalsAway: 0,
            goalsHome: 0,
            homeTeamId: "fd5fa7bb-3211-41ce-b66f-49b074c2aab8",
            kickOffTime: "2019-09-14T20:00:00.000+02:00",
          },
        },
        id: "f385fe6f-1fa5-4db1-8e27-a91faeeb18ef",
        matchday: 5,
        startDate: "2019-09-13T19:00:00.000+02:00",
      },
      {
        endDate: "2019-09-22T23:00:00.000+02:00",
        fixtures: {
          "14189aa3-6f76-4f6b-8a72-668f18291d91": {
            awayTeamId: "2dc5c094-9b90-4f1b-911a-3f68294dad99",
            goalsAway: 1,
            goalsHome: 1,
            homeTeamId: "a0497862-8645-4890-a4f1-10d83941ecb8",
            kickOffTime: "2019-09-22T15:00:00.000+02:00",
          },
          "1855e64e-4544-4487-bf69-201d13df5682": {
            awayTeamId: "3ba8e3a3-ba20-4ec8-b01a-a5945a56a93b",
            goalsAway: 1,
            goalsHome: 4,
            homeTeamId: "fee996ac-2454-425a-97f9-09c35f28a65f",
            kickOffTime: "2019-09-22T17:00:00.000+02:00",
          },
          "1abeed41-eb85-4852-a80b-f3cdf81f8e87": {
            awayTeamId: "2507719b-e3f6-4763-a012-b3c302b2b4b8",
            goalsAway: 1,
            goalsHome: 2,
            homeTeamId: "a7edfa0f-eb3d-4484-8437-3886cee7a3c5",
            kickOffTime: "2019-09-21T20:00:00.000+02:00",
          },
          "45e8c488-162a-428f-a599-552fc58b8362": {
            awayTeamId: "7e6c61aa-3e8c-4a3e-8520-523e8608070c",
            goalsAway: 1,
            goalsHome: 0,
            homeTeamId: "4b2a1635-9a3d-42ca-afb1-f46766b7b179",
            kickOffTime: "2019-09-22T21:00:00.000+02:00",
          },
          "70a46da2-bba4-4a8e-b3c5-1eec9ca3506e": {
            awayTeamId: "a0a38e6c-30e3-4ec9-9dd9-02b524217df2",
            goalsAway: 2,
            goalsHome: 1,
            homeTeamId: "2b3249eb-5868-4700-8d55-cb5985e34339",
            kickOffTime: "2019-09-21T20:00:00.000+02:00",
          },
          "afc0dcba-352a-4fd8-8ac0-3d6d12db45cc": {
            awayTeamId: "f4aceb89-a8ac-4ff8-b13c-9f230ed85d56",
            goalsAway: 1,
            goalsHome: 1,
            homeTeamId: "ae1b5cf9-73b2-41ef-bc92-4715dd6a4af0",
            kickOffTime: "2019-09-21T17:30:00.000+02:00",
          },
          "b5d95620-9b08-4ce6-9b63-204e469a5a32": {
            awayTeamId: "3e6520d5-8a18-4bd6-8ad4-5e00f7add2e0",
            goalsAway: 0,
            goalsHome: 0,
            homeTeamId: "5e7d0f28-97c0-46f4-b733-2073f02065ef",
            kickOffTime: "2019-09-21T20:00:00.000+02:00",
          },
          "c3aa71a2-110e-4992-a491-64201a9aff4b": {
            awayTeamId: "64b2a17a-aa75-4171-b2b6-dfabd6083d48",
            goalsAway: 0,
            goalsHome: 1,
            homeTeamId: "e3c68260-df86-4fc4-b5b2-40db66cee51d",
            kickOffTime: "2019-09-21T20:00:00.000+02:00",
          },
          "d1f9a41a-5908-40c4-a6a5-0b72480730ac": {
            awayTeamId: "fd5fa7bb-3211-41ce-b66f-49b074c2aab8",
            goalsAway: 2,
            goalsHome: 2,
            homeTeamId: "883b4940-1fb9-4714-9fd1-418c8ea7ed65",
            kickOffTime: "2019-09-21T20:00:00.000+02:00",
          },
          "d8fee9fa-ead5-490b-9140-6cb38f4a9f05": {
            awayTeamId: "21274b2b-3500-4a49-971b-0a6ae9cafb58",
            goalsAway: 1,
            goalsHome: 2,
            homeTeamId: "cdfaf7f7-8d7c-4d35-8173-d67e238c8a71",
            kickOffTime: "2019-09-20T20:45:00.000+02:00",
          },
        },
        id: "32baf2a2-9b6e-43e7-820b-3df9655b7a77",
        matchday: 6,
        startDate: "2019-09-20T20:45:00.000+02:00",
      },
      {
        endDate: "2019-09-25T23:00:00.000+02:00",
        fixtures: {
          "11919bd0-941e-43a6-ba41-060d169aaeb1": {
            awayTeamId: "4b2a1635-9a3d-42ca-afb1-f46766b7b179",
            goalsAway: 2,
            goalsHome: 2,
            homeTeamId: "fd5fa7bb-3211-41ce-b66f-49b074c2aab8",
            kickOffTime: "2019-09-25T19:00:00.000+02:00",
          },
          "388265cb-6629-4e95-bd22-a7c27da8585c": {
            awayTeamId: "ae1b5cf9-73b2-41ef-bc92-4715dd6a4af0",
            goalsAway: 0,
            goalsHome: 0,
            homeTeamId: "2507719b-e3f6-4763-a012-b3c302b2b4b8",
            kickOffTime: "2019-09-24T19:00:00.000+02:00",
          },
          "3c506472-1e7d-4c6e-b89b-ff861d44b18d": {
            awayTeamId: "2b3249eb-5868-4700-8d55-cb5985e34339",
            goalsAway: 1,
            goalsHome: 0,
            homeTeamId: "3ba8e3a3-ba20-4ec8-b01a-a5945a56a93b",
            kickOffTime: "2019-09-25T19:00:00.000+02:00",
          },
          "607fe9dd-a1d3-44e1-80fd-9e73b2d361e5": {
            awayTeamId: "a0497862-8645-4890-a4f1-10d83941ecb8",
            goalsAway: 0,
            goalsHome: 1,
            homeTeamId: "21274b2b-3500-4a49-971b-0a6ae9cafb58",
            kickOffTime: "2019-09-25T19:00:00.000+02:00",
          },
          "9cef8d54-bca1-4f35-ba02-767e9a2451f6": {
            awayTeamId: "5e7d0f28-97c0-46f4-b733-2073f02065ef",
            goalsAway: 2,
            goalsHome: 0,
            homeTeamId: "7e6c61aa-3e8c-4a3e-8520-523e8608070c",
            kickOffTime: "2019-09-25T21:00:00.000+02:00",
          },
          "ad1cbd48-96d4-45ad-9c80-42effce9d5a5": {
            awayTeamId: "883b4940-1fb9-4714-9fd1-418c8ea7ed65",
            goalsAway: 3,
            goalsHome: 1,
            homeTeamId: "a0a38e6c-30e3-4ec9-9dd9-02b524217df2",
            kickOffTime: "2019-09-25T19:00:00.000+02:00",
          },
          "b36d89f6-455a-4509-a186-3a3ccf6799e7": {
            awayTeamId: "fee996ac-2454-425a-97f9-09c35f28a65f",
            goalsAway: 2,
            goalsHome: 0,
            homeTeamId: "64b2a17a-aa75-4171-b2b6-dfabd6083d48",
            kickOffTime: "2019-09-25T19:00:00.000+02:00",
          },
          "b9c812f6-2c3e-444c-b947-a1cfe24dce5d": {
            awayTeamId: "a7edfa0f-eb3d-4484-8437-3886cee7a3c5",
            goalsAway: 1,
            goalsHome: 3,
            homeTeamId: "3e6520d5-8a18-4bd6-8ad4-5e00f7add2e0",
            kickOffTime: "2019-09-24T21:00:00.000+02:00",
          },
          "ecb29b92-3651-4454-92e5-e3439743712d": {
            awayTeamId: "e3c68260-df86-4fc4-b5b2-40db66cee51d",
            goalsAway: 0,
            goalsHome: 1,
            homeTeamId: "f4aceb89-a8ac-4ff8-b13c-9f230ed85d56",
            kickOffTime: "2019-09-25T19:00:00.000+02:00",
          },
          "f80fdbc0-160f-47aa-8329-c9ab58c38a1f": {
            awayTeamId: "cdfaf7f7-8d7c-4d35-8173-d67e238c8a71",
            goalsAway: 0,
            goalsHome: 2,
            homeTeamId: "2dc5c094-9b90-4f1b-911a-3f68294dad99",
            kickOffTime: "2019-09-25T19:00:00.000+02:00",
          },
        },
        id: "150b2123-8571-4b87-8d1a-21c915cb8a8e",
        matchday: 7,
        startDate: "2019-09-24T19:00:00.000+02:00",
      },
      {
        endDate: "2019-09-29T23:00:00.000+02:00",
        fixtures: {
          "02890988-1150-452b-a097-93228050f88d": {
            awayTeamId: "21274b2b-3500-4a49-971b-0a6ae9cafb58",
            goalsAway: 1,
            goalsHome: 0,
            homeTeamId: "4b2a1635-9a3d-42ca-afb1-f46766b7b179",
            kickOffTime: "2019-09-28T13:30:00.000+02:00",
          },
          "0a6f1d27-5366-4801-976f-54fb051c4a1f": {
            awayTeamId: "f4aceb89-a8ac-4ff8-b13c-9f230ed85d56",
            goalsAway: 0,
            goalsHome: 1,
            homeTeamId: "cdfaf7f7-8d7c-4d35-8173-d67e238c8a71",
            kickOffTime: "2019-09-29T15:00:00.000+02:00",
          },
          "65260e67-7020-407c-940b-7d24ef949da4": {
            awayTeamId: "64b2a17a-aa75-4171-b2b6-dfabd6083d48",
            goalsAway: 2,
            goalsHome: 2,
            homeTeamId: "2b3249eb-5868-4700-8d55-cb5985e34339",
            kickOffTime: "2019-09-28T20:00:00.000+02:00",
          },
          "6b13e3a3-e739-42a1-86c1-d2680c6e2c3e": {
            awayTeamId: "2dc5c094-9b90-4f1b-911a-3f68294dad99",
            goalsAway: 1,
            goalsHome: 1,
            homeTeamId: "a7edfa0f-eb3d-4484-8437-3886cee7a3c5",
            kickOffTime: "2019-09-28T20:00:00.000+02:00",
          },
          "79d419bf-99b1-496a-a9a1-7701f493ce34": {
            awayTeamId: "7e6c61aa-3e8c-4a3e-8520-523e8608070c",
            goalsAway: 1,
            goalsHome: 0,
            homeTeamId: "883b4940-1fb9-4714-9fd1-418c8ea7ed65",
            kickOffTime: "2019-09-28T17:30:00.000+02:00",
          },
          "82025e61-c522-4cbe-8d37-f85054f9ebc6": {
            awayTeamId: "2507719b-e3f6-4763-a012-b3c302b2b4b8",
            goalsAway: 2,
            goalsHome: 1,
            homeTeamId: "5e7d0f28-97c0-46f4-b733-2073f02065ef",
            kickOffTime: "2019-09-28T20:00:00.000+02:00",
          },
          "87fc0c53-c86f-4b6d-9c67-851f106d3211": {
            awayTeamId: "a0497862-8645-4890-a4f1-10d83941ecb8",
            goalsAway: 1,
            goalsHome: 1,
            homeTeamId: "ae1b5cf9-73b2-41ef-bc92-4715dd6a4af0",
            kickOffTime: "2019-09-29T21:00:00.000+02:00",
          },
          "c49988a4-1ff0-4e14-b9f9-e6f5657c2b3f": {
            awayTeamId: "3ba8e3a3-ba20-4ec8-b01a-a5945a56a93b",
            goalsAway: 1,
            goalsHome: 0,
            homeTeamId: "e3c68260-df86-4fc4-b5b2-40db66cee51d",
            kickOffTime: "2019-09-29T17:00:00.000+02:00",
          },
          "d9fdff0a-7e7d-46dc-877f-705b8aaa9eb7": {
            awayTeamId: "fd5fa7bb-3211-41ce-b66f-49b074c2aab8",
            goalsAway: 1,
            goalsHome: 4,
            homeTeamId: "3e6520d5-8a18-4bd6-8ad4-5e00f7add2e0",
            kickOffTime: "2019-09-28T20:00:00.000+02:00",
          },
          "e7d757e4-1755-4f03-af04-7d0ae8ffdbb2": {
            awayTeamId: "a0a38e6c-30e3-4ec9-9dd9-02b524217df2",
            goalsAway: 1,
            goalsHome: 1,
            homeTeamId: "fee996ac-2454-425a-97f9-09c35f28a65f",
            kickOffTime: "2019-09-28T20:00:00.000+02:00",
          },
        },
        id: "1ef544d3-f2e7-4a59-8789-ad7339d32afc",
        matchday: 8,
        startDate: "2019-09-28T13:30:00.000+02:00",
      },
      {
        endDate: "2019-10-06T23:00:00.000+02:00",
        fixtures: {
          "20078662-ae67-4b3b-9a9d-35a5f9dbf8a7": {
            awayTeamId: "4b2a1635-9a3d-42ca-afb1-f46766b7b179",
            goalsAway: 0,
            goalsHome: 1,
            homeTeamId: "3ba8e3a3-ba20-4ec8-b01a-a5945a56a93b",
            kickOffTime: "2019-10-06T21:00:00.000+02:00",
          },
          "3e97d294-c28d-4dc3-80d6-5885e09489c5": {
            awayTeamId: "5e7d0f28-97c0-46f4-b733-2073f02065ef",
            goalsAway: 1,
            goalsHome: 0,
            homeTeamId: "a0497862-8645-4890-a4f1-10d83941ecb8",
            kickOffTime: "2019-10-06T17:00:00.000+02:00",
          },
          "4ea0e11b-2d69-414a-a49b-b661ff2903d8": {
            awayTeamId: "2b3249eb-5868-4700-8d55-cb5985e34339",
            goalsAway: 0,
            goalsHome: 2,
            homeTeamId: "fd5fa7bb-3211-41ce-b66f-49b074c2aab8",
            kickOffTime: "2019-10-05T20:00:00.000+02:00",
          },
          "761b3676-021a-431c-9720-20de7dfb4003": {
            awayTeamId: "3e6520d5-8a18-4bd6-8ad4-5e00f7add2e0",
            goalsAway: 1,
            goalsHome: 3,
            homeTeamId: "f4aceb89-a8ac-4ff8-b13c-9f230ed85d56",
            kickOffTime: "2019-10-05T20:00:00.000+02:00",
          },
          "997e18ae-9686-4f7c-919d-d11df0bb6dfd": {
            awayTeamId: "e3c68260-df86-4fc4-b5b2-40db66cee51d",
            goalsAway: 2,
            goalsHome: 2,
            homeTeamId: "2dc5c094-9b90-4f1b-911a-3f68294dad99",
            kickOffTime: "2019-10-06T15:00:00.000+02:00",
          },
          "ab6bfbdf-19de-42f4-87b9-1396fbfca576": {
            awayTeamId: "a7edfa0f-eb3d-4484-8437-3886cee7a3c5",
            goalsAway: 0,
            goalsHome: 1,
            homeTeamId: "21274b2b-3500-4a49-971b-0a6ae9cafb58",
            kickOffTime: "2019-10-05T20:00:00.000+02:00",
          },
          "b965bb7b-db46-4c86-a103-f0b728dc4a0c": {
            awayTeamId: "ae1b5cf9-73b2-41ef-bc92-4715dd6a4af0",
            goalsAway: 1,
            goalsHome: 3,
            homeTeamId: "a0a38e6c-30e3-4ec9-9dd9-02b524217df2",
            kickOffTime: "2019-10-04T20:45:00.000+02:00",
          },
          "d22c6eff-0875-4c11-bb50-28ce878a0f5d": {
            awayTeamId: "fee996ac-2454-425a-97f9-09c35f28a65f",
            goalsAway: 0,
            goalsHome: 4,
            homeTeamId: "7e6c61aa-3e8c-4a3e-8520-523e8608070c",
            kickOffTime: "2019-10-05T17:30:00.000+02:00",
          },
          "d2b477c7-b00c-4ac6-829c-55506d20df6e": {
            awayTeamId: "883b4940-1fb9-4714-9fd1-418c8ea7ed65",
            goalsAway: 3,
            goalsHome: 1,
            homeTeamId: "64b2a17a-aa75-4171-b2b6-dfabd6083d48",
            kickOffTime: "2019-10-05T20:00:00.000+02:00",
          },
          "f7acfb83-55e5-4ac6-8c2a-900d9635ab99": {
            awayTeamId: "cdfaf7f7-8d7c-4d35-8173-d67e238c8a71",
            goalsAway: 0,
            goalsHome: 1,
            homeTeamId: "2507719b-e3f6-4763-a012-b3c302b2b4b8",
            kickOffTime: "2019-10-05T20:00:00.000+02:00",
          },
        },
        id: "a4aa0a91-6bef-4000-9148-76b661397e7e",
        matchday: 9,
        startDate: "2019-10-04T20:45:00.000+02:00",
      },
      {
        endDate: "2019-10-20T23:00:00.000+02:00",
        fixtures: {
          "0b2e228f-02df-4911-9ff8-8dff7775604f": {
            awayTeamId: "cdfaf7f7-8d7c-4d35-8173-d67e238c8a71",
            goalsAway: 0,
            goalsHome: 2,
            homeTeamId: "ae1b5cf9-73b2-41ef-bc92-4715dd6a4af0",
            kickOffTime: "2019-10-20T21:00:00.000+02:00",
          },
          "2b48a568-3dbd-4dcf-b19d-23b8a152b9b7": {
            awayTeamId: "2dc5c094-9b90-4f1b-911a-3f68294dad99",
            goalsAway: 1,
            goalsHome: 2,
            homeTeamId: "64b2a17a-aa75-4171-b2b6-dfabd6083d48",
            kickOffTime: "2019-10-19T20:00:00.000+02:00",
          },
          "39ed48fd-c529-4b20-ace8-74de9547d7d3": {
            awayTeamId: "7e6c61aa-3e8c-4a3e-8520-523e8608070c",
            goalsAway: 4,
            goalsHome: 1,
            homeTeamId: "a7edfa0f-eb3d-4484-8437-3886cee7a3c5",
            kickOffTime: "2019-10-18T20:45:00.000+02:00",
          },
          "3f7710bc-5e0a-494f-9cd0-dffd6faef24a": {
            awayTeamId: "a0a38e6c-30e3-4ec9-9dd9-02b524217df2",
            goalsAway: 1,
            goalsHome: 1,
            homeTeamId: "e3c68260-df86-4fc4-b5b2-40db66cee51d",
            kickOffTime: "2019-10-19T20:00:00.000+02:00",
          },
          "42f45a82-1763-4634-8c4b-d63ad9afa72f": {
            awayTeamId: "f4aceb89-a8ac-4ff8-b13c-9f230ed85d56",
            goalsAway: 0,
            goalsHome: 1,
            homeTeamId: "5e7d0f28-97c0-46f4-b733-2073f02065ef",
            kickOffTime: "2019-10-19T20:00:00.000+02:00",
          },
          "608c7054-eba4-449b-a6fa-6fb1569f69d7": {
            awayTeamId: "fd5fa7bb-3211-41ce-b66f-49b074c2aab8",
            goalsAway: 1,
            goalsHome: 0,
            homeTeamId: "fee996ac-2454-425a-97f9-09c35f28a65f",
            kickOffTime: "2019-10-19T20:00:00.000+02:00",
          },
          "7518d36f-c876-4006-8eab-48ede1fb1939": {
            awayTeamId: "a0497862-8645-4890-a4f1-10d83941ecb8",
            goalsAway: 2,
            goalsHome: 3,
            homeTeamId: "3e6520d5-8a18-4bd6-8ad4-5e00f7add2e0",
            kickOffTime: "2019-10-20T17:00:00.000+02:00",
          },
          "7b789622-2b99-4880-9349-f045abb72d50": {
            awayTeamId: "2507719b-e3f6-4763-a012-b3c302b2b4b8",
            goalsAway: 0,
            goalsHome: 0,
            homeTeamId: "4b2a1635-9a3d-42ca-afb1-f46766b7b179",
            kickOffTime: "2019-10-19T17:30:00.000+02:00",
          },
          "a0ac6e4c-63f0-4594-9a2f-869d9f051b04": {
            awayTeamId: "21274b2b-3500-4a49-971b-0a6ae9cafb58",
            goalsAway: 0,
            goalsHome: 1,
            homeTeamId: "2b3249eb-5868-4700-8d55-cb5985e34339",
            kickOffTime: "2019-10-19T20:00:00.000+02:00",
          },
          "ad266742-730d-4a94-8c12-4f6122c6c708": {
            awayTeamId: "3ba8e3a3-ba20-4ec8-b01a-a5945a56a93b",
            goalsAway: 1,
            goalsHome: 0,
            homeTeamId: "883b4940-1fb9-4714-9fd1-418c8ea7ed65",
            kickOffTime: "2019-10-20T15:00:00.000+02:00",
          },
        },
        id: "1571b333-241d-42ef-8239-a9e8787b4027",
        matchday: 10,
        startDate: "2019-10-18T20:45:00.000+02:00",
      },
      {
        endDate: "2019-10-27T23:00:00.000+01:00",
        fixtures: {
          "305fa9be-03bc-4c0b-9c66-3f385ddd4853": {
            awayTeamId: "fee996ac-2454-425a-97f9-09c35f28a65f",
            goalsAway: 0,
            goalsHome: 0,
            homeTeamId: "f4aceb89-a8ac-4ff8-b13c-9f230ed85d56",
            kickOffTime: "2019-10-26T20:00:00.000+02:00",
          },
          "777c5978-912a-4b9a-bb7e-d48573eb4e98": {
            awayTeamId: "ae1b5cf9-73b2-41ef-bc92-4715dd6a4af0",
            goalsAway: 0,
            goalsHome: 4,
            homeTeamId: "7e6c61aa-3e8c-4a3e-8520-523e8608070c",
            kickOffTime: "2019-10-27T21:00:00.000+01:00",
          },
          "817ddb71-3d4b-4a2e-bfca-a7e2958811a4": {
            awayTeamId: "64b2a17a-aa75-4171-b2b6-dfabd6083d48",
            goalsAway: 2,
            goalsHome: 3,
            homeTeamId: "a0497862-8645-4890-a4f1-10d83941ecb8",
            kickOffTime: "2019-10-27T15:00:00.000+01:00",
          },
          "a2e93227-5009-43b4-92ce-c9fcef074ab0": {
            awayTeamId: "a7edfa0f-eb3d-4484-8437-3886cee7a3c5",
            goalsAway: 0,
            goalsHome: 1,
            homeTeamId: "cdfaf7f7-8d7c-4d35-8173-d67e238c8a71",
            kickOffTime: "2019-10-26T20:00:00.000+02:00",
          },
          "d085be99-2bdc-43bc-9046-ca59bf9a6464": {
            awayTeamId: "e3c68260-df86-4fc4-b5b2-40db66cee51d",
            goalsAway: 0,
            goalsHome: 0,
            homeTeamId: "5e7d0f28-97c0-46f4-b733-2073f02065ef",
            kickOffTime: "2019-10-26T20:00:00.000+02:00",
          },
          "e561f778-2047-4c2e-adf0-aff4622f4e75": {
            awayTeamId: "883b4940-1fb9-4714-9fd1-418c8ea7ed65",
            goalsAway: 0,
            goalsHome: 3,
            homeTeamId: "2dc5c094-9b90-4f1b-911a-3f68294dad99",
            kickOffTime: "2019-10-26T17:30:00.000+02:00",
          },
          "e73524c1-894a-4087-8c48-425553375772": {
            awayTeamId: "2507719b-e3f6-4763-a012-b3c302b2b4b8",
            goalsAway: 0,
            goalsHome: 2,
            homeTeamId: "fd5fa7bb-3211-41ce-b66f-49b074c2aab8",
            kickOffTime: "2019-10-26T20:00:00.000+02:00",
          },
          "eebd398a-e588-459d-9dd6-4dc4383a783f": {
            awayTeamId: "a0a38e6c-30e3-4ec9-9dd9-02b524217df2",
            goalsAway: 2,
            goalsHome: 2,
            homeTeamId: "3ba8e3a3-ba20-4ec8-b01a-a5945a56a93b",
            kickOffTime: "2019-10-27T17:00:00.000+01:00",
          },
          "f894799c-b765-4680-a9bb-d789991451f7": {
            awayTeamId: "2b3249eb-5868-4700-8d55-cb5985e34339",
            goalsAway: 0,
            goalsHome: 2,
            homeTeamId: "4b2a1635-9a3d-42ca-afb1-f46766b7b179",
            kickOffTime: "2019-10-26T20:00:00.000+02:00",
          },
          "fc56535d-2b0f-4a28-9eed-2bde4e253f86": {
            awayTeamId: "3e6520d5-8a18-4bd6-8ad4-5e00f7add2e0",
            goalsAway: 1,
            goalsHome: 0,
            homeTeamId: "21274b2b-3500-4a49-971b-0a6ae9cafb58",
            kickOffTime: "2019-10-25T20:45:00.000+02:00",
          },
        },
        id: "75ee1d0b-e056-47cf-a766-d4f027d91ee6",
        matchday: 11,
        startDate: "2019-10-25T20:45:00.000+02:00",
      },
      {
        endDate: "2019-11-03T23:00:00.000+01:00",
        fixtures: {
          "229d02d8-90e9-4668-be80-0702276ae925": {
            awayTeamId: "f4aceb89-a8ac-4ff8-b13c-9f230ed85d56",
            goalsAway: 2,
            goalsHome: 2,
            homeTeamId: "2b3249eb-5868-4700-8d55-cb5985e34339",
            kickOffTime: "2019-11-02T20:00:00.000+01:00",
          },
          "8a401fed-6057-4903-a4f2-93b1290ab586": {
            awayTeamId: "a0497862-8645-4890-a4f1-10d83941ecb8",
            goalsAway: 1,
            goalsHome: 0,
            homeTeamId: "e3c68260-df86-4fc4-b5b2-40db66cee51d",
            id: "8a401fed-6057-4903-a4f2-93b1290ab586",
            kickOffTime: "2020-01-15T18:01:02.472Z",
          },
          "8c063774-2c12-4e83-8f41-3e5938b16be0": {
            awayTeamId: "4b2a1635-9a3d-42ca-afb1-f46766b7b179",
            goalsAway: 3,
            goalsHome: 2,
            homeTeamId: "64b2a17a-aa75-4171-b2b6-dfabd6083d48",
            kickOffTime: "2019-11-02T20:00:00.000+01:00",
          },
          "9a65146a-26d5-4649-b2e8-78c0d8fecc53": {
            awayTeamId: "fd5fa7bb-3211-41ce-b66f-49b074c2aab8",
            goalsAway: 0,
            goalsHome: 1,
            homeTeamId: "a0a38e6c-30e3-4ec9-9dd9-02b524217df2",
            kickOffTime: "2019-11-02T20:00:00.000+01:00",
          },
          "a1362bb4-bbbd-40bf-ab6c-57b29218a382": {
            awayTeamId: "21274b2b-3500-4a49-971b-0a6ae9cafb58",
            goalsAway: 0,
            goalsHome: 2,
            homeTeamId: "883b4940-1fb9-4714-9fd1-418c8ea7ed65",
            kickOffTime: "2019-11-03T15:00:00.000+01:00",
          },
          "af99cfd0-d47b-4305-b927-0e8e20613402": {
            awayTeamId: "2dc5c094-9b90-4f1b-911a-3f68294dad99",
            goalsAway: 1,
            goalsHome: 2,
            homeTeamId: "ae1b5cf9-73b2-41ef-bc92-4715dd6a4af0",
            kickOffTime: "2019-11-02T17:30:00.000+01:00",
          },
          "cc98f6f4-d272-4db9-bbaf-dd3c1f7a13f1": {
            awayTeamId: "5e7d0f28-97c0-46f4-b733-2073f02065ef",
            goalsAway: 0,
            goalsHome: 2,
            homeTeamId: "a7edfa0f-eb3d-4484-8437-3886cee7a3c5",
            kickOffTime: "2019-11-03T17:00:00.000+01:00",
          },
          "dcb890b3-2456-4078-a054-696abdf187ef": {
            awayTeamId: "3e6520d5-8a18-4bd6-8ad4-5e00f7add2e0",
            goalsAway: 0,
            goalsHome: 1,
            homeTeamId: "3ba8e3a3-ba20-4ec8-b01a-a5945a56a93b",
            kickOffTime: "2019-11-03T21:00:00.000+01:00",
          },
          "eb533bf2-7e61-42f2-83ab-abfcab255eee": {
            awayTeamId: "cdfaf7f7-8d7c-4d35-8173-d67e238c8a71",
            goalsAway: 0,
            goalsHome: 1,
            homeTeamId: "fee996ac-2454-425a-97f9-09c35f28a65f",
            kickOffTime: "2019-11-02T20:00:00.000+01:00",
          },
          "f371886c-a08d-43a8-8489-f8f42f04311b": {
            awayTeamId: "7e6c61aa-3e8c-4a3e-8520-523e8608070c",
            goalsAway: 1,
            goalsHome: 2,
            homeTeamId: "2507719b-e3f6-4763-a012-b3c302b2b4b8",
            kickOffTime: "2019-11-01T20:45:00.000+01:00",
          },
        },
        id: "21d5fdc1-e940-476c-892a-0501c2c5a927",
        matchday: 12,
        startDate: "2019-11-01T20:45:00.000+01:00",
      },
      {
        endDate: "2019-11-10T23:00:00.000+01:00",
        fixtures: {
          "1c3bd44a-990b-4875-b0bf-8ce8dfd2abcb": {
            awayTeamId: "883b4940-1fb9-4714-9fd1-418c8ea7ed65",
            goalsAway: 1,
            goalsHome: 1,
            homeTeamId: "a7edfa0f-eb3d-4484-8437-3886cee7a3c5",
            kickOffTime: "2019-11-08T20:45:00.000+01:00",
          },
          "26d8be8b-e19d-484c-b28a-a9dcaa5066fe": {
            awayTeamId: "2507719b-e3f6-4763-a012-b3c302b2b4b8",
            goalsAway: 0,
            goalsHome: 1,
            homeTeamId: "3e6520d5-8a18-4bd6-8ad4-5e00f7add2e0",
            kickOffTime: "2019-11-09T20:00:00.000+01:00",
          },
          "6815c8c4-77cc-4f8f-b2d2-554ef4d22998": {
            awayTeamId: "a0a38e6c-30e3-4ec9-9dd9-02b524217df2",
            goalsAway: 1,
            goalsHome: 3,
            homeTeamId: "a0497862-8645-4890-a4f1-10d83941ecb8",
            kickOffTime: "2019-11-10T15:00:00.000+01:00",
          },
          "7948ce6a-4459-43cc-ae4f-d20af9676fb9": {
            awayTeamId: "fee996ac-2454-425a-97f9-09c35f28a65f",
            goalsAway: 0,
            goalsHome: 0,
            homeTeamId: "5e7d0f28-97c0-46f4-b733-2073f02065ef",
            kickOffTime: "2019-11-09T20:00:00.000+01:00",
          },
          "7ab0f64c-4275-4ee2-b84a-8fe9954311af": {
            awayTeamId: "2b3249eb-5868-4700-8d55-cb5985e34339",
            goalsAway: 0,
            goalsHome: 0,
            homeTeamId: "2dc5c094-9b90-4f1b-911a-3f68294dad99",
            kickOffTime: "2019-11-09T20:00:00.000+01:00",
          },
          "80225927-1bc0-43c8-ad29-ecb7130635af": {
            awayTeamId: "e3c68260-df86-4fc4-b5b2-40db66cee51d",
            goalsAway: 1,
            goalsHome: 4,
            homeTeamId: "cdfaf7f7-8d7c-4d35-8173-d67e238c8a71",
            kickOffTime: "2019-11-09T20:00:00.000+01:00",
          },
          "87f98e0d-3840-45b6-bde8-0b8efbef2240": {
            awayTeamId: "3ba8e3a3-ba20-4ec8-b01a-a5945a56a93b",
            goalsAway: 3,
            goalsHome: 2,
            homeTeamId: "21274b2b-3500-4a49-971b-0a6ae9cafb58",
            kickOffTime: "2019-11-10T17:05:00.000+01:00",
          },
          "8d7c4b65-d105-4a67-ba17-8d567709a56f": {
            awayTeamId: "7e6c61aa-3e8c-4a3e-8520-523e8608070c",
            goalsAway: 2,
            goalsHome: 1,
            homeTeamId: "fd5fa7bb-3211-41ce-b66f-49b074c2aab8",
            kickOffTime: "2019-11-09T17:30:00.000+01:00",
          },
          "a2e2c42f-aca1-4810-bc82-49574114087c": {
            awayTeamId: "4b2a1635-9a3d-42ca-afb1-f46766b7b179",
            goalsAway: 1,
            goalsHome: 2,
            homeTeamId: "ae1b5cf9-73b2-41ef-bc92-4715dd6a4af0",
            kickOffTime: "2019-11-10T21:00:00.000+01:00",
          },
          "dd45a8be-5331-48ca-8839-493065168773": {
            awayTeamId: "64b2a17a-aa75-4171-b2b6-dfabd6083d48",
            goalsAway: 0,
            goalsHome: 3,
            homeTeamId: "f4aceb89-a8ac-4ff8-b13c-9f230ed85d56",
            kickOffTime: "2019-11-10T17:00:00.000+01:00",
          },
        },
        id: "bc4ad8ba-748d-4888-bfcf-9eeed3969742",
        matchday: 13,
        startDate: "2019-11-08T20:45:00.000+01:00",
      },
      {
        endDate: "2019-11-24T23:00:00.000+01:00",
        fixtures: {
          "18ced89b-8399-4844-9218-4d40160f6cb0": {
            awayTeamId: "e3c68260-df86-4fc4-b5b2-40db66cee51d",
            goalsAway: 0,
            goalsHome: 1,
            homeTeamId: "fee996ac-2454-425a-97f9-09c35f28a65f",
            kickOffTime: "2019-11-23T20:00:00.000+01:00",
          },
          "2ba91a04-92e4-46b5-8b48-0ea0060d4a8c": {
            awayTeamId: "5e7d0f28-97c0-46f4-b733-2073f02065ef",
            goalsAway: 1,
            goalsHome: 1,
            homeTeamId: "2b3249eb-5868-4700-8d55-cb5985e34339",
            kickOffTime: "2019-11-23T20:00:00.000+01:00",
          },
          "41b1cc1d-ee93-4d56-8269-bb6cdcde2f68": {
            awayTeamId: "f4aceb89-a8ac-4ff8-b13c-9f230ed85d56",
            goalsAway: 0,
            goalsHome: 0,
            homeTeamId: "3ba8e3a3-ba20-4ec8-b01a-a5945a56a93b",
            kickOffTime: "2019-11-24T17:00:00.000+01:00",
          },
          "6a7cb019-ff6d-46db-b3de-ac5767a34098": {
            awayTeamId: "cdfaf7f7-8d7c-4d35-8173-d67e238c8a71",
            goalsAway: 4,
            goalsHome: 0,
            homeTeamId: "a0a38e6c-30e3-4ec9-9dd9-02b524217df2",
            kickOffTime: "2019-11-23T20:00:00.000+01:00",
          },
          "76f7c139-8ad5-4d33-b44e-8b2f6bb013aa": {
            awayTeamId: "21274b2b-3500-4a49-971b-0a6ae9cafb58",
            goalsAway: 1,
            goalsHome: 1,
            homeTeamId: "fd5fa7bb-3211-41ce-b66f-49b074c2aab8",
            kickOffTime: "2019-11-23T20:00:00.000+01:00",
          },
          "84b77875-64ee-4d2d-bcd5-adc860e03e17": {
            awayTeamId: "ae1b5cf9-73b2-41ef-bc92-4715dd6a4af0",
            goalsAway: 2,
            goalsHome: 0,
            homeTeamId: "64b2a17a-aa75-4171-b2b6-dfabd6083d48",
            kickOffTime: "2019-11-24T21:00:00.000+01:00",
          },
          "86cd0dce-ae91-420c-9c4a-5c369442d1ed": {
            awayTeamId: "2dc5c094-9b90-4f1b-911a-3f68294dad99",
            goalsAway: 0,
            goalsHome: 2,
            homeTeamId: "7e6c61aa-3e8c-4a3e-8520-523e8608070c",
            kickOffTime: "2019-11-22T20:45:00.000+01:00",
          },
          "ad5f7256-3fe8-4775-9e70-3577ecece791": {
            awayTeamId: "a0497862-8645-4890-a4f1-10d83941ecb8",
            goalsAway: 1,
            goalsHome: 2,
            homeTeamId: "2507719b-e3f6-4763-a012-b3c302b2b4b8",
            kickOffTime: "2019-11-23T20:00:00.000+01:00",
          },
          "b24d2a23-a3de-40e3-846c-6f09f6ed5ed9": {
            awayTeamId: "3e6520d5-8a18-4bd6-8ad4-5e00f7add2e0",
            goalsAway: 1,
            goalsHome: 2,
            homeTeamId: "883b4940-1fb9-4714-9fd1-418c8ea7ed65",
            kickOffTime: "2019-11-24T15:00:00.000+01:00",
          },
          "cb7167ef-095d-41ca-ab14-21936aacdc53": {
            awayTeamId: "a7edfa0f-eb3d-4484-8437-3886cee7a3c5",
            goalsAway: 1,
            goalsHome: 2,
            homeTeamId: "4b2a1635-9a3d-42ca-afb1-f46766b7b179",
            kickOffTime: "2019-11-23T17:30:00.000+01:00",
          },
        },
        id: "fbae61e7-48aa-4d04-aa76-d9107cbc65fc",
        matchday: 14,
        startDate: "2019-11-22T20:45:00.000+01:00",
      },
      {
        endDate: "2019-12-01T19:00:00.000+01:00",
        fixtures: {
          "0562880d-5692-4c36-b939-e2e25845178c": {
            awayTeamId: "fd5fa7bb-3211-41ce-b66f-49b074c2aab8",
            goalsAway: 1,
            goalsHome: 2,
            homeTeamId: "ae1b5cf9-73b2-41ef-bc92-4715dd6a4af0",
            kickOffTime: "2019-11-29T20:45:00.000+01:00",
          },
          "388f5480-20a5-4698-99b6-33ace33571ec": {
            awayTeamId: "883b4940-1fb9-4714-9fd1-418c8ea7ed65",
            goalsAway: 1,
            goalsHome: 1,
            homeTeamId: "5e7d0f28-97c0-46f4-b733-2073f02065ef",
            kickOffTime: "2019-11-30T20:00:00.000+01:00",
          },
          "44829959-d226-4d39-a602-45e0a36fec08": {
            awayTeamId: "64b2a17a-aa75-4171-b2b6-dfabd6083d48",
            goalsAway: 1,
            goalsHome: 2,
            homeTeamId: "21274b2b-3500-4a49-971b-0a6ae9cafb58",
            kickOffTime: "2019-12-01T15:00:00.000+01:00",
          },
          "7d14017c-6fc9-4722-bd6f-51a74d90d648": {
            awayTeamId: "3ba8e3a3-ba20-4ec8-b01a-a5945a56a93b",
            goalsAway: 1,
            goalsHome: 2,
            homeTeamId: "a0497862-8645-4890-a4f1-10d83941ecb8",
            kickOffTime: "2019-12-01T17:00:00.000+01:00",
          },
          "826f0b3c-065a-4b61-ae67-b4585ce1d40b": {
            awayTeamId: "a0a38e6c-30e3-4ec9-9dd9-02b524217df2",
            goalsAway: 2,
            goalsHome: 4,
            homeTeamId: "f4aceb89-a8ac-4ff8-b13c-9f230ed85d56",
            kickOffTime: "2019-11-30T20:00:00.000+01:00",
          },
          "92aac80b-51e4-4fcc-b9cc-b8f7201b5aff": {
            awayTeamId: "4b2a1635-9a3d-42ca-afb1-f46766b7b179",
            goalsAway: 2,
            goalsHome: 1,
            homeTeamId: "cdfaf7f7-8d7c-4d35-8173-d67e238c8a71",
            kickOffTime: "2019-11-30T17:30:00.000+01:00",
          },
          "ae056d24-ab2e-4388-8210-41429e8d2bfd": {
            awayTeamId: "7e6c61aa-3e8c-4a3e-8520-523e8608070c",
            goalsAway: 4,
            goalsHome: 1,
            homeTeamId: "3e6520d5-8a18-4bd6-8ad4-5e00f7add2e0",
            id: "ae056d24-ab2e-4388-8210-41429e8d2bfd",
            kickOffTime: "2020-01-15T20:01:07.800Z",
          },
          "b44b906e-1672-4ecd-a272-0cc8cc0d678f": {
            awayTeamId: "2b3249eb-5868-4700-8d55-cb5985e34339",
            goalsAway: 1,
            goalsHome: 1,
            homeTeamId: "e3c68260-df86-4fc4-b5b2-40db66cee51d",
            kickOffTime: "2019-11-30T20:00:00.000+01:00",
          },
          "b586f6dd-9832-418d-bbea-9314c39482c1": {
            awayTeamId: "2507719b-e3f6-4763-a012-b3c302b2b4b8",
            goalsAway: 0,
            goalsHome: 1,
            homeTeamId: "2dc5c094-9b90-4f1b-911a-3f68294dad99",
            kickOffTime: "2019-11-30T20:00:00.000+01:00",
          },
          "d9ed2b16-9f0f-48ca-b504-76d3e4ad8a65": {
            awayTeamId: "fee996ac-2454-425a-97f9-09c35f28a65f",
            goalsAway: 1,
            goalsHome: 3,
            homeTeamId: "a7edfa0f-eb3d-4484-8437-3886cee7a3c5",
            kickOffTime: "2019-11-30T20:00:00.000+01:00",
          },
        },
        id: "61a74bc5-3d21-406c-97b1-81b71366875a",
        matchday: 15,
        startDate: "2019-11-29T20:45:00.000+01:00",
      },
      {
        endDate: "2019-12-04T23:05:00.000+01:00",
        fixtures: {
          "00019ada-3b06-45fc-9bf3-186c92b10582": {
            awayTeamId: "a7edfa0f-eb3d-4484-8437-3886cee7a3c5",
            goalsAway: 1,
            goalsHome: 4,
            homeTeamId: "3ba8e3a3-ba20-4ec8-b01a-a5945a56a93b",
            kickOffTime: "2019-12-04T19:00:00.000+01:00",
          },
          "5e67c45f-404f-4d34-a824-27e97978422d": {
            awayTeamId: "21274b2b-3500-4a49-971b-0a6ae9cafb58",
            goalsAway: 0,
            goalsHome: 2,
            homeTeamId: "7e6c61aa-3e8c-4a3e-8520-523e8608070c",
            kickOffTime: "2019-12-04T21:05:00.000+01:00",
          },
          "637f4587-7125-49a6-9e2f-873053791ed5": {
            awayTeamId: "a0497862-8645-4890-a4f1-10d83941ecb8",
            goalsAway: 1,
            goalsHome: 0,
            homeTeamId: "2b3249eb-5868-4700-8d55-cb5985e34339",
            kickOffTime: "2019-12-04T19:00:00.000+01:00",
          },
          "95b78839-a3d3-4854-a4ef-9754b2c86ed8": {
            awayTeamId: "3e6520d5-8a18-4bd6-8ad4-5e00f7add2e0",
            goalsAway: 2,
            goalsHome: 1,
            homeTeamId: "64b2a17a-aa75-4171-b2b6-dfabd6083d48",
            kickOffTime: "2019-12-04T19:00:00.000+01:00",
          },
          "9d5bfd14-e8a0-4c28-9d85-5a814cf2e286": {
            awayTeamId: "2dc5c094-9b90-4f1b-911a-3f68294dad99",
            goalsAway: 1,
            goalsHome: 0,
            homeTeamId: "4b2a1635-9a3d-42ca-afb1-f46766b7b179",
            kickOffTime: "2019-12-03T21:05:00.000+01:00",
          },
          "ad9203b2-fd92-4583-b2c0-caee26b1b887": {
            awayTeamId: "f4aceb89-a8ac-4ff8-b13c-9f230ed85d56",
            goalsAway: 2,
            goalsHome: 2,
            homeTeamId: "2507719b-e3f6-4763-a012-b3c302b2b4b8",
            kickOffTime: "2019-12-04T19:00:00.000+01:00",
          },
          "c22c0a09-d421-406e-bd24-b1e08ff427b1": {
            awayTeamId: "cdfaf7f7-8d7c-4d35-8173-d67e238c8a71",
            goalsAway: 0,
            goalsHome: 5,
            homeTeamId: "fd5fa7bb-3211-41ce-b66f-49b074c2aab8",
            kickOffTime: "2019-12-03T19:00:00.000+01:00",
          },
          "d66f3623-00d0-49ba-8eaf-e49f11b43aef": {
            awayTeamId: "e3c68260-df86-4fc4-b5b2-40db66cee51d",
            goalsAway: 0,
            goalsHome: 6,
            homeTeamId: "883b4940-1fb9-4714-9fd1-418c8ea7ed65",
            kickOffTime: "2019-12-03T19:00:00.000+01:00",
          },
          "dbb7174a-e627-4a1d-8990-c74d253deebf": {
            awayTeamId: "5e7d0f28-97c0-46f4-b733-2073f02065ef",
            goalsAway: 1,
            goalsHome: 1,
            homeTeamId: "a0a38e6c-30e3-4ec9-9dd9-02b524217df2",
            id: "dbb7174a-e627-4a1d-8990-c74d253deebf",
            kickOffTime: "2020-01-15T18:01:02.473Z",
          },
          "f1f4aa4f-05fc-4f88-b1b5-f96c71314609": {
            awayTeamId: "ae1b5cf9-73b2-41ef-bc92-4715dd6a4af0",
            goalsAway: 2,
            goalsHome: 0,
            homeTeamId: "fee996ac-2454-425a-97f9-09c35f28a65f",
            kickOffTime: "2019-12-03T19:00:00.000+01:00",
          },
        },
        id: "7ef22b63-448c-4d94-8c89-efcf55cec7aa",
        matchday: 16,
        startDate: "2019-12-03T19:00:00.000+01:00",
      },
      {
        endDate: "2019-12-08T23:00:00.000+01:00",
        fixtures: {
          "085a8d55-be7c-4cbd-9ea4-5c2608cfa713": {
            awayTeamId: "fd5fa7bb-3211-41ce-b66f-49b074c2aab8",
            goalsAway: 0,
            goalsHome: 1,
            homeTeamId: "2dc5c094-9b90-4f1b-911a-3f68294dad99",
            kickOffTime: "2019-12-06T19:00:00.000+01:00",
          },
          "15b38d04-3a60-437f-afee-0605fe2de61a": {
            awayTeamId: "a0a38e6c-30e3-4ec9-9dd9-02b524217df2",
            goalsAway: 0,
            goalsHome: 3,
            homeTeamId: "3e6520d5-8a18-4bd6-8ad4-5e00f7add2e0",
            kickOffTime: "2019-12-07T20:00:00.000+01:00",
          },
          "3adfb104-093e-4131-ab5e-e43beb0a53be": {
            awayTeamId: "fee996ac-2454-425a-97f9-09c35f28a65f",
            goalsAway: 1,
            goalsHome: 2,
            homeTeamId: "a0497862-8645-4890-a4f1-10d83941ecb8",
            kickOffTime: "2019-12-07T20:00:00.000+01:00",
          },
          "6c6fc411-b5b6-4840-9182-44fd1c645956": {
            awayTeamId: "4b2a1635-9a3d-42ca-afb1-f46766b7b179",
            goalsAway: 4,
            goalsHome: 0,
            homeTeamId: "e3c68260-df86-4fc4-b5b2-40db66cee51d",
            kickOffTime: "2019-12-06T20:45:00.000+01:00",
          },
          "71a5382e-5723-4d6c-8465-08dee6ed83b1": {
            awayTeamId: "2b3249eb-5868-4700-8d55-cb5985e34339",
            goalsAway: 1,
            goalsHome: 4,
            homeTeamId: "a7edfa0f-eb3d-4484-8437-3886cee7a3c5",
            kickOffTime: "2019-12-07T20:00:00.000+01:00",
          },
          "7eef04a7-3432-4f91-adb9-43788ca1074f": {
            awayTeamId: "64b2a17a-aa75-4171-b2b6-dfabd6083d48",
            goalsAway: 2,
            goalsHome: 4,
            homeTeamId: "cdfaf7f7-8d7c-4d35-8173-d67e238c8a71",
            kickOffTime: "2019-12-07T20:00:00.000+01:00",
          },
          "9e72387f-9de1-4697-a109-06d3155a8ca3": {
            awayTeamId: "2507719b-e3f6-4763-a012-b3c302b2b4b8",
            goalsAway: 0,
            goalsHome: 1,
            homeTeamId: "21274b2b-3500-4a49-971b-0a6ae9cafb58",
            kickOffTime: "2019-12-08T16:00:00.000+01:00",
          },
          "ca3bd079-fe87-40e2-81bd-a159bc6d7ca1": {
            awayTeamId: "7e6c61aa-3e8c-4a3e-8520-523e8608070c",
            goalsAway: 3,
            goalsHome: 1,
            homeTeamId: "f4aceb89-a8ac-4ff8-b13c-9f230ed85d56",
            kickOffTime: "2019-12-07T17:30:00.000+01:00",
          },
          "cd889262-650b-4717-a193-9509ab738018": {
            awayTeamId: "3ba8e3a3-ba20-4ec8-b01a-a5945a56a93b",
            goalsAway: 1,
            goalsHome: 3,
            homeTeamId: "5e7d0f28-97c0-46f4-b733-2073f02065ef",
            kickOffTime: "2019-12-08T15:00:00.000+01:00",
          },
          "e7a3edd2-7cf8-40d1-954d-92f5df5052f5": {
            awayTeamId: "883b4940-1fb9-4714-9fd1-418c8ea7ed65",
            goalsAway: 1,
            goalsHome: 3,
            homeTeamId: "ae1b5cf9-73b2-41ef-bc92-4715dd6a4af0",
            kickOffTime: "2019-12-08T21:00:00.000+01:00",
          },
        },
        id: "e83e877e-eb12-4ff4-a77e-25f1f0100cb4",
        matchday: 17,
        startDate: "2019-12-06T19:00:00.000+01:00",
      },
      {
        endDate: "",
        fixtures: {
          "1066225f-5cbb-490a-bebb-00a3df73ea62": {
            awayTeamId: "2507719b-e3f6-4763-a012-b3c302b2b4b8",
            goalsAway: 1,
            goalsHome: 1,
            homeTeamId: "a0a38e6c-30e3-4ec9-9dd9-02b524217df2",
            id: "1066225f-5cbb-490a-bebb-00a3df73ea62",
            kickOffTime: "2019-12-14T20:00:39.351Z",
          },
          "22c11679-49ad-44a1-a171-2d1790d94ccb": {
            awayTeamId: "ae1b5cf9-73b2-41ef-bc92-4715dd6a4af0",
            goalsAway: 1,
            goalsHome: 1,
            homeTeamId: "2b3249eb-5868-4700-8d55-cb5985e34339",
            id: "22c11679-49ad-44a1-a171-2d1790d94ccb",
            kickOffTime: "2019-12-14T17:30:39.349Z",
          },
          "2790cb45-c082-4bd6-a649-5f0c68adb3ea": {
            awayTeamId: "cdfaf7f7-8d7c-4d35-8173-d67e238c8a71",
            goalsAway: 1,
            goalsHome: 0,
            homeTeamId: "883b4940-1fb9-4714-9fd1-418c8ea7ed65",
            id: "2790cb45-c082-4bd6-a649-5f0c68adb3ea",
            kickOffTime: "2019-12-15T15:00:26.495Z",
          },
          "2839fd9a-dde2-48ec-b1ee-550322f7e07d": {
            awayTeamId: "3e6520d5-8a18-4bd6-8ad4-5e00f7add2e0",
            goalsAway: 0,
            goalsHome: 0,
            homeTeamId: "fee996ac-2454-425a-97f9-09c35f28a65f",
            id: "2839fd9a-dde2-48ec-b1ee-550322f7e07d",
            kickOffTime: "2019-12-14T20:00:39.352Z",
          },
          "2cb96a5d-1537-4934-b9fe-924f416ce07a": {
            awayTeamId: "f4aceb89-a8ac-4ff8-b13c-9f230ed85d56",
            goalsAway: 1,
            goalsHome: 2,
            homeTeamId: "2dc5c094-9b90-4f1b-911a-3f68294dad99",
            id: "2cb96a5d-1537-4934-b9fe-924f416ce07a",
            kickOffTime: "2019-12-13T20:45:07.491Z",
          },
          "38fca8f9-c546-4a3a-938b-ef0e2809475e": {
            awayTeamId: "5e7d0f28-97c0-46f4-b733-2073f02065ef",
            goalsAway: 1,
            goalsHome: 0,
            homeTeamId: "64b2a17a-aa75-4171-b2b6-dfabd6083d48",
            id: "38fca8f9-c546-4a3a-938b-ef0e2809475e",
            kickOffTime: "2019-12-14T20:00:39.352Z",
          },
          "857810ae-d242-4df6-9605-3b7207a6d21c": {
            awayTeamId: "a0497862-8645-4890-a4f1-10d83941ecb8",
            goalsAway: 1,
            goalsHome: 0,
            homeTeamId: "4b2a1635-9a3d-42ca-afb1-f46766b7b179",
            id: "857810ae-d242-4df6-9605-3b7207a6d21c",
            kickOffTime: "2019-12-15T16:00:26.496Z",
          },
          "9b9b4493-6ded-41bd-9d18-0c57f7956618": {
            awayTeamId: "21274b2b-3500-4a49-971b-0a6ae9cafb58",
            goalsAway: 1,
            goalsHome: 0,
            homeTeamId: "e3c68260-df86-4fc4-b5b2-40db66cee51d",
            id: "9b9b4493-6ded-41bd-9d18-0c57f7956618",
            kickOffTime: "2019-12-14T20:00:39.351Z",
          },
          "c09b0541-b2da-4d05-a159-5d92c2650296": {
            awayTeamId: "a7edfa0f-eb3d-4484-8437-3886cee7a3c5",
            goalsAway: 0,
            goalsHome: 0,
            homeTeamId: "fd5fa7bb-3211-41ce-b66f-49b074c2aab8",
            id: "c09b0541-b2da-4d05-a159-5d92c2650296",
            kickOffTime: "2019-12-14T20:00:39.353Z",
          },
          "dcf8cf40-6019-4eac-8e3c-19cd225bc88e": {
            awayTeamId: "7e6c61aa-3e8c-4a3e-8520-523e8608070c",
            goalsAway: 4,
            goalsHome: 0,
            homeTeamId: "3ba8e3a3-ba20-4ec8-b01a-a5945a56a93b",
            id: "dcf8cf40-6019-4eac-8e3c-19cd225bc88e",
            kickOffTime: "2019-12-15T21:00:26.497Z",
          },
        },
        id: "a91a3f94-5d3b-4a71-b4ca-448c13131878",
        matchday: 18,
        startDate: "",
      },
      {
        endDate: "",
        fixtures: {
          "0427cfc8-5b28-466c-9c26-eb8a901401ed": {
            awayTeamId: "2dc5c094-9b90-4f1b-911a-3f68294dad99",
            goalsAway: 1,
            goalsHome: 5,
            homeTeamId: "3e6520d5-8a18-4bd6-8ad4-5e00f7add2e0",
            kickOffTime: "2019-12-21T20:45:00.000+01:00",
          },
          "230ce01c-a024-4e03-af5b-3e693d7de436": {
            awayTeamId: "fd5fa7bb-3211-41ce-b66f-49b074c2aab8",
            goalsAway: 0,
            goalsHome: 4,
            homeTeamId: "f4aceb89-a8ac-4ff8-b13c-9f230ed85d56",
            kickOffTime: "2019-12-21T20:45:00.000+01:00",
          },
          "62e580af-81f5-4b13-80b9-b58c6de98a09": {
            awayTeamId: "2b3249eb-5868-4700-8d55-cb5985e34339",
            goalsAway: 2,
            goalsHome: 2,
            homeTeamId: "2507719b-e3f6-4763-a012-b3c302b2b4b8",
            kickOffTime: "2019-12-21T20:45:00.000+01:00",
          },
          "63297e2f-56b4-44d8-96bc-86baca606d5e": {
            awayTeamId: "4b2a1635-9a3d-42ca-afb1-f46766b7b179",
            goalsAway: 1,
            goalsHome: 1,
            homeTeamId: "5e7d0f28-97c0-46f4-b733-2073f02065ef",
            kickOffTime: "2019-12-21T20:45:00.000+01:00",
          },
          "681be99c-1fe7-4553-8ddc-4646da7fe2e0": {
            awayTeamId: "883b4940-1fb9-4714-9fd1-418c8ea7ed65",
            goalsAway: 0,
            goalsHome: 1,
            homeTeamId: "a0497862-8645-4890-a4f1-10d83941ecb8",
            kickOffTime: "2019-12-21T20:45:00.000+01:00",
          },
          "7818f910-49f0-41a5-9d9a-a3b8a452a468": {
            awayTeamId: "3ba8e3a3-ba20-4ec8-b01a-a5945a56a93b",
            goalsAway: 1,
            goalsHome: 2,
            homeTeamId: "cdfaf7f7-8d7c-4d35-8173-d67e238c8a71",
            kickOffTime: "2019-12-21T20:45:00.000+01:00",
          },
          "a0675540-0afe-4ba6-8d33-2ef2e8a0b5cb": {
            awayTeamId: "e3c68260-df86-4fc4-b5b2-40db66cee51d",
            goalsAway: 1,
            goalsHome: 3,
            homeTeamId: "ae1b5cf9-73b2-41ef-bc92-4715dd6a4af0",
            kickOffTime: "2019-12-21T20:45:00.000+01:00",
          },
          "b52ffb11-2097-45e9-938e-494dea1e8b6f": {
            awayTeamId: "a0a38e6c-30e3-4ec9-9dd9-02b524217df2",
            goalsAway: 1,
            goalsHome: 4,
            homeTeamId: "7e6c61aa-3e8c-4a3e-8520-523e8608070c",
            kickOffTime: "2019-12-21T20:45:00.000+01:00",
          },
          "eb8c717b-ddb9-4d17-9c81-ba70cba93448": {
            awayTeamId: "64b2a17a-aa75-4171-b2b6-dfabd6083d48",
            goalsAway: 0,
            goalsHome: 3,
            homeTeamId: "a7edfa0f-eb3d-4484-8437-3886cee7a3c5",
            kickOffTime: "2019-12-21T20:45:00.000+01:00",
          },
          "f4136bfa-85d6-48c5-80b6-f1c651ce4e18": {
            awayTeamId: "fee996ac-2454-425a-97f9-09c35f28a65f",
            goalsAway: 2,
            goalsHome: 1,
            homeTeamId: "21274b2b-3500-4a49-971b-0a6ae9cafb58",
            kickOffTime: "2019-12-21T20:45:00.000+01:00",
          },
        },
        id: "b2f9255d-4b2f-4bc7-baa4-5c68861d31a3",
        matchday: 19,
        startDate: "",
      },
      {
        endDate: "",
        fixtures: {
          "097fbcab-5239-448c-9fa0-a438c0240ebe": {
            awayTeamId: "5e7d0f28-97c0-46f4-b733-2073f02065ef",
            goalsAway: 0,
            goalsHome: 2,
            homeTeamId: "e3c68260-df86-4fc4-b5b2-40db66cee51d",
            id: "097fbcab-5239-448c-9fa0-a438c0240ebe",
            kickOffTime: "2020-01-11T19:01:04.584Z",
          },
          "1fad6c84-0b75-4209-bce3-143c5d325c9f": {
            awayTeamId: "f4aceb89-a8ac-4ff8-b13c-9f230ed85d56",
            goalsAway: 2,
            goalsHome: 1,
            homeTeamId: "a0a38e6c-30e3-4ec9-9dd9-02b524217df2",
            id: "1fad6c84-0b75-4209-bce3-143c5d325c9f",
            kickOffTime: "2020-01-11T19:01:04.584Z",
          },
          "2348f184-c1cc-4d91-9906-1bbcdfe5743b": {
            awayTeamId: "cdfaf7f7-8d7c-4d35-8173-d67e238c8a71",
            goalsAway: 0,
            goalsHome: 1,
            homeTeamId: "2b3249eb-5868-4700-8d55-cb5985e34339",
            id: "2348f184-c1cc-4d91-9906-1bbcdfe5743b",
            kickOffTime: "2020-01-11T19:01:04.585Z",
          },
          "237aa077-537d-4cae-b123-62289c03b0dc": {
            awayTeamId: "fd5fa7bb-3211-41ce-b66f-49b074c2aab8",
            goalsAway: 5,
            goalsHome: 2,
            homeTeamId: "64b2a17a-aa75-4171-b2b6-dfabd6083d48",
            id: "237aa077-537d-4cae-b123-62289c03b0dc",
            kickOffTime: "2020-01-11T19:01:04.584Z",
          },
          "b211d784-7620-4839-9815-e9863fd2cccb": {
            awayTeamId: "a7edfa0f-eb3d-4484-8437-3886cee7a3c5",
            goalsAway: 1,
            goalsHome: 1,
            homeTeamId: "fee996ac-2454-425a-97f9-09c35f28a65f",
            id: "b211d784-7620-4839-9815-e9863fd2cccb",
            kickOffTime: "2020-01-11T19:01:04.584Z",
          },
          "ba4af27b-9a33-417b-9549-3a2ff9f2c7f1": {
            awayTeamId: "2dc5c094-9b90-4f1b-911a-3f68294dad99",
            goalsAway: 0,
            goalsHome: 1,
            homeTeamId: "2507719b-e3f6-4763-a012-b3c302b2b4b8",
            id: "ba4af27b-9a33-417b-9549-3a2ff9f2c7f1",
            kickOffTime: "2020-01-12T16:01:03.573Z",
          },
          "c6adfa1c-1287-4183-8e52-e49759d2c87a": {
            awayTeamId: "ae1b5cf9-73b2-41ef-bc92-4715dd6a4af0",
            goalsAway: 1,
            goalsHome: 0,
            homeTeamId: "a0497862-8645-4890-a4f1-10d83941ecb8",
            id: "c6adfa1c-1287-4183-8e52-e49759d2c87a",
            kickOffTime: "2020-01-10T20:01:01.819Z",
          },
          "c716da83-abdb-42ea-95f9-4a3af460f37f": {
            awayTeamId: "3e6520d5-8a18-4bd6-8ad4-5e00f7add2e0",
            goalsAway: 3,
            goalsHome: 3,
            homeTeamId: "7e6c61aa-3e8c-4a3e-8520-523e8608070c",
            id: "c716da83-abdb-42ea-95f9-4a3af460f37f",
            kickOffTime: "2020-01-12T20:01:11.574Z",
          },
          "d2ebbcca-ec5c-4bc2-b14f-c20b1df2fe19": {
            awayTeamId: "4b2a1635-9a3d-42ca-afb1-f46766b7b179",
            goalsAway: 2,
            goalsHome: 1,
            homeTeamId: "883b4940-1fb9-4714-9fd1-418c8ea7ed65",
            id: "d2ebbcca-ec5c-4bc2-b14f-c20b1df2fe19",
            kickOffTime: "2020-01-11T16:31:02.971Z",
          },
          "dd331690-231a-444c-8b7c-cd45646bf5c4": {
            awayTeamId: "21274b2b-3500-4a49-971b-0a6ae9cafb58",
            goalsAway: 2,
            goalsHome: 0,
            homeTeamId: "3ba8e3a3-ba20-4ec8-b01a-a5945a56a93b",
            id: "dd331690-231a-444c-8b7c-cd45646bf5c4",
            kickOffTime: "2020-01-12T14:01:01.886Z",
          },
        },
        id: "d917ac06-14df-4860-97f4-fbdc0236a082",
        matchday: 20,
        startDate: "",
      },
      {
        endDate: "",
        fixtures: {
          "2aebed41-cedc-470a-902b-ace453e5d675": {
            awayTeamId: "fee996ac-2454-425a-97f9-09c35f28a65f",
            goalsAway: 0,
            goalsHome: 0,
            homeTeamId: "ae1b5cf9-73b2-41ef-bc92-4715dd6a4af0",
            id: "2aebed41-cedc-470a-902b-ace453e5d675",
            kickOffTime: "2020-01-25T16:31:03.454Z",
          },
          "3b2c23b3-8316-49a9-a8c5-2c0720976110": {
            awayTeamId: "883b4940-1fb9-4714-9fd1-418c8ea7ed65",
            goalsAway: 1,
            goalsHome: 0,
            homeTeamId: "21274b2b-3500-4a49-971b-0a6ae9cafb58",
            id: "3b2c23b3-8316-49a9-a8c5-2c0720976110",
            kickOffTime: "2020-01-26T16:01:02.445Z",
          },
          "3f0612d8-8afd-445c-b336-ba66fbca59cd": {
            awayTeamId: "a0a38e6c-30e3-4ec9-9dd9-02b524217df2",
            goalsAway: 1,
            goalsHome: 2,
            homeTeamId: "fd5fa7bb-3211-41ce-b66f-49b074c2aab8",
            id: "3f0612d8-8afd-445c-b336-ba66fbca59cd",
            kickOffTime: "2020-01-25T19:00:59.865Z",
          },
          "4026397f-6825-4365-89e6-e14addb82661": {
            awayTeamId: "64b2a17a-aa75-4171-b2b6-dfabd6083d48",
            goalsAway: 0,
            goalsHome: 3,
            homeTeamId: "4b2a1635-9a3d-42ca-afb1-f46766b7b179",
            id: "4026397f-6825-4365-89e6-e14addb82661",
            kickOffTime: "2020-01-26T14:01:03.217Z",
          },
          "5bfcfecb-7557-48a5-a339-2a0aaf9771ba": {
            awayTeamId: "cdfaf7f7-8d7c-4d35-8173-d67e238c8a71",
            goalsAway: 3,
            goalsHome: 1,
            homeTeamId: "3e6520d5-8a18-4bd6-8ad4-5e00f7add2e0",
            id: "5bfcfecb-7557-48a5-a339-2a0aaf9771ba",
            kickOffTime: "2020-01-25T19:00:59.866Z",
          },
          "6b85d04a-fcad-4258-a291-7cc204010c84": {
            awayTeamId: "2b3249eb-5868-4700-8d55-cb5985e34339",
            goalsAway: 1,
            goalsHome: 0,
            homeTeamId: "5e7d0f28-97c0-46f4-b733-2073f02065ef",
            id: "6b85d04a-fcad-4258-a291-7cc204010c84",
            kickOffTime: "2020-01-25T19:00:59.866Z",
          },
          "789b49c4-466c-483c-b307-72244fa1d174": {
            awayTeamId: "a0497862-8645-4890-a4f1-10d83941ecb8",
            goalsAway: 1,
            goalsHome: 1,
            homeTeamId: "a7edfa0f-eb3d-4484-8437-3886cee7a3c5",
            id: "789b49c4-466c-483c-b307-72244fa1d174",
            kickOffTime: "2020-01-24T19:45:56.271Z",
          },
          "cbc22b2c-8ae7-4dfe-8d41-46915d4fd08c": {
            awayTeamId: "7e6c61aa-3e8c-4a3e-8520-523e8608070c",
            goalsAway: 2,
            goalsHome: 0,
            homeTeamId: "2dc5c094-9b90-4f1b-911a-3f68294dad99",
            id: "cbc22b2c-8ae7-4dfe-8d41-46915d4fd08c",
            kickOffTime: "2020-01-26T21:00:57.854Z",
          },
          "f37e93f7-7bf3-4193-acd0-fc90d007e22e": {
            awayTeamId: "2507719b-e3f6-4763-a012-b3c302b2b4b8",
            goalsAway: 1,
            goalsHome: 2,
            homeTeamId: "f4aceb89-a8ac-4ff8-b13c-9f230ed85d56",
            id: "f37e93f7-7bf3-4193-acd0-fc90d007e22e",
            kickOffTime: "2020-01-25T19:00:59.866Z",
          },
          "f3a920f1-68b7-4e58-a8c1-e108d4b778c9": {
            awayTeamId: "e3c68260-df86-4fc4-b5b2-40db66cee51d",
            goalsAway: 1,
            goalsHome: 2,
            homeTeamId: "3ba8e3a3-ba20-4ec8-b01a-a5945a56a93b",
            id: "f3a920f1-68b7-4e58-a8c1-e108d4b778c9",
            kickOffTime: "2020-01-25T19:16:07.691Z",
          },
        },
        id: "f60ab16d-10ff-4e74-9177-b92d5362b610",
        matchday: 21,
        startDate: "",
      },
      {
        endDate: "",
        fixtures: {
          "08391bb9-de46-4a7b-b578-8a8f575fd6bc": {
            awayTeamId: "fd5fa7bb-3211-41ce-b66f-49b074c2aab8",
            goalsAway: 0,
            goalsHome: 3,
            homeTeamId: "2507719b-e3f6-4763-a012-b3c302b2b4b8",
            id: "08391bb9-de46-4a7b-b578-8a8f575fd6bc",
            kickOffTime: "2020-02-01T19:01:09.208Z",
          },
          "218ebdd4-71bc-4eb9-b2cc-611831935658": {
            awayTeamId: "3e6520d5-8a18-4bd6-8ad4-5e00f7add2e0",
            goalsAway: 1,
            goalsHome: 3,
            homeTeamId: "e3c68260-df86-4fc4-b5b2-40db66cee51d",
            id: "218ebdd4-71bc-4eb9-b2cc-611831935658",
            kickOffTime: "2020-02-01T19:01:09.208Z",
          },
          "22c32a28-e589-46a0-be2d-afae2fa9dbec": {
            awayTeamId: "64b2a17a-aa75-4171-b2b6-dfabd6083d48",
            goalsAway: 0,
            goalsHome: 0,
            homeTeamId: "a0a38e6c-30e3-4ec9-9dd9-02b524217df2",
            id: "22c32a28-e589-46a0-be2d-afae2fa9dbec",
            kickOffTime: "2020-02-01T19:01:09.208Z",
          },
          "4f6f1af7-876f-4cd7-bb7b-a751cde07735": {
            awayTeamId: "21274b2b-3500-4a49-971b-0a6ae9cafb58",
            goalsAway: 2,
            goalsHome: 3,
            homeTeamId: "a0497862-8645-4890-a4f1-10d83941ecb8",
            id: "4f6f1af7-876f-4cd7-bb7b-a751cde07735",
            kickOffTime: "2020-01-31T20:00:57.647Z",
          },
          "6f96eb45-92b0-4a35-912a-083bacea2a84": {
            awayTeamId: "ae1b5cf9-73b2-41ef-bc92-4715dd6a4af0",
            goalsAway: 0,
            goalsHome: 0,
            homeTeamId: "883b4940-1fb9-4714-9fd1-418c8ea7ed65",
            id: "6f96eb45-92b0-4a35-912a-083bacea2a84",
            kickOffTime: "2020-02-02T20:16:02.546Z",
          },
          "86efc08c-45e4-4bf8-bab0-3a9521ae9ce7": {
            awayTeamId: "f4aceb89-a8ac-4ff8-b13c-9f230ed85d56",
            goalsAway: 0,
            goalsHome: 5,
            homeTeamId: "7e6c61aa-3e8c-4a3e-8520-523e8608070c",
            id: "86efc08c-45e4-4bf8-bab0-3a9521ae9ce7",
            kickOffTime: "2020-02-01T16:31:07.709Z",
          },
          "9a108444-2669-4e4e-9f97-5fcd235af264": {
            awayTeamId: "2dc5c094-9b90-4f1b-911a-3f68294dad99",
            goalsAway: 2,
            goalsHome: 1,
            homeTeamId: "cdfaf7f7-8d7c-4d35-8173-d67e238c8a71",
            id: "9a108444-2669-4e4e-9f97-5fcd235af264",
            kickOffTime: "2020-02-01T19:01:09.208Z",
          },
          "b18231af-629c-4806-8b2f-f9254309e3a5": {
            awayTeamId: "3ba8e3a3-ba20-4ec8-b01a-a5945a56a93b",
            goalsAway: 1,
            goalsHome: 3,
            homeTeamId: "2b3249eb-5868-4700-8d55-cb5985e34339",
            id: "b18231af-629c-4806-8b2f-f9254309e3a5",
            kickOffTime: "2020-02-02T16:01:01.646Z",
          },
          "ef94bac2-705e-448e-8dc7-f120c63319f6": {
            awayTeamId: "4b2a1635-9a3d-42ca-afb1-f46766b7b179",
            goalsAway: 1,
            goalsHome: 2,
            homeTeamId: "a7edfa0f-eb3d-4484-8437-3886cee7a3c5",
            id: "ef94bac2-705e-448e-8dc7-f120c63319f6",
            kickOffTime: "2020-02-02T14:01:01.763Z",
          },
          "f9e5a8e7-7700-4cf2-b5b9-21acd81847bc": {
            awayTeamId: "5e7d0f28-97c0-46f4-b733-2073f02065ef",
            goalsAway: 4,
            goalsHome: 1,
            homeTeamId: "fee996ac-2454-425a-97f9-09c35f28a65f",
            id: "f9e5a8e7-7700-4cf2-b5b9-21acd81847bc",
            kickOffTime: "2020-02-01T19:01:09.208Z",
          },
        },
        id: "68536f42-9265-4988-b308-07407a9010f0",
        matchday: 22,
        startDate: "",
      },
      {
        endDate: "",
        fixtures: {
          "02032c8b-04a1-4267-9b6c-343953ab6a4a": {
            awayTeamId: "cdfaf7f7-8d7c-4d35-8173-d67e238c8a71",
            goalsAway: 1,
            goalsHome: 0,
            homeTeamId: "64b2a17a-aa75-4171-b2b6-dfabd6083d48",
            id: "02032c8b-04a1-4267-9b6c-343953ab6a4a",
            kickOffTime: "2020-02-05T18:00:59.918Z",
          },
          "19ea9551-fe09-4ce5-9a57-0811fb463c21": {
            awayTeamId: "2507719b-e3f6-4763-a012-b3c302b2b4b8",
            goalsAway: 0,
            goalsHome: 2,
            homeTeamId: "e3c68260-df86-4fc4-b5b2-40db66cee51d",
            id: "19ea9551-fe09-4ce5-9a57-0811fb463c21",
            kickOffTime: "2020-02-05T18:00:59.918Z",
          },
          "30dc2d03-d8fd-4722-8c16-a4be0e4c44ae": {
            awayTeamId: "a0497862-8645-4890-a4f1-10d83941ecb8",
            goalsAway: 0,
            goalsHome: 1,
            homeTeamId: "2dc5c094-9b90-4f1b-911a-3f68294dad99",
            id: "30dc2d03-d8fd-4722-8c16-a4be0e4c44ae",
            kickOffTime: "2020-02-04T18:00:59.515Z",
          },
          "53ccd29e-6f80-443b-9b2d-e0ac4faeb913": {
            awayTeamId: "2b3249eb-5868-4700-8d55-cb5985e34339",
            goalsAway: 1,
            goalsHome: 1,
            homeTeamId: "f4aceb89-a8ac-4ff8-b13c-9f230ed85d56",
            id: "53ccd29e-6f80-443b-9b2d-e0ac4faeb913",
            kickOffTime: "2020-02-05T18:00:59.918Z",
          },
          "9edde389-34a7-4bb8-b318-6c5a9925653b": {
            awayTeamId: "ae1b5cf9-73b2-41ef-bc92-4715dd6a4af0",
            goalsAway: 2,
            goalsHome: 0,
            homeTeamId: "3ba8e3a3-ba20-4ec8-b01a-a5945a56a93b",
            id: "9edde389-34a7-4bb8-b318-6c5a9925653b",
            kickOffTime: "2020-02-05T20:15:56.538Z",
          },
          "a29c1769-ce1d-4771-b94a-2d1b51a63497": {
            awayTeamId: "a0a38e6c-30e3-4ec9-9dd9-02b524217df2",
            goalsAway: 0,
            goalsHome: 0,
            homeTeamId: "4b2a1635-9a3d-42ca-afb1-f46766b7b179",
            id: "a29c1769-ce1d-4771-b94a-2d1b51a63497",
            kickOffTime: "2020-02-05T18:00:59.918Z",
          },
          "a2f13217-2555-4e63-9452-b59b72d73212": {
            awayTeamId: "a7edfa0f-eb3d-4484-8437-3886cee7a3c5",
            goalsAway: 1,
            goalsHome: 1,
            homeTeamId: "5e7d0f28-97c0-46f4-b733-2073f02065ef",
            id: "a2f13217-2555-4e63-9452-b59b72d73212",
            kickOffTime: "2020-02-05T18:00:59.918Z",
          },
          "a3f843fa-3ba2-4a33-acb7-d12f0c194049": {
            awayTeamId: "fee996ac-2454-425a-97f9-09c35f28a65f",
            goalsAway: 0,
            goalsHome: 1,
            homeTeamId: "3e6520d5-8a18-4bd6-8ad4-5e00f7add2e0",
            id: "a3f843fa-3ba2-4a33-acb7-d12f0c194049",
            kickOffTime: "2020-02-04T18:00:59.515Z",
          },
          "b252b78b-5517-4e68-b1c2-26eed0aa83e0": {
            awayTeamId: "7e6c61aa-3e8c-4a3e-8520-523e8608070c",
            goalsAway: 2,
            goalsHome: 1,
            homeTeamId: "21274b2b-3500-4a49-971b-0a6ae9cafb58",
            id: "b252b78b-5517-4e68-b1c2-26eed0aa83e0",
            kickOffTime: "2020-02-04T20:00:58.775Z",
          },
          "f8934413-2445-44bb-a117-9d89ec08eb73": {
            awayTeamId: "883b4940-1fb9-4714-9fd1-418c8ea7ed65",
            goalsAway: 1,
            goalsHome: 1,
            homeTeamId: "fd5fa7bb-3211-41ce-b66f-49b074c2aab8",
            id: "f8934413-2445-44bb-a117-9d89ec08eb73",
            kickOffTime: "2020-02-05T18:00:59.918Z",
          },
        },
        id: "6208ddbb-d88e-4d94-9a91-20de29cff883",
        matchday: 23,
        startDate: "",
      },
      {
        endDate: "",
        fixtures: {
          "0749ffa6-4a5e-456a-ba90-1fe90f93212b": {
            awayTeamId: "5e7d0f28-97c0-46f4-b733-2073f02065ef",
            goalsAway: 0,
            goalsHome: 3,
            homeTeamId: "cdfaf7f7-8d7c-4d35-8173-d67e238c8a71",
            id: "0749ffa6-4a5e-456a-ba90-1fe90f93212b",
            kickOffTime: "2020-02-09T16:01:04.877Z",
          },
          "20045909-51e3-472d-9821-78632855f938": {
            awayTeamId: "2dc5c094-9b90-4f1b-911a-3f68294dad99",
            goalsAway: 2,
            goalsHome: 0,
            homeTeamId: "fee996ac-2454-425a-97f9-09c35f28a65f",
            id: "20045909-51e3-472d-9821-78632855f938",
            kickOffTime: "2020-02-07T19:45:53.140Z",
          },
          "49763d26-92b7-46b6-8051-d00f3787304b": {
            awayTeamId: "3e6520d5-8a18-4bd6-8ad4-5e00f7add2e0",
            goalsAway: 2,
            goalsHome: 1,
            homeTeamId: "a0a38e6c-30e3-4ec9-9dd9-02b524217df2",
            id: "49763d26-92b7-46b6-8051-d00f3787304b",
            kickOffTime: "2020-02-08T19:01:02.167Z",
          },
          "4d7bdc69-c181-468d-a523-94fc8ad99a3b": {
            awayTeamId: "883b4940-1fb9-4714-9fd1-418c8ea7ed65",
            goalsAway: 2,
            goalsHome: 1,
            homeTeamId: "2b3249eb-5868-4700-8d55-cb5985e34339",
            id: "4d7bdc69-c181-468d-a523-94fc8ad99a3b",
            kickOffTime: "2020-02-08T19:01:02.167Z",
          },
          "66d5f057-053e-464c-8853-64d271dc4859": {
            awayTeamId: "4b2a1635-9a3d-42ca-afb1-f46766b7b179",
            goalsAway: 2,
            goalsHome: 4,
            homeTeamId: "7e6c61aa-3e8c-4a3e-8520-523e8608070c",
            id: "66d5f057-053e-464c-8853-64d271dc4859",
            kickOffTime: "2020-02-09T20:01:08.860Z",
          },
          "74c29248-f70a-41c8-8c60-5931ee9af7d2": {
            awayTeamId: "3ba8e3a3-ba20-4ec8-b01a-a5945a56a93b",
            goalsAway: 0,
            goalsHome: 1,
            homeTeamId: "f4aceb89-a8ac-4ff8-b13c-9f230ed85d56",
            id: "74c29248-f70a-41c8-8c60-5931ee9af7d2",
            kickOffTime: "2020-02-09T14:00:57.454Z",
          },
          "7cd3d481-5d7a-4a41-a027-a689a1b11199": {
            awayTeamId: "e3c68260-df86-4fc4-b5b2-40db66cee51d",
            goalsAway: 3,
            goalsHome: 1,
            homeTeamId: "a7edfa0f-eb3d-4484-8437-3886cee7a3c5",
            id: "7cd3d481-5d7a-4a41-a027-a689a1b11199",
            kickOffTime: "2020-02-08T19:01:02.167Z",
          },
          "8f5b2418-3989-4be6-b782-31ee5b681074": {
            awayTeamId: "21274b2b-3500-4a49-971b-0a6ae9cafb58",
            goalsAway: 3,
            goalsHome: 3,
            homeTeamId: "2507719b-e3f6-4763-a012-b3c302b2b4b8",
            id: "8f5b2418-3989-4be6-b782-31ee5b681074",
            kickOffTime: "2020-02-08T19:01:02.167Z",
          },
          "a169ac43-9c10-4b67-beef-3caa5fe09859": {
            awayTeamId: "fd5fa7bb-3211-41ce-b66f-49b074c2aab8",
            goalsAway: 0,
            goalsHome: 0,
            homeTeamId: "a0497862-8645-4890-a4f1-10d83941ecb8",
            id: "a169ac43-9c10-4b67-beef-3caa5fe09859",
            kickOffTime: "2020-02-08T19:01:02.167Z",
          },
          "acd0c7bd-f203-4163-b427-9eead9f82122": {
            awayTeamId: "64b2a17a-aa75-4171-b2b6-dfabd6083d48",
            goalsAway: 0,
            goalsHome: 1,
            homeTeamId: "ae1b5cf9-73b2-41ef-bc92-4715dd6a4af0",
            id: "acd0c7bd-f203-4163-b427-9eead9f82122",
            kickOffTime: "2020-02-08T16:31:04.461Z",
          },
        },
        id: "1474af6c-3a81-418e-bed7-719ddccf92bc",
        matchday: 24,
        startDate: "",
      },
      {
        endDate: "",
        fixtures: {
          "273739e7-ca84-4c03-ab36-7bde7729d772": {
            awayTeamId: "3ba8e3a3-ba20-4ec8-b01a-a5945a56a93b",
            goalsAway: 2,
            goalsHome: 3,
            homeTeamId: "fd5fa7bb-3211-41ce-b66f-49b074c2aab8",
            id: "273739e7-ca84-4c03-ab36-7bde7729d772",
            kickOffTime: "2020-02-16T16:01:03.701Z",
          },
          "5918ba66-354e-4f8c-a85b-f2b1ddd39ee0": {
            awayTeamId: "cdfaf7f7-8d7c-4d35-8173-d67e238c8a71",
            goalsAway: 1,
            goalsHome: 1,
            homeTeamId: "4b2a1635-9a3d-42ca-afb1-f46766b7b179",
            id: "5918ba66-354e-4f8c-a85b-f2b1ddd39ee0",
            kickOffTime: "2020-02-16T14:01:07.104Z",
          },
          "6d1a409f-5183-4da6-b236-aeb318c55cc8": {
            awayTeamId: "ae1b5cf9-73b2-41ef-bc92-4715dd6a4af0",
            goalsAway: 2,
            goalsHome: 1,
            homeTeamId: "2dc5c094-9b90-4f1b-911a-3f68294dad99",
            id: "6d1a409f-5183-4da6-b236-aeb318c55cc8",
            kickOffTime: "2020-02-16T20:01:07.110Z",
          },
          "8055487d-ed12-4d3f-8dc2-06fc73652dc6": {
            awayTeamId: "a0497862-8645-4890-a4f1-10d83941ecb8",
            goalsAway: 0,
            goalsHome: 1,
            homeTeamId: "5e7d0f28-97c0-46f4-b733-2073f02065ef",
            id: "8055487d-ed12-4d3f-8dc2-06fc73652dc6",
            kickOffTime: "2020-02-16T16:01:03.701Z",
          },
          "8fc892c1-1bd4-48a9-8362-007d5adad0ec": {
            awayTeamId: "f4aceb89-a8ac-4ff8-b13c-9f230ed85d56",
            goalsAway: 0,
            goalsHome: 1,
            homeTeamId: "3e6520d5-8a18-4bd6-8ad4-5e00f7add2e0",
            id: "8fc892c1-1bd4-48a9-8362-007d5adad0ec",
            kickOffTime: "2020-02-14T19:45:55.650Z",
          },
          "994536ba-d3d5-4439-bf60-ec61e9c88347": {
            awayTeamId: "2507719b-e3f6-4763-a012-b3c302b2b4b8",
            goalsAway: 2,
            goalsHome: 2,
            homeTeamId: "883b4940-1fb9-4714-9fd1-418c8ea7ed65",
            id: "994536ba-d3d5-4439-bf60-ec61e9c88347",
            kickOffTime: "2020-02-15T19:01:10.595Z",
          },
          "cfdef0ee-6dd3-45f4-be5e-75d1c2945b23": {
            awayTeamId: "2b3249eb-5868-4700-8d55-cb5985e34339",
            goalsAway: 0,
            goalsHome: 0,
            homeTeamId: "21274b2b-3500-4a49-971b-0a6ae9cafb58",
            id: "cfdef0ee-6dd3-45f4-be5e-75d1c2945b23",
            kickOffTime: "2020-02-15T19:01:10.595Z",
          },
          "d78338fc-2801-4666-809e-df90bca92636": {
            awayTeamId: "7e6c61aa-3e8c-4a3e-8520-523e8608070c",
            goalsAway: 4,
            goalsHome: 4,
            homeTeamId: "a0a38e6c-30e3-4ec9-9dd9-02b524217df2",
            id: "d78338fc-2801-4666-809e-df90bca92636",
            kickOffTime: "2020-02-15T16:31:07.396Z",
          },
          "e271b3a3-6c4d-4cca-a610-22bf7c9363d7": {
            awayTeamId: "a7edfa0f-eb3d-4484-8437-3886cee7a3c5",
            goalsAway: 2,
            goalsHome: 0,
            homeTeamId: "64b2a17a-aa75-4171-b2b6-dfabd6083d48",
            id: "e271b3a3-6c4d-4cca-a610-22bf7c9363d7",
            kickOffTime: "2020-02-15T19:01:10.595Z",
          },
          "ebedc7ca-14bb-4501-a3da-45c4cbed46c2": {
            awayTeamId: "fee996ac-2454-425a-97f9-09c35f28a65f",
            goalsAway: 0,
            goalsHome: 1,
            homeTeamId: "e3c68260-df86-4fc4-b5b2-40db66cee51d",
            id: "ebedc7ca-14bb-4501-a3da-45c4cbed46c2",
            kickOffTime: "2020-02-15T19:01:10.595Z",
          },
        },
        id: "5aadd27f-fea5-43dd-ae33-1f2150df5a65",
        matchday: 25,
        startDate: "",
      },
      {
        endDate: "",
        fixtures: {
          "06aca4ca-a75f-418f-b7e4-b92e06495762": {
            awayTeamId: "e3c68260-df86-4fc4-b5b2-40db66cee51d",
            goalsAway: 1,
            goalsHome: 2,
            homeTeamId: "a0497862-8645-4890-a4f1-10d83941ecb8",
            id: "06aca4ca-a75f-418f-b7e4-b92e06495762",
            kickOffTime: "2020-02-23T17:30:57.360Z",
          },
          "1fd27e03-46e3-40bd-bf56-8ee3490347b0": {
            awayTeamId: "fd5fa7bb-3211-41ce-b66f-49b074c2aab8",
            goalsAway: 2,
            goalsHome: 2,
            homeTeamId: "a7edfa0f-eb3d-4484-8437-3886cee7a3c5",
            id: "1fd27e03-46e3-40bd-bf56-8ee3490347b0",
            kickOffTime: "2020-02-21T18:00:55.368Z",
          },
          "21deaa6e-b22a-44d0-9b53-21aeed2c73ce": {
            awayTeamId: "f4aceb89-a8ac-4ff8-b13c-9f230ed85d56",
            goalsAway: 0,
            goalsHome: 1,
            homeTeamId: "fee996ac-2454-425a-97f9-09c35f28a65f",
            id: "21deaa6e-b22a-44d0-9b53-21aeed2c73ce",
            kickOffTime: "2020-02-22T19:01:00.376Z",
          },
          "5dd50640-bedb-4d3a-9474-98acb59c5c0b": {
            awayTeamId: "883b4940-1fb9-4714-9fd1-418c8ea7ed65",
            goalsAway: 3,
            goalsHome: 4,
            homeTeamId: "7e6c61aa-3e8c-4a3e-8520-523e8608070c",
            kickOffTime: "2020-02-23T21:00:00.000+01:00",
          },
          "60450510-11db-47fa-98fa-42f9b5964296": {
            awayTeamId: "64b2a17a-aa75-4171-b2b6-dfabd6083d48",
            goalsAway: 0,
            goalsHome: 3,
            homeTeamId: "2dc5c094-9b90-4f1b-911a-3f68294dad99",
            id: "60450510-11db-47fa-98fa-42f9b5964296",
            kickOffTime: "2020-02-22T19:01:00.376Z",
          },
          "8bbbda94-3b4c-4a4d-8cc2-29db6eeaf760": {
            awayTeamId: "5e7d0f28-97c0-46f4-b733-2073f02065ef",
            goalsAway: 1,
            goalsHome: 1,
            homeTeamId: "3ba8e3a3-ba20-4ec8-b01a-a5945a56a93b",
            id: "8bbbda94-3b4c-4a4d-8cc2-29db6eeaf760",
            kickOffTime: "2020-02-23T14:00:58.351Z",
          },
          "8cfa000c-28f4-47f3-aac0-f7f8c7b1f04d": {
            awayTeamId: "21274b2b-3500-4a49-971b-0a6ae9cafb58",
            goalsAway: 3,
            goalsHome: 1,
            homeTeamId: "ae1b5cf9-73b2-41ef-bc92-4715dd6a4af0",
            id: "8cfa000c-28f4-47f3-aac0-f7f8c7b1f04d",
            kickOffTime: "2020-02-22T16:30:59.562Z",
          },
          "9e0dd8d8-5882-44ac-8453-3745b1621e52": {
            awayTeamId: "4b2a1635-9a3d-42ca-afb1-f46766b7b179",
            goalsAway: 2,
            goalsHome: 0,
            homeTeamId: "2b3249eb-5868-4700-8d55-cb5985e34339",
            id: "9e0dd8d8-5882-44ac-8453-3745b1621e52",
            kickOffTime: "2020-02-21T20:00:55.961Z",
          },
          "a4507462-b2a6-42af-81cb-a054ab4f37da": {
            awayTeamId: "a0a38e6c-30e3-4ec9-9dd9-02b524217df2",
            goalsAway: 0,
            goalsHome: 0,
            homeTeamId: "cdfaf7f7-8d7c-4d35-8173-d67e238c8a71",
            id: "a4507462-b2a6-42af-81cb-a054ab4f37da",
            kickOffTime: "2020-02-22T19:01:00.376Z",
          },
          "d284da34-53fe-4e0f-ba73-88562ebfc447": {
            awayTeamId: "3e6520d5-8a18-4bd6-8ad4-5e00f7add2e0",
            goalsAway: 1,
            goalsHome: 1,
            homeTeamId: "2507719b-e3f6-4763-a012-b3c302b2b4b8",
            id: "d284da34-53fe-4e0f-ba73-88562ebfc447",
            kickOffTime: "2020-02-22T19:01:00.376Z",
          },
        },
        id: "c58d2c26-399e-4fae-8a8d-d56265dda784",
        matchday: 26,
        startDate: "",
      },
      {
        endDate: "",
        fixtures: {
          "325f37d1-97a9-4fba-88c4-ab1808bc768e": {
            awayTeamId: "2507719b-e3f6-4763-a012-b3c302b2b4b8",
            goalsAway: 0,
            goalsHome: 4,
            homeTeamId: "7e6c61aa-3e8c-4a3e-8520-523e8608070c",
            id: "325f37d1-97a9-4fba-88c4-ab1808bc768e",
            kickOffTime: "2020-02-29T16:31:03.320Z",
          },
          "3c4f1496-101d-4966-ba7a-f14900ab4882": {
            awayTeamId: "cdfaf7f7-8d7c-4d35-8173-d67e238c8a71",
            goalsAway: 0,
            goalsHome: 3,
            homeTeamId: "f4aceb89-a8ac-4ff8-b13c-9f230ed85d56",
            id: "3c4f1496-101d-4966-ba7a-f14900ab4882",
            kickOffTime: "2020-02-29T19:01:05.721Z",
          },
          "450e07ba-a72d-479c-8aab-fa5c25a12fac": {
            awayTeamId: "2b3249eb-5868-4700-8d55-cb5985e34339",
            goalsAway: 1,
            goalsHome: 0,
            homeTeamId: "a0a38e6c-30e3-4ec9-9dd9-02b524217df2",
            id: "450e07ba-a72d-479c-8aab-fa5c25a12fac",
            kickOffTime: "2020-02-29T19:01:05.719Z",
          },
          "4cb1ac70-4483-4e6a-8587-8111ec67fd30": {
            awayTeamId: "a0497862-8645-4890-a4f1-10d83941ecb8",
            goalsAway: 2,
            goalsHome: 0,
            homeTeamId: "64b2a17a-aa75-4171-b2b6-dfabd6083d48",
            id: "4cb1ac70-4483-4e6a-8587-8111ec67fd30",
            kickOffTime: "2020-02-29T19:01:05.720Z",
          },
          "69a36ee7-6ace-4f7e-ae9f-a2adb56bd203": {
            awayTeamId: "2dc5c094-9b90-4f1b-911a-3f68294dad99",
            goalsAway: 1,
            goalsHome: 0,
            homeTeamId: "21274b2b-3500-4a49-971b-0a6ae9cafb58",
            id: "69a36ee7-6ace-4f7e-ae9f-a2adb56bd203",
            kickOffTime: "2020-03-01T14:01:02.363Z",
          },
          "7c0e231d-e178-4e31-a1ba-7281b0733376": {
            awayTeamId: "a7edfa0f-eb3d-4484-8437-3886cee7a3c5",
            goalsAway: 1,
            goalsHome: 1,
            homeTeamId: "883b4940-1fb9-4714-9fd1-418c8ea7ed65",
            id: "7c0e231d-e178-4e31-a1ba-7281b0733376",
            kickOffTime: "2020-03-01T16:16:00.552Z",
          },
          "83e8ac18-72a3-4c25-8d33-df5899c68d8c": {
            awayTeamId: "5e7d0f28-97c0-46f4-b733-2073f02065ef",
            goalsAway: 1,
            goalsHome: 1,
            homeTeamId: "3e6520d5-8a18-4bd6-8ad4-5e00f7add2e0",
            id: "83e8ac18-72a3-4c25-8d33-df5899c68d8c",
            kickOffTime: "2020-02-29T19:01:05.721Z",
          },
          "8e11fe82-90fd-4d88-b68f-16c037bdd92e": {
            awayTeamId: "3ba8e3a3-ba20-4ec8-b01a-a5945a56a93b",
            goalsAway: 0,
            goalsHome: 2,
            homeTeamId: "4b2a1635-9a3d-42ca-afb1-f46766b7b179",
            id: "8e11fe82-90fd-4d88-b68f-16c037bdd92e",
            kickOffTime: "2020-03-01T20:01:06.852Z",
          },
          "95a2df51-6292-469b-b761-8bafd9284421": {
            awayTeamId: "fee996ac-2454-425a-97f9-09c35f28a65f",
            goalsAway: 1,
            goalsHome: 0,
            homeTeamId: "fd5fa7bb-3211-41ce-b66f-49b074c2aab8",
            id: "95a2df51-6292-469b-b761-8bafd9284421",
            kickOffTime: "2020-02-29T19:01:05.720Z",
          },
          "a59e83f4-19ef-4fc2-b031-54bc1252599e": {
            awayTeamId: "ae1b5cf9-73b2-41ef-bc92-4715dd6a4af0",
            goalsAway: 3,
            goalsHome: 2,
            homeTeamId: "e3c68260-df86-4fc4-b5b2-40db66cee51d",
            id: "a59e83f4-19ef-4fc2-b031-54bc1252599e",
            kickOffTime: "2020-02-28T19:45:55.995Z",
          },
        },
        id: "1bdb9e6d-f9f7-45f1-8caa-0c5ac80fe0c7",
        matchday: 27,
        startDate: "",
      },
      {
        endDate: "",
        fixtures: {
          "136e2565-1343-4137-a57e-765356ecf6cd": {
            awayTeamId: "4b2a1635-9a3d-42ca-afb1-f46766b7b179",
            goalsAway: 0,
            goalsHome: 1,
            homeTeamId: "2dc5c094-9b90-4f1b-911a-3f68294dad99",
            id: "136e2565-1343-4137-a57e-765356ecf6cd",
            kickOffTime: "2020-03-08T20:01:16.327Z",
          },
          "4b47220e-2d14-4e95-a83f-9cacb070ca29": {
            awayTeamId: "f4aceb89-a8ac-4ff8-b13c-9f230ed85d56",
            goalsAway: 0,
            goalsHome: 5,
            homeTeamId: "a0497862-8645-4890-a4f1-10d83941ecb8",
            id: "4b47220e-2d14-4e95-a83f-9cacb070ca29",
            kickOffTime: "2020-03-08T16:01:04.240Z",
          },
          "4f56c717-83ed-49a5-ba8a-d62c658c07aa": {
            awayTeamId: "64b2a17a-aa75-4171-b2b6-dfabd6083d48",
            goalsAway: 1,
            goalsHome: 2,
            homeTeamId: "2507719b-e3f6-4763-a012-b3c302b2b4b8",
            id: "4f56c717-83ed-49a5-ba8a-d62c658c07aa",
            kickOffTime: "2020-03-07T19:01:16.752Z",
          },
          "58dc7c0c-46fe-46eb-91e8-5b0a4ea23b1b": {
            awayTeamId: "a0a38e6c-30e3-4ec9-9dd9-02b524217df2",
            goalsAway: 2,
            goalsHome: 2,
            homeTeamId: "ae1b5cf9-73b2-41ef-bc92-4715dd6a4af0",
            id: "58dc7c0c-46fe-46eb-91e8-5b0a4ea23b1b",
            kickOffTime: "2020-03-06T20:00:58.813Z",
          },
          "8b10bd9d-b428-4bcb-8ff5-af1c9f243076": {
            awayTeamId: "fd5fa7bb-3211-41ce-b66f-49b074c2aab8",
            goalsAway: 0,
            goalsHome: 1,
            homeTeamId: "5e7d0f28-97c0-46f4-b733-2073f02065ef",
            id: "8b10bd9d-b428-4bcb-8ff5-af1c9f243076",
            kickOffTime: "2020-03-07T19:01:16.754Z",
          },
          "92aa617b-1d9c-4a0f-98a7-5531120d6790": {
            awayTeamId: "21274b2b-3500-4a49-971b-0a6ae9cafb58",
            goalsAway: 0,
            goalsHome: 2,
            homeTeamId: "fee996ac-2454-425a-97f9-09c35f28a65f",
            id: "92aa617b-1d9c-4a0f-98a7-5531120d6790",
            kickOffTime: "2020-03-07T19:01:16.752Z",
          },
          "95da84fe-476f-4c94-a5b8-cef1c18bbede": {
            awayTeamId: "e3c68260-df86-4fc4-b5b2-40db66cee51d",
            goalsAway: 1,
            goalsHome: 2,
            homeTeamId: "2b3249eb-5868-4700-8d55-cb5985e34339",
            id: "95da84fe-476f-4c94-a5b8-cef1c18bbede",
            kickOffTime: "2020-03-07T19:01:16.753Z",
          },
          "a8129fd0-2583-44cc-b098-027a98029298": {
            awayTeamId: "883b4940-1fb9-4714-9fd1-418c8ea7ed65",
            goalsAway: 1,
            goalsHome: 1,
            homeTeamId: "3ba8e3a3-ba20-4ec8-b01a-a5945a56a93b",
            id: "a8129fd0-2583-44cc-b098-027a98029298",
            kickOffTime: "2020-03-08T14:01:02.324Z",
          },
          "e5148a7e-26c1-4891-99ac-f07e36005060": {
            awayTeamId: "3e6520d5-8a18-4bd6-8ad4-5e00f7add2e0",
            goalsAway: 1,
            goalsHome: 2,
            homeTeamId: "a7edfa0f-eb3d-4484-8437-3886cee7a3c5",
            id: "e5148a7e-26c1-4891-99ac-f07e36005060",
            kickOffTime: "2020-03-07T19:01:16.752Z",
          },
        },
        id: "96e3442c-0b28-466e-b9e7-f702a39bc569",
        matchday: 28,
        startDate: "",
      },
    ],
  },
  germany: {
    "2019": [
      {
        endDate: "2019-08-18T20:00:00.000+02:00",
        fixtures: {
          "1c6af473-c1a8-43a1-90f6-d2ded50102a2": {
            awayTeamId: "cbe09562-1bf1-4b92-8e6b-92ea740d2774",
            goalsAway: 2,
            goalsHome: 3,
            homeTeamId: "b14bb614-3a22-4e46-9c8f-6b0f7e091c6d",
            kickOffTime: "2019-08-17T15:30:00.000+02:00",
          },
          "200b65df-a109-487a-82e1-8b887f72ee58": {
            awayTeamId: "dccf4aa9-74fb-4e7c-9011-20e7dd13ffbc",
            goalsAway: 2,
            goalsHome: 2,
            homeTeamId: "93c01474-719c-4df3-a4ff-7c2561e04ac1",
            kickOffTime: "2019-08-16T20:30:00.000+02:00",
          },
          "6bfcc8d3-5884-41a5-8b2f-c3c40f96e395": {
            awayTeamId: "0f231945-0ffb-4dc6-9bae-604bf236ab2f",
            goalsAway: 3,
            goalsHome: 1,
            homeTeamId: "1bbea28c-81cc-49e3-a894-a33c3714ffc5",
            kickOffTime: "2019-08-17T15:30:00.000+02:00",
          },
          "6ea84829-3fda-426e-93a9-a4ee78d3fd1d": {
            awayTeamId: "49b443c0-c5f9-49fa-8e51-5a27547a9f67",
            goalsAway: 0,
            goalsHome: 1,
            homeTeamId: "c80d1327-c1f6-44ff-8d54-4ac93ff89763",
            kickOffTime: "2019-08-18T15:30:00.000+02:00",
          },
          "883c574d-b94c-4da9-9614-c4bc2911b458": {
            awayTeamId: "166b21c1-7fcb-4eb0-b01c-ece3943a900b",
            goalsAway: 0,
            goalsHome: 0,
            homeTeamId: "6a0d669b-9a11-4001-a753-de12bb24bd0a",
            kickOffTime: "2019-08-17T18:30:00.000+02:00",
          },
          "8d9a465c-11b4-41b8-93be-361656ec2a6f": {
            awayTeamId: "4a8ab99d-7731-4467-9c16-8ba1663c545b",
            goalsAway: 0,
            goalsHome: 3,
            homeTeamId: "91f5c377-c4d9-49e9-9569-b5f6c44808e1",
            kickOffTime: "2019-08-17T15:30:00.000+02:00",
          },
          "a2a09a3a-f2ab-44c5-b49d-1628aa1d95eb": {
            awayTeamId: "4e3bfa69-db9e-4b06-ba57-bffd9c11b8d1",
            goalsAway: 1,
            goalsHome: 5,
            homeTeamId: "3fa3a04b-fa87-49e9-8772-0820a516be9c",
            kickOffTime: "2019-08-17T15:30:00.000+02:00",
          },
          "bed6b0b0-ce17-4481-87b5-44550d15720c": {
            awayTeamId: "75e3d230-76a1-4339-9c0c-6155386bf897",
            goalsAway: 4,
            goalsHome: 0,
            homeTeamId: "158c2559-8f11-4e58-8439-0921d101c732",
            kickOffTime: "2019-08-18T18:00:00.000+02:00",
          },
          "e2d58fa8-d34f-480d-8290-907dc0d4e5f0": {
            awayTeamId: "2e7b4ee7-8c0b-450b-8e10-a1bd5fc892c3",
            goalsAway: 1,
            goalsHome: 2,
            homeTeamId: "e18be703-c750-4731-a9e1-2079ad8837f2",
            kickOffTime: "2019-08-17T15:30:00.000+02:00",
          },
        },
        id: "56b3b1a3-5beb-4606-897f-fd488cba1001",
        matchday: 1,
        startDate: "2019-08-16T20:30:00.000+02:00",
      },
      {
        endDate: "2019-08-25T20:00:00.000+02:00",
        fixtures: {
          "07380ab0-4245-45b4-b578-20d684c892d2": {
            awayTeamId: "91f5c377-c4d9-49e9-9569-b5f6c44808e1",
            goalsAway: 3,
            goalsHome: 1,
            homeTeamId: "cbe09562-1bf1-4b92-8e6b-92ea740d2774",
            kickOffTime: "2019-08-24T15:30:00.000+02:00",
          },
          "260dc08b-e127-4d3a-88cc-285c8dd155b9": {
            awayTeamId: "1bbea28c-81cc-49e3-a894-a33c3714ffc5",
            goalsAway: 2,
            goalsHome: 3,
            homeTeamId: "49b443c0-c5f9-49fa-8e51-5a27547a9f67",
            kickOffTime: "2019-08-24T15:30:00.000+02:00",
          },
          "2eda4783-10f2-4ed2-b2a5-1e80b1225646": {
            awayTeamId: "c80d1327-c1f6-44ff-8d54-4ac93ff89763",
            goalsAway: 1,
            goalsHome: 2,
            homeTeamId: "75e3d230-76a1-4339-9c0c-6155386bf897",
            kickOffTime: "2019-08-25T15:30:00.000+02:00",
          },
          "52571545-214b-40f5-8a3c-5596332a2ccc": {
            awayTeamId: "158c2559-8f11-4e58-8439-0921d101c732",
            goalsAway: 1,
            goalsHome: 1,
            homeTeamId: "4e3bfa69-db9e-4b06-ba57-bffd9c11b8d1",
            kickOffTime: "2019-08-24T15:30:00.000+02:00",
          },
          "53f64a96-f62c-4542-b9b4-f510d3a5c3b0": {
            awayTeamId: "6a0d669b-9a11-4001-a753-de12bb24bd0a",
            goalsAway: 3,
            goalsHome: 1,
            homeTeamId: "4a8ab99d-7731-4467-9c16-8ba1663c545b",
            kickOffTime: "2019-08-24T15:30:00.000+02:00",
          },
          "6927f88d-0efe-4550-9c1b-e370b3662b65": {
            awayTeamId: "3fa3a04b-fa87-49e9-8772-0820a516be9c",
            goalsAway: 3,
            goalsHome: 1,
            homeTeamId: "2e7b4ee7-8c0b-450b-8e10-a1bd5fc892c3",
            kickOffTime: "2019-08-23T20:30:00.000+02:00",
          },
          "abfc8256-ea4c-40ae-9135-2169aa79f687": {
            awayTeamId: "93c01474-719c-4df3-a4ff-7c2561e04ac1",
            goalsAway: 3,
            goalsHome: 0,
            homeTeamId: "166b21c1-7fcb-4eb0-b01c-ece3943a900b",
            kickOffTime: "2019-08-24T18:30:00.000+02:00",
          },
          "c1af444f-e268-4d7e-99d9-777a78c9ae87": {
            awayTeamId: "b14bb614-3a22-4e46-9c8f-6b0f7e091c6d",
            goalsAway: 3,
            goalsHome: 1,
            homeTeamId: "0f231945-0ffb-4dc6-9bae-604bf236ab2f",
            kickOffTime: "2019-08-24T15:30:00.000+02:00",
          },
          "ec40321a-0cd1-4f56-a734-78cb21bbdce2": {
            awayTeamId: "e18be703-c750-4731-a9e1-2079ad8837f2",
            goalsAway: 3,
            goalsHome: 0,
            homeTeamId: "dccf4aa9-74fb-4e7c-9011-20e7dd13ffbc",
            kickOffTime: "2019-08-25T18:00:00.000+02:00",
          },
        },
        id: "3276a73f-6d1b-4bc3-a95a-5b8a6fa1ab5e",
        matchday: 2,
        startDate: "2019-08-23T20:30:00.000+02:00",
      },
      {
        endDate: "2019-09-01T20:00:00.000+02:00",
        fixtures: {
          "192f00a2-7dcc-4f50-90e2-7d3d6cfbc6b4": {
            awayTeamId: "3fa3a04b-fa87-49e9-8772-0820a516be9c",
            goalsAway: 1,
            goalsHome: 3,
            homeTeamId: "158c2559-8f11-4e58-8439-0921d101c732",
            kickOffTime: "2019-08-31T18:30:00.000+02:00",
          },
          "427cc219-495f-47d6-ab95-3b0e3c390939": {
            awayTeamId: "4a8ab99d-7731-4467-9c16-8ba1663c545b",
            goalsAway: 1,
            goalsHome: 6,
            homeTeamId: "93c01474-719c-4df3-a4ff-7c2561e04ac1",
            kickOffTime: "2019-08-31T15:30:00.000+02:00",
          },
          "579dfee6-762c-4c63-bb95-40bfe99d52fc": {
            awayTeamId: "49b443c0-c5f9-49fa-8e51-5a27547a9f67",
            goalsAway: 0,
            goalsHome: 0,
            homeTeamId: "b14bb614-3a22-4e46-9c8f-6b0f7e091c6d",
            kickOffTime: "2019-08-31T15:30:00.000+02:00",
          },
          "ae9f6c37-ea31-46b4-9052-aef5841488a4": {
            awayTeamId: "75e3d230-76a1-4339-9c0c-6155386bf897",
            goalsAway: 3,
            goalsHome: 1,
            homeTeamId: "6a0d669b-9a11-4001-a753-de12bb24bd0a",
            kickOffTime: "2019-08-30T20:30:00.000+02:00",
          },
          "bfa2e160-3728-47a7-a8e2-cf4591e30aea": {
            awayTeamId: "0f231945-0ffb-4dc6-9bae-604bf236ab2f",
            goalsAway: 1,
            goalsHome: 2,
            homeTeamId: "c80d1327-c1f6-44ff-8d54-4ac93ff89763",
            kickOffTime: "2019-09-01T18:00:00.000+02:00",
          },
          "c2d8bf94-9790-4622-9a07-259fdc65d79e": {
            awayTeamId: "4e3bfa69-db9e-4b06-ba57-bffd9c11b8d1",
            goalsAway: 2,
            goalsHome: 3,
            homeTeamId: "1bbea28c-81cc-49e3-a894-a33c3714ffc5",
            kickOffTime: "2019-09-01T15:30:00.000+02:00",
          },
          "dbaeb215-a583-4c0b-9a1e-91efa5b4892c": {
            awayTeamId: "dccf4aa9-74fb-4e7c-9011-20e7dd13ffbc",
            goalsAway: 0,
            goalsHome: 3,
            homeTeamId: "166b21c1-7fcb-4eb0-b01c-ece3943a900b",
            kickOffTime: "2019-08-31T15:30:00.000+02:00",
          },
          "f204ff6b-ae4c-4667-828b-c91acf030b38": {
            awayTeamId: "cbe09562-1bf1-4b92-8e6b-92ea740d2774",
            goalsAway: 1,
            goalsHome: 1,
            homeTeamId: "e18be703-c750-4731-a9e1-2079ad8837f2",
            kickOffTime: "2019-08-31T15:30:00.000+02:00",
          },
          "ff43899b-eb18-4027-9a5c-a2ae4821763a": {
            awayTeamId: "2e7b4ee7-8c0b-450b-8e10-a1bd5fc892c3",
            goalsAway: 2,
            goalsHome: 1,
            homeTeamId: "91f5c377-c4d9-49e9-9569-b5f6c44808e1",
            kickOffTime: "2019-08-31T15:30:00.000+02:00",
          },
        },
        id: "c148d538-b690-4ef3-8d02-c0280442108e",
        matchday: 3,
        startDate: "2019-08-30T20:30:00.000+02:00",
      },
      {
        endDate: "2019-09-15T20:00:00.000+02:00",
        fixtures: {
          "264ef9dc-8333-4c0a-bdbc-9f3df9a0bb4e": {
            awayTeamId: "b14bb614-3a22-4e46-9c8f-6b0f7e091c6d",
            goalsAway: 0,
            goalsHome: 4,
            homeTeamId: "3fa3a04b-fa87-49e9-8772-0820a516be9c",
            kickOffTime: "2019-09-14T15:30:00.000+02:00",
          },
          "539171cb-72f2-463e-a4a0-ab2fc8a3991b": {
            awayTeamId: "c80d1327-c1f6-44ff-8d54-4ac93ff89763",
            goalsAway: 1,
            goalsHome: 2,
            homeTeamId: "4e3bfa69-db9e-4b06-ba57-bffd9c11b8d1",
            kickOffTime: "2019-09-14T15:30:00.000+02:00",
          },
          "565140a9-a889-42ab-a020-999e6677bd5a": {
            awayTeamId: "dccf4aa9-74fb-4e7c-9011-20e7dd13ffbc",
            goalsAway: 1,
            goalsHome: 2,
            homeTeamId: "4a8ab99d-7731-4467-9c16-8ba1663c545b",
            kickOffTime: "2019-09-14T15:30:00.000+02:00",
          },
          "634f7ca5-091b-4a8f-8d82-31d2eafacd05": {
            awayTeamId: "91f5c377-c4d9-49e9-9569-b5f6c44808e1",
            goalsAway: 3,
            goalsHome: 0,
            homeTeamId: "49b443c0-c5f9-49fa-8e51-5a27547a9f67",
            kickOffTime: "2019-09-15T15:30:00.000+02:00",
          },
          "780c53ad-709d-4773-8202-f2ce62fb312b": {
            awayTeamId: "1bbea28c-81cc-49e3-a894-a33c3714ffc5",
            goalsAway: 2,
            goalsHome: 1,
            homeTeamId: "158c2559-8f11-4e58-8439-0921d101c732",
            kickOffTime: "2019-09-14T15:30:00.000+02:00",
          },
          "7bf6b578-9528-4a30-807a-72274a876b9b": {
            awayTeamId: "166b21c1-7fcb-4eb0-b01c-ece3943a900b",
            goalsAway: 5,
            goalsHome: 1,
            homeTeamId: "cbe09562-1bf1-4b92-8e6b-92ea740d2774",
            kickOffTime: "2019-09-15T18:00:00.000+02:00",
          },
          "ca198167-2f5c-4ba6-8307-5e26cb5c2985": {
            awayTeamId: "e18be703-c750-4731-a9e1-2079ad8837f2",
            goalsAway: 1,
            goalsHome: 1,
            homeTeamId: "0f231945-0ffb-4dc6-9bae-604bf236ab2f",
            kickOffTime: "2019-09-13T20:30:00.000+02:00",
          },
          "da5ec3d8-7ef3-4831-936a-266dff68d177": {
            awayTeamId: "6a0d669b-9a11-4001-a753-de12bb24bd0a",
            goalsAway: 1,
            goalsHome: 0,
            homeTeamId: "2e7b4ee7-8c0b-450b-8e10-a1bd5fc892c3",
            kickOffTime: "2019-09-14T15:30:00.000+02:00",
          },
          "db4474d0-9733-453a-afc6-dc708a311288": {
            awayTeamId: "93c01474-719c-4df3-a4ff-7c2561e04ac1",
            goalsAway: 1,
            goalsHome: 1,
            homeTeamId: "75e3d230-76a1-4339-9c0c-6155386bf897",
            kickOffTime: "2019-09-14T18:30:00.000+02:00",
          },
        },
        id: "8699c3cb-6876-4b6d-97c9-856c806e3efe",
        matchday: 4,
        startDate: "2019-09-13T20:30:00.000+02:00",
      },
      {
        endDate: "2019-09-23T22:30:00.000+02:00",
        fixtures: {
          "4beaebd9-7ec4-4e70-9b7a-57a2f45141ca": {
            awayTeamId: "49b443c0-c5f9-49fa-8e51-5a27547a9f67",
            goalsAway: 1,
            goalsHome: 1,
            homeTeamId: "e18be703-c750-4731-a9e1-2079ad8837f2",
            kickOffTime: "2019-09-23T20:30:00.000+02:00",
          },
          "824cc20a-75e7-4f3a-8a8d-e44e2434a179": {
            awayTeamId: "cbe09562-1bf1-4b92-8e6b-92ea740d2774",
            goalsAway: 1,
            goalsHome: 2,
            homeTeamId: "dccf4aa9-74fb-4e7c-9011-20e7dd13ffbc",
            kickOffTime: "2019-09-21T15:30:00.000+02:00",
          },
          "921e0dbb-886b-439b-8546-45b4ed1fce5d": {
            awayTeamId: "0f231945-0ffb-4dc6-9bae-604bf236ab2f",
            goalsAway: 1,
            goalsHome: 2,
            homeTeamId: "6a0d669b-9a11-4001-a753-de12bb24bd0a",
            kickOffTime: "2019-09-22T15:30:00.000+02:00",
          },
          "95d9b20a-a5eb-4eac-8063-dd341b7eef14": {
            awayTeamId: "4a8ab99d-7731-4467-9c16-8ba1663c545b",
            goalsAway: 1,
            goalsHome: 2,
            homeTeamId: "166b21c1-7fcb-4eb0-b01c-ece3943a900b",
            kickOffTime: "2019-09-20T20:30:00.000+02:00",
          },
          "a35eb8db-3644-474b-91b7-c89f3d506b4f": {
            awayTeamId: "75e3d230-76a1-4339-9c0c-6155386bf897",
            goalsAway: 3,
            goalsHome: 0,
            homeTeamId: "1bbea28c-81cc-49e3-a894-a33c3714ffc5",
            kickOffTime: "2019-09-21T18:30:00.000+02:00",
          },
          "cf674347-97e1-4795-a382-a7e3e8f33079": {
            awayTeamId: "3fa3a04b-fa87-49e9-8772-0820a516be9c",
            goalsAway: 2,
            goalsHome: 2,
            homeTeamId: "c80d1327-c1f6-44ff-8d54-4ac93ff89763",
            kickOffTime: "2019-09-22T18:00:00.000+02:00",
          },
          "d325c28d-424c-48c8-8475-b8a417604543": {
            awayTeamId: "158c2559-8f11-4e58-8439-0921d101c732",
            goalsAway: 0,
            goalsHome: 2,
            homeTeamId: "b14bb614-3a22-4e46-9c8f-6b0f7e091c6d",
            kickOffTime: "2019-09-21T15:30:00.000+02:00",
          },
          "d54a0418-44bb-4f51-a70a-a81511c90c61": {
            awayTeamId: "4e3bfa69-db9e-4b06-ba57-bffd9c11b8d1",
            goalsAway: 1,
            goalsHome: 1,
            homeTeamId: "91f5c377-c4d9-49e9-9569-b5f6c44808e1",
            kickOffTime: "2019-09-21T15:30:00.000+02:00",
          },
          "dc88e695-027d-453d-b33d-658bb5fdbaa2": {
            awayTeamId: "2e7b4ee7-8c0b-450b-8e10-a1bd5fc892c3",
            goalsAway: 0,
            goalsHome: 4,
            homeTeamId: "93c01474-719c-4df3-a4ff-7c2561e04ac1",
            kickOffTime: "2019-09-21T15:30:00.000+02:00",
          },
        },
        id: "1a499dd8-9c2d-4f1d-91df-376021154ed2",
        matchday: 5,
        startDate: "2019-09-20T20:30:00.000+02:00",
      },
      {
        endDate: "2019-09-29T20:00:00.000+02:00",
        fixtures: {
          "06e197bf-bc92-4a57-afdc-e8aa4027778c": {
            awayTeamId: "1bbea28c-81cc-49e3-a894-a33c3714ffc5",
            goalsAway: 2,
            goalsHome: 2,
            homeTeamId: "3fa3a04b-fa87-49e9-8772-0820a516be9c",
            kickOffTime: "2019-09-28T18:30:00.000+02:00",
          },
          "1204c1a9-ddc2-4253-9a2b-0e146feeddb5": {
            awayTeamId: "b14bb614-3a22-4e46-9c8f-6b0f7e091c6d",
            goalsAway: 3,
            goalsHome: 0,
            homeTeamId: "4e3bfa69-db9e-4b06-ba57-bffd9c11b8d1",
            kickOffTime: "2019-09-28T15:30:00.000+02:00",
          },
          "229806da-7889-42ae-8b51-88acd654158e": {
            awayTeamId: "dccf4aa9-74fb-4e7c-9011-20e7dd13ffbc",
            goalsAway: 4,
            goalsHome: 0,
            homeTeamId: "2e7b4ee7-8c0b-450b-8e10-a1bd5fc892c3",
            kickOffTime: "2019-09-29T18:00:00.000+02:00",
          },
          "574aed3b-2799-4eb1-9268-f53917a8a87d": {
            awayTeamId: "166b21c1-7fcb-4eb0-b01c-ece3943a900b",
            goalsAway: 3,
            goalsHome: 1,
            homeTeamId: "75e3d230-76a1-4339-9c0c-6155386bf897",
            kickOffTime: "2019-09-28T15:30:00.000+02:00",
          },
          "6a26e399-2e03-4c45-82b1-909156b3d990": {
            awayTeamId: "c80d1327-c1f6-44ff-8d54-4ac93ff89763",
            goalsAway: 2,
            goalsHome: 1,
            homeTeamId: "158c2559-8f11-4e58-8439-0921d101c732",
            kickOffTime: "2019-09-27T20:30:00.000+02:00",
          },
          "716ebea8-d91c-4d72-bd41-acfad0640395": {
            awayTeamId: "93c01474-719c-4df3-a4ff-7c2561e04ac1",
            goalsAway: 3,
            goalsHome: 2,
            homeTeamId: "cbe09562-1bf1-4b92-8e6b-92ea740d2774",
            kickOffTime: "2019-09-28T15:30:00.000+02:00",
          },
          "798969ea-ec4b-4917-bede-1d9b75259f29": {
            awayTeamId: "6a0d669b-9a11-4001-a753-de12bb24bd0a",
            goalsAway: 3,
            goalsHome: 0,
            homeTeamId: "49b443c0-c5f9-49fa-8e51-5a27547a9f67",
            kickOffTime: "2019-09-28T15:30:00.000+02:00",
          },
          "82a97a1e-5387-4320-baa7-37aa7d92c8e9": {
            awayTeamId: "91f5c377-c4d9-49e9-9569-b5f6c44808e1",
            goalsAway: 2,
            goalsHome: 1,
            homeTeamId: "0f231945-0ffb-4dc6-9bae-604bf236ab2f",
            kickOffTime: "2019-09-29T15:30:00.000+02:00",
          },
          "a00c7862-af07-4fe2-a791-f4ee4c380fe6": {
            awayTeamId: "e18be703-c750-4731-a9e1-2079ad8837f2",
            goalsAway: 1,
            goalsHome: 0,
            homeTeamId: "4a8ab99d-7731-4467-9c16-8ba1663c545b",
            kickOffTime: "2019-09-28T15:30:00.000+02:00",
          },
        },
        id: "448f65bc-6c17-431a-b4ee-ac9a65675998",
        matchday: 6,
        startDate: "2019-09-27T20:30:00.000+02:00",
      },
      {
        endDate: "2019-10-06T20:00:00.000+02:00",
        fixtures: {
          "0e860c2c-3513-4fdd-8106-4acd91c74746": {
            awayTeamId: "158c2559-8f11-4e58-8439-0921d101c732",
            goalsAway: 0,
            goalsHome: 1,
            homeTeamId: "e18be703-c750-4731-a9e1-2079ad8837f2",
            kickOffTime: "2019-10-06T15:30:00.000+02:00",
          },
          "42f5ae13-90a9-4cfa-9f29-5975b8ac50d0": {
            awayTeamId: "75e3d230-76a1-4339-9c0c-6155386bf897",
            goalsAway: 1,
            goalsHome: 1,
            homeTeamId: "b14bb614-3a22-4e46-9c8f-6b0f7e091c6d",
            kickOffTime: "2019-10-05T15:30:00.000+02:00",
          },
          "4f34e452-5703-44cb-96f3-e4a73239f3a5": {
            awayTeamId: "49b443c0-c5f9-49fa-8e51-5a27547a9f67",
            goalsAway: 2,
            goalsHome: 1,
            homeTeamId: "93c01474-719c-4df3-a4ff-7c2561e04ac1",
            kickOffTime: "2019-10-05T15:30:00.000+02:00",
          },
          "5176af44-2fd3-48fd-bbb6-332fd5c2a5b2": {
            awayTeamId: "3fa3a04b-fa87-49e9-8772-0820a516be9c",
            goalsAway: 2,
            goalsHome: 2,
            homeTeamId: "91f5c377-c4d9-49e9-9569-b5f6c44808e1",
            kickOffTime: "2019-10-05T15:30:00.000+02:00",
          },
          "6a4e5e86-65d3-4905-912b-116b7d9e62a9": {
            awayTeamId: "2e7b4ee7-8c0b-450b-8e10-a1bd5fc892c3",
            goalsAway: 1,
            goalsHome: 1,
            homeTeamId: "166b21c1-7fcb-4eb0-b01c-ece3943a900b",
            kickOffTime: "2019-10-05T18:30:00.000+02:00",
          },
          "6f460ee1-6c74-45ec-9a48-9b758dd59be2": {
            awayTeamId: "4e3bfa69-db9e-4b06-ba57-bffd9c11b8d1",
            goalsAway: 1,
            goalsHome: 5,
            homeTeamId: "6a0d669b-9a11-4001-a753-de12bb24bd0a",
            kickOffTime: "2019-10-06T13:30:00.000+02:00",
          },
          "91640530-a34d-4b7f-a117-b76ed62ea241": {
            awayTeamId: "0f231945-0ffb-4dc6-9bae-604bf236ab2f",
            goalsAway: 1,
            goalsHome: 3,
            homeTeamId: "dccf4aa9-74fb-4e7c-9011-20e7dd13ffbc",
            kickOffTime: "2019-10-04T20:30:00.000+02:00",
          },
          "e4dd4021-24f4-4871-94da-7abd84c57592": {
            awayTeamId: "1bbea28c-81cc-49e3-a894-a33c3714ffc5",
            goalsAway: 2,
            goalsHome: 2,
            homeTeamId: "c80d1327-c1f6-44ff-8d54-4ac93ff89763",
            kickOffTime: "2019-10-06T18:00:00.000+02:00",
          },
          "e7fcdf52-e9a7-4ba6-91f1-dc2fcc0da948": {
            awayTeamId: "4a8ab99d-7731-4467-9c16-8ba1663c545b",
            goalsAway: 2,
            goalsHome: 1,
            homeTeamId: "cbe09562-1bf1-4b92-8e6b-92ea740d2774",
            kickOffTime: "2019-10-05T15:30:00.000+02:00",
          },
        },
        id: "b9a0fc01-c578-4e81-b82c-296bfa015660",
        matchday: 7,
        startDate: "2019-10-04T20:30:00.000+02:00",
      },
      {
        endDate: "2019-10-20T20:00:00.000+02:00",
        fixtures: {
          "024d15d9-46e2-4f0c-b605-c97b473636cf": {
            awayTeamId: "166b21c1-7fcb-4eb0-b01c-ece3943a900b",
            goalsAway: 0,
            goalsHome: 2,
            homeTeamId: "49b443c0-c5f9-49fa-8e51-5a27547a9f67",
            kickOffTime: "2019-10-20T18:00:00.000+02:00",
          },
          "494692cd-4e54-4525-8db3-6ceb788569f8": {
            awayTeamId: "b14bb614-3a22-4e46-9c8f-6b0f7e091c6d",
            goalsAway: 0,
            goalsHome: 3,
            homeTeamId: "c80d1327-c1f6-44ff-8d54-4ac93ff89763",
            kickOffTime: "2019-10-18T20:30:00.000+02:00",
          },
          "7b0e1d72-5657-4b14-9e30-b0b9f38812b6": {
            awayTeamId: "6a0d669b-9a11-4001-a753-de12bb24bd0a",
            goalsAway: 0,
            goalsHome: 1,
            homeTeamId: "3fa3a04b-fa87-49e9-8772-0820a516be9c",
            kickOffTime: "2019-10-19T18:30:00.000+02:00",
          },
          "95a850b9-cfb1-4c20-b089-12774f42719c": {
            awayTeamId: "4a8ab99d-7731-4467-9c16-8ba1663c545b",
            goalsAway: 0,
            goalsHome: 1,
            homeTeamId: "0f231945-0ffb-4dc6-9bae-604bf236ab2f",
            kickOffTime: "2019-10-19T15:30:00.000+02:00",
          },
          "a4953b0a-86cc-44e1-b25a-02733ab8a030": {
            awayTeamId: "dccf4aa9-74fb-4e7c-9011-20e7dd13ffbc",
            goalsAway: 1,
            goalsHome: 1,
            homeTeamId: "1bbea28c-81cc-49e3-a894-a33c3714ffc5",
            kickOffTime: "2019-10-19T15:30:00.000+02:00",
          },
          "a8c15353-bd1d-4f53-b88c-0172065d2df4": {
            awayTeamId: "91f5c377-c4d9-49e9-9569-b5f6c44808e1",
            goalsAway: 0,
            goalsHome: 2,
            homeTeamId: "158c2559-8f11-4e58-8439-0921d101c732",
            kickOffTime: "2019-10-19T15:30:00.000+02:00",
          },
          "d7b12dd9-f19f-49e9-8291-6b8b4c75af25": {
            awayTeamId: "cbe09562-1bf1-4b92-8e6b-92ea740d2774",
            goalsAway: 0,
            goalsHome: 3,
            homeTeamId: "2e7b4ee7-8c0b-450b-8e10-a1bd5fc892c3",
            kickOffTime: "2019-10-20T15:30:00.000+02:00",
          },
          "e92cf6e2-f4af-41bc-a2a9-e3cb6566c0f9": {
            awayTeamId: "93c01474-719c-4df3-a4ff-7c2561e04ac1",
            goalsAway: 2,
            goalsHome: 2,
            homeTeamId: "4e3bfa69-db9e-4b06-ba57-bffd9c11b8d1",
            kickOffTime: "2019-10-19T15:30:00.000+02:00",
          },
          "ec67be20-5906-4008-bc7d-ac48fc0cab54": {
            awayTeamId: "e18be703-c750-4731-a9e1-2079ad8837f2",
            goalsAway: 1,
            goalsHome: 1,
            homeTeamId: "75e3d230-76a1-4339-9c0c-6155386bf897",
            kickOffTime: "2019-10-19T15:30:00.000+02:00",
          },
        },
        id: "2de920f9-1475-490e-baf5-1e1d2ecee6a3",
        matchday: 8,
        startDate: "2019-10-18T20:30:00.000+02:00",
      },
      {
        endDate: "2019-10-27T20:00:00.000+01:00",
        fixtures: {
          "0c84ffc5-d125-48d2-80b0-81098dd57139": {
            awayTeamId: "75e3d230-76a1-4339-9c0c-6155386bf897",
            goalsAway: 1,
            goalsHome: 2,
            homeTeamId: "91f5c377-c4d9-49e9-9569-b5f6c44808e1",
            kickOffTime: "2019-10-26T15:30:00.000+02:00",
          },
          "0d42a364-e56d-431d-92a0-f2689767e5cd": {
            awayTeamId: "2e7b4ee7-8c0b-450b-8e10-a1bd5fc892c3",
            goalsAway: 1,
            goalsHome: 3,
            homeTeamId: "4a8ab99d-7731-4467-9c16-8ba1663c545b",
            kickOffTime: "2019-10-25T20:30:00.000+02:00",
          },
          "1ff3507a-6b1d-45e2-8dd0-0e0ca5020388": {
            awayTeamId: "c80d1327-c1f6-44ff-8d54-4ac93ff89763",
            goalsAway: 2,
            goalsHome: 4,
            homeTeamId: "6a0d669b-9a11-4001-a753-de12bb24bd0a",
            kickOffTime: "2019-10-27T18:00:00.000+01:00",
          },
          "3361a115-96f6-4b04-b09a-11472e9cbc59": {
            awayTeamId: "4e3bfa69-db9e-4b06-ba57-bffd9c11b8d1",
            goalsAway: 0,
            goalsHome: 0,
            homeTeamId: "e18be703-c750-4731-a9e1-2079ad8837f2",
            kickOffTime: "2019-10-27T15:30:00.000+01:00",
          },
          "8db88179-9d58-461c-8cf1-2197bc0d9f18": {
            awayTeamId: "1bbea28c-81cc-49e3-a894-a33c3714ffc5",
            goalsAway: 2,
            goalsHome: 2,
            homeTeamId: "b14bb614-3a22-4e46-9c8f-6b0f7e091c6d",
            kickOffTime: "2019-10-26T18:30:00.000+02:00",
          },
          "bdd53a05-1320-4732-89fd-c535e371e053": {
            awayTeamId: "0f231945-0ffb-4dc6-9bae-604bf236ab2f",
            goalsAway: 0,
            goalsHome: 2,
            homeTeamId: "cbe09562-1bf1-4b92-8e6b-92ea740d2774",
            kickOffTime: "2019-10-26T15:30:00.000+02:00",
          },
          "d51b3957-8ac5-4e60-9230-9d1b3ea09812": {
            awayTeamId: "3fa3a04b-fa87-49e9-8772-0820a516be9c",
            goalsAway: 0,
            goalsHome: 0,
            homeTeamId: "166b21c1-7fcb-4eb0-b01c-ece3943a900b",
            kickOffTime: "2019-10-26T15:30:00.000+02:00",
          },
          "edaa1dab-48eb-404d-8f58-a19f9f324507": {
            awayTeamId: "49b443c0-c5f9-49fa-8e51-5a27547a9f67",
            goalsAway: 3,
            goalsHome: 2,
            homeTeamId: "dccf4aa9-74fb-4e7c-9011-20e7dd13ffbc",
            kickOffTime: "2019-10-26T15:30:00.000+02:00",
          },
          "fc51922c-db03-47a4-8257-fcada5344cc4": {
            awayTeamId: "158c2559-8f11-4e58-8439-0921d101c732",
            goalsAway: 1,
            goalsHome: 2,
            homeTeamId: "93c01474-719c-4df3-a4ff-7c2561e04ac1",
            kickOffTime: "2019-10-26T15:30:00.000+02:00",
          },
        },
        id: "a84813e4-20ae-4cb4-b508-822a5835c1dc",
        matchday: 9,
        startDate: "2019-10-25T20:30:00.000+02:00",
      },
      {
        endDate: "2019-11-03T20:00:00.000+01:00",
        fixtures: {
          "07bba38f-e03e-4e82-b4d8-f700fe5a130e": {
            awayTeamId: "2e7b4ee7-8c0b-450b-8e10-a1bd5fc892c3",
            goalsAway: 0,
            goalsHome: 2,
            homeTeamId: "0f231945-0ffb-4dc6-9bae-604bf236ab2f",
            kickOffTime: "2019-11-03T15:30:00.000+01:00",
          },
          "0f8e2b35-a273-4d90-933c-df7e25e1a052": {
            awayTeamId: "91f5c377-c4d9-49e9-9569-b5f6c44808e1",
            goalsAway: 2,
            goalsHome: 2,
            homeTeamId: "1bbea28c-81cc-49e3-a894-a33c3714ffc5",
            kickOffTime: "2019-11-02T15:30:00.000+01:00",
          },
          "31819518-9b53-4341-9a8e-109a13955aa9": {
            awayTeamId: "166b21c1-7fcb-4eb0-b01c-ece3943a900b",
            goalsAway: 3,
            goalsHome: 2,
            homeTeamId: "4e3bfa69-db9e-4b06-ba57-bffd9c11b8d1",
            kickOffTime: "2019-11-03T18:00:00.000+01:00",
          },
          "6f397722-4c47-47c1-879a-995477de93ca": {
            awayTeamId: "dccf4aa9-74fb-4e7c-9011-20e7dd13ffbc",
            goalsAway: 0,
            goalsHome: 1,
            homeTeamId: "158c2559-8f11-4e58-8439-0921d101c732",
            kickOffTime: "2019-11-02T18:30:00.000+01:00",
          },
          "7cd6d4e5-4174-4685-9308-6b7d75d7eec7": {
            awayTeamId: "cbe09562-1bf1-4b92-8e6b-92ea740d2774",
            goalsAway: 0,
            goalsHome: 3,
            homeTeamId: "49b443c0-c5f9-49fa-8e51-5a27547a9f67",
            kickOffTime: "2019-11-01T20:30:00.000+01:00",
          },
          "7d6ae0cd-8453-41d6-bee2-25c410775a9f": {
            awayTeamId: "e18be703-c750-4731-a9e1-2079ad8837f2",
            goalsAway: 0,
            goalsHome: 3,
            homeTeamId: "3fa3a04b-fa87-49e9-8772-0820a516be9c",
            kickOffTime: "2019-11-02T15:30:00.000+01:00",
          },
          "8474fac3-110c-4770-b89f-1587cea0d6ca": {
            awayTeamId: "6a0d669b-9a11-4001-a753-de12bb24bd0a",
            goalsAway: 2,
            goalsHome: 1,
            homeTeamId: "b14bb614-3a22-4e46-9c8f-6b0f7e091c6d",
            kickOffTime: "2019-11-02T15:30:00.000+01:00",
          },
          "a50af30a-0735-4265-956b-8df599b5862a": {
            awayTeamId: "93c01474-719c-4df3-a4ff-7c2561e04ac1",
            goalsAway: 1,
            goalsHome: 5,
            homeTeamId: "c80d1327-c1f6-44ff-8d54-4ac93ff89763",
            kickOffTime: "2019-11-02T15:30:00.000+01:00",
          },
          "ee666e6a-9710-4f99-8d93-34f96c5b9be6": {
            awayTeamId: "4a8ab99d-7731-4467-9c16-8ba1663c545b",
            goalsAway: 0,
            goalsHome: 8,
            homeTeamId: "75e3d230-76a1-4339-9c0c-6155386bf897",
            kickOffTime: "2019-11-02T15:30:00.000+01:00",
          },
        },
        id: "33c9380c-3489-44f9-919f-8de504c3b674",
        matchday: 10,
        startDate: "2019-11-01T20:30:00.000+01:00",
      },
      {
        endDate: "2019-11-10T20:00:00.000+01:00",
        fixtures: {
          "1ec1ffa2-c818-4798-9b89-44bbf47f3f56": {
            awayTeamId: "3fa3a04b-fa87-49e9-8772-0820a516be9c",
            goalsAway: 0,
            goalsHome: 4,
            homeTeamId: "93c01474-719c-4df3-a4ff-7c2561e04ac1",
            kickOffTime: "2019-11-09T18:30:00.000+01:00",
          },
          "22639c49-43e0-4f92-be9c-357897704588": {
            awayTeamId: "1bbea28c-81cc-49e3-a894-a33c3714ffc5",
            goalsAway: 1,
            goalsHome: 3,
            homeTeamId: "6a0d669b-9a11-4001-a753-de12bb24bd0a",
            kickOffTime: "2019-11-10T13:30:00.000+01:00",
          },
          "3f57fc60-e5ea-416f-be37-786d83ca0056": {
            awayTeamId: "158c2559-8f11-4e58-8439-0921d101c732",
            goalsAway: 3,
            goalsHome: 2,
            homeTeamId: "4a8ab99d-7731-4467-9c16-8ba1663c545b",
            kickOffTime: "2019-11-09T15:30:00.000+01:00",
          },
          "4883419d-1603-4ace-9af3-45bcd3873a01": {
            awayTeamId: "75e3d230-76a1-4339-9c0c-6155386bf897",
            goalsAway: 4,
            goalsHome: 2,
            homeTeamId: "dccf4aa9-74fb-4e7c-9011-20e7dd13ffbc",
            kickOffTime: "2019-11-09T15:30:00.000+01:00",
          },
          "af65242e-88f7-442c-8287-f4c9b113721e": {
            awayTeamId: "4e3bfa69-db9e-4b06-ba57-bffd9c11b8d1",
            goalsAway: 1,
            goalsHome: 0,
            homeTeamId: "cbe09562-1bf1-4b92-8e6b-92ea740d2774",
            kickOffTime: "2019-11-09T15:30:00.000+01:00",
          },
          "b99b7988-a57d-471b-a952-90653fcbd633": {
            awayTeamId: "0f231945-0ffb-4dc6-9bae-604bf236ab2f",
            goalsAway: 3,
            goalsHome: 3,
            homeTeamId: "166b21c1-7fcb-4eb0-b01c-ece3943a900b",
            kickOffTime: "2019-11-09T15:30:00.000+01:00",
          },
          "bde83511-84e6-464d-bb6a-4d26beeec6b5": {
            awayTeamId: "c80d1327-c1f6-44ff-8d54-4ac93ff89763",
            goalsAway: 0,
            goalsHome: 1,
            homeTeamId: "91f5c377-c4d9-49e9-9569-b5f6c44808e1",
            kickOffTime: "2019-11-10T18:00:00.000+01:00",
          },
          "de212a40-1c97-4d13-94b7-54cdde189c57": {
            awayTeamId: "b14bb614-3a22-4e46-9c8f-6b0f7e091c6d",
            goalsAway: 2,
            goalsHome: 0,
            homeTeamId: "e18be703-c750-4731-a9e1-2079ad8837f2",
            kickOffTime: "2019-11-10T15:30:00.000+01:00",
          },
          "f51669f9-e0f5-4d09-9b89-a3ba52b306ec": {
            awayTeamId: "49b443c0-c5f9-49fa-8e51-5a27547a9f67",
            goalsAway: 2,
            goalsHome: 1,
            homeTeamId: "2e7b4ee7-8c0b-450b-8e10-a1bd5fc892c3",
            kickOffTime: "2019-11-08T20:30:00.000+01:00",
          },
        },
        id: "6766f241-c2e8-4f04-80c3-d0c452bf6497",
        matchday: 11,
        startDate: "2019-11-08T20:30:00.000+01:00",
      },
      {
        endDate: "2019-11-24T20:00:00.000+01:00",
        fixtures: {
          "01af024c-3881-4059-a358-b018e012a5ba": {
            awayTeamId: "e18be703-c750-4731-a9e1-2079ad8837f2",
            goalsAway: 2,
            goalsHome: 0,
            homeTeamId: "c80d1327-c1f6-44ff-8d54-4ac93ff89763",
            kickOffTime: "2019-11-23T15:30:00.000+01:00",
          },
          "111a7ff5-0dbc-48ec-95c3-53485a79490b": {
            awayTeamId: "93c01474-719c-4df3-a4ff-7c2561e04ac1",
            goalsAway: 4,
            goalsHome: 0,
            homeTeamId: "0f231945-0ffb-4dc6-9bae-604bf236ab2f",
            kickOffTime: "2019-11-23T15:30:00.000+01:00",
          },
          "30baf420-9336-4c00-899e-c0233b3e783c": {
            awayTeamId: "166b21c1-7fcb-4eb0-b01c-ece3943a900b",
            goalsAway: 2,
            goalsHome: 1,
            homeTeamId: "1bbea28c-81cc-49e3-a894-a33c3714ffc5",
            kickOffTime: "2019-11-23T15:30:00.000+01:00",
          },
          "46f88aa2-d0ca-465a-8d62-15a119acdac2": {
            awayTeamId: "6a0d669b-9a11-4001-a753-de12bb24bd0a",
            goalsAway: 0,
            goalsHome: 2,
            homeTeamId: "158c2559-8f11-4e58-8439-0921d101c732",
            kickOffTime: "2019-11-23T15:30:00.000+01:00",
          },
          "a455ff8c-648f-4c81-8cbc-6e079723509b": {
            awayTeamId: "dccf4aa9-74fb-4e7c-9011-20e7dd13ffbc",
            goalsAway: 0,
            goalsHome: 4,
            homeTeamId: "4e3bfa69-db9e-4b06-ba57-bffd9c11b8d1",
            kickOffTime: "2019-11-24T15:30:00.000+01:00",
          },
          "a6140bd9-c3f8-46d3-80eb-4d39314db130": {
            awayTeamId: "cbe09562-1bf1-4b92-8e6b-92ea740d2774",
            goalsAway: 3,
            goalsHome: 3,
            homeTeamId: "3fa3a04b-fa87-49e9-8772-0820a516be9c",
            kickOffTime: "2019-11-22T20:30:00.000+01:00",
          },
          "a90a8520-d74d-4c9e-8011-f45cc12f5703": {
            awayTeamId: "2e7b4ee7-8c0b-450b-8e10-a1bd5fc892c3",
            goalsAway: 1,
            goalsHome: 4,
            homeTeamId: "75e3d230-76a1-4339-9c0c-6155386bf897",
            kickOffTime: "2019-11-23T18:30:00.000+01:00",
          },
          "b66efaab-428d-464f-a1ea-54c5083147b7": {
            awayTeamId: "91f5c377-c4d9-49e9-9569-b5f6c44808e1",
            goalsAway: 1,
            goalsHome: 1,
            homeTeamId: "b14bb614-3a22-4e46-9c8f-6b0f7e091c6d",
            kickOffTime: "2019-11-23T15:30:00.000+01:00",
          },
          "ec4afbb8-4811-4c07-9ca4-dc348cdea3ea": {
            awayTeamId: "4a8ab99d-7731-4467-9c16-8ba1663c545b",
            goalsAway: 5,
            goalsHome: 1,
            homeTeamId: "49b443c0-c5f9-49fa-8e51-5a27547a9f67",
            kickOffTime: "2019-11-24T18:00:00.000+01:00",
          },
        },
        id: "a65fda7a-ccc0-40c7-b7bb-7ca3db6cc73e",
        matchday: 12,
        startDate: "2019-11-22T20:30:00.000+01:00",
      },
      {
        endDate: "2019-12-02T20:30:00.000+01:00",
        fixtures: {
          "01bd36fa-8457-450b-85b5-42360c61ea7a": {
            awayTeamId: "c80d1327-c1f6-44ff-8d54-4ac93ff89763",
            goalsAway: 1,
            goalsHome: 2,
            homeTeamId: "4a8ab99d-7731-4467-9c16-8ba1663c545b",
            kickOffTime: "2019-12-02T18:30:00.000+01:00",
          },
          "023689ef-4b31-418a-b6e0-0db8d959307a": {
            awayTeamId: "1bbea28c-81cc-49e3-a894-a33c3714ffc5",
            goalsAway: 3,
            goalsHome: 2,
            homeTeamId: "e18be703-c750-4731-a9e1-2079ad8837f2",
            kickOffTime: "2019-12-01T18:00:00.000+01:00",
          },
          "30b8be48-a04a-4c04-98e8-78aa38c2fafb": {
            awayTeamId: "158c2559-8f11-4e58-8439-0921d101c732",
            goalsAway: 1,
            goalsHome: 2,
            homeTeamId: "166b21c1-7fcb-4eb0-b01c-ece3943a900b",
            kickOffTime: "2019-11-29T20:30:00.000+01:00",
          },
          "69398823-50e6-4790-9459-38e02ae737d3": {
            awayTeamId: "75e3d230-76a1-4339-9c0c-6155386bf897",
            goalsAway: 3,
            goalsHome: 2,
            homeTeamId: "cbe09562-1bf1-4b92-8e6b-92ea740d2774",
            kickOffTime: "2019-11-30T15:30:00.000+01:00",
          },
          "7f3745dc-2164-44a2-ac4d-c563831db3a7": {
            awayTeamId: "3fa3a04b-fa87-49e9-8772-0820a516be9c",
            goalsAway: 2,
            goalsHome: 1,
            homeTeamId: "dccf4aa9-74fb-4e7c-9011-20e7dd13ffbc",
            kickOffTime: "2019-11-30T15:30:00.000+01:00",
          },
          "8534269f-181f-42ad-ae8d-0ee1957cdf23": {
            awayTeamId: "4e3bfa69-db9e-4b06-ba57-bffd9c11b8d1",
            goalsAway: 1,
            goalsHome: 1,
            homeTeamId: "2e7b4ee7-8c0b-450b-8e10-a1bd5fc892c3",
            kickOffTime: "2019-11-30T15:30:00.000+01:00",
          },
          "93814097-7285-46b2-94de-80257c422b36": {
            awayTeamId: "0f231945-0ffb-4dc6-9bae-604bf236ab2f",
            goalsAway: 1,
            goalsHome: 1,
            homeTeamId: "49b443c0-c5f9-49fa-8e51-5a27547a9f67",
            kickOffTime: "2019-11-30T15:30:00.000+01:00",
          },
          "a892ab78-be33-49db-85bb-d55e12d6d09b": {
            awayTeamId: "91f5c377-c4d9-49e9-9569-b5f6c44808e1",
            goalsAway: 2,
            goalsHome: 4,
            homeTeamId: "6a0d669b-9a11-4001-a753-de12bb24bd0a",
            kickOffTime: "2019-12-01T15:30:00.000+01:00",
          },
          "e965d9d5-0b73-40f3-97b1-0337b5ff8e34": {
            awayTeamId: "b14bb614-3a22-4e46-9c8f-6b0f7e091c6d",
            goalsAway: 2,
            goalsHome: 1,
            homeTeamId: "93c01474-719c-4df3-a4ff-7c2561e04ac1",
            kickOffTime: "2019-11-30T18:30:00.000+01:00",
          },
        },
        id: "5afba46d-791a-4f7a-9a48-34eb466b275c",
        matchday: 13,
        startDate: "2019-11-29T20:30:00.000+01:00",
      },
      {
        endDate: "2019-12-08T20:00:00.000+01:00",
        fixtures: {
          "7eb7ca10-3ebd-4b31-a1b1-6eeab6bb4926": {
            awayTeamId: "cbe09562-1bf1-4b92-8e6b-92ea740d2774",
            goalsAway: 1,
            goalsHome: 0,
            homeTeamId: "1bbea28c-81cc-49e3-a894-a33c3714ffc5",
            kickOffTime: "2019-12-08T18:00:00.000+01:00",
          },
          "9770904d-32ab-4c3f-9a63-b58af7b0ede9": {
            awayTeamId: "49b443c0-c5f9-49fa-8e51-5a27547a9f67",
            goalsAway: 1,
            goalsHome: 3,
            homeTeamId: "75e3d230-76a1-4339-9c0c-6155386bf897",
            kickOffTime: "2019-12-07T15:30:00.000+01:00",
          },
          "9acd8910-dc41-47b3-95fc-eff99b3cd632": {
            awayTeamId: "e18be703-c750-4731-a9e1-2079ad8837f2",
            goalsAway: 0,
            goalsHome: 1,
            homeTeamId: "91f5c377-c4d9-49e9-9569-b5f6c44808e1",
            kickOffTime: "2019-12-07T15:30:00.000+01:00",
          },
          "c518c5c5-2559-4e54-9506-b431cc9bae56": {
            awayTeamId: "2e7b4ee7-8c0b-450b-8e10-a1bd5fc892c3",
            goalsAway: 0,
            goalsHome: 2,
            homeTeamId: "158c2559-8f11-4e58-8439-0921d101c732",
            kickOffTime: "2019-12-08T15:30:00.000+01:00",
          },
          "d418cfd8-b6bc-4dfb-89f0-a2175758bda6": {
            awayTeamId: "93c01474-719c-4df3-a4ff-7c2561e04ac1",
            goalsAway: 1,
            goalsHome: 2,
            homeTeamId: "6a0d669b-9a11-4001-a753-de12bb24bd0a",
            kickOffTime: "2019-12-07T15:30:00.000+01:00",
          },
          "da562680-4053-4c0e-9cbb-5656f7f2cf3e": {
            awayTeamId: "0f231945-0ffb-4dc6-9bae-604bf236ab2f",
            goalsAway: 0,
            goalsHome: 5,
            homeTeamId: "3fa3a04b-fa87-49e9-8772-0820a516be9c",
            kickOffTime: "2019-12-07T15:30:00.000+01:00",
          },
          "de2b9bc5-7170-4feb-97b6-10fb10aaafbf": {
            awayTeamId: "dccf4aa9-74fb-4e7c-9011-20e7dd13ffbc",
            goalsAway: 2,
            goalsHome: 2,
            homeTeamId: "c80d1327-c1f6-44ff-8d54-4ac93ff89763",
            kickOffTime: "2019-12-06T20:30:00.000+01:00",
          },
          "e8f4f13d-4f52-4c45-9a41-891655f41cfc": {
            awayTeamId: "166b21c1-7fcb-4eb0-b01c-ece3943a900b",
            goalsAway: 1,
            goalsHome: 2,
            homeTeamId: "b14bb614-3a22-4e46-9c8f-6b0f7e091c6d",
            kickOffTime: "2019-12-07T18:30:00.000+01:00",
          },
          "f9092a2e-5e39-4e18-9ed2-7fa56182be25": {
            awayTeamId: "4a8ab99d-7731-4467-9c16-8ba1663c545b",
            goalsAway: 1,
            goalsHome: 2,
            homeTeamId: "4e3bfa69-db9e-4b06-ba57-bffd9c11b8d1",
            kickOffTime: "2019-12-07T15:30:00.000+01:00",
          },
        },
        id: "8df81d94-51ff-478e-8d33-b88c71de0d03",
        matchday: 14,
        startDate: "2019-12-06T20:30:00.000+01:00",
      },
      {
        endDate: "",
        fixtures: {
          "2b090d0d-f439-4fcf-ad57-9b9ff44ab890": {
            awayTeamId: "1bbea28c-81cc-49e3-a894-a33c3714ffc5",
            goalsAway: 1,
            goalsHome: 6,
            homeTeamId: "93c01474-719c-4df3-a4ff-7c2561e04ac1",
            id: "2b090d0d-f439-4fcf-ad57-9b9ff44ab890",
            kickOffTime: "2019-12-14T15:30:42.459Z",
          },
          "4d84e6b0-c3da-4adf-b09f-73ccf6ab6e5a": {
            awayTeamId: "b14bb614-3a22-4e46-9c8f-6b0f7e091c6d",
            goalsAway: 0,
            goalsHome: 2,
            homeTeamId: "2e7b4ee7-8c0b-450b-8e10-a1bd5fc892c3",
            id: "4d84e6b0-c3da-4adf-b09f-73ccf6ab6e5a",
            kickOffTime: "2019-12-14T15:30:42.465Z",
          },
          "6c4efdf0-b79d-4fe5-8a01-b855b3b3c05c": {
            awayTeamId: "75e3d230-76a1-4339-9c0c-6155386bf897",
            goalsAway: 3,
            goalsHome: 0,
            homeTeamId: "0f231945-0ffb-4dc6-9bae-604bf236ab2f",
            id: "6c4efdf0-b79d-4fe5-8a01-b855b3b3c05c",
            kickOffTime: "2019-12-14T18:30:42.466Z",
          },
          "8a6a9d93-de4e-488f-bea9-12c1e435fe22": {
            awayTeamId: "158c2559-8f11-4e58-8439-0921d101c732",
            goalsAway: 1,
            goalsHome: 1,
            homeTeamId: "cbe09562-1bf1-4b92-8e6b-92ea740d2774",
            id: "8a6a9d93-de4e-488f-bea9-12c1e435fe22",
            kickOffTime: "2019-12-14T15:30:42.465Z",
          },
          "90c916ff-966e-4697-8736-f970deedc686": {
            awayTeamId: "91f5c377-c4d9-49e9-9569-b5f6c44808e1",
            goalsAway: 0,
            goalsHome: 1,
            homeTeamId: "dccf4aa9-74fb-4e7c-9011-20e7dd13ffbc",
            id: "90c916ff-966e-4697-8736-f970deedc686",
            kickOffTime: "2019-12-14T15:30:42.461Z",
          },
          "96a14a82-8bd7-426a-9f78-7e2a4425e6f3": {
            awayTeamId: "4e3bfa69-db9e-4b06-ba57-bffd9c11b8d1",
            goalsAway: 4,
            goalsHome: 2,
            homeTeamId: "49b443c0-c5f9-49fa-8e51-5a27547a9f67",
            id: "96a14a82-8bd7-426a-9f78-7e2a4425e6f3",
            kickOffTime: "2019-12-13T20:30:12.477Z",
          },
          "b2de136e-b316-49e3-8255-37dce03c1ff0": {
            awayTeamId: "c80d1327-c1f6-44ff-8d54-4ac93ff89763",
            goalsAway: 0,
            goalsHome: 1,
            homeTeamId: "166b21c1-7fcb-4eb0-b01c-ece3943a900b",
            id: "b2de136e-b316-49e3-8255-37dce03c1ff0",
            kickOffTime: "2019-12-15T18:00:05.138Z",
          },
          "e337be8a-49c1-47d1-958b-1974e3fd6d98": {
            awayTeamId: "3fa3a04b-fa87-49e9-8772-0820a516be9c",
            goalsAway: 4,
            goalsHome: 0,
            homeTeamId: "4a8ab99d-7731-4467-9c16-8ba1663c545b",
            id: "e337be8a-49c1-47d1-958b-1974e3fd6d98",
            kickOffTime: "2019-12-14T15:30:42.464Z",
          },
          "e8d16719-5b73-4eea-b538-0de8c0c9ec0b": {
            awayTeamId: "6a0d669b-9a11-4001-a753-de12bb24bd0a",
            goalsAway: 1,
            goalsHome: 2,
            homeTeamId: "e18be703-c750-4731-a9e1-2079ad8837f2",
            id: "e8d16719-5b73-4eea-b538-0de8c0c9ec0b",
            kickOffTime: "2019-12-15T15:30:05.136Z",
          },
        },
        id: "be260154-17da-4cd0-a7ec-a84be1f5c482",
        matchday: 15,
        startDate: "",
      },
      {
        endDate: "",
        fixtures: {
          "36cd1afa-e956-4f58-ba2c-f0848b6453df": {
            awayTeamId: "dccf4aa9-74fb-4e7c-9011-20e7dd13ffbc",
            goalsAway: 1,
            goalsHome: 0,
            homeTeamId: "b14bb614-3a22-4e46-9c8f-6b0f7e091c6d",
            kickOffTime: "2019-12-18T18:30:00.000+01:00",
          },
          "4a28b298-bc01-4a07-b656-1c2c48817b0a": {
            awayTeamId: "49b443c0-c5f9-49fa-8e51-5a27547a9f67",
            goalsAway: 2,
            goalsHome: 0,
            homeTeamId: "158c2559-8f11-4e58-8439-0921d101c732",
            kickOffTime: "2019-12-17T20:30:00.000+01:00",
          },
          "5265242e-a87d-4577-9499-7a6477f66a91": {
            awayTeamId: "93c01474-719c-4df3-a4ff-7c2561e04ac1",
            goalsAway: 3,
            goalsHome: 1,
            homeTeamId: "91f5c377-c4d9-49e9-9569-b5f6c44808e1",
            kickOffTime: "2019-12-18T20:30:00.000+01:00",
          },
          "7e59b1cb-4a50-4b0e-833c-e6ea72f2089c": {
            awayTeamId: "2e7b4ee7-8c0b-450b-8e10-a1bd5fc892c3",
            goalsAway: 4,
            goalsHome: 2,
            homeTeamId: "c80d1327-c1f6-44ff-8d54-4ac93ff89763",
            kickOffTime: "2019-12-18T20:30:00.000+01:00",
          },
          "9e16ae3d-fd27-4e3a-a143-3927e0696e57": {
            awayTeamId: "4a8ab99d-7731-4467-9c16-8ba1663c545b",
            goalsAway: 5,
            goalsHome: 0,
            homeTeamId: "1bbea28c-81cc-49e3-a894-a33c3714ffc5",
            kickOffTime: "2019-12-17T18:30:00.000+01:00",
          },
          "b3b756e2-13c6-446a-805b-68dbc2865209": {
            awayTeamId: "166b21c1-7fcb-4eb0-b01c-ece3943a900b",
            goalsAway: 1,
            goalsHome: 1,
            homeTeamId: "e18be703-c750-4731-a9e1-2079ad8837f2",
            kickOffTime: "2019-12-18T20:30:00.000+01:00",
          },
          "c99076bc-7410-4d2d-8bac-87558083df6d": {
            awayTeamId: "cbe09562-1bf1-4b92-8e6b-92ea740d2774",
            goalsAway: 0,
            goalsHome: 2,
            homeTeamId: "6a0d669b-9a11-4001-a753-de12bb24bd0a",
            kickOffTime: "2019-12-18T20:30:00.000+01:00",
          },
          "d65f3f35-d136-4a47-98b0-e664544b5524": {
            awayTeamId: "75e3d230-76a1-4339-9c0c-6155386bf897",
            goalsAway: 3,
            goalsHome: 3,
            homeTeamId: "3fa3a04b-fa87-49e9-8772-0820a516be9c",
            kickOffTime: "2019-12-17T20:30:00.000+01:00",
          },
          "edc26631-82a5-4193-83ad-69d8afd59e1f": {
            awayTeamId: "0f231945-0ffb-4dc6-9bae-604bf236ab2f",
            goalsAway: 0,
            goalsHome: 3,
            homeTeamId: "4e3bfa69-db9e-4b06-ba57-bffd9c11b8d1",
            kickOffTime: "2019-12-17T20:30:00.000+01:00",
          },
        },
        id: "b603b4de-4b1a-41aa-809e-d15c5a7f17bd",
        matchday: 16,
        startDate: "",
      },
      {
        endDate: "",
        fixtures: {
          "3c420bad-d614-4554-b857-d78220baa9dc": {
            awayTeamId: "3fa3a04b-fa87-49e9-8772-0820a516be9c",
            goalsAway: 1,
            goalsHome: 2,
            homeTeamId: "49b443c0-c5f9-49fa-8e51-5a27547a9f67",
            kickOffTime: "2019-12-20T20:30:00.000+01:00",
          },
          "6e4529b6-aec3-4773-a84d-f70fb6a75b86": {
            awayTeamId: "c80d1327-c1f6-44ff-8d54-4ac93ff89763",
            goalsAway: 1,
            goalsHome: 2,
            homeTeamId: "cbe09562-1bf1-4b92-8e6b-92ea740d2774",
            kickOffTime: "2019-12-22T18:00:00.000+01:00",
          },
          "7a76f9fb-9311-4e7d-beac-dfdcae1f1d38": {
            awayTeamId: "b14bb614-3a22-4e46-9c8f-6b0f7e091c6d",
            goalsAway: 1,
            goalsHome: 0,
            homeTeamId: "4a8ab99d-7731-4467-9c16-8ba1663c545b",
            kickOffTime: "2019-12-21T15:30:00.000+01:00",
          },
          "7f52c524-4611-4f4e-84dd-458450c3d0a1": {
            awayTeamId: "1bbea28c-81cc-49e3-a894-a33c3714ffc5",
            goalsAway: 0,
            goalsHome: 1,
            homeTeamId: "2e7b4ee7-8c0b-450b-8e10-a1bd5fc892c3",
            kickOffTime: "2019-12-21T15:30:00.000+01:00",
          },
          "9741bdff-1636-459f-9915-2c7f0ed5b1b3": {
            awayTeamId: "158c2559-8f11-4e58-8439-0921d101c732",
            goalsAway: 1,
            goalsHome: 2,
            homeTeamId: "0f231945-0ffb-4dc6-9bae-604bf236ab2f",
            kickOffTime: "2019-12-22T15:30:00.000+01:00",
          },
          "a42c03c3-ea27-491b-88c8-c80bc4324136": {
            awayTeamId: "91f5c377-c4d9-49e9-9569-b5f6c44808e1",
            goalsAway: 2,
            goalsHome: 2,
            homeTeamId: "166b21c1-7fcb-4eb0-b01c-ece3943a900b",
            kickOffTime: "2019-12-21T15:30:00.000+01:00",
          },
          "b7a0bf66-29d6-4d87-bb72-7ea197ad98ad": {
            awayTeamId: "e18be703-c750-4731-a9e1-2079ad8837f2",
            goalsAway: 0,
            goalsHome: 2,
            homeTeamId: "93c01474-719c-4df3-a4ff-7c2561e04ac1",
            kickOffTime: "2019-12-21T15:30:00.000+01:00",
          },
          "b8c1a9d5-9f5c-4a50-a3bf-68233c4a7d3a": {
            awayTeamId: "4e3bfa69-db9e-4b06-ba57-bffd9c11b8d1",
            goalsAway: 1,
            goalsHome: 3,
            homeTeamId: "75e3d230-76a1-4339-9c0c-6155386bf897",
            kickOffTime: "2019-12-21T15:30:00.000+01:00",
          },
          "ec899dc7-226b-4992-be06-ed43174ce340": {
            awayTeamId: "6a0d669b-9a11-4001-a753-de12bb24bd0a",
            goalsAway: 0,
            goalsHome: 0,
            homeTeamId: "dccf4aa9-74fb-4e7c-9011-20e7dd13ffbc",
            kickOffTime: "2019-12-21T18:30:00.000+01:00",
          },
        },
        id: "65c4ed12-801f-4690-8b62-33f31147d1ea",
        matchday: 17,
        startDate: "",
      },
      {
        endDate: "",
        fixtures: {
          "1ff66277-d04d-47af-9325-c81a9495101f": {
            awayTeamId: "1bbea28c-81cc-49e3-a894-a33c3714ffc5",
            goalsAway: 1,
            goalsHome: 0,
            homeTeamId: "0f231945-0ffb-4dc6-9bae-604bf236ab2f",
            id: "1ff66277-d04d-47af-9325-c81a9495101f",
            kickOffTime: "2020-01-18T14:31:12.471Z",
          },
          "4a79ed48-fad3-4eb5-ab61-7b2746dd12b4": {
            awayTeamId: "c80d1327-c1f6-44ff-8d54-4ac93ff89763",
            goalsAway: 2,
            goalsHome: 1,
            homeTeamId: "49b443c0-c5f9-49fa-8e51-5a27547a9f67",
            id: "4a79ed48-fad3-4eb5-ab61-7b2746dd12b4",
            kickOffTime: "2020-01-18T14:31:12.471Z",
          },
          "6fa413d2-0054-441e-8777-d3017a056064": {
            awayTeamId: "3fa3a04b-fa87-49e9-8772-0820a516be9c",
            goalsAway: 5,
            goalsHome: 3,
            homeTeamId: "4e3bfa69-db9e-4b06-ba57-bffd9c11b8d1",
            id: "6fa413d2-0054-441e-8777-d3017a056064",
            kickOffTime: "2020-01-18T14:31:12.472Z",
          },
          "92db40ea-7692-4bce-b31e-7e2e1955af4f": {
            awayTeamId: "93c01474-719c-4df3-a4ff-7c2561e04ac1",
            goalsAway: 4,
            goalsHome: 0,
            homeTeamId: "dccf4aa9-74fb-4e7c-9011-20e7dd13ffbc",
            id: "92db40ea-7692-4bce-b31e-7e2e1955af4f",
            kickOffTime: "2020-01-19T14:31:10.137Z",
          },
          "a4583696-146f-44fd-bdec-4135c9729bca": {
            awayTeamId: "91f5c377-c4d9-49e9-9569-b5f6c44808e1",
            goalsAway: 2,
            goalsHome: 1,
            homeTeamId: "4a8ab99d-7731-4467-9c16-8ba1663c545b",
            id: "a4583696-146f-44fd-bdec-4135c9729bca",
            kickOffTime: "2020-01-18T14:31:12.472Z",
          },
          "a8e53029-041d-4dd2-911d-7fd1c16f9536": {
            awayTeamId: "b14bb614-3a22-4e46-9c8f-6b0f7e091c6d",
            goalsAway: 4,
            goalsHome: 1,
            homeTeamId: "cbe09562-1bf1-4b92-8e6b-92ea740d2774",
            id: "a8e53029-041d-4dd2-911d-7fd1c16f9536",
            kickOffTime: "2020-01-19T17:01:11.838Z",
          },
          "c3b92c39-03cf-4b79-9a99-b3a282c70b2a": {
            awayTeamId: "158c2559-8f11-4e58-8439-0921d101c732",
            goalsAway: 1,
            goalsHome: 3,
            homeTeamId: "75e3d230-76a1-4339-9c0c-6155386bf897",
            id: "c3b92c39-03cf-4b79-9a99-b3a282c70b2a",
            kickOffTime: "2020-01-18T17:31:06.737Z",
          },
          "e4d2679c-f773-4b1b-b2e6-c5f11362cf57": {
            awayTeamId: "6a0d669b-9a11-4001-a753-de12bb24bd0a",
            goalsAway: 0,
            goalsHome: 2,
            homeTeamId: "166b21c1-7fcb-4eb0-b01c-ece3943a900b",
            id: "e4d2679c-f773-4b1b-b2e6-c5f11362cf57",
            kickOffTime: "2020-01-17T19:31:00.812Z",
          },
          "fed59473-5bad-43c9-8280-a4f4e50ae68c": {
            awayTeamId: "e18be703-c750-4731-a9e1-2079ad8837f2",
            goalsAway: 1,
            goalsHome: 3,
            homeTeamId: "2e7b4ee7-8c0b-450b-8e10-a1bd5fc892c3",
            id: "fed59473-5bad-43c9-8280-a4f4e50ae68c",
            kickOffTime: "2020-01-18T14:31:12.472Z",
          },
        },
        id: "2e82b624-bb3e-418a-b1b5-58276b528c11",
        matchday: 18,
        startDate: "",
      },
      {
        endDate: "",
        fixtures: {
          "24552d5a-3710-4999-b6cd-f6e40dcdabcf": {
            awayTeamId: "0f231945-0ffb-4dc6-9bae-604bf236ab2f",
            goalsAway: 0,
            goalsHome: 3,
            homeTeamId: "b14bb614-3a22-4e46-9c8f-6b0f7e091c6d",
            id: "24552d5a-3710-4999-b6cd-f6e40dcdabcf",
            kickOffTime: "2020-01-26T17:01:01.347Z",
          },
          "7a780b98-4e1f-4918-b9c1-fb9bc0daf4d5": {
            awayTeamId: "4a8ab99d-7731-4467-9c16-8ba1663c545b",
            goalsAway: 1,
            goalsHome: 3,
            homeTeamId: "6a0d669b-9a11-4001-a753-de12bb24bd0a",
            id: "7a780b98-4e1f-4918-b9c1-fb9bc0daf4d5",
            kickOffTime: "2020-01-25T14:31:06.046Z",
          },
          "96f4d4ae-7a04-4771-a854-9f0a0b51fc25": {
            awayTeamId: "166b21c1-7fcb-4eb0-b01c-ece3943a900b",
            goalsAway: 0,
            goalsHome: 5,
            homeTeamId: "93c01474-719c-4df3-a4ff-7c2561e04ac1",
            id: "96f4d4ae-7a04-4771-a854-9f0a0b51fc25",
            kickOffTime: "2020-01-25T17:31:07.146Z",
          },
          "9cdcd5e7-405e-434f-a07e-1ccbfb1df85c": {
            awayTeamId: "cbe09562-1bf1-4b92-8e6b-92ea740d2774",
            goalsAway: 2,
            goalsHome: 0,
            homeTeamId: "91f5c377-c4d9-49e9-9569-b5f6c44808e1",
            id: "9cdcd5e7-405e-434f-a07e-1ccbfb1df85c",
            kickOffTime: "2020-01-25T14:31:06.047Z",
          },
          "a4cbffdd-ef9c-4a17-933a-0d6d3401af77": {
            awayTeamId: "4e3bfa69-db9e-4b06-ba57-bffd9c11b8d1",
            goalsAway: 0,
            goalsHome: 2,
            homeTeamId: "158c2559-8f11-4e58-8439-0921d101c732",
            id: "a4cbffdd-ef9c-4a17-933a-0d6d3401af77",
            kickOffTime: "2020-01-25T14:31:06.047Z",
          },
          "ab607d7a-8f8a-4444-8653-895d087ca945": {
            awayTeamId: "49b443c0-c5f9-49fa-8e51-5a27547a9f67",
            goalsAway: 3,
            goalsHome: 0,
            homeTeamId: "1bbea28c-81cc-49e3-a894-a33c3714ffc5",
            id: "ab607d7a-8f8a-4444-8653-895d087ca945",
            kickOffTime: "2020-01-26T14:31:01.117Z",
          },
          "b5716a32-0deb-4ba0-b15b-ad9056346732": {
            awayTeamId: "2e7b4ee7-8c0b-450b-8e10-a1bd5fc892c3",
            goalsAway: 1,
            goalsHome: 5,
            homeTeamId: "3fa3a04b-fa87-49e9-8772-0820a516be9c",
            id: "b5716a32-0deb-4ba0-b15b-ad9056346732",
            kickOffTime: "2020-01-24T19:31:00.546Z",
          },
          "b62507ba-0e0e-4255-8c5d-5edbccad04ad": {
            awayTeamId: "75e3d230-76a1-4339-9c0c-6155386bf897",
            goalsAway: 0,
            goalsHome: 2,
            homeTeamId: "c80d1327-c1f6-44ff-8d54-4ac93ff89763",
            id: "b62507ba-0e0e-4255-8c5d-5edbccad04ad",
            kickOffTime: "2020-01-25T14:31:06.047Z",
          },
          "e0a16cba-2e0c-49c8-9e47-0c692abfd126": {
            awayTeamId: "dccf4aa9-74fb-4e7c-9011-20e7dd13ffbc",
            goalsAway: 2,
            goalsHome: 1,
            homeTeamId: "e18be703-c750-4731-a9e1-2079ad8837f2",
            id: "e0a16cba-2e0c-49c8-9e47-0c692abfd126",
            kickOffTime: "2020-01-25T14:31:06.047Z",
          },
        },
        id: "11fc6da7-05ab-47a0-b420-1594fa471a14",
        matchday: 19,
        startDate: "",
      },
      {
        endDate: "",
        fixtures: {
          "2636750b-2583-4fff-98fa-7b162485a0e2": {
            awayTeamId: "6a0d669b-9a11-4001-a753-de12bb24bd0a",
            goalsAway: 2,
            goalsHome: 2,
            homeTeamId: "75e3d230-76a1-4339-9c0c-6155386bf897",
            id: "2636750b-2583-4fff-98fa-7b162485a0e2",
            kickOffTime: "2020-02-01T17:31:12.604Z",
          },
          "5f410b6c-a849-4050-96f9-89f213f4e43a": {
            awayTeamId: "b14bb614-3a22-4e46-9c8f-6b0f7e091c6d",
            goalsAway: 1,
            goalsHome: 2,
            homeTeamId: "49b443c0-c5f9-49fa-8e51-5a27547a9f67",
            id: "5f410b6c-a849-4050-96f9-89f213f4e43a",
            kickOffTime: "2020-02-01T14:31:05.404Z",
          },
          "82d12605-f3e7-4371-a924-4b711ee3d5c5": {
            awayTeamId: "91f5c377-c4d9-49e9-9569-b5f6c44808e1",
            goalsAway: 0,
            goalsHome: 4,
            homeTeamId: "2e7b4ee7-8c0b-450b-8e10-a1bd5fc892c3",
            id: "82d12605-f3e7-4371-a924-4b711ee3d5c5",
            kickOffTime: "2020-02-02T14:31:03.145Z",
          },
          "9b4ea054-67eb-435c-9fc8-480ffcda98a3": {
            awayTeamId: "c80d1327-c1f6-44ff-8d54-4ac93ff89763",
            goalsAway: 1,
            goalsHome: 1,
            homeTeamId: "0f231945-0ffb-4dc6-9bae-604bf236ab2f",
            id: "9b4ea054-67eb-435c-9fc8-480ffcda98a3",
            kickOffTime: "2020-02-01T14:31:05.405Z",
          },
          "af35fa6b-4c98-4a1b-a6ee-1b117e36856c": {
            awayTeamId: "e18be703-c750-4731-a9e1-2079ad8837f2",
            goalsAway: 4,
            goalsHome: 2,
            homeTeamId: "cbe09562-1bf1-4b92-8e6b-92ea740d2774",
            id: "af35fa6b-4c98-4a1b-a6ee-1b117e36856c",
            kickOffTime: "2020-02-02T17:01:03.453Z",
          },
          "c52cd602-e1c7-4296-8fb0-15a6ba80624e": {
            awayTeamId: "166b21c1-7fcb-4eb0-b01c-ece3943a900b",
            goalsAway: 0,
            goalsHome: 0,
            homeTeamId: "dccf4aa9-74fb-4e7c-9011-20e7dd13ffbc",
            id: "c52cd602-e1c7-4296-8fb0-15a6ba80624e",
            kickOffTime: "2020-01-31T19:31:05.314Z",
          },
          "dad75a01-19ce-4322-ac72-752aafe3c972": {
            awayTeamId: "93c01474-719c-4df3-a4ff-7c2561e04ac1",
            goalsAway: 3,
            goalsHome: 1,
            homeTeamId: "4a8ab99d-7731-4467-9c16-8ba1663c545b",
            id: "dad75a01-19ce-4322-ac72-752aafe3c972",
            kickOffTime: "2020-02-01T14:31:05.406Z",
          },
          "e896f88f-735d-48db-bce4-4b56572e99e4": {
            awayTeamId: "158c2559-8f11-4e58-8439-0921d101c732",
            goalsAway: 0,
            goalsHome: 5,
            homeTeamId: "3fa3a04b-fa87-49e9-8772-0820a516be9c",
            id: "e896f88f-735d-48db-bce4-4b56572e99e4",
            kickOffTime: "2020-02-01T14:31:05.405Z",
          },
          "ede227bc-24ff-418f-87f4-37fe39f4a0d1": {
            awayTeamId: "1bbea28c-81cc-49e3-a894-a33c3714ffc5",
            goalsAway: 1,
            goalsHome: 2,
            homeTeamId: "4e3bfa69-db9e-4b06-ba57-bffd9c11b8d1",
            id: "ede227bc-24ff-418f-87f4-37fe39f4a0d1",
            kickOffTime: "2020-02-01T14:31:05.405Z",
          },
        },
        id: "7dd9279f-3303-4312-988d-ad2efc318a46",
        matchday: 20,
        startDate: "",
      },
      {
        endDate: "",
        fixtures: {
          "0a8d328c-d4e2-4e08-9dc0-9ec8b20f0b7f": {
            awayTeamId: "158c2559-8f11-4e58-8439-0921d101c732",
            goalsAway: 2,
            goalsHome: 0,
            homeTeamId: "1bbea28c-81cc-49e3-a894-a33c3714ffc5",
            id: "0a8d328c-d4e2-4e08-9dc0-9ec8b20f0b7f",
            kickOffTime: "2020-02-08T14:31:09.657Z",
          },
          "2ae72dac-3cbe-4f87-854f-dd88aeda6460": {
            awayTeamId: "0f231945-0ffb-4dc6-9bae-604bf236ab2f",
            goalsAway: 1,
            goalsHome: 1,
            homeTeamId: "e18be703-c750-4731-a9e1-2079ad8837f2",
            id: "2ae72dac-3cbe-4f87-854f-dd88aeda6460",
            kickOffTime: "2020-02-08T14:31:09.656Z",
          },
          "2b956c5a-c3cb-4845-ab86-73e6c1fd4bc8": {
            awayTeamId: "49b443c0-c5f9-49fa-8e51-5a27547a9f67",
            goalsAway: 0,
            goalsHome: 1,
            homeTeamId: "91f5c377-c4d9-49e9-9569-b5f6c44808e1",
            id: "2b956c5a-c3cb-4845-ab86-73e6c1fd4bc8",
            kickOffTime: "2020-02-08T14:31:09.657Z",
          },
          "3296bb09-24dd-42a6-bd9b-d472a5e881ac": {
            awayTeamId: "3fa3a04b-fa87-49e9-8772-0820a516be9c",
            goalsAway: 3,
            goalsHome: 4,
            homeTeamId: "b14bb614-3a22-4e46-9c8f-6b0f7e091c6d",
            id: "3296bb09-24dd-42a6-bd9b-d472a5e881ac",
            kickOffTime: "2020-02-08T17:31:03.254Z",
          },
          "da57aa5c-0f40-4f24-a460-441b0f44730b": {
            awayTeamId: "4a8ab99d-7731-4467-9c16-8ba1663c545b",
            goalsAway: 3,
            goalsHome: 1,
            homeTeamId: "dccf4aa9-74fb-4e7c-9011-20e7dd13ffbc",
            id: "da57aa5c-0f40-4f24-a460-441b0f44730b",
            kickOffTime: "2020-02-08T14:31:09.656Z",
          },
          "dffd8817-ce9d-4a2a-a13f-1ef28c364667": {
            awayTeamId: "75e3d230-76a1-4339-9c0c-6155386bf897",
            goalsAway: 0,
            goalsHome: 0,
            homeTeamId: "93c01474-719c-4df3-a4ff-7c2561e04ac1",
            id: "dffd8817-ce9d-4a2a-a13f-1ef28c364667",
            kickOffTime: "2020-02-09T17:01:00.357Z",
          },
          "e85c32c7-5aac-4d19-83c8-7ef3cecba015": {
            awayTeamId: "2e7b4ee7-8c0b-450b-8e10-a1bd5fc892c3",
            goalsAway: 1,
            goalsHome: 2,
            homeTeamId: "6a0d669b-9a11-4001-a753-de12bb24bd0a",
            id: "e85c32c7-5aac-4d19-83c8-7ef3cecba015",
            kickOffTime: "2020-03-11T17:30:53.639Z",
          },
          "eb9afb76-0bd0-467f-a846-31dfb238149a": {
            awayTeamId: "cbe09562-1bf1-4b92-8e6b-92ea740d2774",
            goalsAway: 1,
            goalsHome: 1,
            homeTeamId: "166b21c1-7fcb-4eb0-b01c-ece3943a900b",
            id: "eb9afb76-0bd0-467f-a846-31dfb238149a",
            kickOffTime: "2020-02-08T14:31:09.657Z",
          },
          "fc991273-73b2-45ff-ba35-43cda2988dc4": {
            awayTeamId: "4e3bfa69-db9e-4b06-ba57-bffd9c11b8d1",
            goalsAway: 0,
            goalsHome: 5,
            homeTeamId: "c80d1327-c1f6-44ff-8d54-4ac93ff89763",
            id: "fc991273-73b2-45ff-ba35-43cda2988dc4",
            kickOffTime: "2020-02-07T19:30:59.524Z",
          },
        },
        id: "a4abcc5e-15b1-458d-9515-f5f750bd5e84",
        matchday: 21,
        startDate: "",
      },
      {
        endDate: "",
        fixtures: {
          "3df0a665-239a-47c7-912c-67c40e4d1d59": {
            awayTeamId: "91f5c377-c4d9-49e9-9569-b5f6c44808e1",
            goalsAway: 1,
            goalsHome: 1,
            homeTeamId: "4e3bfa69-db9e-4b06-ba57-bffd9c11b8d1",
            id: "3df0a665-239a-47c7-912c-67c40e4d1d59",
            kickOffTime: "2020-02-15T14:31:05.991Z",
          },
          "49e20022-c869-4f8b-961d-4549aa1dd5f0": {
            awayTeamId: "c80d1327-c1f6-44ff-8d54-4ac93ff89763",
            goalsAway: 0,
            goalsHome: 4,
            homeTeamId: "3fa3a04b-fa87-49e9-8772-0820a516be9c",
            id: "49e20022-c869-4f8b-961d-4549aa1dd5f0",
            kickOffTime: "2020-02-14T19:31:01.348Z",
          },
          "667902ce-0fc0-4c1c-9c6c-67d9ee171974": {
            awayTeamId: "6a0d669b-9a11-4001-a753-de12bb24bd0a",
            goalsAway: 4,
            goalsHome: 1,
            homeTeamId: "0f231945-0ffb-4dc6-9bae-604bf236ab2f",
            id: "667902ce-0fc0-4c1c-9c6c-67d9ee171974",
            kickOffTime: "2020-02-15T17:31:03.889Z",
          },
          "6f09ad7c-5426-4c9d-b513-339218d93a24": {
            awayTeamId: "166b21c1-7fcb-4eb0-b01c-ece3943a900b",
            goalsAway: 0,
            goalsHome: 0,
            homeTeamId: "4a8ab99d-7731-4467-9c16-8ba1663c545b",
            id: "6f09ad7c-5426-4c9d-b513-339218d93a24",
            kickOffTime: "2020-02-16T17:01:04.400Z",
          },
          "810e2404-558f-482e-8493-33d6be132ea9": {
            awayTeamId: "93c01474-719c-4df3-a4ff-7c2561e04ac1",
            goalsAway: 4,
            goalsHome: 1,
            homeTeamId: "2e7b4ee7-8c0b-450b-8e10-a1bd5fc892c3",
            id: "810e2404-558f-482e-8493-33d6be132ea9",
            kickOffTime: "2020-02-16T14:31:01.101Z",
          },
          "9b0e77b8-f2fb-43e4-8339-85b47ff767a8": {
            awayTeamId: "e18be703-c750-4731-a9e1-2079ad8837f2",
            goalsAway: 3,
            goalsHome: 2,
            homeTeamId: "49b443c0-c5f9-49fa-8e51-5a27547a9f67",
            id: "9b0e77b8-f2fb-43e4-8339-85b47ff767a8",
            kickOffTime: "2020-02-15T14:31:05.991Z",
          },
          "c3ae5c58-d7e8-46bc-a5bf-3ff3897d996d": {
            awayTeamId: "1bbea28c-81cc-49e3-a894-a33c3714ffc5",
            goalsAway: 0,
            goalsHome: 3,
            homeTeamId: "75e3d230-76a1-4339-9c0c-6155386bf897",
            id: "c3ae5c58-d7e8-46bc-a5bf-3ff3897d996d",
            kickOffTime: "2020-02-15T14:31:05.991Z",
          },
          "dbd1f13d-a764-4b2f-9c5e-a04d5edc7ba0": {
            awayTeamId: "dccf4aa9-74fb-4e7c-9011-20e7dd13ffbc",
            goalsAway: 2,
            goalsHome: 1,
            homeTeamId: "cbe09562-1bf1-4b92-8e6b-92ea740d2774",
            id: "dbd1f13d-a764-4b2f-9c5e-a04d5edc7ba0",
            kickOffTime: "2020-02-15T14:31:05.991Z",
          },
          "ff4e3fa5-7f6a-4323-953f-b76cd59c40a4": {
            awayTeamId: "b14bb614-3a22-4e46-9c8f-6b0f7e091c6d",
            goalsAway: 3,
            goalsHome: 2,
            homeTeamId: "158c2559-8f11-4e58-8439-0921d101c732",
            id: "ff4e3fa5-7f6a-4323-953f-b76cd59c40a4",
            kickOffTime: "2020-02-15T14:31:05.991Z",
          },
        },
        id: "806bd79f-fa37-4772-85bc-745ab6050092",
        matchday: 22,
        startDate: "",
      },
      {
        endDate: "",
        fixtures: {
          "008bc719-6609-4ed4-a148-cc76e284d59d": {
            awayTeamId: "0f231945-0ffb-4dc6-9bae-604bf236ab2f",
            goalsAway: 2,
            goalsHome: 0,
            homeTeamId: "91f5c377-c4d9-49e9-9569-b5f6c44808e1",
            id: "008bc719-6609-4ed4-a148-cc76e284d59d",
            kickOffTime: "2020-02-22T15:00:56.475Z",
          },
          "00e822cf-0d76-40fa-b2eb-ea9c5929803a": {
            awayTeamId: "4e3bfa69-db9e-4b06-ba57-bffd9c11b8d1",
            goalsAway: 0,
            goalsHome: 2,
            homeTeamId: "b14bb614-3a22-4e46-9c8f-6b0f7e091c6d",
            id: "00e822cf-0d76-40fa-b2eb-ea9c5929803a",
            kickOffTime: "2020-02-23T14:30:59.048Z",
          },
          "079ab582-c2d1-4bd6-9059-574bac01089d": {
            awayTeamId: "4a8ab99d-7731-4467-9c16-8ba1663c545b",
            goalsAway: 0,
            goalsHome: 4,
            homeTeamId: "e18be703-c750-4731-a9e1-2079ad8837f2",
            id: "079ab582-c2d1-4bd6-9059-574bac01089d",
            kickOffTime: "2020-02-23T17:30:57.288Z",
          },
          "12871711-5e16-429b-9a09-207e38fe4d20": {
            awayTeamId: "cbe09562-1bf1-4b92-8e6b-92ea740d2774",
            goalsAway: 2,
            goalsHome: 3,
            homeTeamId: "93c01474-719c-4df3-a4ff-7c2561e04ac1",
            id: "12871711-5e16-429b-9a09-207e38fe4d20",
            kickOffTime: "2020-02-21T19:30:55.556Z",
          },
          "6b1a4ef2-3469-4b73-9c00-7b3f97fcb19c": {
            awayTeamId: "75e3d230-76a1-4339-9c0c-6155386bf897",
            goalsAway: 5,
            goalsHome: 0,
            homeTeamId: "166b21c1-7fcb-4eb0-b01c-ece3943a900b",
            id: "6b1a4ef2-3469-4b73-9c00-7b3f97fcb19c",
            kickOffTime: "2020-02-22T17:30:58.363Z",
          },
          "8c1330bb-2442-45f4-ace5-e9f284ce5789": {
            awayTeamId: "158c2559-8f11-4e58-8439-0921d101c732",
            goalsAway: 2,
            goalsHome: 1,
            homeTeamId: "c80d1327-c1f6-44ff-8d54-4ac93ff89763",
            id: "8c1330bb-2442-45f4-ace5-e9f284ce5789",
            kickOffTime: "2020-02-24T19:30:53.515Z",
          },
          "9b4799a2-cbe2-4151-9b96-c7e5b1f468b3": {
            awayTeamId: "49b443c0-c5f9-49fa-8e51-5a27547a9f67",
            goalsAway: 1,
            goalsHome: 1,
            homeTeamId: "6a0d669b-9a11-4001-a753-de12bb24bd0a",
            id: "9b4799a2-cbe2-4151-9b96-c7e5b1f468b3",
            kickOffTime: "2020-02-22T14:45:52.661Z",
          },
          "a002ae2c-7120-426a-930f-5ed8791375ca": {
            awayTeamId: "3fa3a04b-fa87-49e9-8772-0820a516be9c",
            goalsAway: 2,
            goalsHome: 0,
            homeTeamId: "1bbea28c-81cc-49e3-a894-a33c3714ffc5",
            id: "a002ae2c-7120-426a-930f-5ed8791375ca",
            kickOffTime: "2020-02-22T14:30:56.365Z",
          },
          "e65fa2fa-8269-4e60-b8db-20c597e1bf9a": {
            awayTeamId: "2e7b4ee7-8c0b-450b-8e10-a1bd5fc892c3",
            goalsAway: 5,
            goalsHome: 0,
            homeTeamId: "dccf4aa9-74fb-4e7c-9011-20e7dd13ffbc",
            id: "e65fa2fa-8269-4e60-b8db-20c597e1bf9a",
            kickOffTime: "2020-02-22T14:30:56.365Z",
          },
        },
        id: "cfbc42b3-7787-4a74-80d5-a9e57953008d",
        matchday: 23,
        startDate: "",
      },
      {
        endDate: "",
        fixtures: {
          "1364d3f6-39f3-4c7a-aa79-811fe2681192": {
            awayTeamId: "166b21c1-7fcb-4eb0-b01c-ece3943a900b",
            goalsAway: 0,
            goalsHome: 3,
            homeTeamId: "2e7b4ee7-8c0b-450b-8e10-a1bd5fc892c3",
            id: "1364d3f6-39f3-4c7a-aa79-811fe2681192",
            kickOffTime: "2020-02-29T17:31:06.022Z",
          },
          "181d3992-5424-4606-81a3-a3e8c3965601": {
            awayTeamId: "c80d1327-c1f6-44ff-8d54-4ac93ff89763",
            goalsAway: 3,
            goalsHome: 0,
            homeTeamId: "1bbea28c-81cc-49e3-a894-a33c3714ffc5",
            id: "181d3992-5424-4606-81a3-a3e8c3965601",
            kickOffTime: "2020-06-03T18:30:18.233Z",
          },
          "28d729ee-ff84-48fa-9f4c-10880806bf79": {
            awayTeamId: "dccf4aa9-74fb-4e7c-9011-20e7dd13ffbc",
            goalsAway: 3,
            goalsHome: 3,
            homeTeamId: "0f231945-0ffb-4dc6-9bae-604bf236ab2f",
            id: "28d729ee-ff84-48fa-9f4c-10880806bf79",
            kickOffTime: "2020-02-28T19:30:59.407Z",
          },
          "62f261a7-8e01-4b5f-91b1-a060d4d06bde": {
            awayTeamId: "e18be703-c750-4731-a9e1-2079ad8837f2",
            goalsAway: 2,
            goalsHome: 2,
            homeTeamId: "158c2559-8f11-4e58-8439-0921d101c732",
            id: "62f261a7-8e01-4b5f-91b1-a060d4d06bde",
            kickOffTime: "2020-03-01T12:45:56.445Z",
          },
          "63b2ff63-d83c-4ace-9c00-c2dd982dd57e": {
            awayTeamId: "91f5c377-c4d9-49e9-9569-b5f6c44808e1",
            goalsAway: 0,
            goalsHome: 1,
            homeTeamId: "3fa3a04b-fa87-49e9-8772-0820a516be9c",
            id: "63b2ff63-d83c-4ace-9c00-c2dd982dd57e",
            kickOffTime: "2020-02-29T14:31:13.391Z",
          },
          "a636bdce-3cac-4455-8631-97af7daf9dab": {
            awayTeamId: "6a0d669b-9a11-4001-a753-de12bb24bd0a",
            goalsAway: 3,
            goalsHome: 2,
            homeTeamId: "4e3bfa69-db9e-4b06-ba57-bffd9c11b8d1",
            id: "a636bdce-3cac-4455-8631-97af7daf9dab",
            kickOffTime: "2020-02-29T14:31:13.392Z",
          },
          "d37b9a44-be35-4e62-b09c-9cc0ae415fac": {
            awayTeamId: "cbe09562-1bf1-4b92-8e6b-92ea740d2774",
            goalsAway: 0,
            goalsHome: 2,
            homeTeamId: "4a8ab99d-7731-4467-9c16-8ba1663c545b",
            id: "d37b9a44-be35-4e62-b09c-9cc0ae415fac",
            kickOffTime: "2020-02-29T14:31:13.392Z",
          },
          "f0d0b9df-eb6f-481c-8823-8aa0daa1e363": {
            awayTeamId: "b14bb614-3a22-4e46-9c8f-6b0f7e091c6d",
            goalsAway: 1,
            goalsHome: 1,
            homeTeamId: "75e3d230-76a1-4339-9c0c-6155386bf897",
            id: "f0d0b9df-eb6f-481c-8823-8aa0daa1e363",
            kickOffTime: "2020-03-01T14:31:01.957Z",
          },
          "f79ea47a-4696-43c4-a6e0-e831de4f0950": {
            awayTeamId: "93c01474-719c-4df3-a4ff-7c2561e04ac1",
            goalsAway: 6,
            goalsHome: 0,
            homeTeamId: "49b443c0-c5f9-49fa-8e51-5a27547a9f67",
            id: "f79ea47a-4696-43c4-a6e0-e831de4f0950",
            kickOffTime: "2020-02-29T14:46:06.690Z",
          },
        },
        id: "dde6d220-2966-417d-8e8c-8f91374414b6",
        matchday: 24,
        startDate: "",
      },
      {
        endDate: "",
        fixtures: {
          "061a9e69-d43d-41f8-aa26-c430bd8e40a8": {
            awayTeamId: "3fa3a04b-fa87-49e9-8772-0820a516be9c",
            goalsAway: 2,
            goalsHome: 1,
            homeTeamId: "6a0d669b-9a11-4001-a753-de12bb24bd0a",
            id: "061a9e69-d43d-41f8-aa26-c430bd8e40a8",
            kickOffTime: "2020-03-07T17:31:05.536Z",
          },
          "089cb1a8-1ac2-4696-94d3-376a1640126a": {
            awayTeamId: "2e7b4ee7-8c0b-450b-8e10-a1bd5fc892c3",
            goalsAway: 2,
            goalsHome: 1,
            homeTeamId: "cbe09562-1bf1-4b92-8e6b-92ea740d2774",
            id: "089cb1a8-1ac2-4696-94d3-376a1640126a",
            kickOffTime: "2020-03-06T19:00:58.645Z",
          },
          "0b10559f-5733-4caa-87d5-192a60eee0fe": {
            awayTeamId: "4e3bfa69-db9e-4b06-ba57-bffd9c11b8d1",
            goalsAway: 0,
            goalsHome: 2,
            homeTeamId: "93c01474-719c-4df3-a4ff-7c2561e04ac1",
            id: "0b10559f-5733-4caa-87d5-192a60eee0fe",
            kickOffTime: "2020-03-08T14:30:58.423Z",
          },
          "19c07f26-cf0e-4a3c-8066-910737ff7fb5": {
            awayTeamId: "75e3d230-76a1-4339-9c0c-6155386bf897",
            goalsAway: 0,
            goalsHome: 0,
            homeTeamId: "e18be703-c750-4731-a9e1-2079ad8837f2",
            id: "19c07f26-cf0e-4a3c-8066-910737ff7fb5",
            kickOffTime: "2020-03-07T14:31:02.136Z",
          },
          "69c17ec4-f4ef-4a67-9ef1-5358a92a82f5": {
            awayTeamId: "0f231945-0ffb-4dc6-9bae-604bf236ab2f",
            goalsAway: 1,
            goalsHome: 1,
            homeTeamId: "4a8ab99d-7731-4467-9c16-8ba1663c545b",
            id: "69c17ec4-f4ef-4a67-9ef1-5358a92a82f5",
            kickOffTime: "2020-03-08T17:01:04.232Z",
          },
          "8c3cb24e-3167-4002-8a45-be8ae00cca37": {
            awayTeamId: "c80d1327-c1f6-44ff-8d54-4ac93ff89763",
            goalsAway: 0,
            goalsHome: 4,
            homeTeamId: "b14bb614-3a22-4e46-9c8f-6b0f7e091c6d",
            id: "8c3cb24e-3167-4002-8a45-be8ae00cca37",
            kickOffTime: "2020-03-07T14:31:02.136Z",
          },
          "b0d4e7cf-3a04-4fb0-b2e5-063fa61c76a3": {
            awayTeamId: "1bbea28c-81cc-49e3-a894-a33c3714ffc5",
            goalsAway: 2,
            goalsHome: 2,
            homeTeamId: "dccf4aa9-74fb-4e7c-9011-20e7dd13ffbc",
            id: "b0d4e7cf-3a04-4fb0-b2e5-063fa61c76a3",
            kickOffTime: "2020-03-07T14:31:02.136Z",
          },
          "b2b6fc17-2447-4b7a-b223-d2283c95a4ac": {
            awayTeamId: "49b443c0-c5f9-49fa-8e51-5a27547a9f67",
            goalsAway: 1,
            goalsHome: 1,
            homeTeamId: "166b21c1-7fcb-4eb0-b01c-ece3943a900b",
            id: "b2b6fc17-2447-4b7a-b223-d2283c95a4ac",
            kickOffTime: "2020-03-07T14:31:02.137Z",
          },
          "fc9a7317-263b-4ac0-9f00-bbc321c1eb6e": {
            awayTeamId: "158c2559-8f11-4e58-8439-0921d101c732",
            goalsAway: 1,
            goalsHome: 3,
            homeTeamId: "91f5c377-c4d9-49e9-9569-b5f6c44808e1",
            id: "fc9a7317-263b-4ac0-9f00-bbc321c1eb6e",
            kickOffTime: "2020-03-07T14:31:02.137Z",
          },
        },
        id: "219ffde1-6565-43c7-97b9-7bab7bc70b8b",
        matchday: 25,
        startDate: "",
      },
      {
        endDate: "",
        fixtures: {
          "04b1b648-b3a3-4516-b57c-f025412e3d05": {
            awayTeamId: "dccf4aa9-74fb-4e7c-9011-20e7dd13ffbc",
            goalsAway: 3,
            goalsHome: 0,
            homeTeamId: "49b443c0-c5f9-49fa-8e51-5a27547a9f67",
            id: "04b1b648-b3a3-4516-b57c-f025412e3d05",
            kickOffTime: "2020-05-16T13:30:18.274Z",
          },
          "05e1b8eb-ceea-4dcf-b24f-47a9b7acf72e": {
            awayTeamId: "91f5c377-c4d9-49e9-9569-b5f6c44808e1",
            goalsAway: 1,
            goalsHome: 1,
            homeTeamId: "75e3d230-76a1-4339-9c0c-6155386bf897",
            id: "05e1b8eb-ceea-4dcf-b24f-47a9b7acf72e",
            kickOffTime: "2020-05-16T13:30:18.274Z",
          },
          "3886614f-14c5-4452-9ee5-2ae4756c730c": {
            awayTeamId: "6a0d669b-9a11-4001-a753-de12bb24bd0a",
            goalsAway: 3,
            goalsHome: 1,
            homeTeamId: "c80d1327-c1f6-44ff-8d54-4ac93ff89763",
            id: "3886614f-14c5-4452-9ee5-2ae4756c730c",
            kickOffTime: "2020-05-16T16:30:22.243Z",
          },
          "48c1027f-df8b-403d-ba26-6a6fe65d97a1": {
            awayTeamId: "4a8ab99d-7731-4467-9c16-8ba1663c545b",
            goalsAway: 2,
            goalsHome: 2,
            homeTeamId: "2e7b4ee7-8c0b-450b-8e10-a1bd5fc892c3",
            id: "48c1027f-df8b-403d-ba26-6a6fe65d97a1",
            kickOffTime: "2020-05-17T13:30:17.241Z",
          },
          "6718dd10-da20-44f3-8b97-fe3f0a36a5a2": {
            awayTeamId: "b14bb614-3a22-4e46-9c8f-6b0f7e091c6d",
            goalsAway: 4,
            goalsHome: 1,
            homeTeamId: "1bbea28c-81cc-49e3-a894-a33c3714ffc5",
            id: "6718dd10-da20-44f3-8b97-fe3f0a36a5a2",
            kickOffTime: "2020-05-18T18:30:16.025Z",
          },
          "a55af0ee-272b-41c1-a7fe-c58a18958f1d": {
            awayTeamId: "cbe09562-1bf1-4b92-8e6b-92ea740d2774",
            goalsAway: 0,
            goalsHome: 0,
            homeTeamId: "0f231945-0ffb-4dc6-9bae-604bf236ab2f",
            id: "a55af0ee-272b-41c1-a7fe-c58a18958f1d",
            kickOffTime: "2020-05-16T13:30:18.275Z",
          },
          "d5243ace-e5bc-4569-9994-b5c41247b5c0": {
            awayTeamId: "93c01474-719c-4df3-a4ff-7c2561e04ac1",
            goalsAway: 2,
            goalsHome: 0,
            homeTeamId: "158c2559-8f11-4e58-8439-0921d101c732",
            id: "d5243ace-e5bc-4569-9994-b5c41247b5c0",
            kickOffTime: "2020-05-17T16:00:24.854Z",
          },
          "e9e6878d-c37c-4445-ae65-eeedc6697594": {
            awayTeamId: "e18be703-c750-4731-a9e1-2079ad8837f2",
            goalsAway: 2,
            goalsHome: 1,
            homeTeamId: "4e3bfa69-db9e-4b06-ba57-bffd9c11b8d1",
            id: "e9e6878d-c37c-4445-ae65-eeedc6697594",
            kickOffTime: "2020-05-16T13:30:18.276Z",
          },
          "fdbb36da-069d-4752-b493-3873d54c4b73": {
            awayTeamId: "166b21c1-7fcb-4eb0-b01c-ece3943a900b",
            goalsAway: 0,
            goalsHome: 4,
            homeTeamId: "3fa3a04b-fa87-49e9-8772-0820a516be9c",
            id: "fdbb36da-069d-4752-b493-3873d54c4b73",
            kickOffTime: "2020-05-16T13:30:18.276Z",
          },
        },
        id: "6d0b437c-21de-4e38-8629-9a5b55847b05",
        matchday: 26,
        startDate: "",
      },
      {
        endDate: "",
        fixtures: {
          "01c3ad6a-d86f-4d4d-999c-48a3c8381796": {
            awayTeamId: "158c2559-8f11-4e58-8439-0921d101c732",
            goalsAway: 0,
            goalsHome: 4,
            homeTeamId: "dccf4aa9-74fb-4e7c-9011-20e7dd13ffbc",
            id: "01c3ad6a-d86f-4d4d-999c-48a3c8381796",
            kickOffTime: "2020-05-22T18:30:17.527Z",
          },
          "2c0ecc3b-317f-4eaa-bca5-563b9b14fc5f": {
            awayTeamId: "3fa3a04b-fa87-49e9-8772-0820a516be9c",
            goalsAway: 2,
            goalsHome: 0,
            homeTeamId: "e18be703-c750-4731-a9e1-2079ad8837f2",
            id: "2c0ecc3b-317f-4eaa-bca5-563b9b14fc5f",
            kickOffTime: "2020-05-23T13:30:21.841Z",
          },
          "318c7407-40f9-4c42-97d4-c50f5f629b35": {
            awayTeamId: "49b443c0-c5f9-49fa-8e51-5a27547a9f67",
            goalsAway: 1,
            goalsHome: 1,
            homeTeamId: "cbe09562-1bf1-4b92-8e6b-92ea740d2774",
            id: "318c7407-40f9-4c42-97d4-c50f5f629b35",
            kickOffTime: "2020-05-23T13:30:21.841Z",
          },
          "3913c19d-5245-4bbc-a321-7b87566b641a": {
            awayTeamId: "4e3bfa69-db9e-4b06-ba57-bffd9c11b8d1",
            goalsAway: 3,
            goalsHome: 0,
            homeTeamId: "166b21c1-7fcb-4eb0-b01c-ece3943a900b",
            id: "3913c19d-5245-4bbc-a321-7b87566b641a",
            kickOffTime: "2020-05-24T11:30:17.442Z",
          },
          "87f42161-294f-413d-97ab-382be488a5ef": {
            awayTeamId: "b14bb614-3a22-4e46-9c8f-6b0f7e091c6d",
            goalsAway: 3,
            goalsHome: 1,
            homeTeamId: "6a0d669b-9a11-4001-a753-de12bb24bd0a",
            id: "87f42161-294f-413d-97ab-382be488a5ef",
            kickOffTime: "2020-05-23T13:30:21.840Z",
          },
          "a4ba8e2c-8be5-4186-b073-b87a0d3a6b5e": {
            awayTeamId: "c80d1327-c1f6-44ff-8d54-4ac93ff89763",
            goalsAway: 2,
            goalsHome: 5,
            homeTeamId: "93c01474-719c-4df3-a4ff-7c2561e04ac1",
            id: "a4ba8e2c-8be5-4186-b073-b87a0d3a6b5e",
            kickOffTime: "2020-05-23T16:30:20.723Z",
          },
          "a755a013-8040-44cb-bd9d-71d90e168d00": {
            awayTeamId: "0f231945-0ffb-4dc6-9bae-604bf236ab2f",
            goalsAway: 2,
            goalsHome: 2,
            homeTeamId: "2e7b4ee7-8c0b-450b-8e10-a1bd5fc892c3",
            id: "a755a013-8040-44cb-bd9d-71d90e168d00",
            kickOffTime: "2020-05-24T16:00:18.638Z",
          },
          "bedf43c9-cf2c-4608-8263-ae32ba198df5": {
            awayTeamId: "75e3d230-76a1-4339-9c0c-6155386bf897",
            goalsAway: 5,
            goalsHome: 0,
            homeTeamId: "4a8ab99d-7731-4467-9c16-8ba1663c545b",
            id: "bedf43c9-cf2c-4608-8263-ae32ba198df5",
            kickOffTime: "2020-05-24T13:30:18.243Z",
          },
          "ee8943bd-9390-4406-ac83-e6656070fe95": {
            awayTeamId: "1bbea28c-81cc-49e3-a894-a33c3714ffc5",
            goalsAway: 1,
            goalsHome: 0,
            homeTeamId: "91f5c377-c4d9-49e9-9569-b5f6c44808e1",
            id: "ee8943bd-9390-4406-ac83-e6656070fe95",
            kickOffTime: "2020-05-23T13:30:21.841Z",
          },
        },
        id: "44b2ede1-4f77-4ba3-a05d-24fa01587542",
        matchday: 27,
        startDate: "",
      },
      {
        endDate: "",
        fixtures: {
          "07398e2d-b593-4eef-a6a9-4c155643be22": {
            awayTeamId: "166b21c1-7fcb-4eb0-b01c-ece3943a900b",
            goalsAway: 1,
            goalsHome: 2,
            homeTeamId: "0f231945-0ffb-4dc6-9bae-604bf236ab2f",
            id: "07398e2d-b593-4eef-a6a9-4c155643be22",
            kickOffTime: "2020-05-27T18:30:16.148Z",
          },
          "8495b25f-26d3-4d3d-b046-8016c13a326c": {
            awayTeamId: "e18be703-c750-4731-a9e1-2079ad8837f2",
            goalsAway: 4,
            goalsHome: 1,
            homeTeamId: "b14bb614-3a22-4e46-9c8f-6b0f7e091c6d",
            id: "8495b25f-26d3-4d3d-b046-8016c13a326c",
            kickOffTime: "2020-05-26T18:30:16.146Z",
          },
          "85dba181-7450-4b55-8394-d3d6e8c2ec98": {
            awayTeamId: "91f5c377-c4d9-49e9-9569-b5f6c44808e1",
            goalsAway: 3,
            goalsHome: 3,
            homeTeamId: "c80d1327-c1f6-44ff-8d54-4ac93ff89763",
            id: "85dba181-7450-4b55-8394-d3d6e8c2ec98",
            kickOffTime: "2020-05-26T18:30:16.222Z",
          },
          "8a10eecc-ac8d-46b1-8cd7-88bc001ae924": {
            awayTeamId: "cbe09562-1bf1-4b92-8e6b-92ea740d2774",
            goalsAway: 0,
            goalsHome: 0,
            homeTeamId: "4e3bfa69-db9e-4b06-ba57-bffd9c11b8d1",
            id: "8a10eecc-ac8d-46b1-8cd7-88bc001ae924",
            kickOffTime: "2020-05-27T18:30:15.950Z",
          },
          "aa3dd0cc-9de7-45b4-a5e2-04073e2f2937": {
            awayTeamId: "2e7b4ee7-8c0b-450b-8e10-a1bd5fc892c3",
            goalsAway: 1,
            goalsHome: 3,
            homeTeamId: "49b443c0-c5f9-49fa-8e51-5a27547a9f67",
            id: "aa3dd0cc-9de7-45b4-a5e2-04073e2f2937",
            kickOffTime: "2020-05-27T18:30:16.148Z",
          },
          "b271ac98-019c-4499-b7d8-7abd98616944": {
            awayTeamId: "93c01474-719c-4df3-a4ff-7c2561e04ac1",
            goalsAway: 1,
            goalsHome: 0,
            homeTeamId: "3fa3a04b-fa87-49e9-8772-0820a516be9c",
            id: "b271ac98-019c-4499-b7d8-7abd98616944",
            kickOffTime: "2020-05-26T16:30:17.524Z",
          },
          "c46edd32-c0a0-4d3d-9153-4302e87c4268": {
            awayTeamId: "6a0d669b-9a11-4001-a753-de12bb24bd0a",
            goalsAway: 0,
            goalsHome: 0,
            homeTeamId: "1bbea28c-81cc-49e3-a894-a33c3714ffc5",
            id: "c46edd32-c0a0-4d3d-9153-4302e87c4268",
            kickOffTime: "2020-05-26T18:30:16.223Z",
          },
          "cd2f8610-d6bd-44a8-9208-067b479f578c": {
            awayTeamId: "dccf4aa9-74fb-4e7c-9011-20e7dd13ffbc",
            goalsAway: 2,
            goalsHome: 2,
            homeTeamId: "75e3d230-76a1-4339-9c0c-6155386bf897",
            id: "cd2f8610-d6bd-44a8-9208-067b479f578c",
            kickOffTime: "2020-05-27T16:30:21.865Z",
          },
          "f3e8d97c-dae2-49aa-b80b-67fe90ecd024": {
            awayTeamId: "4a8ab99d-7731-4467-9c16-8ba1663c545b",
            goalsAway: 1,
            goalsHome: 1,
            homeTeamId: "158c2559-8f11-4e58-8439-0921d101c732",
            id: "f3e8d97c-dae2-49aa-b80b-67fe90ecd024",
            kickOffTime: "2020-05-27T18:30:15.951Z",
          },
        },
        id: "9234734a-49ec-4c49-8302-a57953a4ef4b",
        matchday: 28,
        startDate: "",
      },
      {
        endDate: "",
        fixtures: {
          "4a4e18f7-1aa2-4d95-95f0-0a03e6431f35": {
            awayTeamId: "b14bb614-3a22-4e46-9c8f-6b0f7e091c6d",
            goalsAway: 1,
            goalsHome: 0,
            homeTeamId: "91f5c377-c4d9-49e9-9569-b5f6c44808e1",
            id: "4a4e18f7-1aa2-4d95-95f0-0a03e6431f35",
            kickOffTime: "2020-05-29T18:30:20.539Z",
          },
          "7b3d3311-2fcd-4e60-9fb2-bcd1d5a4258b": {
            awayTeamId: "c80d1327-c1f6-44ff-8d54-4ac93ff89763",
            goalsAway: 2,
            goalsHome: 1,
            homeTeamId: "e18be703-c750-4731-a9e1-2079ad8837f2",
            id: "7b3d3311-2fcd-4e60-9fb2-bcd1d5a4258b",
            kickOffTime: "2020-05-30T13:30:17.564Z",
          },
          "afac2483-9da3-4fe9-8325-43c58bbf5f9d": {
            awayTeamId: "49b443c0-c5f9-49fa-8e51-5a27547a9f67",
            goalsAway: 1,
            goalsHome: 0,
            homeTeamId: "4a8ab99d-7731-4467-9c16-8ba1663c545b",
            id: "afac2483-9da3-4fe9-8325-43c58bbf5f9d",
            kickOffTime: "2020-05-30T13:30:17.565Z",
          },
          "bbb75950-5df6-4f92-b5c9-434e976196c4": {
            awayTeamId: "3fa3a04b-fa87-49e9-8772-0820a516be9c",
            goalsAway: 6,
            goalsHome: 1,
            homeTeamId: "cbe09562-1bf1-4b92-8e6b-92ea740d2774",
            id: "bbb75950-5df6-4f92-b5c9-434e976196c4",
            kickOffTime: "2020-05-31T16:00:22.366Z",
          },
          "d60c7a33-60ba-4f39-b1d3-fb8b159ec89e": {
            awayTeamId: "0f231945-0ffb-4dc6-9bae-604bf236ab2f",
            goalsAway: 0,
            goalsHome: 5,
            homeTeamId: "93c01474-719c-4df3-a4ff-7c2561e04ac1",
            id: "d60c7a33-60ba-4f39-b1d3-fb8b159ec89e",
            kickOffTime: "2020-05-30T16:30:19.468Z",
          },
          "da96ef47-af5d-4539-ad4f-65bd243bbe2d": {
            awayTeamId: "4e3bfa69-db9e-4b06-ba57-bffd9c11b8d1",
            goalsAway: 0,
            goalsHome: 2,
            homeTeamId: "dccf4aa9-74fb-4e7c-9011-20e7dd13ffbc",
            id: "da96ef47-af5d-4539-ad4f-65bd243bbe2d",
            kickOffTime: "2020-05-30T13:30:17.565Z",
          },
          "eac24460-429a-41b7-ad3f-5aad65fc5e4a": {
            awayTeamId: "75e3d230-76a1-4339-9c0c-6155386bf897",
            goalsAway: 4,
            goalsHome: 2,
            homeTeamId: "2e7b4ee7-8c0b-450b-8e10-a1bd5fc892c3",
            id: "eac24460-429a-41b7-ad3f-5aad65fc5e4a",
            kickOffTime: "2020-06-01T18:30:17.239Z",
          },
          "f25ae66d-a75d-4748-a437-650693b53074": {
            awayTeamId: "1bbea28c-81cc-49e3-a894-a33c3714ffc5",
            goalsAway: 1,
            goalsHome: 0,
            homeTeamId: "166b21c1-7fcb-4eb0-b01c-ece3943a900b",
            id: "f25ae66d-a75d-4748-a437-650693b53074",
            kickOffTime: "2020-05-30T13:30:17.565Z",
          },
          "f359abe4-ce65-4293-9fb7-88cfa3c82177": {
            awayTeamId: "158c2559-8f11-4e58-8439-0921d101c732",
            goalsAway: 1,
            goalsHome: 4,
            homeTeamId: "6a0d669b-9a11-4001-a753-de12bb24bd0a",
            id: "f359abe4-ce65-4293-9fb7-88cfa3c82177",
            kickOffTime: "2020-05-31T13:30:21.059Z",
          },
        },
        id: "eda7adc3-c919-4012-97df-c3f0b1af2399",
        matchday: 29,
        startDate: "",
      },
      {
        endDate: "",
        fixtures: {
          "1274259b-65be-4dd8-a083-b03d9d55e906": {
            awayTeamId: "dccf4aa9-74fb-4e7c-9011-20e7dd13ffbc",
            goalsAway: 0,
            goalsHome: 1,
            homeTeamId: "3fa3a04b-fa87-49e9-8772-0820a516be9c",
            id: "1274259b-65be-4dd8-a083-b03d9d55e906",
            kickOffTime: "2020-06-06T16:30:17.037Z",
          },
          "4a046626-bc04-4f3b-9240-ed3a6648c129": {
            awayTeamId: "4a8ab99d-7731-4467-9c16-8ba1663c545b",
            goalsAway: 2,
            goalsHome: 0,
            homeTeamId: "c80d1327-c1f6-44ff-8d54-4ac93ff89763",
            id: "4a046626-bc04-4f3b-9240-ed3a6648c129",
            kickOffTime: "2020-06-06T13:30:17.716Z",
          },
          "5f072568-1ce3-4da3-902f-507b320b7381": {
            awayTeamId: "2e7b4ee7-8c0b-450b-8e10-a1bd5fc892c3",
            goalsAway: 1,
            goalsHome: 1,
            homeTeamId: "4e3bfa69-db9e-4b06-ba57-bffd9c11b8d1",
            id: "5f072568-1ce3-4da3-902f-507b320b7381",
            kickOffTime: "2020-06-07T16:00:17.638Z",
          },
          "5ffb938f-d45c-42fc-84ed-48955eef891b": {
            awayTeamId: "93c01474-719c-4df3-a4ff-7c2561e04ac1",
            goalsAway: 4,
            goalsHome: 2,
            homeTeamId: "b14bb614-3a22-4e46-9c8f-6b0f7e091c6d",
            id: "5ffb938f-d45c-42fc-84ed-48955eef891b",
            kickOffTime: "2020-06-06T13:30:17.715Z",
          },
          "66714e38-1ff9-407b-96d0-28a44027fd89": {
            awayTeamId: "49b443c0-c5f9-49fa-8e51-5a27547a9f67",
            goalsAway: 2,
            goalsHome: 2,
            homeTeamId: "0f231945-0ffb-4dc6-9bae-604bf236ab2f",
            id: "66714e38-1ff9-407b-96d0-28a44027fd89",
            kickOffTime: "2020-06-06T13:30:17.716Z",
          },
          "eca01414-0fd0-4450-a887-2eba97272559": {
            awayTeamId: "6a0d669b-9a11-4001-a753-de12bb24bd0a",
            goalsAway: 0,
            goalsHome: 1,
            homeTeamId: "91f5c377-c4d9-49e9-9569-b5f6c44808e1",
            id: "eca01414-0fd0-4450-a887-2eba97272559",
            kickOffTime: "2020-06-05T18:30:20.427Z",
          },
          "f1d78edc-834a-4f1d-ab80-555ed59dd138": {
            awayTeamId: "166b21c1-7fcb-4eb0-b01c-ece3943a900b",
            goalsAway: 1,
            goalsHome: 1,
            homeTeamId: "158c2559-8f11-4e58-8439-0921d101c732",
            id: "f1d78edc-834a-4f1d-ab80-555ed59dd138",
            kickOffTime: "2020-06-07T13:30:17.950Z",
          },
          "f98c908c-6d7a-49a1-ac76-a8deb9325a02": {
            awayTeamId: "cbe09562-1bf1-4b92-8e6b-92ea740d2774",
            goalsAway: 1,
            goalsHome: 1,
            homeTeamId: "75e3d230-76a1-4339-9c0c-6155386bf897",
            id: "f98c908c-6d7a-49a1-ac76-a8deb9325a02",
            kickOffTime: "2020-06-06T13:30:17.715Z",
          },
          "fa655e53-f787-408d-a75d-27e3281bdc64": {
            awayTeamId: "e18be703-c750-4731-a9e1-2079ad8837f2",
            goalsAway: 1,
            goalsHome: 0,
            homeTeamId: "1bbea28c-81cc-49e3-a894-a33c3714ffc5",
            id: "fa655e53-f787-408d-a75d-27e3281bdc64",
            kickOffTime: "2020-06-07T11:30:16.837Z",
          },
        },
        id: "4c2bf738-982f-4b78-8ec5-fd24041c784d",
        matchday: 30,
        startDate: "",
      },
      {
        endDate: "",
        fixtures: {
          "198b5b4c-727f-446e-ab32-7484f6e73435": {
            awayTeamId: "3fa3a04b-fa87-49e9-8772-0820a516be9c",
            goalsAway: 1,
            goalsHome: 0,
            homeTeamId: "0f231945-0ffb-4dc6-9bae-604bf236ab2f",
            id: "198b5b4c-727f-446e-ab32-7484f6e73435",
            kickOffTime: "2020-06-13T13:30:13.929Z",
          },
          "4ee5a031-08ce-426a-affb-d192a0aa3a7c": {
            awayTeamId: "1bbea28c-81cc-49e3-a894-a33c3714ffc5",
            goalsAway: 5,
            goalsHome: 1,
            homeTeamId: "cbe09562-1bf1-4b92-8e6b-92ea740d2774",
            id: "4ee5a031-08ce-426a-affb-d192a0aa3a7c",
            kickOffTime: "2020-06-13T13:30:13.928Z",
          },
          "5b991d42-db37-4bc2-b107-8bb16d19a01a": {
            awayTeamId: "b14bb614-3a22-4e46-9c8f-6b0f7e091c6d",
            goalsAway: 1,
            goalsHome: 1,
            homeTeamId: "166b21c1-7fcb-4eb0-b01c-ece3943a900b",
            id: "5b991d42-db37-4bc2-b107-8bb16d19a01a",
            kickOffTime: "2020-06-14T16:00:19.750Z",
          },
          "7f384ded-e05e-406d-beec-3e21775d1731": {
            awayTeamId: "4e3bfa69-db9e-4b06-ba57-bffd9c11b8d1",
            goalsAway: 1,
            goalsHome: 0,
            homeTeamId: "4a8ab99d-7731-4467-9c16-8ba1663c545b",
            id: "7f384ded-e05e-406d-beec-3e21775d1731",
            kickOffTime: "2020-06-14T13:30:18.554Z",
          },
          "82bb2181-8e9e-4912-a953-39d3bae696f6": {
            awayTeamId: "75e3d230-76a1-4339-9c0c-6155386bf897",
            goalsAway: 2,
            goalsHome: 0,
            homeTeamId: "49b443c0-c5f9-49fa-8e51-5a27547a9f67",
            id: "82bb2181-8e9e-4912-a953-39d3bae696f6",
            kickOffTime: "2020-06-12T18:30:15.607Z",
          },
          "88c23628-16e2-4ff8-9b02-bf963cc1f19c": {
            awayTeamId: "91f5c377-c4d9-49e9-9569-b5f6c44808e1",
            goalsAway: 2,
            goalsHome: 2,
            homeTeamId: "e18be703-c750-4731-a9e1-2079ad8837f2",
            id: "88c23628-16e2-4ff8-9b02-bf963cc1f19c",
            kickOffTime: "2020-06-13T13:30:13.929Z",
          },
          "bd43ee4c-144d-4a23-88e1-e1daa4a255b7": {
            awayTeamId: "158c2559-8f11-4e58-8439-0921d101c732",
            goalsAway: 2,
            goalsHome: 1,
            homeTeamId: "2e7b4ee7-8c0b-450b-8e10-a1bd5fc892c3",
            id: "bd43ee4c-144d-4a23-88e1-e1daa4a255b7",
            kickOffTime: "2020-06-13T13:30:13.928Z",
          },
          "f09a6c59-6db7-4396-910d-cdf245348de4": {
            awayTeamId: "c80d1327-c1f6-44ff-8d54-4ac93ff89763",
            goalsAway: 4,
            goalsHome: 1,
            homeTeamId: "dccf4aa9-74fb-4e7c-9011-20e7dd13ffbc",
            id: "f09a6c59-6db7-4396-910d-cdf245348de4",
            kickOffTime: "2020-06-13T13:30:13.930Z",
          },
          "fc0371a6-e901-4b96-8ec6-2f3376486446": {
            awayTeamId: "6a0d669b-9a11-4001-a753-de12bb24bd0a",
            goalsAway: 1,
            goalsHome: 2,
            homeTeamId: "93c01474-719c-4df3-a4ff-7c2561e04ac1",
            id: "fc0371a6-e901-4b96-8ec6-2f3376486446",
            kickOffTime: "2020-06-13T16:30:15.618Z",
          },
        },
        id: "393b0375-f471-46fb-9c72-ea1a9badd96c",
        matchday: 31,
        startDate: "",
      },
      {
        endDate: "",
        fixtures: {
          "0f685341-10a8-4cd5-9096-435e75637d63": {
            awayTeamId: "166b21c1-7fcb-4eb0-b01c-ece3943a900b",
            goalsAway: 1,
            goalsHome: 2,
            homeTeamId: "c80d1327-c1f6-44ff-8d54-4ac93ff89763",
            id: "0f685341-10a8-4cd5-9096-435e75637d63",
            kickOffTime: "2020-06-17T16:30:14.323Z",
          },
          "6fa6f5be-f31e-4533-b037-f14ce629ce7b": {
            awayTeamId: "cbe09562-1bf1-4b92-8e6b-92ea740d2774",
            goalsAway: 0,
            goalsHome: 1,
            homeTeamId: "158c2559-8f11-4e58-8439-0921d101c732",
            id: "6fa6f5be-f31e-4533-b037-f14ce629ce7b",
            kickOffTime: "2020-06-16T18:30:13.234Z",
          },
          "7315ee47-f767-403d-8b87-2085d4fba8a6": {
            awayTeamId: "2e7b4ee7-8c0b-450b-8e10-a1bd5fc892c3",
            goalsAway: 1,
            goalsHome: 3,
            homeTeamId: "b14bb614-3a22-4e46-9c8f-6b0f7e091c6d",
            id: "7315ee47-f767-403d-8b87-2085d4fba8a6",
            kickOffTime: "2020-06-17T18:30:15.411Z",
          },
          "7ec2a47b-e669-4f18-a723-167b9fcf1b13": {
            awayTeamId: "dccf4aa9-74fb-4e7c-9011-20e7dd13ffbc",
            goalsAway: 1,
            goalsHome: 2,
            homeTeamId: "91f5c377-c4d9-49e9-9569-b5f6c44808e1",
            id: "7ec2a47b-e669-4f18-a723-167b9fcf1b13",
            kickOffTime: "2020-06-16T18:30:13.234Z",
          },
          "887b5aa6-c9e6-4bfb-a648-6f0a4b0e6928": {
            awayTeamId: "4a8ab99d-7731-4467-9c16-8ba1663c545b",
            goalsAway: 2,
            goalsHome: 0,
            homeTeamId: "3fa3a04b-fa87-49e9-8772-0820a516be9c",
            id: "887b5aa6-c9e6-4bfb-a648-6f0a4b0e6928",
            kickOffTime: "2020-06-17T18:30:15.412Z",
          },
          "9e542644-6fc1-421b-8598-85abf6498ad7": {
            awayTeamId: "93c01474-719c-4df3-a4ff-7c2561e04ac1",
            goalsAway: 1,
            goalsHome: 0,
            homeTeamId: "1bbea28c-81cc-49e3-a894-a33c3714ffc5",
            id: "9e542644-6fc1-421b-8598-85abf6498ad7",
            kickOffTime: "2020-06-16T18:30:13.234Z",
          },
          "a0f7ef0f-a8bc-46e6-874b-9ae18bc14448": {
            awayTeamId: "49b443c0-c5f9-49fa-8e51-5a27547a9f67",
            goalsAway: 3,
            goalsHome: 1,
            homeTeamId: "4e3bfa69-db9e-4b06-ba57-bffd9c11b8d1",
            id: "a0f7ef0f-a8bc-46e6-874b-9ae18bc14448",
            kickOffTime: "2020-06-17T18:30:15.412Z",
          },
          "c99c00d8-12f5-49df-a163-60c5b72bb4ac": {
            awayTeamId: "e18be703-c750-4731-a9e1-2079ad8837f2",
            goalsAway: 0,
            goalsHome: 3,
            homeTeamId: "6a0d669b-9a11-4001-a753-de12bb24bd0a",
            id: "c99c00d8-12f5-49df-a163-60c5b72bb4ac",
            kickOffTime: "2020-06-16T16:30:15.207Z",
          },
          "db5664c6-c056-467e-89d5-a06ad88eadd7": {
            awayTeamId: "0f231945-0ffb-4dc6-9bae-604bf236ab2f",
            goalsAway: 2,
            goalsHome: 2,
            homeTeamId: "75e3d230-76a1-4339-9c0c-6155386bf897",
            id: "db5664c6-c056-467e-89d5-a06ad88eadd7",
            kickOffTime: "2020-06-17T18:30:15.411Z",
          },
        },
        id: "d1979116-fff5-4523-94e8-37075f132747",
        matchday: 32,
        startDate: "",
      },
      {
        endDate: "",
        fixtures: {
          "0b5bf92a-bda5-4cc9-a54d-bb33057a6e44": {
            awayTeamId: "c80d1327-c1f6-44ff-8d54-4ac93ff89763",
            goalsAway: 1,
            goalsHome: 1,
            homeTeamId: "2e7b4ee7-8c0b-450b-8e10-a1bd5fc892c3",
            id: "0b5bf92a-bda5-4cc9-a54d-bb33057a6e44",
            kickOffTime: "2020-06-20T13:30:18.721Z",
          },
          "2746a394-ff64-476c-8e39-826582f19be2": {
            awayTeamId: "1bbea28c-81cc-49e3-a894-a33c3714ffc5",
            goalsAway: 1,
            goalsHome: 3,
            homeTeamId: "4a8ab99d-7731-4467-9c16-8ba1663c545b",
            id: "2746a394-ff64-476c-8e39-826582f19be2",
            kickOffTime: "2020-06-20T13:30:18.719Z",
          },
          "2b229469-aec5-4194-8477-c63bf9b545ff": {
            awayTeamId: "4e3bfa69-db9e-4b06-ba57-bffd9c11b8d1",
            goalsAway: 1,
            goalsHome: 1,
            homeTeamId: "0f231945-0ffb-4dc6-9bae-604bf236ab2f",
            id: "2b229469-aec5-4194-8477-c63bf9b545ff",
            kickOffTime: "2020-06-20T13:30:18.719Z",
          },
          "3aefeaf7-4ce9-40e9-bcb1-1f4fcc15732f": {
            awayTeamId: "91f5c377-c4d9-49e9-9569-b5f6c44808e1",
            goalsAway: 1,
            goalsHome: 3,
            homeTeamId: "93c01474-719c-4df3-a4ff-7c2561e04ac1",
            id: "3aefeaf7-4ce9-40e9-bcb1-1f4fcc15732f",
            kickOffTime: "2020-06-20T13:30:18.718Z",
          },
          "4f751f8b-ba12-4db5-bd26-9ff156ea7ea0": {
            awayTeamId: "e18be703-c750-4731-a9e1-2079ad8837f2",
            goalsAway: 4,
            goalsHome: 1,
            homeTeamId: "166b21c1-7fcb-4eb0-b01c-ece3943a900b",
            id: "4f751f8b-ba12-4db5-bd26-9ff156ea7ea0",
            kickOffTime: "2020-06-20T13:30:18.720Z",
          },
          "7dbe3d74-696a-4a86-a50d-f677cb7a40d7": {
            awayTeamId: "6a0d669b-9a11-4001-a753-de12bb24bd0a",
            goalsAway: 3,
            goalsHome: 1,
            homeTeamId: "cbe09562-1bf1-4b92-8e6b-92ea740d2774",
            id: "7dbe3d74-696a-4a86-a50d-f677cb7a40d7",
            kickOffTime: "2020-06-20T13:30:18.721Z",
          },
          "973255ed-35a4-47c9-84b9-a04266b58dd5": {
            awayTeamId: "b14bb614-3a22-4e46-9c8f-6b0f7e091c6d",
            goalsAway: 0,
            goalsHome: 2,
            homeTeamId: "dccf4aa9-74fb-4e7c-9011-20e7dd13ffbc",
            id: "973255ed-35a4-47c9-84b9-a04266b58dd5",
            kickOffTime: "2020-06-20T13:30:18.719Z",
          },
          "b63ff8bc-bbba-4642-865a-233b1acd6537": {
            awayTeamId: "3fa3a04b-fa87-49e9-8772-0820a516be9c",
            goalsAway: 2,
            goalsHome: 0,
            homeTeamId: "75e3d230-76a1-4339-9c0c-6155386bf897",
            id: "b63ff8bc-bbba-4642-865a-233b1acd6537",
            kickOffTime: "2020-06-20T13:30:18.722Z",
          },
          "fbd671f2-40a0-4169-8469-518f881ce8a5": {
            awayTeamId: "158c2559-8f11-4e58-8439-0921d101c732",
            goalsAway: 0,
            goalsHome: 4,
            homeTeamId: "49b443c0-c5f9-49fa-8e51-5a27547a9f67",
            id: "fbd671f2-40a0-4169-8469-518f881ce8a5",
            kickOffTime: "2020-06-20T13:30:18.718Z",
          },
        },
        id: "5e597972-e4aa-4c61-8f87-123eb9649225",
        matchday: 33,
        startDate: "",
      },
      {
        endDate: "",
        fixtures: {
          "1b653d8c-94e2-4f42-b5f8-5cf980172185": {
            awayTeamId: "2e7b4ee7-8c0b-450b-8e10-a1bd5fc892c3",
            goalsAway: 1,
            goalsHome: 6,
            homeTeamId: "1bbea28c-81cc-49e3-a894-a33c3714ffc5",
            id: "1b653d8c-94e2-4f42-b5f8-5cf980172185",
            kickOffTime: "2020-06-27T13:30:15.613Z",
          },
          "268bba3f-908e-4961-ab7c-8a02714ee6b4": {
            awayTeamId: "dccf4aa9-74fb-4e7c-9011-20e7dd13ffbc",
            goalsAway: 1,
            goalsHome: 2,
            homeTeamId: "6a0d669b-9a11-4001-a753-de12bb24bd0a",
            id: "268bba3f-908e-4961-ab7c-8a02714ee6b4",
            kickOffTime: "2020-06-27T13:30:15.612Z",
          },
          "45069c01-46b8-45b7-9c09-ffa93e53a69a": {
            awayTeamId: "166b21c1-7fcb-4eb0-b01c-ece3943a900b",
            goalsAway: 0,
            goalsHome: 4,
            homeTeamId: "91f5c377-c4d9-49e9-9569-b5f6c44808e1",
            id: "45069c01-46b8-45b7-9c09-ffa93e53a69a",
            kickOffTime: "2020-06-27T13:30:15.613Z",
          },
          "7a707960-da64-47c6-8ef0-773d1f4462a4": {
            awayTeamId: "cbe09562-1bf1-4b92-8e6b-92ea740d2774",
            goalsAway: 2,
            goalsHome: 3,
            homeTeamId: "c80d1327-c1f6-44ff-8d54-4ac93ff89763",
            id: "7a707960-da64-47c6-8ef0-773d1f4462a4",
            kickOffTime: "2020-06-27T13:30:15.613Z",
          },
          "9342482c-8eb7-47db-bb36-3156be4eafe8": {
            awayTeamId: "0f231945-0ffb-4dc6-9bae-604bf236ab2f",
            goalsAway: 0,
            goalsHome: 3,
            homeTeamId: "158c2559-8f11-4e58-8439-0921d101c732",
            id: "9342482c-8eb7-47db-bb36-3156be4eafe8",
            kickOffTime: "2020-06-27T13:30:15.613Z",
          },
          "ba8c3985-ebd8-42bd-826e-e38f1e94c85a": {
            awayTeamId: "49b443c0-c5f9-49fa-8e51-5a27547a9f67",
            goalsAway: 4,
            goalsHome: 0,
            homeTeamId: "3fa3a04b-fa87-49e9-8772-0820a516be9c",
            id: "ba8c3985-ebd8-42bd-826e-e38f1e94c85a",
            kickOffTime: "2020-06-27T13:30:15.614Z",
          },
          "bb0f082d-8826-4be6-94b3-0987db7f5808": {
            awayTeamId: "75e3d230-76a1-4339-9c0c-6155386bf897",
            goalsAway: 2,
            goalsHome: 1,
            homeTeamId: "4e3bfa69-db9e-4b06-ba57-bffd9c11b8d1",
            id: "bb0f082d-8826-4be6-94b3-0987db7f5808",
            kickOffTime: "2020-06-27T13:30:15.613Z",
          },
          "c5ae1a02-a534-44cd-be07-bfc10ac9554b": {
            awayTeamId: "93c01474-719c-4df3-a4ff-7c2561e04ac1",
            goalsAway: 4,
            goalsHome: 0,
            homeTeamId: "e18be703-c750-4731-a9e1-2079ad8837f2",
            id: "c5ae1a02-a534-44cd-be07-bfc10ac9554b",
            kickOffTime: "2020-06-27T13:30:15.612Z",
          },
          "ca45397b-23d5-4c5d-aa30-f76dfbf63dda": {
            awayTeamId: "4a8ab99d-7731-4467-9c16-8ba1663c545b",
            goalsAway: 0,
            goalsHome: 1,
            homeTeamId: "b14bb614-3a22-4e46-9c8f-6b0f7e091c6d",
            id: "ca45397b-23d5-4c5d-aa30-f76dfbf63dda",
            kickOffTime: "2020-06-27T13:30:15.612Z",
          },
        },
        id: "b1d306e4-6ba8-47b3-8912-01c8df846266",
        matchday: 34,
        startDate: "",
      },
    ],
  },
  italy: {
    "2019": [
      {
        endDate: "2019-08-26T22:45:00.000+02:00",
        fixtures: {
          "0ccae2b5-500c-4c70-9bf7-01150d5979fc": {
            awayTeamId: "4a7d7192-288d-4185-8d46-a337129c6e77",
            goalsAway: 4,
            goalsHome: 3,
            homeTeamId: "9bc4bbfc-5b00-40b6-9ba4-e398114ec130",
            kickOffTime: "2019-08-24T20:45:00.000+02:00",
          },
          "1b8931b7-91ec-426d-a074-24782b7d0b4a": {
            awayTeamId: "8b3c665f-6738-4744-81a7-91dbce1c58f7",
            goalsAway: 1,
            goalsHome: 0,
            homeTeamId: "fd626290-dd26-4768-acae-1f3770304ff6",
            kickOffTime: "2019-08-24T18:00:00.000+02:00",
          },
          "2d24cce3-be58-4ab5-ba5d-3c13555eb53a": {
            awayTeamId: "b59106f0-dd86-4e9d-8dc9-fd074aece6ee",
            goalsAway: 1,
            goalsHome: 2,
            homeTeamId: "69007dc2-fb11-43ba-8b60-321960051e67",
            kickOffTime: "2019-08-25T20:45:00.000+02:00",
          },
          "47223350-93f2-4024-9b47-91928d0f5d76": {
            awayTeamId: "5afd6cb9-f14f-431a-a0c0-22e4d9424a8f",
            goalsAway: 3,
            goalsHome: 3,
            homeTeamId: "d1c1940c-2fae-4aab-81cd-7355bc2c9d85",
            kickOffTime: "2019-08-25T20:45:00.000+02:00",
          },
          "4972e0e5-7744-415b-b466-5fbeb97484c7": {
            awayTeamId: "52aa8f01-478f-4efc-be06-5472237d7fc9",
            goalsAway: 1,
            goalsHome: 0,
            homeTeamId: "174e65e5-6d72-4f53-b4be-9d139715c89a",
            kickOffTime: "2019-08-25T20:45:00.000+02:00",
          },
          "6b5257ef-f8ce-4736-ad64-57837fafb4de": {
            awayTeamId: "17dc6c9a-4f3b-4ebc-b3a4-bcb6eda1a30a",
            goalsAway: 3,
            goalsHome: 0,
            homeTeamId: "6ab88ce9-af44-4299-9675-0b0598c8aba0",
            kickOffTime: "2019-08-25T20:45:00.000+02:00",
          },
          "7e9175e5-c7c2-47dd-89f6-ecbcd2eebd5c": {
            awayTeamId: "553160b8-3b85-400d-b295-4c3212c2014f",
            goalsAway: 0,
            goalsHome: 4,
            homeTeamId: "3f45562f-f848-41e5-83ba-5f1a1e4e285f",
            kickOffTime: "2019-08-26T20:45:00.000+02:00",
          },
          "afa33334-b2b8-4cad-91ab-59b4c9dd3ef1": {
            awayTeamId: "ed4244af-01d2-4c79-92b9-2f77149615cd",
            goalsAway: 1,
            goalsHome: 1,
            homeTeamId: "619fbd53-4382-441f-a664-31c2dc5507b2",
            kickOffTime: "2019-08-25T20:45:00.000+02:00",
          },
          "c4aa1356-367e-4d98-b168-a9eef39e9764": {
            awayTeamId: "83ab7af4-0410-4670-9398-844a1c251336",
            goalsAway: 3,
            goalsHome: 2,
            homeTeamId: "6d7b6c20-1bae-4439-8762-f52144812dc3",
            kickOffTime: "2019-08-25T20:45:00.000+02:00",
          },
          "f77bba14-3362-4617-afcf-0c17de30d06b": {
            awayTeamId: "1869c021-2191-49cf-b671-ea9ea08cd0fb",
            goalsAway: 0,
            goalsHome: 1,
            homeTeamId: "2e52cbda-e75d-4420-9406-35b48f4393d7",
            kickOffTime: "2019-08-25T18:00:00.000+02:00",
          },
        },
        id: "868933a1-bd11-4cbd-a4ab-cb34b35a37dd",
        matchday: 1,
        startDate: "2019-08-24T18:00:00.000+02:00",
      },
      {
        endDate: "2019-09-01T22:45:00.000+02:00",
        fixtures: {
          "13a99529-d1f6-4a5a-8eb6-5f2d25dfe758": {
            awayTeamId: "d1c1940c-2fae-4aab-81cd-7355bc2c9d85",
            goalsAway: 1,
            goalsHome: 1,
            homeTeamId: "17dc6c9a-4f3b-4ebc-b3a4-bcb6eda1a30a",
            kickOffTime: "2019-09-01T18:00:00.000+02:00",
          },
          "198c706f-5a0b-4661-bf5b-5eb2629fa78b": {
            awayTeamId: "3f45562f-f848-41e5-83ba-5f1a1e4e285f",
            goalsAway: 2,
            goalsHome: 1,
            homeTeamId: "174e65e5-6d72-4f53-b4be-9d139715c89a",
            kickOffTime: "2019-09-01T20:45:00.000+02:00",
          },
          "1edd9d96-923d-4127-a8c5-60e4c8e81355": {
            awayTeamId: "9bc4bbfc-5b00-40b6-9ba4-e398114ec130",
            goalsAway: 1,
            goalsHome: 2,
            homeTeamId: "5afd6cb9-f14f-431a-a0c0-22e4d9424a8f",
            kickOffTime: "2019-09-01T20:45:00.000+02:00",
          },
          "41ee6a54-c19e-451e-964f-eef400604bbe": {
            awayTeamId: "69007dc2-fb11-43ba-8b60-321960051e67",
            goalsAway: 3,
            goalsHome: 2,
            homeTeamId: "83ab7af4-0410-4670-9398-844a1c251336",
            kickOffTime: "2019-09-01T20:45:00.000+02:00",
          },
          "5a69a2d0-ec04-45ac-8b84-391d556cf7d5": {
            awayTeamId: "6ab88ce9-af44-4299-9675-0b0598c8aba0",
            goalsAway: 1,
            goalsHome: 4,
            homeTeamId: "b59106f0-dd86-4e9d-8dc9-fd074aece6ee",
            kickOffTime: "2019-09-01T20:45:00.000+02:00",
          },
          "5ea36502-ebf1-42eb-8e28-d9c67463075d": {
            awayTeamId: "52aa8f01-478f-4efc-be06-5472237d7fc9",
            goalsAway: 0,
            goalsHome: 1,
            homeTeamId: "1869c021-2191-49cf-b671-ea9ea08cd0fb",
            kickOffTime: "2019-08-31T18:00:00.000+02:00",
          },
          "65ac5eb1-d1d6-43e2-9f5d-abed2b56a526": {
            awayTeamId: "6d7b6c20-1bae-4439-8762-f52144812dc3",
            goalsAway: 0,
            goalsHome: 1,
            homeTeamId: "ed4244af-01d2-4c79-92b9-2f77149615cd",
            kickOffTime: "2019-08-30T20:45:00.000+02:00",
          },
          "723148fc-d852-4ad3-94f8-8dfececb2864": {
            awayTeamId: "619fbd53-4382-441f-a664-31c2dc5507b2",
            goalsAway: 1,
            goalsHome: 0,
            homeTeamId: "553160b8-3b85-400d-b295-4c3212c2014f",
            kickOffTime: "2019-09-01T20:45:00.000+02:00",
          },
          "b1e923ca-ba8e-42f5-a928-9e0b931c610e": {
            awayTeamId: "fd626290-dd26-4768-acae-1f3770304ff6",
            goalsAway: 3,
            goalsHome: 1,
            homeTeamId: "2e52cbda-e75d-4420-9406-35b48f4393d7",
            kickOffTime: "2019-09-01T20:45:00.000+02:00",
          },
          "bded6272-0098-4bac-b53d-0095b01e5fa7": {
            awayTeamId: "4a7d7192-288d-4185-8d46-a337129c6e77",
            goalsAway: 3,
            goalsHome: 4,
            homeTeamId: "8b3c665f-6738-4744-81a7-91dbce1c58f7",
            kickOffTime: "2019-08-31T20:45:00.000+02:00",
          },
        },
        id: "521a2c55-eb1c-4cf7-bf52-b121bba2bd55",
        matchday: 2,
        startDate: "2019-08-30T20:45:00.000+02:00",
      },
      {
        endDate: "2019-09-16T22:45:00.000+02:00",
        fixtures: {
          "13b40c02-4bb1-4e55-9990-3558a9230d15": {
            awayTeamId: "553160b8-3b85-400d-b295-4c3212c2014f",
            goalsAway: 2,
            goalsHome: 1,
            homeTeamId: "69007dc2-fb11-43ba-8b60-321960051e67",
            kickOffTime: "2019-09-16T20:45:00.000+02:00",
          },
          "2652eb6b-f0a5-4c97-9526-354851d9027a": {
            awayTeamId: "6ab88ce9-af44-4299-9675-0b0598c8aba0",
            goalsAway: 0,
            goalsHome: 2,
            homeTeamId: "4a7d7192-288d-4185-8d46-a337129c6e77",
            kickOffTime: "2019-09-14T18:00:00.000+02:00",
          },
          "3d7fe9ce-fcb5-460e-89cc-a20fc0bf17d3": {
            awayTeamId: "1869c021-2191-49cf-b671-ea9ea08cd0fb",
            goalsAway: 1,
            goalsHome: 0,
            homeTeamId: "619fbd53-4382-441f-a664-31c2dc5507b2",
            kickOffTime: "2019-09-15T20:45:00.000+02:00",
          },
          "4509b3a9-b3f0-4a3b-b5b0-220e267a98b4": {
            awayTeamId: "2e52cbda-e75d-4420-9406-35b48f4393d7",
            goalsAway: 0,
            goalsHome: 1,
            homeTeamId: "3f45562f-f848-41e5-83ba-5f1a1e4e285f",
            kickOffTime: "2019-09-14T20:45:00.000+02:00",
          },
          "51176b2f-2753-4147-997e-c3454875a1e8": {
            awayTeamId: "17dc6c9a-4f3b-4ebc-b3a4-bcb6eda1a30a",
            goalsAway: 1,
            goalsHome: 2,
            homeTeamId: "6d7b6c20-1bae-4439-8762-f52144812dc3",
            kickOffTime: "2019-09-15T15:00:00.000+02:00",
          },
          "86821064-da78-4e21-b077-de5e53692342": {
            awayTeamId: "b59106f0-dd86-4e9d-8dc9-fd074aece6ee",
            goalsAway: 2,
            goalsHome: 4,
            homeTeamId: "d1c1940c-2fae-4aab-81cd-7355bc2c9d85",
            kickOffTime: "2019-09-15T18:00:00.000+02:00",
          },
          "9de61fb3-cf30-4ee3-ae4c-13ab0f5cafac": {
            awayTeamId: "8b3c665f-6738-4744-81a7-91dbce1c58f7",
            goalsAway: 0,
            goalsHome: 0,
            homeTeamId: "9bc4bbfc-5b00-40b6-9ba4-e398114ec130",
            kickOffTime: "2019-09-14T15:00:00.000+02:00",
          },
          "c0e42269-1b21-4d4a-93ff-19d608072e29": {
            awayTeamId: "83ab7af4-0410-4670-9398-844a1c251336",
            goalsAway: 2,
            goalsHome: 1,
            homeTeamId: "5afd6cb9-f14f-431a-a0c0-22e4d9424a8f",
            kickOffTime: "2019-09-15T12:30:00.000+02:00",
          },
          "e4b435bf-3777-4307-8aca-dfeee71d6456": {
            awayTeamId: "174e65e5-6d72-4f53-b4be-9d139715c89a",
            goalsAway: 3,
            goalsHome: 1,
            homeTeamId: "fd626290-dd26-4768-acae-1f3770304ff6",
            kickOffTime: "2019-09-15T15:00:00.000+02:00",
          },
          "feb92bc5-3ac7-4798-982c-55b337bb79f3": {
            awayTeamId: "ed4244af-01d2-4c79-92b9-2f77149615cd",
            goalsAway: 4,
            goalsHome: 3,
            homeTeamId: "52aa8f01-478f-4efc-be06-5472237d7fc9",
            kickOffTime: "2019-09-15T15:00:00.000+02:00",
          },
        },
        id: "ee642009-0c09-46a0-9029-a0ee854d90cd",
        matchday: 3,
        startDate: "2019-09-14T15:00:00.000+02:00",
      },
      {
        endDate: "2019-09-22T22:45:00.000+02:00",
        fixtures: {
          "08fc380c-d73e-407a-a55f-cc414238ca7a": {
            awayTeamId: "6d7b6c20-1bae-4439-8762-f52144812dc3",
            goalsAway: 0,
            goalsHome: 3,
            homeTeamId: "b59106f0-dd86-4e9d-8dc9-fd074aece6ee",
            kickOffTime: "2019-09-22T12:30:00.000+02:00",
          },
          "1431e358-2b53-49df-a380-68f6a9b3fbd3": {
            awayTeamId: "52aa8f01-478f-4efc-be06-5472237d7fc9",
            goalsAway: 1,
            goalsHome: 0,
            homeTeamId: "2e52cbda-e75d-4420-9406-35b48f4393d7",
            kickOffTime: "2019-09-21T15:00:00.000+02:00",
          },
          "1e647277-9638-4770-b745-f5767557a997": {
            awayTeamId: "9bc4bbfc-5b00-40b6-9ba4-e398114ec130",
            goalsAway: 2,
            goalsHome: 2,
            homeTeamId: "83ab7af4-0410-4670-9398-844a1c251336",
            kickOffTime: "2019-09-22T18:00:00.000+02:00",
          },
          "2077676f-d7c5-46fb-984f-7b1a3850bdfc": {
            awayTeamId: "fd626290-dd26-4768-acae-1f3770304ff6",
            goalsAway: 0,
            goalsHome: 2,
            homeTeamId: "17dc6c9a-4f3b-4ebc-b3a4-bcb6eda1a30a",
            kickOffTime: "2019-09-22T20:45:00.000+02:00",
          },
          "214ce021-2c39-4f04-a33e-74bd03ea7504": {
            awayTeamId: "5afd6cb9-f14f-431a-a0c0-22e4d9424a8f",
            goalsAway: 1,
            goalsHome: 3,
            homeTeamId: "174e65e5-6d72-4f53-b4be-9d139715c89a",
            kickOffTime: "2019-09-20T20:45:00.000+02:00",
          },
          "3ae6175b-7efe-4db3-8780-66a2bbd025b1": {
            awayTeamId: "4a7d7192-288d-4185-8d46-a337129c6e77",
            goalsAway: 4,
            goalsHome: 1,
            homeTeamId: "553160b8-3b85-400d-b295-4c3212c2014f",
            kickOffTime: "2019-09-22T15:00:00.000+02:00",
          },
          "85d92193-5b26-4d92-8c77-a2ef61535aac": {
            awayTeamId: "d1c1940c-2fae-4aab-81cd-7355bc2c9d85",
            goalsAway: 2,
            goalsHome: 1,
            homeTeamId: "ed4244af-01d2-4c79-92b9-2f77149615cd",
            kickOffTime: "2019-09-22T15:00:00.000+02:00",
          },
          "99592a51-0af6-49f2-af95-31652fc7db75": {
            awayTeamId: "619fbd53-4382-441f-a664-31c2dc5507b2",
            goalsAway: 1,
            goalsHome: 2,
            homeTeamId: "8b3c665f-6738-4744-81a7-91dbce1c58f7",
            kickOffTime: "2019-09-21T18:00:00.000+02:00",
          },
          "a5bb2a3a-3940-404d-ada1-ed09dbbc0098": {
            awayTeamId: "3f45562f-f848-41e5-83ba-5f1a1e4e285f",
            goalsAway: 2,
            goalsHome: 0,
            homeTeamId: "1869c021-2191-49cf-b671-ea9ea08cd0fb",
            kickOffTime: "2019-09-21T20:45:00.000+02:00",
          },
          "e1321b5b-4ba0-4cd5-9696-b4d5adbda6bd": {
            awayTeamId: "69007dc2-fb11-43ba-8b60-321960051e67",
            goalsAway: 0,
            goalsHome: 1,
            homeTeamId: "6ab88ce9-af44-4299-9675-0b0598c8aba0",
            kickOffTime: "2019-09-22T15:00:00.000+02:00",
          },
        },
        id: "87aa3d8b-7369-429a-8a74-ba090e53bd91",
        matchday: 4,
        startDate: "2019-09-20T20:45:00.000+02:00",
      },
      {
        endDate: "2019-09-26T22:00:00.000+02:00",
        fixtures: {
          "237daa36-12dd-4108-82fc-bd7dc2683218": {
            awayTeamId: "83ab7af4-0410-4670-9398-844a1c251336",
            goalsAway: 2,
            goalsHome: 0,
            homeTeamId: "d1c1940c-2fae-4aab-81cd-7355bc2c9d85",
            kickOffTime: "2019-09-25T19:00:00.000+02:00",
          },
          "369990a7-694a-459a-a18c-1d1a865a365e": {
            awayTeamId: "ed4244af-01d2-4c79-92b9-2f77149615cd",
            goalsAway: 0,
            goalsHome: 0,
            homeTeamId: "5afd6cb9-f14f-431a-a0c0-22e4d9424a8f",
            kickOffTime: "2019-09-25T21:00:00.000+02:00",
          },
          "4c81002f-6802-432f-9fb8-b17acd5ba3c7": {
            awayTeamId: "1869c021-2191-49cf-b671-ea9ea08cd0fb",
            goalsAway: 1,
            goalsHome: 2,
            homeTeamId: "69007dc2-fb11-43ba-8b60-321960051e67",
            kickOffTime: "2019-09-26T21:00:00.000+02:00",
          },
          "7359b2b0-d959-4831-bbd5-009a13dfdde1": {
            awayTeamId: "2e52cbda-e75d-4420-9406-35b48f4393d7",
            goalsAway: 0,
            goalsHome: 0,
            homeTeamId: "619fbd53-4382-441f-a664-31c2dc5507b2",
            kickOffTime: "2019-09-24T19:00:00.000+02:00",
          },
          "93c676bf-807f-44db-a140-54f298c9aeb0": {
            awayTeamId: "553160b8-3b85-400d-b295-4c3212c2014f",
            goalsAway: 3,
            goalsHome: 1,
            homeTeamId: "6d7b6c20-1bae-4439-8762-f52144812dc3",
            kickOffTime: "2019-09-25T21:00:00.000+02:00",
          },
          "9a619bf9-e894-4b47-a6f1-f91e60a16550": {
            awayTeamId: "b59106f0-dd86-4e9d-8dc9-fd074aece6ee",
            goalsAway: 0,
            goalsHome: 1,
            homeTeamId: "fd626290-dd26-4768-acae-1f3770304ff6",
            kickOffTime: "2019-09-25T21:00:00.000+02:00",
          },
          "ab3b26e9-8434-4ace-bfae-5a9139d5c694": {
            awayTeamId: "6ab88ce9-af44-4299-9675-0b0598c8aba0",
            goalsAway: 1,
            goalsHome: 2,
            homeTeamId: "9bc4bbfc-5b00-40b6-9ba4-e398114ec130",
            kickOffTime: "2019-09-25T21:00:00.000+02:00",
          },
          "ba5f93ac-1b55-454a-933b-f0b7f51701dd": {
            awayTeamId: "8b3c665f-6738-4744-81a7-91dbce1c58f7",
            goalsAway: 2,
            goalsHome: 1,
            homeTeamId: "52aa8f01-478f-4efc-be06-5472237d7fc9",
            kickOffTime: "2019-09-24T21:00:00.000+02:00",
          },
          "c1eed9b9-19a1-4585-ac01-22ded3929d9d": {
            awayTeamId: "17dc6c9a-4f3b-4ebc-b3a4-bcb6eda1a30a",
            goalsAway: 0,
            goalsHome: 1,
            homeTeamId: "3f45562f-f848-41e5-83ba-5f1a1e4e285f",
            kickOffTime: "2019-09-25T21:00:00.000+02:00",
          },
          "c55ec6e6-12d8-4a46-b479-9ba090dd202b": {
            awayTeamId: "174e65e5-6d72-4f53-b4be-9d139715c89a",
            goalsAway: 1,
            goalsHome: 0,
            homeTeamId: "4a7d7192-288d-4185-8d46-a337129c6e77",
            kickOffTime: "2019-09-25T21:00:00.000+02:00",
          },
        },
        id: "b9711d0b-e212-4348-82b7-5dc4d5237884",
        matchday: 5,
        startDate: "2019-09-24T19:00:00.000+02:00",
      },
      {
        endDate: "2019-09-30T22:45:00.000+02:00",
        fixtures: {
          "0e060e71-e634-4036-a19e-f9e99f2d6382": {
            awayTeamId: "3f45562f-f848-41e5-83ba-5f1a1e4e285f",
            goalsAway: 3,
            goalsHome: 1,
            homeTeamId: "6ab88ce9-af44-4299-9675-0b0598c8aba0",
            kickOffTime: "2019-09-28T18:00:00.000+02:00",
          },
          "13a0857a-14ab-47d7-adfe-da6454809eb0": {
            awayTeamId: "69007dc2-fb11-43ba-8b60-321960051e67",
            goalsAway: 2,
            goalsHome: 3,
            homeTeamId: "fd626290-dd26-4768-acae-1f3770304ff6",
            kickOffTime: "2019-09-30T20:45:00.000+02:00",
          },
          "3eb6ad80-4ee9-4fea-8d93-6d4d32f6df0b": {
            awayTeamId: "d1c1940c-2fae-4aab-81cd-7355bc2c9d85",
            goalsAway: 1,
            goalsHome: 0,
            homeTeamId: "553160b8-3b85-400d-b295-4c3212c2014f",
            kickOffTime: "2019-09-29T15:00:00.000+02:00",
          },
          "75a0bbd1-d689-42a3-bacc-d9c3a02ff450": {
            awayTeamId: "6d7b6c20-1bae-4439-8762-f52144812dc3",
            goalsAway: 0,
            goalsHome: 2,
            homeTeamId: "8b3c665f-6738-4744-81a7-91dbce1c58f7",
            kickOffTime: "2019-09-28T15:00:00.000+02:00",
          },
          "8008db82-bfb2-468e-89bd-96098e5f7ed0": {
            awayTeamId: "52aa8f01-478f-4efc-be06-5472237d7fc9",
            goalsAway: 1,
            goalsHome: 2,
            homeTeamId: "4a7d7192-288d-4185-8d46-a337129c6e77",
            kickOffTime: "2019-09-29T12:30:00.000+02:00",
          },
          "a80b2dca-b0e5-4cd6-9aa0-2554f5f82318": {
            awayTeamId: "619fbd53-4382-441f-a664-31c2dc5507b2",
            goalsAway: 1,
            goalsHome: 1,
            homeTeamId: "174e65e5-6d72-4f53-b4be-9d139715c89a",
            kickOffTime: "2019-09-29T18:00:00.000+02:00",
          },
          "c155c21c-41b2-43f7-9138-a28e48d28075": {
            awayTeamId: "5afd6cb9-f14f-431a-a0c0-22e4d9424a8f",
            goalsAway: 0,
            goalsHome: 4,
            homeTeamId: "17dc6c9a-4f3b-4ebc-b3a4-bcb6eda1a30a",
            kickOffTime: "2019-09-29T15:00:00.000+02:00",
          },
          "c6d72b6f-348c-42af-bbf1-6c27d1820724": {
            awayTeamId: "83ab7af4-0410-4670-9398-844a1c251336",
            goalsAway: 4,
            goalsHome: 1,
            homeTeamId: "b59106f0-dd86-4e9d-8dc9-fd074aece6ee",
            kickOffTime: "2019-09-28T20:45:00.000+02:00",
          },
          "cde6be1f-1d4f-42ca-bf8b-c8a8ad072ede": {
            awayTeamId: "9bc4bbfc-5b00-40b6-9ba4-e398114ec130",
            goalsAway: 3,
            goalsHome: 1,
            homeTeamId: "1869c021-2191-49cf-b671-ea9ea08cd0fb",
            kickOffTime: "2019-09-29T20:45:00.000+02:00",
          },
          "f0074a40-f9d4-4c23-896d-b5641d8e02c3": {
            awayTeamId: "ed4244af-01d2-4c79-92b9-2f77149615cd",
            goalsAway: 0,
            goalsHome: 1,
            homeTeamId: "2e52cbda-e75d-4420-9406-35b48f4393d7",
            kickOffTime: "2019-09-29T15:00:00.000+02:00",
          },
        },
        id: "839f8ddc-2b21-447a-b827-d3848bfb422d",
        matchday: 6,
        startDate: "2019-09-28T15:00:00.000+02:00",
      },
      {
        endDate: "2019-10-06T22:45:00.000+02:00",
        fixtures: {
          "0cbdb3cf-189f-411e-a801-e4f97d40454f": {
            awayTeamId: "553160b8-3b85-400d-b295-4c3212c2014f",
            goalsAway: 1,
            goalsHome: 3,
            homeTeamId: "83ab7af4-0410-4670-9398-844a1c251336",
            kickOffTime: "2019-10-06T15:00:00.000+02:00",
          },
          "21a9eaf8-ccf3-44d3-ba72-5f344c5986b6": {
            awayTeamId: "6ab88ce9-af44-4299-9675-0b0598c8aba0",
            goalsAway: 0,
            goalsHome: 2,
            homeTeamId: "619fbd53-4382-441f-a664-31c2dc5507b2",
            kickOffTime: "2019-10-05T18:00:00.000+02:00",
          },
          "26945735-2d0a-449c-add9-d8de3effe2df": {
            awayTeamId: "fd626290-dd26-4768-acae-1f3770304ff6",
            goalsAway: 0,
            goalsHome: 1,
            homeTeamId: "6d7b6c20-1bae-4439-8762-f52144812dc3",
            kickOffTime: "2019-10-05T15:00:00.000+02:00",
          },
          "2e296a8e-c927-406a-a173-66440eaa27f3": {
            awayTeamId: "b59106f0-dd86-4e9d-8dc9-fd074aece6ee",
            goalsAway: 2,
            goalsHome: 0,
            homeTeamId: "52aa8f01-478f-4efc-be06-5472237d7fc9",
            kickOffTime: "2019-12-18T20:45:00.000+01:00",
          },
          "33304e43-773e-4a9f-91d2-cf247dcffb05": {
            awayTeamId: "2e52cbda-e75d-4420-9406-35b48f4393d7",
            goalsAway: 0,
            goalsHome: 1,
            homeTeamId: "9bc4bbfc-5b00-40b6-9ba4-e398114ec130",
            kickOffTime: "2019-10-06T12:30:00.000+02:00",
          },
          "3c9e2cbc-bc32-4fa1-9eaf-57b48a93764b": {
            awayTeamId: "17dc6c9a-4f3b-4ebc-b3a4-bcb6eda1a30a",
            goalsAway: 2,
            goalsHome: 2,
            homeTeamId: "ed4244af-01d2-4c79-92b9-2f77149615cd",
            kickOffTime: "2019-10-06T15:00:00.000+02:00",
          },
          "42b0d0c3-4dad-4c6b-9cde-65b6a8eb645c": {
            awayTeamId: "1869c021-2191-49cf-b671-ea9ea08cd0fb",
            goalsAway: 2,
            goalsHome: 1,
            homeTeamId: "5afd6cb9-f14f-431a-a0c0-22e4d9424a8f",
            kickOffTime: "2019-10-05T20:45:00.000+02:00",
          },
          "ac2d6434-7944-4d1e-aca2-dadce1a68302": {
            awayTeamId: "174e65e5-6d72-4f53-b4be-9d139715c89a",
            goalsAway: 1,
            goalsHome: 1,
            homeTeamId: "d1c1940c-2fae-4aab-81cd-7355bc2c9d85",
            kickOffTime: "2019-10-06T15:00:00.000+02:00",
          },
          "df6799b0-dedb-48f6-b55f-961443c5871d": {
            awayTeamId: "4a7d7192-288d-4185-8d46-a337129c6e77",
            goalsAway: 0,
            goalsHome: 0,
            homeTeamId: "69007dc2-fb11-43ba-8b60-321960051e67",
            kickOffTime: "2019-10-06T18:00:00.000+02:00",
          },
          "f038b5c4-0444-4168-b0d0-fcf85cf276f0": {
            awayTeamId: "8b3c665f-6738-4744-81a7-91dbce1c58f7",
            goalsAway: 2,
            goalsHome: 1,
            homeTeamId: "3f45562f-f848-41e5-83ba-5f1a1e4e285f",
            kickOffTime: "2019-10-06T20:45:00.000+02:00",
          },
        },
        id: "03a72616-a447-4b16-a9aa-db5b59e11409",
        matchday: 7,
        startDate: "2019-10-05T15:00:00.000+02:00",
      },
      {
        endDate: "2019-10-21T23:00:00.000+02:00",
        fixtures: {
          "00b86285-2325-4264-ad37-08aaf9a0c1a7": {
            awayTeamId: "9bc4bbfc-5b00-40b6-9ba4-e398114ec130",
            goalsAway: 0,
            goalsHome: 0,
            homeTeamId: "52aa8f01-478f-4efc-be06-5472237d7fc9",
            kickOffTime: "2019-10-21T21:00:00.000+02:00",
          },
          "069c11da-7c2c-45a3-8925-fc01fd0550a6": {
            awayTeamId: "ed4244af-01d2-4c79-92b9-2f77149615cd",
            goalsAway: 1,
            goalsHome: 2,
            homeTeamId: "8b3c665f-6738-4744-81a7-91dbce1c58f7",
            kickOffTime: "2019-10-19T20:45:00.000+02:00",
          },
          "5595cf3d-5fee-49cf-bd80-9bd307ddd5b3": {
            awayTeamId: "d1c1940c-2fae-4aab-81cd-7355bc2c9d85",
            goalsAway: 0,
            goalsHome: 0,
            homeTeamId: "6ab88ce9-af44-4299-9675-0b0598c8aba0",
            kickOffTime: "2019-10-20T15:00:00.000+02:00",
          },
          "5cb33f82-bc68-4489-95bb-64a4ff6a0b6a": {
            awayTeamId: "6d7b6c20-1bae-4439-8762-f52144812dc3",
            goalsAway: 0,
            goalsHome: 2,
            homeTeamId: "174e65e5-6d72-4f53-b4be-9d139715c89a",
            kickOffTime: "2019-10-20T15:00:00.000+02:00",
          },
          "7f43bb81-bf32-416c-8d81-f3613857dcd7": {
            awayTeamId: "5afd6cb9-f14f-431a-a0c0-22e4d9424a8f",
            goalsAway: 1,
            goalsHome: 5,
            homeTeamId: "fd626290-dd26-4768-acae-1f3770304ff6",
            kickOffTime: "2019-10-20T18:00:00.000+02:00",
          },
          "91efdf07-6e3d-4da2-9048-be40ba391760": {
            awayTeamId: "553160b8-3b85-400d-b295-4c3212c2014f",
            goalsAway: 2,
            goalsHome: 2,
            homeTeamId: "1869c021-2191-49cf-b671-ea9ea08cd0fb",
            kickOffTime: "2019-10-20T20:45:00.000+02:00",
          },
          "9ee66030-c68b-446d-ac1c-8c83a2edac6b": {
            awayTeamId: "69007dc2-fb11-43ba-8b60-321960051e67",
            goalsAway: 0,
            goalsHome: 1,
            homeTeamId: "2e52cbda-e75d-4420-9406-35b48f4393d7",
            kickOffTime: "2019-10-20T15:00:00.000+02:00",
          },
          "ae681f28-0629-4d6f-9bd5-169c9623b7e2": {
            awayTeamId: "619fbd53-4382-441f-a664-31c2dc5507b2",
            goalsAway: 0,
            goalsHome: 2,
            homeTeamId: "4a7d7192-288d-4185-8d46-a337129c6e77",
            kickOffTime: "2019-10-19T18:00:00.000+02:00",
          },
          "e9be5a10-901b-4268-92a2-b8341452e957": {
            awayTeamId: "83ab7af4-0410-4670-9398-844a1c251336",
            goalsAway: 3,
            goalsHome: 3,
            homeTeamId: "17dc6c9a-4f3b-4ebc-b3a4-bcb6eda1a30a",
            kickOffTime: "2019-10-19T15:00:00.000+02:00",
          },
          "fa16f975-4c55-4170-9369-6d193aba7730": {
            awayTeamId: "3f45562f-f848-41e5-83ba-5f1a1e4e285f",
            goalsAway: 4,
            goalsHome: 3,
            homeTeamId: "b59106f0-dd86-4e9d-8dc9-fd074aece6ee",
            kickOffTime: "2019-10-20T12:30:00.000+02:00",
          },
        },
        id: "7f09cb6f-896c-4e92-b60a-6a40ec7f55c8",
        matchday: 8,
        startDate: "2019-10-19T15:00:00.000+02:00",
      },
      {
        endDate: "2019-10-27T22:45:00.000+01:00",
        fixtures: {
          "2fc38360-0a41-4330-be38-9e33983ded3f": {
            awayTeamId: "17dc6c9a-4f3b-4ebc-b3a4-bcb6eda1a30a",
            goalsAway: 2,
            goalsHome: 1,
            homeTeamId: "9bc4bbfc-5b00-40b6-9ba4-e398114ec130",
            kickOffTime: "2019-10-27T20:45:00.000+01:00",
          },
          "3c7ab1e3-80f6-47eb-8b31-45fe0c160b2f": {
            awayTeamId: "1869c021-2191-49cf-b671-ea9ea08cd0fb",
            goalsAway: 1,
            goalsHome: 2,
            homeTeamId: "d1c1940c-2fae-4aab-81cd-7355bc2c9d85",
            kickOffTime: "2019-10-27T18:00:00.000+01:00",
          },
          "6b2e33b1-9b74-43c1-b725-ddd8e678554c": {
            awayTeamId: "174e65e5-6d72-4f53-b4be-9d139715c89a",
            goalsAway: 1,
            goalsHome: 1,
            homeTeamId: "69007dc2-fb11-43ba-8b60-321960051e67",
            kickOffTime: "2019-10-27T15:00:00.000+01:00",
          },
          "6e754510-a479-49ad-808f-84b8134637d1": {
            awayTeamId: "52aa8f01-478f-4efc-be06-5472237d7fc9",
            goalsAway: 1,
            goalsHome: 3,
            homeTeamId: "5afd6cb9-f14f-431a-a0c0-22e4d9424a8f",
            kickOffTime: "2019-10-26T20:45:00.000+02:00",
          },
          "7485e192-cd1e-4b8f-bfa7-5ba63639858d": {
            awayTeamId: "b59106f0-dd86-4e9d-8dc9-fd074aece6ee",
            goalsAway: 1,
            goalsHome: 0,
            homeTeamId: "619fbd53-4382-441f-a664-31c2dc5507b2",
            kickOffTime: "2019-10-25T20:45:00.000+02:00",
          },
          "a0e23da6-789d-49e8-8180-820c5083e7a7": {
            awayTeamId: "fd626290-dd26-4768-acae-1f3770304ff6",
            goalsAway: 2,
            goalsHome: 2,
            homeTeamId: "3f45562f-f848-41e5-83ba-5f1a1e4e285f",
            kickOffTime: "2019-10-26T18:00:00.000+02:00",
          },
          "a806dfe1-e412-48b6-8052-58a0ff613916": {
            awayTeamId: "2e52cbda-e75d-4420-9406-35b48f4393d7",
            goalsAway: 1,
            goalsHome: 7,
            homeTeamId: "83ab7af4-0410-4670-9398-844a1c251336",
            kickOffTime: "2019-10-27T15:00:00.000+01:00",
          },
          "a9582a8a-0e62-47fe-bef3-e61bb4b32f38": {
            awayTeamId: "6ab88ce9-af44-4299-9675-0b0598c8aba0",
            goalsAway: 1,
            goalsHome: 2,
            homeTeamId: "ed4244af-01d2-4c79-92b9-2f77149615cd",
            kickOffTime: "2019-10-27T12:30:00.000+01:00",
          },
          "cba2126c-1fe7-4ec0-92cf-12b7a1cd320a": {
            awayTeamId: "4a7d7192-288d-4185-8d46-a337129c6e77",
            goalsAway: 1,
            goalsHome: 1,
            homeTeamId: "6d7b6c20-1bae-4439-8762-f52144812dc3",
            kickOffTime: "2019-10-27T15:00:00.000+01:00",
          },
          "f529d3bc-f0c2-49a1-8d25-889df877a670": {
            awayTeamId: "8b3c665f-6738-4744-81a7-91dbce1c58f7",
            goalsAway: 1,
            goalsHome: 1,
            homeTeamId: "553160b8-3b85-400d-b295-4c3212c2014f",
            kickOffTime: "2019-10-26T15:00:00.000+02:00",
          },
        },
        id: "36f688ba-3d19-491c-9a30-aed51a9e3a96",
        matchday: 9,
        startDate: "2019-10-25T20:45:00.000+02:00",
      },
      {
        endDate: "2019-10-31T23:00:00.000+01:00",
        fixtures: {
          "08bce1ab-d4c0-44f2-b120-d053215017fb": {
            awayTeamId: "6d7b6c20-1bae-4439-8762-f52144812dc3",
            goalsAway: 0,
            goalsHome: 1,
            homeTeamId: "1869c021-2191-49cf-b671-ea9ea08cd0fb",
            kickOffTime: "2019-10-31T21:00:00.000+01:00",
          },
          "4f3a5d91-a155-4b92-a551-7b2e7e554499": {
            awayTeamId: "553160b8-3b85-400d-b295-4c3212c2014f",
            goalsAway: 1,
            goalsHome: 1,
            homeTeamId: "6ab88ce9-af44-4299-9675-0b0598c8aba0",
            kickOffTime: "2019-10-30T21:00:00.000+01:00",
          },
          "673e84fc-1c1c-4f50-b302-7f40847f6003": {
            awayTeamId: "9bc4bbfc-5b00-40b6-9ba4-e398114ec130",
            goalsAway: 2,
            goalsHome: 1,
            homeTeamId: "b59106f0-dd86-4e9d-8dc9-fd074aece6ee",
            kickOffTime: "2019-10-30T21:00:00.000+01:00",
          },
          "712e5cde-913a-4a87-8315-cddb3fd62465": {
            awayTeamId: "83ab7af4-0410-4670-9398-844a1c251336",
            goalsAway: 2,
            goalsHome: 2,
            homeTeamId: "4a7d7192-288d-4185-8d46-a337129c6e77",
            kickOffTime: "2019-10-30T19:00:00.000+01:00",
          },
          "752e36f0-dfc3-4b27-bbf8-93d1d0c6a3fb": {
            awayTeamId: "d1c1940c-2fae-4aab-81cd-7355bc2c9d85",
            goalsAway: 4,
            goalsHome: 0,
            homeTeamId: "2e52cbda-e75d-4420-9406-35b48f4393d7",
            kickOffTime: "2019-10-30T21:00:00.000+01:00",
          },
          "9a43c9f6-3aec-42dc-9276-6cb3edcdd1b5": {
            awayTeamId: "5afd6cb9-f14f-431a-a0c0-22e4d9424a8f",
            goalsAway: 1,
            goalsHome: 2,
            homeTeamId: "8b3c665f-6738-4744-81a7-91dbce1c58f7",
            kickOffTime: "2019-10-30T21:00:00.000+01:00",
          },
          "a0dfe213-d54b-4082-9660-24270ba4fb11": {
            awayTeamId: "619fbd53-4382-441f-a664-31c2dc5507b2",
            goalsAway: 1,
            goalsHome: 0,
            homeTeamId: "fd626290-dd26-4768-acae-1f3770304ff6",
            kickOffTime: "2019-10-29T19:00:00.000+01:00",
          },
          "c5573eb9-2099-40ba-a0e8-a7bde4de1483": {
            awayTeamId: "69007dc2-fb11-43ba-8b60-321960051e67",
            goalsAway: 0,
            goalsHome: 4,
            homeTeamId: "17dc6c9a-4f3b-4ebc-b3a4-bcb6eda1a30a",
            kickOffTime: "2019-10-30T21:00:00.000+01:00",
          },
          "c5bd357a-de22-4d11-a829-12a252eae9cc": {
            awayTeamId: "ed4244af-01d2-4c79-92b9-2f77149615cd",
            goalsAway: 2,
            goalsHome: 3,
            homeTeamId: "174e65e5-6d72-4f53-b4be-9d139715c89a",
            kickOffTime: "2019-10-30T21:00:00.000+01:00",
          },
          "fd1d10ed-13ab-4e45-9af0-008d2b945dbd": {
            awayTeamId: "3f45562f-f848-41e5-83ba-5f1a1e4e285f",
            goalsAway: 2,
            goalsHome: 1,
            homeTeamId: "52aa8f01-478f-4efc-be06-5472237d7fc9",
            kickOffTime: "2019-10-29T21:00:00.000+01:00",
          },
        },
        id: "be9a546c-a482-478e-8b0e-329b01c10846",
        matchday: 10,
        startDate: "2019-10-29T19:00:00.000+01:00",
      },
      {
        endDate: "2019-11-04T22:45:00.000+01:00",
        fixtures: {
          "2178f0a3-e617-4f0f-91b2-aabc0fd2037c": {
            awayTeamId: "52aa8f01-478f-4efc-be06-5472237d7fc9",
            goalsAway: 1,
            goalsHome: 2,
            homeTeamId: "619fbd53-4382-441f-a664-31c2dc5507b2",
            kickOffTime: "2019-11-03T15:00:00.000+01:00",
          },
          "2c4512dc-f6f8-4d53-8720-e1a1638d2fb3": {
            awayTeamId: "b59106f0-dd86-4e9d-8dc9-fd074aece6ee",
            goalsAway: 2,
            goalsHome: 2,
            homeTeamId: "553160b8-3b85-400d-b295-4c3212c2014f",
            kickOffTime: "2019-11-03T15:00:00.000+01:00",
          },
          "3a4aaf3b-5ec4-4f2d-8940-baade79ad4a6": {
            awayTeamId: "6ab88ce9-af44-4299-9675-0b0598c8aba0",
            goalsAway: 1,
            goalsHome: 0,
            homeTeamId: "6d7b6c20-1bae-4439-8762-f52144812dc3",
            kickOffTime: "2019-11-04T20:45:00.000+01:00",
          },
          "44af3703-8552-4d16-aa5b-df26540397ea": {
            awayTeamId: "fd626290-dd26-4768-acae-1f3770304ff6",
            goalsAway: 1,
            goalsHome: 1,
            homeTeamId: "9bc4bbfc-5b00-40b6-9ba4-e398114ec130",
            kickOffTime: "2019-11-03T18:00:00.000+01:00",
          },
          "6197bed6-f8c6-43af-8fcc-3a5ab85db504": {
            awayTeamId: "17dc6c9a-4f3b-4ebc-b3a4-bcb6eda1a30a",
            goalsAway: 2,
            goalsHome: 1,
            homeTeamId: "1869c021-2191-49cf-b671-ea9ea08cd0fb",
            kickOffTime: "2019-11-03T20:45:00.000+01:00",
          },
          "b4c5f399-dadc-4a30-bb38-baa6b76190bd": {
            awayTeamId: "174e65e5-6d72-4f53-b4be-9d139715c89a",
            goalsAway: 2,
            goalsHome: 0,
            homeTeamId: "83ab7af4-0410-4670-9398-844a1c251336",
            kickOffTime: "2019-11-03T12:30:00.000+01:00",
          },
          "b4fdf234-fb88-4c5d-8493-a35a52a452b2": {
            awayTeamId: "8b3c665f-6738-4744-81a7-91dbce1c58f7",
            goalsAway: 1,
            goalsHome: 0,
            homeTeamId: "69007dc2-fb11-43ba-8b60-321960051e67",
            kickOffTime: "2019-11-02T20:45:00.000+01:00",
          },
          "c773e453-f8db-47d4-985f-e1e0c4314402": {
            awayTeamId: "4a7d7192-288d-4185-8d46-a337129c6e77",
            goalsAway: 1,
            goalsHome: 2,
            homeTeamId: "d1c1940c-2fae-4aab-81cd-7355bc2c9d85",
            kickOffTime: "2019-11-02T15:00:00.000+01:00",
          },
          "cb96c3a9-81a3-4a73-b3e4-cd65f946f1d7": {
            awayTeamId: "2e52cbda-e75d-4420-9406-35b48f4393d7",
            goalsAway: 3,
            goalsHome: 1,
            homeTeamId: "5afd6cb9-f14f-431a-a0c0-22e4d9424a8f",
            kickOffTime: "2019-11-03T15:00:00.000+01:00",
          },
          "e199c82c-1d0c-4b70-847b-ca767a73bfda": {
            awayTeamId: "3f45562f-f848-41e5-83ba-5f1a1e4e285f",
            goalsAway: 2,
            goalsHome: 1,
            homeTeamId: "ed4244af-01d2-4c79-92b9-2f77149615cd",
            kickOffTime: "2019-11-02T18:00:00.000+01:00",
          },
        },
        id: "89585e13-9afc-4a03-81ce-c18e8470f9b2",
        matchday: 11,
        startDate: "2019-11-02T15:00:00.000+01:00",
      },
      {
        endDate: "2019-11-10T22:45:00.000+01:00",
        fixtures: {
          "76cd0e64-9e9c-4012-a0c2-0ebf1c6e15d9": {
            awayTeamId: "6d7b6c20-1bae-4439-8762-f52144812dc3",
            goalsAway: 0,
            goalsHome: 0,
            homeTeamId: "2e52cbda-e75d-4420-9406-35b48f4393d7",
            kickOffTime: "2019-11-10T15:00:00.000+01:00",
          },
          "77139b62-9af9-4346-8679-34d8b1f8d036": {
            awayTeamId: "9bc4bbfc-5b00-40b6-9ba4-e398114ec130",
            goalsAway: 2,
            goalsHome: 5,
            homeTeamId: "174e65e5-6d72-4f53-b4be-9d139715c89a",
            kickOffTime: "2019-11-10T12:30:00.000+01:00",
          },
          "9cf5a1f5-66bb-407b-a20b-b560f559887d": {
            awayTeamId: "553160b8-3b85-400d-b295-4c3212c2014f",
            goalsAway: 2,
            goalsHome: 4,
            homeTeamId: "17dc6c9a-4f3b-4ebc-b3a4-bcb6eda1a30a",
            kickOffTime: "2019-11-10T15:00:00.000+01:00",
          },
          "a1a64d09-bafd-47eb-9560-575d6b009239": {
            awayTeamId: "ed4244af-01d2-4c79-92b9-2f77149615cd",
            goalsAway: 1,
            goalsHome: 3,
            homeTeamId: "b59106f0-dd86-4e9d-8dc9-fd074aece6ee",
            kickOffTime: "2019-11-08T20:45:00.000+01:00",
          },
          "b860b05b-56c1-48e0-827e-6bdd28f1faa5": {
            awayTeamId: "1869c021-2191-49cf-b671-ea9ea08cd0fb",
            goalsAway: 0,
            goalsHome: 1,
            homeTeamId: "8b3c665f-6738-4744-81a7-91dbce1c58f7",
            kickOffTime: "2019-11-10T20:45:00.000+01:00",
          },
          "c5d6144c-df4c-441d-9794-edf6857460d6": {
            awayTeamId: "619fbd53-4382-441f-a664-31c2dc5507b2",
            goalsAway: 1,
            goalsHome: 2,
            homeTeamId: "3f45562f-f848-41e5-83ba-5f1a1e4e285f",
            kickOffTime: "2019-11-09T18:00:00.000+01:00",
          },
          "d73dd22f-dbd8-4ed2-a6ed-0fd188a99dde": {
            awayTeamId: "5afd6cb9-f14f-431a-a0c0-22e4d9424a8f",
            goalsAway: 0,
            goalsHome: 0,
            homeTeamId: "4a7d7192-288d-4185-8d46-a337129c6e77",
            kickOffTime: "2019-11-09T20:45:00.000+01:00",
          },
          "e3fc2085-f482-4526-896a-53c66dcc0131": {
            awayTeamId: "83ab7af4-0410-4670-9398-844a1c251336",
            goalsAway: 0,
            goalsHome: 0,
            homeTeamId: "6ab88ce9-af44-4299-9675-0b0598c8aba0",
            kickOffTime: "2019-11-10T15:00:00.000+01:00",
          },
          "e9427686-2e39-408a-9a58-02261d851899": {
            awayTeamId: "69007dc2-fb11-43ba-8b60-321960051e67",
            goalsAway: 4,
            goalsHome: 0,
            homeTeamId: "52aa8f01-478f-4efc-be06-5472237d7fc9",
            kickOffTime: "2019-11-09T15:00:00.000+01:00",
          },
          "f392bfda-dfc6-4e60-a24f-c6456d06ada7": {
            awayTeamId: "d1c1940c-2fae-4aab-81cd-7355bc2c9d85",
            goalsAway: 0,
            goalsHome: 2,
            homeTeamId: "fd626290-dd26-4768-acae-1f3770304ff6",
            kickOffTime: "2019-11-10T18:00:00.000+01:00",
          },
        },
        id: "9f4e33a5-20d3-4d64-8704-dbcf2b14cf9d",
        matchday: 12,
        startDate: "2019-11-08T20:45:00.000+01:00",
      },
      {
        endDate: "2019-11-25T22:45:00.000+01:00",
        fixtures: {
          "3678dcb9-3ebf-4a58-aa2b-b32ef1d2a79d": {
            awayTeamId: "174e65e5-6d72-4f53-b4be-9d139715c89a",
            goalsAway: 2,
            goalsHome: 2,
            homeTeamId: "553160b8-3b85-400d-b295-4c3212c2014f",
            kickOffTime: "2019-11-25T15:00:00.000+01:00",
          },
          "3b180122-9b0a-4aaa-86fa-186b4ea379e8": {
            awayTeamId: "52aa8f01-478f-4efc-be06-5472237d7fc9",
            goalsAway: 0,
            goalsHome: 3,
            homeTeamId: "d1c1940c-2fae-4aab-81cd-7355bc2c9d85",
            kickOffTime: "2019-11-24T15:00:00.000+01:00",
          },
          "3c44df65-7b44-42f1-a0bc-20a6d023668a": {
            awayTeamId: "8b3c665f-6738-4744-81a7-91dbce1c58f7",
            goalsAway: 3,
            goalsHome: 1,
            homeTeamId: "83ab7af4-0410-4670-9398-844a1c251336",
            kickOffTime: "2019-11-23T15:00:00.000+01:00",
          },
          "3edecb05-99ad-48fa-bf32-30b5bc4b443a": {
            awayTeamId: "4a7d7192-288d-4185-8d46-a337129c6e77",
            goalsAway: 1,
            goalsHome: 1,
            homeTeamId: "1869c021-2191-49cf-b671-ea9ea08cd0fb",
            kickOffTime: "2019-11-23T18:00:00.000+01:00",
          },
          "5cb7e599-ae4c-4057-9bbe-e6fb10d0257b": {
            awayTeamId: "3f45562f-f848-41e5-83ba-5f1a1e4e285f",
            goalsAway: 3,
            goalsHome: 0,
            homeTeamId: "69007dc2-fb11-43ba-8b60-321960051e67",
            kickOffTime: "2019-11-23T20:45:00.000+01:00",
          },
          "7edd5867-a6ff-4b30-bbab-045d3fc9311b": {
            awayTeamId: "9bc4bbfc-5b00-40b6-9ba4-e398114ec130",
            goalsAway: 0,
            goalsHome: 1,
            homeTeamId: "619fbd53-4382-441f-a664-31c2dc5507b2",
            kickOffTime: "2019-11-24T15:00:00.000+01:00",
          },
          "874ff7f9-dae0-4780-bd53-e70ff8f23e0d": {
            awayTeamId: "5afd6cb9-f14f-431a-a0c0-22e4d9424a8f",
            goalsAway: 1,
            goalsHome: 1,
            homeTeamId: "6d7b6c20-1bae-4439-8762-f52144812dc3",
            kickOffTime: "2019-11-25T20:45:00.000+01:00",
          },
          "bdb9bb26-ef0d-4aaa-9da3-836f697a0598": {
            awayTeamId: "17dc6c9a-4f3b-4ebc-b3a4-bcb6eda1a30a",
            goalsAway: 2,
            goalsHome: 1,
            homeTeamId: "b59106f0-dd86-4e9d-8dc9-fd074aece6ee",
            kickOffTime: "2019-11-24T15:00:00.000+01:00",
          },
          "d3e10dee-3f06-44f3-bd33-7c882c785479": {
            awayTeamId: "2e52cbda-e75d-4420-9406-35b48f4393d7",
            goalsAway: 1,
            goalsHome: 2,
            homeTeamId: "6ab88ce9-af44-4299-9675-0b0598c8aba0",
            kickOffTime: "2019-11-24T18:00:00.000+01:00",
          },
          "d69dea31-9aed-4ff3-9be6-d99ad6d89d7c": {
            awayTeamId: "fd626290-dd26-4768-acae-1f3770304ff6",
            goalsAway: 2,
            goalsHome: 2,
            homeTeamId: "ed4244af-01d2-4c79-92b9-2f77149615cd",
            kickOffTime: "2019-11-24T12:30:00.000+01:00",
          },
        },
        id: "419acad8-2667-4cf7-9f4b-c24b578dcdfd",
        matchday: 13,
        startDate: "2019-11-23T15:00:00.000+01:00",
      },
      {
        endDate: "2019-12-02T22:45:00.000+01:00",
        fixtures: {
          "3968d544-4a42-44d3-9172-9afd3e4cad08": {
            awayTeamId: "b59106f0-dd86-4e9d-8dc9-fd074aece6ee",
            goalsAway: 2,
            goalsHome: 2,
            homeTeamId: "8b3c665f-6738-4744-81a7-91dbce1c58f7",
            kickOffTime: "2019-12-01T12:30:00.000+01:00",
          },
          "40bb2f68-91d6-4f3d-8f7a-fe86b0ca3f30": {
            awayTeamId: "6d7b6c20-1bae-4439-8762-f52144812dc3",
            goalsAway: 1,
            goalsHome: 2,
            homeTeamId: "3f45562f-f848-41e5-83ba-5f1a1e4e285f",
            kickOffTime: "2019-12-01T15:00:00.000+01:00",
          },
          "4195b128-0058-4326-a97f-b7750ec4eea2": {
            awayTeamId: "d1c1940c-2fae-4aab-81cd-7355bc2c9d85",
            goalsAway: 3,
            goalsHome: 1,
            homeTeamId: "619fbd53-4382-441f-a664-31c2dc5507b2",
            kickOffTime: "2019-12-01T20:45:00.000+01:00",
          },
          "68ffcd65-3776-4f9c-996f-f9d592d5fcd0": {
            awayTeamId: "6ab88ce9-af44-4299-9675-0b0598c8aba0",
            goalsAway: 3,
            goalsHome: 4,
            homeTeamId: "174e65e5-6d72-4f53-b4be-9d139715c89a",
            kickOffTime: "2019-12-02T20:45:00.000+01:00",
          },
          "94ce8d0d-aa97-4367-b251-9ccc544c500e": {
            awayTeamId: "553160b8-3b85-400d-b295-4c3212c2014f",
            goalsAway: 1,
            goalsHome: 0,
            homeTeamId: "9bc4bbfc-5b00-40b6-9ba4-e398114ec130",
            kickOffTime: "2019-11-30T20:45:00.000+01:00",
          },
          "9b468830-27d2-4204-bbff-3d52da264e40": {
            awayTeamId: "2e52cbda-e75d-4420-9406-35b48f4393d7",
            goalsAway: 0,
            goalsHome: 3,
            homeTeamId: "17dc6c9a-4f3b-4ebc-b3a4-bcb6eda1a30a",
            kickOffTime: "2019-12-01T15:00:00.000+01:00",
          },
          "a1b34baf-756d-48ef-962a-ec14f2281e80": {
            awayTeamId: "69007dc2-fb11-43ba-8b60-321960051e67",
            goalsAway: 1,
            goalsHome: 0,
            homeTeamId: "5afd6cb9-f14f-431a-a0c0-22e4d9424a8f",
            kickOffTime: "2019-11-30T18:00:00.000+01:00",
          },
          "cebffa86-1c46-4277-8ecf-5cbe3a38697e": {
            awayTeamId: "1869c021-2191-49cf-b671-ea9ea08cd0fb",
            goalsAway: 1,
            goalsHome: 0,
            homeTeamId: "fd626290-dd26-4768-acae-1f3770304ff6",
            kickOffTime: "2019-12-01T15:00:00.000+01:00",
          },
          "e17cb405-b578-4bf8-bdad-a0f030974c4b": {
            awayTeamId: "ed4244af-01d2-4c79-92b9-2f77149615cd",
            goalsAway: 2,
            goalsHome: 1,
            homeTeamId: "4a7d7192-288d-4185-8d46-a337129c6e77",
            kickOffTime: "2019-12-01T18:00:00.000+01:00",
          },
          "e854abd8-e829-4c2f-8ba0-5a0578ae7d18": {
            awayTeamId: "83ab7af4-0410-4670-9398-844a1c251336",
            goalsAway: 3,
            goalsHome: 0,
            homeTeamId: "52aa8f01-478f-4efc-be06-5472237d7fc9",
            kickOffTime: "2019-11-30T15:00:00.000+01:00",
          },
        },
        id: "d82aa06b-66ac-4d85-b002-aa4d2084cec6",
        matchday: 14,
        startDate: "2019-11-30T15:00:00.000+01:00",
      },
      {
        endDate: "2019-12-08T22:45:00.000+01:00",
        fixtures: {
          "441323cd-091d-4d88-ac28-2b1656d39c95": {
            awayTeamId: "4a7d7192-288d-4185-8d46-a337129c6e77",
            goalsAway: 1,
            goalsHome: 1,
            homeTeamId: "2e52cbda-e75d-4420-9406-35b48f4393d7",
            kickOffTime: "2019-12-07T18:00:00.000+01:00",
          },
          "803bcfcd-a8af-467b-99ca-a5fe10d918bf": {
            awayTeamId: "d1c1940c-2fae-4aab-81cd-7355bc2c9d85",
            goalsAway: 0,
            goalsHome: 0,
            homeTeamId: "3f45562f-f848-41e5-83ba-5f1a1e4e285f",
            kickOffTime: "2019-12-06T20:45:00.000+01:00",
          },
          "a752a497-4eb5-412f-b9de-2015403f632d": {
            awayTeamId: "619fbd53-4382-441f-a664-31c2dc5507b2",
            goalsAway: 2,
            goalsHome: 3,
            homeTeamId: "83ab7af4-0410-4670-9398-844a1c251336",
            kickOffTime: "2019-12-07T15:00:00.000+01:00",
          },
          "b886fb3e-6183-4a9d-972a-a659e6935363": {
            awayTeamId: "5afd6cb9-f14f-431a-a0c0-22e4d9424a8f",
            goalsAway: 2,
            goalsHome: 2,
            homeTeamId: "553160b8-3b85-400d-b295-4c3212c2014f",
            kickOffTime: "2019-12-08T12:30:00.000+01:00",
          },
          "d07f050a-e12b-4518-a903-dab4cd655541": {
            awayTeamId: "52aa8f01-478f-4efc-be06-5472237d7fc9",
            goalsAway: 1,
            goalsHome: 0,
            homeTeamId: "6d7b6c20-1bae-4439-8762-f52144812dc3",
            kickOffTime: "2019-12-08T15:00:00.000+01:00",
          },
          "e4f2351d-3585-4a7c-81ec-2254c3060730": {
            awayTeamId: "fd626290-dd26-4768-acae-1f3770304ff6",
            goalsAway: 1,
            goalsHome: 0,
            homeTeamId: "6ab88ce9-af44-4299-9675-0b0598c8aba0",
            kickOffTime: "2019-12-08T18:00:00.000+01:00",
          },
          "f03a49b1-e688-4e6e-8826-8d375f071bff": {
            awayTeamId: "9bc4bbfc-5b00-40b6-9ba4-e398114ec130",
            goalsAway: 1,
            goalsHome: 2,
            homeTeamId: "69007dc2-fb11-43ba-8b60-321960051e67",
            kickOffTime: "2019-12-08T15:00:00.000+01:00",
          },
          "f3500110-96e4-4600-bdfd-ecd81b52250a": {
            awayTeamId: "1869c021-2191-49cf-b671-ea9ea08cd0fb",
            goalsAway: 3,
            goalsHome: 2,
            homeTeamId: "ed4244af-01d2-4c79-92b9-2f77149615cd",
            kickOffTime: "2019-12-08T20:45:00.000+01:00",
          },
          "f3a24818-b488-4a9c-b7e1-070b4d80b98e": {
            awayTeamId: "8b3c665f-6738-4744-81a7-91dbce1c58f7",
            goalsAway: 1,
            goalsHome: 3,
            homeTeamId: "17dc6c9a-4f3b-4ebc-b3a4-bcb6eda1a30a",
            kickOffTime: "2019-12-07T20:45:00.000+01:00",
          },
          "fcd2bfd0-654d-4e04-bc4e-4f5d880f4549": {
            awayTeamId: "174e65e5-6d72-4f53-b4be-9d139715c89a",
            goalsAway: 2,
            goalsHome: 2,
            homeTeamId: "b59106f0-dd86-4e9d-8dc9-fd074aece6ee",
            kickOffTime: "2019-12-08T15:00:00.000+01:00",
          },
        },
        id: "58852c5c-66e8-41fa-be2f-eab31cd21a4a",
        matchday: 15,
        startDate: "2019-12-06T20:45:00.000+01:00",
      },
      {
        endDate: "",
        fixtures: {
          "1529cbfa-5106-4615-b2ba-b4e4fa57437f": {
            awayTeamId: "3f45562f-f848-41e5-83ba-5f1a1e4e285f",
            goalsAway: 1,
            goalsHome: 1,
            homeTeamId: "9bc4bbfc-5b00-40b6-9ba4-e398114ec130",
            id: "1529cbfa-5106-4615-b2ba-b4e4fa57437f",
            kickOffTime: "2019-12-15T20:45:52.875Z",
          },
          "33bd2087-6c4a-4549-82c6-3782432c80c1": {
            awayTeamId: "fd626290-dd26-4768-acae-1f3770304ff6",
            goalsAway: 2,
            goalsHome: 1,
            homeTeamId: "4a7d7192-288d-4185-8d46-a337129c6e77",
            id: "33bd2087-6c4a-4549-82c6-3782432c80c1",
            kickOffTime: "2019-12-14T18:30:24.870Z",
          },
          "4668e56c-8dee-435e-a412-0375754130b0": {
            awayTeamId: "17dc6c9a-4f3b-4ebc-b3a4-bcb6eda1a30a",
            goalsAway: 2,
            goalsHome: 1,
            homeTeamId: "174e65e5-6d72-4f53-b4be-9d139715c89a",
            id: "4668e56c-8dee-435e-a412-0375754130b0",
            kickOffTime: "2019-12-16T20:45:48.235+01:00",
          },
          "51bfd55b-76b3-4941-ab41-7dab393b7324": {
            awayTeamId: "b59106f0-dd86-4e9d-8dc9-fd074aece6ee",
            goalsAway: 0,
            goalsHome: 0,
            homeTeamId: "1869c021-2191-49cf-b671-ea9ea08cd0fb",
            id: "51bfd55b-76b3-4941-ab41-7dab393b7324",
            kickOffTime: "2019-12-15T15:00:52.874Z",
          },
          "59bcae24-f761-4100-9bf1-d1eadd8d28d1": {
            awayTeamId: "69007dc2-fb11-43ba-8b60-321960051e67",
            goalsAway: 3,
            goalsHome: 3,
            homeTeamId: "619fbd53-4382-441f-a664-31c2dc5507b2",
            id: "59bcae24-f761-4100-9bf1-d1eadd8d28d1",
            kickOffTime: "2019-12-15T12:30:52.873Z",
          },
          "7e8f6ac9-a7c9-4487-8a08-162267ac13d6": {
            awayTeamId: "553160b8-3b85-400d-b295-4c3212c2014f",
            goalsAway: 0,
            goalsHome: 3,
            homeTeamId: "52aa8f01-478f-4efc-be06-5472237d7fc9",
            id: "7e8f6ac9-a7c9-4487-8a08-162267ac13d6",
            kickOffTime: "2019-12-14T15:00:24.869Z",
          },
          "84a510e8-e74b-4f24-86c8-c847c78e09da": {
            awayTeamId: "2e52cbda-e75d-4420-9406-35b48f4393d7",
            goalsAway: 1,
            goalsHome: 3,
            homeTeamId: "8b3c665f-6738-4744-81a7-91dbce1c58f7",
            id: "84a510e8-e74b-4f24-86c8-c847c78e09da",
            kickOffTime: "2019-12-15T15:00:52.874Z",
          },
          "c32dbd0d-85de-4503-8d98-6f1ce8323fd9": {
            awayTeamId: "83ab7af4-0410-4670-9398-844a1c251336",
            goalsAway: 1,
            goalsHome: 2,
            homeTeamId: "ed4244af-01d2-4c79-92b9-2f77149615cd",
            id: "c32dbd0d-85de-4503-8d98-6f1ce8323fd9",
            kickOffTime: "2019-12-15T15:00:52.873Z",
          },
          "ec6be984-0831-473f-9af8-82bea55e1130": {
            awayTeamId: "6ab88ce9-af44-4299-9675-0b0598c8aba0",
            goalsAway: 1,
            goalsHome: 0,
            homeTeamId: "5afd6cb9-f14f-431a-a0c0-22e4d9424a8f",
            id: "ec6be984-0831-473f-9af8-82bea55e1130",
            kickOffTime: "2019-12-14T20:45:24.871Z",
          },
          "f60c8703-22a5-4efd-ae30-7aa3210d0cf1": {
            awayTeamId: "6d7b6c20-1bae-4439-8762-f52144812dc3",
            goalsAway: 1,
            goalsHome: 3,
            homeTeamId: "d1c1940c-2fae-4aab-81cd-7355bc2c9d85",
            id: "f60c8703-22a5-4efd-ae30-7aa3210d0cf1",
            kickOffTime: "2019-12-15T18:00:52.875Z",
          },
        },
        id: "256a1534-b107-4430-bbca-a1ee7bd90d5e",
        matchday: 16,
        startDate: "",
      },
      {
        endDate: "",
        fixtures: {
          "04eae8c4-8dfc-4c3b-8e84-0e1e5f63b809": {
            awayTeamId: "5afd6cb9-f14f-431a-a0c0-22e4d9424a8f",
            goalsAway: 0,
            goalsHome: 4,
            homeTeamId: "3f45562f-f848-41e5-83ba-5f1a1e4e285f",
            kickOffTime: "2019-12-21T18:00:00.000+01:00",
          },
          "0d35e4cc-133c-46da-ba75-e086965180ed": {
            awayTeamId: "1869c021-2191-49cf-b671-ea9ea08cd0fb",
            goalsAway: 0,
            goalsHome: 5,
            homeTeamId: "83ab7af4-0410-4670-9398-844a1c251336",
            kickOffTime: "2019-12-22T12:30:00.000+01:00",
          },
          "2305f246-f94f-4385-9b56-033b83304425": {
            awayTeamId: "174e65e5-6d72-4f53-b4be-9d139715c89a",
            goalsAway: 1,
            goalsHome: 2,
            homeTeamId: "2e52cbda-e75d-4420-9406-35b48f4393d7",
            kickOffTime: "2019-12-21T15:00:00.000+01:00",
          },
          "28798b98-0fc2-4508-b976-574d0483a635": {
            awayTeamId: "ed4244af-01d2-4c79-92b9-2f77149615cd",
            goalsAway: 3,
            goalsHome: 2,
            homeTeamId: "553160b8-3b85-400d-b295-4c3212c2014f",
            kickOffTime: "2019-12-22T15:00:00.000+01:00",
          },
          "38447978-c583-48da-ad61-baa24f769bd5": {
            awayTeamId: "6d7b6c20-1bae-4439-8762-f52144812dc3",
            goalsAway: 2,
            goalsHome: 1,
            homeTeamId: "69007dc2-fb11-43ba-8b60-321960051e67",
            kickOffTime: "2019-12-21T20:45:00.000+01:00",
          },
          "5987d799-b426-45ec-b6a6-5cf9fb2aff43": {
            awayTeamId: "52aa8f01-478f-4efc-be06-5472237d7fc9",
            goalsAway: 1,
            goalsHome: 1,
            homeTeamId: "fd626290-dd26-4768-acae-1f3770304ff6",
            kickOffTime: "2019-12-22T15:00:00.000+01:00",
          },
          "893a431e-d14f-43f6-a76c-d42bbe45547f": {
            awayTeamId: "8b3c665f-6738-4744-81a7-91dbce1c58f7",
            goalsAway: 2,
            goalsHome: 1,
            homeTeamId: "6ab88ce9-af44-4299-9675-0b0598c8aba0",
            kickOffTime: "2019-12-18T18:55:00.000+01:00",
          },
          "9716ad1d-2fc1-47f7-98d2-135f82a62ff8": {
            awayTeamId: "619fbd53-4382-441f-a664-31c2dc5507b2",
            goalsAway: 0,
            goalsHome: 0,
            homeTeamId: "17dc6c9a-4f3b-4ebc-b3a4-bcb6eda1a30a",
            id: "9716ad1d-2fc1-47f7-98d2-135f82a62ff8",
            kickOffTime: "2020-02-05T19:45:51.413Z",
          },
          "99fb4487-6b77-4c96-8f71-11a7e6cd6f03": {
            awayTeamId: "d1c1940c-2fae-4aab-81cd-7355bc2c9d85",
            goalsAway: 4,
            goalsHome: 1,
            homeTeamId: "9bc4bbfc-5b00-40b6-9ba4-e398114ec130",
            kickOffTime: "2019-12-20T20:45:00.000+01:00",
          },
          "e47c1b77-0271-4b08-9a3e-3dd0acce72f8": {
            awayTeamId: "4a7d7192-288d-4185-8d46-a337129c6e77",
            goalsAway: 2,
            goalsHome: 1,
            homeTeamId: "b59106f0-dd86-4e9d-8dc9-fd074aece6ee",
            kickOffTime: "2019-12-22T20:45:00.000+01:00",
          },
        },
        id: "2acb0175-7ef5-4826-bd94-cd483c3a867d",
        matchday: 17,
        startDate: "",
      },
      {
        endDate: "",
        fixtures: {
          "2d371461-bdc4-43f6-a9e5-6dbfb55fae2f": {
            awayTeamId: "fd626290-dd26-4768-acae-1f3770304ff6",
            goalsAway: 0,
            goalsHome: 5,
            homeTeamId: "83ab7af4-0410-4670-9398-844a1c251336",
            id: "2d371461-bdc4-43f6-a9e5-6dbfb55fae2f",
            kickOffTime: "2020-01-06T14:01:01.846Z",
          },
          "3daa4e42-12bc-480e-a963-851a59942a89": {
            awayTeamId: "2e52cbda-e75d-4420-9406-35b48f4393d7",
            goalsAway: 1,
            goalsHome: 0,
            homeTeamId: "553160b8-3b85-400d-b295-4c3212c2014f",
            id: "3daa4e42-12bc-480e-a963-851a59942a89",
            kickOffTime: "2020-01-06T17:01:01.666Z",
          },
          "43258708-02f6-4d9f-af6a-98582d96fc9f": {
            awayTeamId: "6ab88ce9-af44-4299-9675-0b0598c8aba0",
            goalsAway: 0,
            goalsHome: 0,
            homeTeamId: "1869c021-2191-49cf-b671-ea9ea08cd0fb",
            id: "43258708-02f6-4d9f-af6a-98582d96fc9f",
            kickOffTime: "2020-01-06T14:01:01.846Z",
          },
          "92cf5ae9-552b-4152-82a3-0b50c10ea0dd": {
            awayTeamId: "3f45562f-f848-41e5-83ba-5f1a1e4e285f",
            goalsAway: 3,
            goalsHome: 1,
            homeTeamId: "4a7d7192-288d-4185-8d46-a337129c6e77",
            id: "92cf5ae9-552b-4152-82a3-0b50c10ea0dd",
            kickOffTime: "2020-01-06T19:45:51.947Z",
          },
          "a38aa464-929d-4fcb-9ea7-04074418ca68": {
            awayTeamId: "69007dc2-fb11-43ba-8b60-321960051e67",
            goalsAway: 2,
            goalsHome: 0,
            homeTeamId: "d1c1940c-2fae-4aab-81cd-7355bc2c9d85",
            id: "a38aa464-929d-4fcb-9ea7-04074418ca68",
            kickOffTime: "2020-01-05T20:01:03.707Z",
          },
          "ae40c6be-6079-48d2-b446-d277d6712edc": {
            awayTeamId: "619fbd53-4382-441f-a664-31c2dc5507b2",
            goalsAway: 2,
            goalsHome: 0,
            homeTeamId: "6d7b6c20-1bae-4439-8762-f52144812dc3",
            id: "ae40c6be-6079-48d2-b446-d277d6712edc",
            kickOffTime: "2020-01-05T14:01:02.854Z",
          },
          "c51ffa35-6f17-4f32-a6c9-1276a98800d4": {
            awayTeamId: "9bc4bbfc-5b00-40b6-9ba4-e398114ec130",
            goalsAway: 1,
            goalsHome: 1,
            homeTeamId: "ed4244af-01d2-4c79-92b9-2f77149615cd",
            id: "c51ffa35-6f17-4f32-a6c9-1276a98800d4",
            kickOffTime: "2020-01-06T11:30:59.248Z",
          },
          "dad1d67b-1260-40ee-bf8a-4d1f5a40d842": {
            awayTeamId: "17dc6c9a-4f3b-4ebc-b3a4-bcb6eda1a30a",
            goalsAway: 2,
            goalsHome: 1,
            homeTeamId: "52aa8f01-478f-4efc-be06-5472237d7fc9",
            id: "dad1d67b-1260-40ee-bf8a-4d1f5a40d842",
            kickOffTime: "2020-01-05T11:31:01.236Z",
          },
          "eaa6e0fe-29cd-4dd6-9ac8-2262793ad7b5": {
            awayTeamId: "b59106f0-dd86-4e9d-8dc9-fd074aece6ee",
            goalsAway: 1,
            goalsHome: 2,
            homeTeamId: "5afd6cb9-f14f-431a-a0c0-22e4d9424a8f",
            id: "eaa6e0fe-29cd-4dd6-9ac8-2262793ad7b5",
            kickOffTime: "2020-01-05T17:15:55.456Z",
          },
          "f6b1a01f-aec1-42b6-adcb-852f1b3b816f": {
            awayTeamId: "174e65e5-6d72-4f53-b4be-9d139715c89a",
            goalsAway: 0,
            goalsHome: 4,
            homeTeamId: "8b3c665f-6738-4744-81a7-91dbce1c58f7",
            id: "f6b1a01f-aec1-42b6-adcb-852f1b3b816f",
            kickOffTime: "2020-01-06T14:01:01.846Z",
          },
        },
        id: "51fc4fe2-9d2f-4374-b380-bb464b887703",
        matchday: 18,
        startDate: "",
      },
      {
        endDate: "",
        fixtures: {
          "05279146-e0f1-4cc8-82e5-7de220428215": {
            awayTeamId: "553160b8-3b85-400d-b295-4c3212c2014f",
            goalsAway: 0,
            goalsHome: 2,
            homeTeamId: "fd626290-dd26-4768-acae-1f3770304ff6",
            id: "05279146-e0f1-4cc8-82e5-7de220428215",
            kickOffTime: "2020-01-13T19:45:51.144Z",
          },
          "2f7aa9a6-2c3c-41ff-8297-bc52ad011797": {
            awayTeamId: "83ab7af4-0410-4670-9398-844a1c251336",
            goalsAway: 1,
            goalsHome: 1,
            homeTeamId: "3f45562f-f848-41e5-83ba-5f1a1e4e285f",
            id: "2f7aa9a6-2c3c-41ff-8297-bc52ad011797",
            kickOffTime: "2020-01-11T19:46:00.378Z",
          },
          "32390784-e4a9-47c2-8cc5-6e28e3dbedc5": {
            awayTeamId: "5afd6cb9-f14f-431a-a0c0-22e4d9424a8f",
            goalsAway: 1,
            goalsHome: 2,
            homeTeamId: "619fbd53-4382-441f-a664-31c2dc5507b2",
            id: "32390784-e4a9-47c2-8cc5-6e28e3dbedc5",
            kickOffTime: "2020-01-12T17:15:55.376Z",
          },
          "335e261c-9a11-4d5f-97e1-09184d29ea47": {
            awayTeamId: "1869c021-2191-49cf-b671-ea9ea08cd0fb",
            goalsAway: 2,
            goalsHome: 0,
            homeTeamId: "174e65e5-6d72-4f53-b4be-9d139715c89a",
            id: "335e261c-9a11-4d5f-97e1-09184d29ea47",
            kickOffTime: "2020-01-11T14:01:03.792Z",
          },
          "7144605e-2f5f-428c-8dbc-fe94168a2806": {
            awayTeamId: "6d7b6c20-1bae-4439-8762-f52144812dc3",
            goalsAway: 0,
            goalsHome: 1,
            homeTeamId: "9bc4bbfc-5b00-40b6-9ba4-e398114ec130",
            id: "7144605e-2f5f-428c-8dbc-fe94168a2806",
            kickOffTime: "2020-01-12T14:01:01.872Z",
          },
          "838848ef-da74-4b49-b9b0-3dcca76cc381": {
            awayTeamId: "52aa8f01-478f-4efc-be06-5472237d7fc9",
            goalsAway: 1,
            goalsHome: 5,
            homeTeamId: "6ab88ce9-af44-4299-9675-0b0598c8aba0",
            id: "838848ef-da74-4b49-b9b0-3dcca76cc381",
            kickOffTime: "2020-01-12T14:01:01.872Z",
          },
          "9df24684-3ea6-4cdf-97ad-02eab286b01a": {
            awayTeamId: "b59106f0-dd86-4e9d-8dc9-fd074aece6ee",
            goalsAway: 0,
            goalsHome: 3,
            homeTeamId: "2e52cbda-e75d-4420-9406-35b48f4393d7",
            id: "9df24684-3ea6-4cdf-97ad-02eab286b01a",
            kickOffTime: "2020-01-12T12:30:59.283Z",
          },
          "a214bd28-a7c8-47a9-9a59-6562839ee818": {
            awayTeamId: "ed4244af-01d2-4c79-92b9-2f77149615cd",
            goalsAway: 0,
            goalsHome: 1,
            homeTeamId: "69007dc2-fb11-43ba-8b60-321960051e67",
            id: "a214bd28-a7c8-47a9-9a59-6562839ee818",
            kickOffTime: "2020-01-12T14:01:01.872Z",
          },
          "a6e4292d-3ff0-44f5-a9fc-e6961556335f": {
            awayTeamId: "4a7d7192-288d-4185-8d46-a337129c6e77",
            goalsAway: 0,
            goalsHome: 1,
            homeTeamId: "17dc6c9a-4f3b-4ebc-b3a4-bcb6eda1a30a",
            id: "a6e4292d-3ff0-44f5-a9fc-e6961556335f",
            kickOffTime: "2020-01-11T17:01:10.983Z",
          },
          "ba791306-0839-40ec-8c45-81f0f6bbfa4c": {
            awayTeamId: "8b3c665f-6738-4744-81a7-91dbce1c58f7",
            goalsAway: 2,
            goalsHome: 1,
            homeTeamId: "d1c1940c-2fae-4aab-81cd-7355bc2c9d85",
            id: "ba791306-0839-40ec-8c45-81f0f6bbfa4c",
            kickOffTime: "2020-01-12T19:46:03.973Z",
          },
        },
        id: "a2a2bcd6-6782-4cd2-b3ab-061d4c571c70",
        matchday: 19,
        startDate: "",
      },
      {
        endDate: "",
        fixtures: {
          "37ccac05-512b-4183-8324-4ef6365be021": {
            awayTeamId: "69007dc2-fb11-43ba-8b60-321960051e67",
            goalsAway: 1,
            goalsHome: 2,
            homeTeamId: "b59106f0-dd86-4e9d-8dc9-fd074aece6ee",
            id: "37ccac05-512b-4183-8324-4ef6365be021",
            kickOffTime: "2020-01-18T17:16:01.350Z",
          },
          "7ca7eaeb-6e24-4648-a170-1a8d97bb205c": {
            awayTeamId: "d1c1940c-2fae-4aab-81cd-7355bc2c9d85",
            goalsAway: 3,
            goalsHome: 1,
            homeTeamId: "5afd6cb9-f14f-431a-a0c0-22e4d9424a8f",
            id: "7ca7eaeb-6e24-4648-a170-1a8d97bb205c",
            kickOffTime: "2020-01-19T17:01:12.058Z",
          },
          "7d25c505-d24d-43ca-9ce2-eefa5a49f1d3": {
            awayTeamId: "3f45562f-f848-41e5-83ba-5f1a1e4e285f",
            goalsAway: 1,
            goalsHome: 1,
            homeTeamId: "553160b8-3b85-400d-b295-4c3212c2014f",
            id: "7d25c505-d24d-43ca-9ce2-eefa5a49f1d3",
            kickOffTime: "2020-01-19T14:01:02.647Z",
          },
          "ae5cdf79-d9ae-474c-8a90-383cf9dfc893": {
            awayTeamId: "6d7b6c20-1bae-4439-8762-f52144812dc3",
            goalsAway: 2,
            goalsHome: 1,
            homeTeamId: "83ab7af4-0410-4670-9398-844a1c251336",
            id: "ae5cdf79-d9ae-474c-8a90-383cf9dfc893",
            kickOffTime: "2020-01-20T19:45:53.811Z",
          },
          "b14626ee-efd1-4b22-83eb-6f15a389e5bf": {
            awayTeamId: "2e52cbda-e75d-4420-9406-35b48f4393d7",
            goalsAway: 2,
            goalsHome: 3,
            homeTeamId: "1869c021-2191-49cf-b671-ea9ea08cd0fb",
            id: "b14626ee-efd1-4b22-83eb-6f15a389e5bf",
            kickOffTime: "2020-01-19T11:31:02.737Z",
          },
          "ca5edc68-3ab7-4ef8-ad3f-95fe07ce4873": {
            awayTeamId: "9bc4bbfc-5b00-40b6-9ba4-e398114ec130",
            goalsAway: 2,
            goalsHome: 0,
            homeTeamId: "4a7d7192-288d-4185-8d46-a337129c6e77",
            id: "ca5edc68-3ab7-4ef8-ad3f-95fe07ce4873",
            kickOffTime: "2020-01-18T19:46:00.640Z",
          },
          "cb19e80e-7d61-4c49-808e-f4f76e83d174": {
            awayTeamId: "6ab88ce9-af44-4299-9675-0b0598c8aba0",
            goalsAway: 1,
            goalsHome: 5,
            homeTeamId: "17dc6c9a-4f3b-4ebc-b3a4-bcb6eda1a30a",
            id: "cb19e80e-7d61-4c49-808e-f4f76e83d174",
            kickOffTime: "2020-01-18T14:01:06.339Z",
          },
          "ddfabde4-daf8-4444-9be4-c178d2d1265d": {
            awayTeamId: "619fbd53-4382-441f-a664-31c2dc5507b2",
            goalsAway: 1,
            goalsHome: 1,
            homeTeamId: "ed4244af-01d2-4c79-92b9-2f77149615cd",
            id: "ddfabde4-daf8-4444-9be4-c178d2d1265d",
            kickOffTime: "2020-01-19T14:01:02.647Z",
          },
          "dfb611f7-d33c-40fc-8628-ab4377d80085": {
            awayTeamId: "fd626290-dd26-4768-acae-1f3770304ff6",
            goalsAway: 1,
            goalsHome: 2,
            homeTeamId: "8b3c665f-6738-4744-81a7-91dbce1c58f7",
            id: "dfb611f7-d33c-40fc-8628-ab4377d80085",
            kickOffTime: "2020-01-19T19:46:00.536Z",
          },
          "fe7cb2ae-ade0-4d60-8d54-929f98c780f4": {
            awayTeamId: "174e65e5-6d72-4f53-b4be-9d139715c89a",
            goalsAway: 2,
            goalsHome: 2,
            homeTeamId: "52aa8f01-478f-4efc-be06-5472237d7fc9",
            id: "fe7cb2ae-ade0-4d60-8d54-929f98c780f4",
            kickOffTime: "2020-01-19T14:01:02.647Z",
          },
        },
        id: "edbd0669-f684-4627-82c9-08558c2f36df",
        matchday: 20,
        startDate: "",
      },
      {
        endDate: "",
        fixtures: {
          "19f0e3c4-7016-4cb2-bc89-4b594cb100a5": {
            awayTeamId: "17dc6c9a-4f3b-4ebc-b3a4-bcb6eda1a30a",
            goalsAway: 1,
            goalsHome: 1,
            homeTeamId: "d1c1940c-2fae-4aab-81cd-7355bc2c9d85",
            id: "19f0e3c4-7016-4cb2-bc89-4b594cb100a5",
            kickOffTime: "2020-01-26T17:01:01.384Z",
          },
          "2148d956-88f3-4e81-9bbf-90b7fda77ec2": {
            awayTeamId: "2e52cbda-e75d-4420-9406-35b48f4393d7",
            goalsAway: 0,
            goalsHome: 2,
            homeTeamId: "fd626290-dd26-4768-acae-1f3770304ff6",
            id: "2148d956-88f3-4e81-9bbf-90b7fda77ec2",
            kickOffTime: "2020-01-26T14:01:03.116Z",
          },
          "30c039fe-ef24-4b3b-86b6-9ae81fe4e682": {
            awayTeamId: "1869c021-2191-49cf-b671-ea9ea08cd0fb",
            goalsAway: 1,
            goalsHome: 0,
            homeTeamId: "52aa8f01-478f-4efc-be06-5472237d7fc9",
            id: "30c039fe-ef24-4b3b-86b6-9ae81fe4e682",
            kickOffTime: "2020-01-24T19:45:56.250Z",
          },
          "31537249-0c84-4551-a79f-bef2611a592e": {
            awayTeamId: "83ab7af4-0410-4670-9398-844a1c251336",
            goalsAway: 7,
            goalsHome: 0,
            homeTeamId: "69007dc2-fb11-43ba-8b60-321960051e67",
            id: "31537249-0c84-4551-a79f-bef2611a592e",
            kickOffTime: "2020-01-25T19:46:02.015Z",
          },
          "47d91593-c15d-4c0e-b8d1-f50acc5b1479": {
            awayTeamId: "553160b8-3b85-400d-b295-4c3212c2014f",
            goalsAway: 0,
            goalsHome: 3,
            homeTeamId: "619fbd53-4382-441f-a664-31c2dc5507b2",
            id: "47d91593-c15d-4c0e-b8d1-f50acc5b1479",
            kickOffTime: "2020-01-26T14:01:03.115Z",
          },
          "58d4bc99-460e-47fd-bea6-76c4e5cc51aa": {
            awayTeamId: "ed4244af-01d2-4c79-92b9-2f77149615cd",
            goalsAway: 3,
            goalsHome: 1,
            homeTeamId: "6d7b6c20-1bae-4439-8762-f52144812dc3",
            id: "58d4bc99-460e-47fd-bea6-76c4e5cc51aa",
            kickOffTime: "2020-01-25T14:01:08.843Z",
          },
          "7dd40fed-083a-471d-bf3b-85663ca569e5": {
            awayTeamId: "b59106f0-dd86-4e9d-8dc9-fd074aece6ee",
            goalsAway: 0,
            goalsHome: 0,
            homeTeamId: "6ab88ce9-af44-4299-9675-0b0598c8aba0",
            id: "7dd40fed-083a-471d-bf3b-85663ca569e5",
            kickOffTime: "2020-01-26T14:31:01.417Z",
          },
          "965cb94c-c0d2-456e-aa0e-0439134a7040": {
            awayTeamId: "174e65e5-6d72-4f53-b4be-9d139715c89a",
            goalsAway: 1,
            goalsHome: 1,
            homeTeamId: "3f45562f-f848-41e5-83ba-5f1a1e4e285f",
            id: "965cb94c-c0d2-456e-aa0e-0439134a7040",
            kickOffTime: "2020-01-26T12:15:57.979Z",
          },
          "e461ec68-00e5-4d53-8815-43f67e7d4bdd": {
            awayTeamId: "8b3c665f-6738-4744-81a7-91dbce1c58f7",
            goalsAway: 1,
            goalsHome: 2,
            homeTeamId: "4a7d7192-288d-4185-8d46-a337129c6e77",
            id: "e461ec68-00e5-4d53-8815-43f67e7d4bdd",
            kickOffTime: "2020-01-26T20:45:57.854Z",
          },
          "e53cadb6-76c6-4010-9474-362b7117aa87": {
            awayTeamId: "5afd6cb9-f14f-431a-a0c0-22e4d9424a8f",
            goalsAway: 0,
            goalsHome: 0,
            homeTeamId: "9bc4bbfc-5b00-40b6-9ba4-e398114ec130",
            id: "e53cadb6-76c6-4010-9474-362b7117aa87",
            kickOffTime: "2020-01-25T17:01:04.944Z",
          },
        },
        id: "3cea6658-3772-4abf-b900-752d26815635",
        matchday: 21,
        startDate: "",
      },
      {
        endDate: "",
        fixtures: {
          "152da90e-fcf3-4d42-9745-bb56666480a6": {
            awayTeamId: "69007dc2-fb11-43ba-8b60-321960051e67",
            goalsAway: 0,
            goalsHome: 4,
            homeTeamId: "553160b8-3b85-400d-b295-4c3212c2014f",
            id: "152da90e-fcf3-4d42-9745-bb56666480a6",
            kickOffTime: "2020-02-02T17:01:03.764Z",
          },
          "159718dd-b56b-40a7-b4ec-c3a128e44c10": {
            awayTeamId: "9bc4bbfc-5b00-40b6-9ba4-e398114ec130",
            goalsAway: 0,
            goalsHome: 3,
            homeTeamId: "8b3c665f-6738-4744-81a7-91dbce1c58f7",
            id: "159718dd-b56b-40a7-b4ec-c3a128e44c10",
            kickOffTime: "2020-02-02T11:31:04.044Z",
          },
          "403ae8b6-2ee4-48c8-914b-2c02f7a7da4c": {
            awayTeamId: "52aa8f01-478f-4efc-be06-5472237d7fc9",
            goalsAway: 1,
            goalsHome: 2,
            homeTeamId: "ed4244af-01d2-4c79-92b9-2f77149615cd",
            id: "403ae8b6-2ee4-48c8-914b-2c02f7a7da4c",
            kickOffTime: "2020-02-01T14:16:07.808Z",
          },
          "6ebc1893-f173-4f28-a58a-9e5b4bf97273": {
            awayTeamId: "4a7d7192-288d-4185-8d46-a337129c6e77",
            goalsAway: 4,
            goalsHome: 2,
            homeTeamId: "6ab88ce9-af44-4299-9675-0b0598c8aba0",
            id: "6ebc1893-f173-4f28-a58a-9e5b4bf97273",
            kickOffTime: "2020-02-03T19:45:51.441Z",
          },
          "73196fcb-b0d0-4e0e-a5c5-1e132b871f47": {
            awayTeamId: "3f45562f-f848-41e5-83ba-5f1a1e4e285f",
            goalsAway: 2,
            goalsHome: 0,
            homeTeamId: "2e52cbda-e75d-4420-9406-35b48f4393d7",
            id: "73196fcb-b0d0-4e0e-a5c5-1e132b871f47",
            kickOffTime: "2020-02-02T19:45:59.645Z",
          },
          "8c7114eb-5282-4d7f-9590-c4a2d7e1989b": {
            awayTeamId: "619fbd53-4382-441f-a664-31c2dc5507b2",
            goalsAway: 1,
            goalsHome: 1,
            homeTeamId: "1869c021-2191-49cf-b671-ea9ea08cd0fb",
            id: "8c7114eb-5282-4d7f-9590-c4a2d7e1989b",
            kickOffTime: "2020-02-02T14:01:01.667Z",
          },
          "b27a07ca-c89d-44a8-9d6e-475e7c72670d": {
            awayTeamId: "fd626290-dd26-4768-acae-1f3770304ff6",
            goalsAway: 2,
            goalsHome: 2,
            homeTeamId: "174e65e5-6d72-4f53-b4be-9d139715c89a",
            id: "b27a07ca-c89d-44a8-9d6e-475e7c72670d",
            kickOffTime: "2020-02-01T17:01:07.516Z",
          },
          "c5e466e1-eda1-43b6-9cb9-d4bb02b853e4": {
            awayTeamId: "5afd6cb9-f14f-431a-a0c0-22e4d9424a8f",
            goalsAway: 2,
            goalsHome: 2,
            homeTeamId: "83ab7af4-0410-4670-9398-844a1c251336",
            id: "c5e466e1-eda1-43b6-9cb9-d4bb02b853e4",
            kickOffTime: "2020-02-02T14:01:01.667Z",
          },
          "c9703780-df72-47a6-b9e0-32fd6326b415": {
            awayTeamId: "d1c1940c-2fae-4aab-81cd-7355bc2c9d85",
            goalsAway: 2,
            goalsHome: 3,
            homeTeamId: "b59106f0-dd86-4e9d-8dc9-fd074aece6ee",
            id: "c9703780-df72-47a6-b9e0-32fd6326b415",
            kickOffTime: "2020-02-01T19:16:02.516Z",
          },
          "e00f7852-d9d6-49fb-b6f1-c7e39723f25b": {
            awayTeamId: "6d7b6c20-1bae-4439-8762-f52144812dc3",
            goalsAway: 1,
            goalsHome: 5,
            homeTeamId: "17dc6c9a-4f3b-4ebc-b3a4-bcb6eda1a30a",
            id: "e00f7852-d9d6-49fb-b6f1-c7e39723f25b",
            kickOffTime: "2020-02-02T14:01:01.667Z",
          },
        },
        id: "c4583844-4208-415a-b6f5-086045c5368d",
        matchday: 22,
        startDate: "",
      },
      {
        endDate: "",
        fixtures: {
          "1034a942-db86-4d78-9b13-6b45ded4cfc1": {
            awayTeamId: "ed4244af-01d2-4c79-92b9-2f77149615cd",
            goalsAway: 3,
            goalsHome: 2,
            homeTeamId: "d1c1940c-2fae-4aab-81cd-7355bc2c9d85",
            id: "1034a942-db86-4d78-9b13-6b45ded4cfc1",
            kickOffTime: "2020-02-07T19:45:53.122Z",
          },
          "27c85933-056d-4dda-ab84-c103fdc4fbf2": {
            awayTeamId: "17dc6c9a-4f3b-4ebc-b3a4-bcb6eda1a30a",
            goalsAway: 1,
            goalsHome: 0,
            homeTeamId: "fd626290-dd26-4768-acae-1f3770304ff6",
            id: "27c85933-056d-4dda-ab84-c103fdc4fbf2",
            kickOffTime: "2020-02-09T17:01:00.724Z",
          },
          "28e979a3-4390-4ed2-b779-d57214a5585f": {
            awayTeamId: "83ab7af4-0410-4670-9398-844a1c251336",
            goalsAway: 2,
            goalsHome: 1,
            homeTeamId: "9bc4bbfc-5b00-40b6-9ba4-e398114ec130",
            id: "28e979a3-4390-4ed2-b779-d57214a5585f",
            kickOffTime: "2020-02-08T14:01:06.259Z",
          },
          "3241c6dc-435f-4406-af2b-1344960c209a": {
            awayTeamId: "1869c021-2191-49cf-b671-ea9ea08cd0fb",
            goalsAway: 2,
            goalsHome: 4,
            homeTeamId: "3f45562f-f848-41e5-83ba-5f1a1e4e285f",
            id: "3241c6dc-435f-4406-af2b-1344960c209a",
            kickOffTime: "2020-02-09T20:01:08.765Z",
          },
          "449783d4-8124-4442-923e-a65deac5eeff": {
            awayTeamId: "174e65e5-6d72-4f53-b4be-9d139715c89a",
            goalsAway: 0,
            goalsHome: 1,
            homeTeamId: "5afd6cb9-f14f-431a-a0c0-22e4d9424a8f",
            id: "449783d4-8124-4442-923e-a65deac5eeff",
            kickOffTime: "2020-02-09T14:00:57.266Z",
          },
          "60fbe07f-fd3e-4e8c-9849-d251f3b59351": {
            awayTeamId: "8b3c665f-6738-4744-81a7-91dbce1c58f7",
            goalsAway: 1,
            goalsHome: 2,
            homeTeamId: "619fbd53-4382-441f-a664-31c2dc5507b2",
            id: "60fbe07f-fd3e-4e8c-9849-d251f3b59351",
            kickOffTime: "2020-02-08T19:46:04.318Z",
          },
          "8803f527-03e0-4d73-943b-5be068f2b7eb": {
            awayTeamId: "6ab88ce9-af44-4299-9675-0b0598c8aba0",
            goalsAway: 3,
            goalsHome: 1,
            homeTeamId: "69007dc2-fb11-43ba-8b60-321960051e67",
            id: "8803f527-03e0-4d73-943b-5be068f2b7eb",
            kickOffTime: "2020-02-08T17:01:06.059Z",
          },
          "8be99665-7293-4464-86e4-31fcbeef16cc": {
            awayTeamId: "2e52cbda-e75d-4420-9406-35b48f4393d7",
            goalsAway: 1,
            goalsHome: 1,
            homeTeamId: "52aa8f01-478f-4efc-be06-5472237d7fc9",
            id: "8be99665-7293-4464-86e4-31fcbeef16cc",
            kickOffTime: "2020-02-09T14:00:57.266Z",
          },
          "8f15dde2-e157-43cd-a68f-d55002e5b72b": {
            awayTeamId: "b59106f0-dd86-4e9d-8dc9-fd074aece6ee",
            goalsAway: 2,
            goalsHome: 1,
            homeTeamId: "6d7b6c20-1bae-4439-8762-f52144812dc3",
            id: "8f15dde2-e157-43cd-a68f-d55002e5b72b",
            kickOffTime: "2020-02-09T11:45:52.178Z",
          },
          "df164bec-2074-4905-b0e8-fdd973d5a624": {
            awayTeamId: "553160b8-3b85-400d-b295-4c3212c2014f",
            goalsAway: 3,
            goalsHome: 2,
            homeTeamId: "4a7d7192-288d-4185-8d46-a337129c6e77",
            id: "df164bec-2074-4905-b0e8-fdd973d5a624",
            kickOffTime: "2020-02-09T14:00:57.266Z",
          },
        },
        id: "dee7a375-3c94-451c-817f-06a1527dd382",
        matchday: 23,
        startDate: "",
      },
      {
        endDate: "",
        fixtures: {
          "1f0b6ecd-3184-4126-a69f-f6055d86bc8e": {
            awayTeamId: "52aa8f01-478f-4efc-be06-5472237d7fc9",
            goalsAway: 0,
            goalsHome: 2,
            homeTeamId: "8b3c665f-6738-4744-81a7-91dbce1c58f7",
            id: "1f0b6ecd-3184-4126-a69f-f6055d86bc8e",
            kickOffTime: "2020-02-16T14:01:07.011Z",
          },
          "44e29d0f-12ce-4e58-bcde-e855bf31ddb5": {
            awayTeamId: "619fbd53-4382-441f-a664-31c2dc5507b2",
            goalsAway: 0,
            goalsHome: 0,
            homeTeamId: "2e52cbda-e75d-4420-9406-35b48f4393d7",
            id: "44e29d0f-12ce-4e58-bcde-e855bf31ddb5",
            kickOffTime: "2020-02-16T11:31:00.108Z",
          },
          "584d7131-87db-4e0e-be39-3803f1366dcd": {
            awayTeamId: "fd626290-dd26-4768-acae-1f3770304ff6",
            goalsAway: 1,
            goalsHome: 0,
            homeTeamId: "b59106f0-dd86-4e9d-8dc9-fd074aece6ee",
            id: "584d7131-87db-4e0e-be39-3803f1366dcd",
            kickOffTime: "2020-02-16T14:15:56.421Z",
          },
          "74e4d8ce-6aa3-44b0-889f-ec4bfd2d0c84": {
            awayTeamId: "4a7d7192-288d-4185-8d46-a337129c6e77",
            goalsAway: 1,
            goalsHome: 0,
            homeTeamId: "174e65e5-6d72-4f53-b4be-9d139715c89a",
            id: "74e4d8ce-6aa3-44b0-889f-ec4bfd2d0c84",
            kickOffTime: "2020-02-16T17:01:04.597Z",
          },
          "7d39e5ee-2ddd-4ee2-8934-203cae9907d9": {
            awayTeamId: "3f45562f-f848-41e5-83ba-5f1a1e4e285f",
            goalsAway: 1,
            goalsHome: 2,
            homeTeamId: "17dc6c9a-4f3b-4ebc-b3a4-bcb6eda1a30a",
            id: "7d39e5ee-2ddd-4ee2-8934-203cae9907d9",
            kickOffTime: "2020-02-16T19:46:00.207Z",
          },
          "8ea14b99-9c67-4fb3-ad73-004616338126": {
            awayTeamId: "6d7b6c20-1bae-4439-8762-f52144812dc3",
            goalsAway: 1,
            goalsHome: 2,
            homeTeamId: "553160b8-3b85-400d-b295-4c3212c2014f",
            id: "8ea14b99-9c67-4fb3-ad73-004616338126",
            kickOffTime: "2020-02-15T14:01:01.012Z",
          },
          "a2c1bd3c-cf8b-4a5e-8ea7-0e71e8736609": {
            awayTeamId: "d1c1940c-2fae-4aab-81cd-7355bc2c9d85",
            goalsAway: 1,
            goalsHome: 2,
            homeTeamId: "83ab7af4-0410-4670-9398-844a1c251336",
            id: "a2c1bd3c-cf8b-4a5e-8ea7-0e71e8736609",
            kickOffTime: "2020-02-15T19:45:57.093Z",
          },
          "b3bfbdc4-4edf-4786-93bd-05ef9fdf2d52": {
            awayTeamId: "5afd6cb9-f14f-431a-a0c0-22e4d9424a8f",
            goalsAway: 3,
            goalsHome: 0,
            homeTeamId: "ed4244af-01d2-4c79-92b9-2f77149615cd",
            id: "b3bfbdc4-4edf-4786-93bd-05ef9fdf2d52",
            kickOffTime: "2020-02-15T17:01:07.107Z",
          },
          "b777fbdc-c5c8-4a21-ac57-537980f2ba76": {
            awayTeamId: "69007dc2-fb11-43ba-8b60-321960051e67",
            goalsAway: 0,
            goalsHome: 1,
            homeTeamId: "1869c021-2191-49cf-b671-ea9ea08cd0fb",
            id: "b777fbdc-c5c8-4a21-ac57-537980f2ba76",
            kickOffTime: "2020-02-17T19:45:56.521Z",
          },
          "bb0039d4-f4ab-49b8-b778-9e7a0a3014cb": {
            awayTeamId: "9bc4bbfc-5b00-40b6-9ba4-e398114ec130",
            goalsAway: 5,
            goalsHome: 1,
            homeTeamId: "6ab88ce9-af44-4299-9675-0b0598c8aba0",
            id: "bb0039d4-f4ab-49b8-b778-9e7a0a3014cb",
            kickOffTime: "2020-02-16T14:01:07.012Z",
          },
        },
        id: "5b9249ce-f0d3-4a5f-99b2-67ac2f7727f2",
        matchday: 24,
        startDate: "",
      },
      {
        endDate: "",
        fixtures: {
          "3d149acf-2b2b-466c-a848-9cd1d653754e": {
            awayTeamId: "4a7d7192-288d-4185-8d46-a337129c6e77",
            goalsAway: 2,
            goalsHome: 1,
            homeTeamId: "52aa8f01-478f-4efc-be06-5472237d7fc9",
            id: "3d149acf-2b2b-466c-a848-9cd1d653754e",
            kickOffTime: "2020-02-21T19:45:52.470Z",
          },
          "3d8b2a2f-d17d-4ab2-9735-3cef64088510": {
            awayTeamId: "2e52cbda-e75d-4420-9406-35b48f4393d7",
            goalsAway: 1,
            goalsHome: 1,
            homeTeamId: "ed4244af-01d2-4c79-92b9-2f77149615cd",
            id: "3d8b2a2f-d17d-4ab2-9735-3cef64088510",
            kickOffTime: "2020-02-22T14:15:54.573Z",
          },
          "5d2cc0cf-cab7-41a6-9b9a-e16e0b2309e5": {
            awayTeamId: "17dc6c9a-4f3b-4ebc-b3a4-bcb6eda1a30a",
            goalsAway: 3,
            goalsHome: 2,
            homeTeamId: "5afd6cb9-f14f-431a-a0c0-22e4d9424a8f",
            id: "5d2cc0cf-cab7-41a6-9b9a-e16e0b2309e5",
            kickOffTime: "2020-02-23T11:31:02.860Z",
          },
          "872f74af-360c-4e95-a413-7a771efd63f9": {
            awayTeamId: "6ab88ce9-af44-4299-9675-0b0598c8aba0",
            goalsAway: 1,
            goalsHome: 2,
            homeTeamId: "3f45562f-f848-41e5-83ba-5f1a1e4e285f",
            kickOffTime: "2020-06-21T21:45:00.000+02:00",
          },
          "a11fa4ee-aeb4-4c47-b27d-75bf63eee0a5": {
            awayTeamId: "1869c021-2191-49cf-b671-ea9ea08cd0fb",
            goalsAway: 1,
            goalsHome: 1,
            homeTeamId: "9bc4bbfc-5b00-40b6-9ba4-e398114ec130",
            id: "a11fa4ee-aeb4-4c47-b27d-75bf63eee0a5",
            kickOffTime: "2020-02-22T20:01:01.967Z",
          },
          "aa49ab94-21a7-4fd3-b006-bda3150b92f8": {
            awayTeamId: "553160b8-3b85-400d-b295-4c3212c2014f",
            goalsAway: 0,
            goalsHome: 4,
            homeTeamId: "d1c1940c-2fae-4aab-81cd-7355bc2c9d85",
            id: "aa49ab94-21a7-4fd3-b006-bda3150b92f8",
            kickOffTime: "2020-02-23T17:01:02.256Z",
          },
          "b53dad96-affa-4fbb-8d5d-11c3260951c6": {
            awayTeamId: "fd626290-dd26-4768-acae-1f3770304ff6",
            goalsAway: 1,
            goalsHome: 1,
            homeTeamId: "69007dc2-fb11-43ba-8b60-321960051e67",
            id: "b53dad96-affa-4fbb-8d5d-11c3260951c6",
            kickOffTime: "2020-06-20T17:30:14.740Z",
          },
          "cc4d047e-365a-411c-b3da-4574c3b16cdb": {
            awayTeamId: "b59106f0-dd86-4e9d-8dc9-fd074aece6ee",
            goalsAway: 1,
            goalsHome: 4,
            homeTeamId: "83ab7af4-0410-4670-9398-844a1c251336",
            id: "cc4d047e-365a-411c-b3da-4574c3b16cdb",
            kickOffTime: "2020-06-21T17:45:16.662Z",
          },
          "d0f292eb-0f3e-4b8c-98b2-bce08020e0b3": {
            awayTeamId: "8b3c665f-6738-4744-81a7-91dbce1c58f7",
            goalsAway: 2,
            goalsHome: 1,
            homeTeamId: "6d7b6c20-1bae-4439-8762-f52144812dc3",
            id: "d0f292eb-0f3e-4b8c-98b2-bce08020e0b3",
            kickOffTime: "2020-02-22T17:01:10.862Z",
          },
          "e5b7e78d-2372-480a-985e-4ba088615af2": {
            awayTeamId: "174e65e5-6d72-4f53-b4be-9d139715c89a",
            goalsAway: 1,
            goalsHome: 2,
            homeTeamId: "619fbd53-4382-441f-a664-31c2dc5507b2",
            id: "e5b7e78d-2372-480a-985e-4ba088615af2",
            kickOffTime: "2020-06-20T19:45:15.626Z",
          },
        },
        id: "b3849e65-dc13-45b5-889b-7d93e0009d06",
        matchday: 25,
        startDate: "",
      },
      {
        endDate: "",
        fixtures: {
          "0ee9c168-977a-4f6e-b10e-8aaff4ff76d9": {
            awayTeamId: "5afd6cb9-f14f-431a-a0c0-22e4d9424a8f",
            goalsAway: 2,
            goalsHome: 1,
            homeTeamId: "1869c021-2191-49cf-b671-ea9ea08cd0fb",
            id: "0ee9c168-977a-4f6e-b10e-8aaff4ff76d9",
            kickOffTime: "2020-03-08T14:01:02.232Z",
          },
          "11020d09-7d17-4d51-a049-a01f5d93f286": {
            awayTeamId: "ed4244af-01d2-4c79-92b9-2f77149615cd",
            goalsAway: 0,
            goalsHome: 2,
            homeTeamId: "17dc6c9a-4f3b-4ebc-b3a4-bcb6eda1a30a",
            id: "11020d09-7d17-4d51-a049-a01f5d93f286",
            kickOffTime: "2020-02-29T14:01:01.702Z",
          },
          "196bc6dc-a289-4caf-8bd1-e92fb3d87e96": {
            awayTeamId: "83ab7af4-0410-4670-9398-844a1c251336",
            goalsAway: 7,
            goalsHome: 2,
            homeTeamId: "553160b8-3b85-400d-b295-4c3212c2014f",
            id: "196bc6dc-a289-4caf-8bd1-e92fb3d87e96",
            kickOffTime: "2020-03-01T14:01:02.348Z",
          },
          "63670c17-be87-4195-ac59-97e841268a07": {
            awayTeamId: "619fbd53-4382-441f-a664-31c2dc5507b2",
            goalsAway: 1,
            goalsHome: 2,
            homeTeamId: "6ab88ce9-af44-4299-9675-0b0598c8aba0",
            id: "63670c17-be87-4195-ac59-97e841268a07",
            kickOffTime: "2020-03-08T14:01:02.232Z",
          },
          "6865e39f-4ad2-4fbf-8f78-7907c4a880b9": {
            awayTeamId: "9bc4bbfc-5b00-40b6-9ba4-e398114ec130",
            goalsAway: 0,
            goalsHome: 0,
            homeTeamId: "2e52cbda-e75d-4420-9406-35b48f4393d7",
            id: "6865e39f-4ad2-4fbf-8f78-7907c4a880b9",
            kickOffTime: "2020-03-08T17:01:04.424Z",
          },
          "9aa66827-e073-4ef3-8c66-33f13e0bda3d": {
            awayTeamId: "3f45562f-f848-41e5-83ba-5f1a1e4e285f",
            goalsAway: 0,
            goalsHome: 2,
            homeTeamId: "8b3c665f-6738-4744-81a7-91dbce1c58f7",
            id: "9aa66827-e073-4ef3-8c66-33f13e0bda3d",
            kickOffTime: "2020-03-08T19:46:07.526Z",
          },
          "b4f00417-f3f8-4f42-b815-ea8a3ce1ff6c": {
            awayTeamId: "52aa8f01-478f-4efc-be06-5472237d7fc9",
            goalsAway: 0,
            goalsHome: 3,
            homeTeamId: "b59106f0-dd86-4e9d-8dc9-fd074aece6ee",
            id: "b4f00417-f3f8-4f42-b815-ea8a3ce1ff6c",
            kickOffTime: "2020-03-09T17:30:54.048Z",
          },
          "b530dac1-40c7-46a1-93ca-3ce8d6c89879": {
            awayTeamId: "d1c1940c-2fae-4aab-81cd-7355bc2c9d85",
            goalsAway: 4,
            goalsHome: 3,
            homeTeamId: "174e65e5-6d72-4f53-b4be-9d139715c89a",
            id: "b530dac1-40c7-46a1-93ca-3ce8d6c89879",
            kickOffTime: "2020-03-01T17:01:15.563Z",
          },
          "d94027e4-d0f3-4e1f-91ce-b43cc5524186": {
            awayTeamId: "6d7b6c20-1bae-4439-8762-f52144812dc3",
            goalsAway: 1,
            goalsHome: 0,
            homeTeamId: "fd626290-dd26-4768-acae-1f3770304ff6",
            id: "d94027e4-d0f3-4e1f-91ce-b43cc5524186",
            kickOffTime: "2020-03-08T12:46:00.480Z",
          },
          "e77992c4-45df-452c-8fa0-a12ff639a8ea": {
            awayTeamId: "69007dc2-fb11-43ba-8b60-321960051e67",
            goalsAway: 1,
            goalsHome: 2,
            homeTeamId: "4a7d7192-288d-4185-8d46-a337129c6e77",
            id: "e77992c4-45df-452c-8fa0-a12ff639a8ea",
            kickOffTime: "2020-02-29T19:46:00.428Z",
          },
        },
        id: "b5d77e51-bb83-448b-8883-d991f68e3ed1",
        matchday: 26,
        startDate: "",
      },
      {
        endDate: "",
        fixtures: {
          "1a76f1a9-d89c-4861-a286-593e9f0b02fd": {
            awayTeamId: "2e52cbda-e75d-4420-9406-35b48f4393d7",
            goalsAway: 0,
            goalsHome: 1,
            homeTeamId: "69007dc2-fb11-43ba-8b60-321960051e67",
            id: "1a76f1a9-d89c-4861-a286-593e9f0b02fd",
            kickOffTime: "2020-06-23T20:00:18.533Z",
          },
          "267470b8-5ab9-4c7a-babc-c8cf573da6db": {
            awayTeamId: "174e65e5-6d72-4f53-b4be-9d139715c89a",
            goalsAway: 1,
            goalsHome: 0,
            homeTeamId: "6d7b6c20-1bae-4439-8762-f52144812dc3",
            id: "267470b8-5ab9-4c7a-babc-c8cf573da6db",
            kickOffTime: "2020-06-23T17:45:16.620Z",
          },
          "60c5efcd-507e-4db4-91f3-f24eccb61718": {
            awayTeamId: "b59106f0-dd86-4e9d-8dc9-fd074aece6ee",
            goalsAway: 3,
            goalsHome: 3,
            homeTeamId: "3f45562f-f848-41e5-83ba-5f1a1e4e285f",
            id: "60c5efcd-507e-4db4-91f3-f24eccb61718",
            kickOffTime: "2020-06-24T17:45:15.880Z",
          },
          "89006a81-f207-46de-9fe4-2ddb5ff7e95c": {
            awayTeamId: "8b3c665f-6738-4744-81a7-91dbce1c58f7",
            goalsAway: 2,
            goalsHome: 0,
            homeTeamId: "ed4244af-01d2-4c79-92b9-2f77149615cd",
            id: "89006a81-f207-46de-9fe4-2ddb5ff7e95c",
            kickOffTime: "2020-06-22T19:45:12.008Z",
          },
          "ae7e0239-a686-4100-8180-7beabfccd943": {
            awayTeamId: "fd626290-dd26-4768-acae-1f3770304ff6",
            goalsAway: 4,
            goalsHome: 1,
            homeTeamId: "5afd6cb9-f14f-431a-a0c0-22e4d9424a8f",
            id: "ae7e0239-a686-4100-8180-7beabfccd943",
            kickOffTime: "2020-06-23T19:45:17.755Z",
          },
          "bb15c0a6-4fd5-4b37-8012-bdf9aae83f42": {
            awayTeamId: "6ab88ce9-af44-4299-9675-0b0598c8aba0",
            goalsAway: 1,
            goalsHome: 2,
            homeTeamId: "d1c1940c-2fae-4aab-81cd-7355bc2c9d85",
            id: "bb15c0a6-4fd5-4b37-8012-bdf9aae83f42",
            kickOffTime: "2020-06-24T19:45:17.408Z",
          },
          "c03de725-775a-4c65-998c-4f02aa847af9": {
            awayTeamId: "17dc6c9a-4f3b-4ebc-b3a4-bcb6eda1a30a",
            goalsAway: 2,
            goalsHome: 3,
            homeTeamId: "83ab7af4-0410-4670-9398-844a1c251336",
            id: "c03de725-775a-4c65-998c-4f02aa847af9",
            kickOffTime: "2020-06-24T19:45:17.407Z",
          },
          "c5ef7bd8-c035-44e2-88e5-375a8e72e9f5": {
            awayTeamId: "4a7d7192-288d-4185-8d46-a337129c6e77",
            goalsAway: 2,
            goalsHome: 0,
            homeTeamId: "619fbd53-4382-441f-a664-31c2dc5507b2",
            id: "c5ef7bd8-c035-44e2-88e5-375a8e72e9f5",
            kickOffTime: "2020-06-23T17:45:16.619Z",
          },
          "f4bd094a-0b15-4cbe-a6b6-c60fd0ed67d3": {
            awayTeamId: "1869c021-2191-49cf-b671-ea9ea08cd0fb",
            goalsAway: 4,
            goalsHome: 1,
            homeTeamId: "553160b8-3b85-400d-b295-4c3212c2014f",
            id: "f4bd094a-0b15-4cbe-a6b6-c60fd0ed67d3",
            kickOffTime: "2020-06-22T17:30:12.406Z",
          },
          "f5ccd7a6-60c9-40d7-8a67-90ad01f661e5": {
            awayTeamId: "52aa8f01-478f-4efc-be06-5472237d7fc9",
            goalsAway: 1,
            goalsHome: 1,
            homeTeamId: "9bc4bbfc-5b00-40b6-9ba4-e398114ec130",
            id: "f5ccd7a6-60c9-40d7-8a67-90ad01f661e5",
            kickOffTime: "2020-06-22T17:45:11.426Z",
          },
        },
        id: "14d0b7ec-ca2a-4d7a-866c-5e36d030031f",
        matchday: 27,
        startDate: "",
      },
      {
        endDate: "",
        fixtures: {
          "1bdfe0b8-8bc5-434b-829c-36fd4f6645f4": {
            awayTeamId: "5afd6cb9-f14f-431a-a0c0-22e4d9424a8f",
            goalsAway: 2,
            goalsHome: 2,
            homeTeamId: "52aa8f01-478f-4efc-be06-5472237d7fc9",
            id: "1bdfe0b8-8bc5-434b-829c-36fd4f6645f4",
            kickOffTime: "2020-06-27T15:15:16.461Z",
          },
          "20a2b80f-d2d1-4010-8e90-7000d3425b85": {
            awayTeamId: "9bc4bbfc-5b00-40b6-9ba4-e398114ec130",
            goalsAway: 1,
            goalsHome: 2,
            homeTeamId: "17dc6c9a-4f3b-4ebc-b3a4-bcb6eda1a30a",
            id: "20a2b80f-d2d1-4010-8e90-7000d3425b85",
            kickOffTime: "2020-06-27T19:45:15.758Z",
          },
          "58c83c4f-b258-4c3e-9fd1-67854be379a5": {
            awayTeamId: "69007dc2-fb11-43ba-8b60-321960051e67",
            goalsAway: 2,
            goalsHome: 4,
            homeTeamId: "174e65e5-6d72-4f53-b4be-9d139715c89a",
            id: "58c83c4f-b258-4c3e-9fd1-67854be379a5",
            kickOffTime: "2020-06-27T17:45:15.657Z",
          },
          "87d76996-2837-4eab-94d8-ca5ebe735f3b": {
            awayTeamId: "619fbd53-4382-441f-a664-31c2dc5507b2",
            goalsAway: 3,
            goalsHome: 3,
            homeTeamId: "b59106f0-dd86-4e9d-8dc9-fd074aece6ee",
            id: "87d76996-2837-4eab-94d8-ca5ebe735f3b",
            kickOffTime: "2020-06-28T17:45:17.273Z",
          },
          "97783e2a-41e0-482d-839f-93c7fef13d86": {
            awayTeamId: "d1c1940c-2fae-4aab-81cd-7355bc2c9d85",
            goalsAway: 0,
            goalsHome: 2,
            homeTeamId: "1869c021-2191-49cf-b671-ea9ea08cd0fb",
            id: "97783e2a-41e0-482d-839f-93c7fef13d86",
            kickOffTime: "2020-06-28T15:30:16.788Z",
          },
          "a02406be-5ca6-4373-acab-4718af4d53c0": {
            awayTeamId: "6d7b6c20-1bae-4439-8762-f52144812dc3",
            goalsAway: 1,
            goalsHome: 3,
            homeTeamId: "4a7d7192-288d-4185-8d46-a337129c6e77",
            id: "a02406be-5ca6-4373-acab-4718af4d53c0",
            kickOffTime: "2020-06-28T17:45:17.274Z",
          },
          "a69c9d61-6b7b-4c1e-94be-36c869def75a": {
            awayTeamId: "553160b8-3b85-400d-b295-4c3212c2014f",
            goalsAway: 0,
            goalsHome: 4,
            homeTeamId: "8b3c665f-6738-4744-81a7-91dbce1c58f7",
            id: "a69c9d61-6b7b-4c1e-94be-36c869def75a",
            kickOffTime: "2020-06-26T19:45:12.497Z",
          },
          "d4f899ce-9ae7-4e06-9796-4995b62bf748": {
            awayTeamId: "3f45562f-f848-41e5-83ba-5f1a1e4e285f",
            goalsAway: 2,
            goalsHome: 1,
            homeTeamId: "fd626290-dd26-4768-acae-1f3770304ff6",
            kickOffTime: "2020-06-28T21:45:00.000+02:00",
          },
          "fab443db-2a6a-440d-a9e7-c173aa985d6a": {
            awayTeamId: "83ab7af4-0410-4670-9398-844a1c251336",
            goalsAway: 3,
            goalsHome: 2,
            homeTeamId: "2e52cbda-e75d-4420-9406-35b48f4393d7",
            id: "fab443db-2a6a-440d-a9e7-c173aa985d6a",
            kickOffTime: "2020-06-28T17:30:21.285Z",
          },
          "fac9c64d-1183-4205-bc2a-54978337fe20": {
            awayTeamId: "ed4244af-01d2-4c79-92b9-2f77149615cd",
            goalsAway: 2,
            goalsHome: 1,
            homeTeamId: "6ab88ce9-af44-4299-9675-0b0598c8aba0",
            id: "fac9c64d-1183-4205-bc2a-54978337fe20",
            kickOffTime: "2020-06-28T17:45:17.273Z",
          },
        },
        id: "b26e3092-f4ed-460d-9515-3b80b053642c",
        matchday: 28,
        startDate: "",
      },
      {
        endDate: "",
        fixtures: {
          "003b20a0-2f1b-4429-a6fb-5c3ed16dbd73": {
            awayTeamId: "8b3c665f-6738-4744-81a7-91dbce1c58f7",
            goalsAway: 3,
            goalsHome: 1,
            homeTeamId: "5afd6cb9-f14f-431a-a0c0-22e4d9424a8f",
            id: "003b20a0-2f1b-4429-a6fb-5c3ed16dbd73",
            kickOffTime: "2020-06-30T19:45:15.659Z",
          },
          "00c65412-52e5-4ee4-a9a1-5cf0f7ea8ae6": {
            awayTeamId: "2e52cbda-e75d-4420-9406-35b48f4393d7",
            goalsAway: 2,
            goalsHome: 0,
            homeTeamId: "d1c1940c-2fae-4aab-81cd-7355bc2c9d85",
            id: "00c65412-52e5-4ee4-a9a1-5cf0f7ea8ae6",
            kickOffTime: "2020-07-02T19:45:15.764Z",
          },
          "038b8840-c683-40e1-9471-b88fbc63756e": {
            awayTeamId: "52aa8f01-478f-4efc-be06-5472237d7fc9",
            goalsAway: 0,
            goalsHome: 6,
            homeTeamId: "3f45562f-f848-41e5-83ba-5f1a1e4e285f",
            id: "038b8840-c683-40e1-9471-b88fbc63756e",
            kickOffTime: "2020-07-01T17:30:18.655Z",
          },
          "172054c6-fd52-4102-b351-4d8146955916": {
            awayTeamId: "b59106f0-dd86-4e9d-8dc9-fd074aece6ee",
            goalsAway: 3,
            goalsHome: 1,
            homeTeamId: "9bc4bbfc-5b00-40b6-9ba4-e398114ec130",
            id: "172054c6-fd52-4102-b351-4d8146955916",
            kickOffTime: "2020-07-01T19:45:15.755Z",
          },
          "83171c43-efeb-483f-8498-8a199c5d3b17": {
            awayTeamId: "4a7d7192-288d-4185-8d46-a337129c6e77",
            goalsAway: 0,
            goalsHome: 2,
            homeTeamId: "83ab7af4-0410-4670-9398-844a1c251336",
            id: "83171c43-efeb-483f-8498-8a199c5d3b17",
            kickOffTime: "2020-07-02T17:30:19.975Z",
          },
          "961da6c9-5aa2-4b6e-863b-5a015ad7bc0b": {
            awayTeamId: "6ab88ce9-af44-4299-9675-0b0598c8aba0",
            goalsAway: 2,
            goalsHome: 1,
            homeTeamId: "553160b8-3b85-400d-b295-4c3212c2014f",
            id: "961da6c9-5aa2-4b6e-863b-5a015ad7bc0b",
            kickOffTime: "2020-07-01T20:00:17.558Z",
          },
          "a719f925-e619-42a7-be1e-e5106dc58004": {
            awayTeamId: "1869c021-2191-49cf-b671-ea9ea08cd0fb",
            goalsAway: 2,
            goalsHome: 2,
            homeTeamId: "6d7b6c20-1bae-4439-8762-f52144812dc3",
            id: "a719f925-e619-42a7-be1e-e5106dc58004",
            kickOffTime: "2020-07-01T20:00:17.558Z",
          },
          "c99a87e5-0c59-4d34-9499-e4614bf2b0c9": {
            awayTeamId: "fd626290-dd26-4768-acae-1f3770304ff6",
            goalsAway: 2,
            goalsHome: 3,
            homeTeamId: "619fbd53-4382-441f-a664-31c2dc5507b2",
            id: "c99a87e5-0c59-4d34-9499-e4614bf2b0c9",
            kickOffTime: "2020-07-01T19:45:15.755Z",
          },
          "d662ff3c-3cb8-4a89-832c-7e879ff42a81": {
            awayTeamId: "174e65e5-6d72-4f53-b4be-9d139715c89a",
            goalsAway: 1,
            goalsHome: 1,
            homeTeamId: "ed4244af-01d2-4c79-92b9-2f77149615cd",
            id: "d662ff3c-3cb8-4a89-832c-7e879ff42a81",
            kickOffTime: "2020-07-01T17:45:15.565Z",
          },
          "f6de3070-08c5-4279-8ec5-f0700e7c8c45": {
            awayTeamId: "17dc6c9a-4f3b-4ebc-b3a4-bcb6eda1a30a",
            goalsAway: 2,
            goalsHome: 1,
            homeTeamId: "69007dc2-fb11-43ba-8b60-321960051e67",
            id: "f6de3070-08c5-4279-8ec5-f0700e7c8c45",
            kickOffTime: "2020-06-30T17:45:13.558Z",
          },
        },
        id: "ba99d2b8-61d2-43fe-a63d-d0543ec7d9c3",
        matchday: 29,
        startDate: "",
      },
      {
        endDate: "",
        fixtures: {
          "37c0a324-33ba-4140-bec5-f37164cd6391": {
            awayTeamId: "d1c1940c-2fae-4aab-81cd-7355bc2c9d85",
            goalsAway: 1,
            goalsHome: 2,
            homeTeamId: "4a7d7192-288d-4185-8d46-a337129c6e77",
            id: "37c0a324-33ba-4140-bec5-f37164cd6391",
            kickOffTime: "2020-07-05T19:45:17.342Z",
          },
          "452b21a2-1064-472a-a34e-c73e9131fcb4": {
            awayTeamId: "6d7b6c20-1bae-4439-8762-f52144812dc3",
            goalsAway: 0,
            goalsHome: 3,
            homeTeamId: "6ab88ce9-af44-4299-9675-0b0598c8aba0",
            id: "452b21a2-1064-472a-a34e-c73e9131fcb4",
            kickOffTime: "2020-07-05T19:45:17.342Z",
          },
          "834c01bf-2b89-4d8f-936d-de5bdfc12874": {
            awayTeamId: "5afd6cb9-f14f-431a-a0c0-22e4d9424a8f",
            goalsAway: 2,
            goalsHome: 2,
            homeTeamId: "2e52cbda-e75d-4420-9406-35b48f4393d7",
            id: "834c01bf-2b89-4d8f-936d-de5bdfc12874",
            kickOffTime: "2020-07-05T19:45:17.341Z",
          },
          "a10fd4d2-ce5d-4456-b9cc-e6734a8a1da9": {
            awayTeamId: "ed4244af-01d2-4c79-92b9-2f77149615cd",
            goalsAway: 2,
            goalsHome: 1,
            homeTeamId: "3f45562f-f848-41e5-83ba-5f1a1e4e285f",
            id: "a10fd4d2-ce5d-4456-b9cc-e6734a8a1da9",
            kickOffTime: "2020-07-05T19:45:17.307Z",
          },
          "bd267e3c-b6bd-4a4d-a75f-f133236369fc": {
            awayTeamId: "69007dc2-fb11-43ba-8b60-321960051e67",
            goalsAway: 1,
            goalsHome: 4,
            homeTeamId: "8b3c665f-6738-4744-81a7-91dbce1c58f7",
            id: "bd267e3c-b6bd-4a4d-a75f-f133236369fc",
            kickOffTime: "2020-07-04T15:15:17.760Z",
          },
          "c8ef0e47-a86b-412a-b24d-890afadce066": {
            awayTeamId: "619fbd53-4382-441f-a664-31c2dc5507b2",
            goalsAway: 0,
            goalsHome: 2,
            homeTeamId: "52aa8f01-478f-4efc-be06-5472237d7fc9",
            id: "c8ef0e47-a86b-412a-b24d-890afadce066",
            kickOffTime: "2020-07-05T19:45:17.341Z",
          },
          "cf94dbc7-da42-46a8-8092-23494845e7b4": {
            awayTeamId: "553160b8-3b85-400d-b295-4c3212c2014f",
            goalsAway: 2,
            goalsHome: 4,
            homeTeamId: "b59106f0-dd86-4e9d-8dc9-fd074aece6ee",
            id: "cf94dbc7-da42-46a8-8092-23494845e7b4",
            kickOffTime: "2020-07-04T17:30:22.248Z",
          },
          "e105aabc-3801-420b-9bc1-1b51f3ac4ed8": {
            awayTeamId: "83ab7af4-0410-4670-9398-844a1c251336",
            goalsAway: 1,
            goalsHome: 0,
            homeTeamId: "174e65e5-6d72-4f53-b4be-9d139715c89a",
            id: "e105aabc-3801-420b-9bc1-1b51f3ac4ed8",
            kickOffTime: "2020-07-05T19:45:17.308Z",
          },
          "f93e60d4-308f-4940-93c1-55fb48a07b87": {
            awayTeamId: "9bc4bbfc-5b00-40b6-9ba4-e398114ec130",
            goalsAway: 2,
            goalsHome: 1,
            homeTeamId: "fd626290-dd26-4768-acae-1f3770304ff6",
            id: "f93e60d4-308f-4940-93c1-55fb48a07b87",
            kickOffTime: "2020-07-05T19:45:17.308Z",
          },
        },
        id: "d6e0082d-0d59-41d7-a022-a48247bcdb8a",
        matchday: 30,
        startDate: "",
      },
      {
        endDate: "",
        fixtures: {
          "1b9e90bd-08e0-4635-a774-bec97d90501d": {
            awayTeamId: "4a7d7192-288d-4185-8d46-a337129c6e77",
            goalsAway: 2,
            goalsHome: 1,
            homeTeamId: "5afd6cb9-f14f-431a-a0c0-22e4d9424a8f",
            id: "1b9e90bd-08e0-4635-a774-bec97d90501d",
            kickOffTime: "2020-07-08T17:30:13.628Z",
          },
          "313de305-3c7d-4d91-b460-fdad199cbd66": {
            awayTeamId: "52aa8f01-478f-4efc-be06-5472237d7fc9",
            goalsAway: 1,
            goalsHome: 3,
            homeTeamId: "69007dc2-fb11-43ba-8b60-321960051e67",
            id: "313de305-3c7d-4d91-b460-fdad199cbd66",
            kickOffTime: "2020-07-08T19:45:17.633Z",
          },
          "469ec99e-3d70-48c4-8597-8f903fc431ad": {
            awayTeamId: "fd626290-dd26-4768-acae-1f3770304ff6",
            goalsAway: 1,
            goalsHome: 2,
            homeTeamId: "d1c1940c-2fae-4aab-81cd-7355bc2c9d85",
            id: "469ec99e-3d70-48c4-8597-8f903fc431ad",
            kickOffTime: "2020-07-08T19:45:17.633Z",
          },
          "494fd6dd-2464-4161-99ee-4a23bb6878b6": {
            awayTeamId: "6ab88ce9-af44-4299-9675-0b0598c8aba0",
            goalsAway: 0,
            goalsHome: 2,
            homeTeamId: "83ab7af4-0410-4670-9398-844a1c251336",
            id: "494fd6dd-2464-4161-99ee-4a23bb6878b6",
            kickOffTime: "2020-07-08T19:45:17.634Z",
          },
          "5016a6d4-ec0d-4aa4-8808-e771de736653": {
            awayTeamId: "17dc6c9a-4f3b-4ebc-b3a4-bcb6eda1a30a",
            goalsAway: 1,
            goalsHome: 2,
            homeTeamId: "553160b8-3b85-400d-b295-4c3212c2014f",
            id: "5016a6d4-ec0d-4aa4-8808-e771de736653",
            kickOffTime: "2020-07-07T17:45:11.833Z",
          },
          "5de46fb2-2cd4-4dc0-9c12-c77e66d34e43": {
            awayTeamId: "2e52cbda-e75d-4420-9406-35b48f4393d7",
            goalsAway: 3,
            goalsHome: 0,
            homeTeamId: "6d7b6c20-1bae-4439-8762-f52144812dc3",
            id: "5de46fb2-2cd4-4dc0-9c12-c77e66d34e43",
            kickOffTime: "2020-07-09T17:30:16.320Z",
          },
          "9fd940a5-e17a-45ca-8f6a-40d05e80f196": {
            awayTeamId: "b59106f0-dd86-4e9d-8dc9-fd074aece6ee",
            goalsAway: 2,
            goalsHome: 1,
            homeTeamId: "ed4244af-01d2-4c79-92b9-2f77149615cd",
            id: "9fd940a5-e17a-45ca-8f6a-40d05e80f196",
            kickOffTime: "2020-07-08T19:45:17.634Z",
          },
          "f7a451b8-c90a-43db-bb11-8c1d2e8cd43e": {
            awayTeamId: "174e65e5-6d72-4f53-b4be-9d139715c89a",
            goalsAway: 0,
            goalsHome: 0,
            homeTeamId: "9bc4bbfc-5b00-40b6-9ba4-e398114ec130",
            id: "f7a451b8-c90a-43db-bb11-8c1d2e8cd43e",
            kickOffTime: "2020-07-08T17:30:13.628Z",
          },
        },
        id: "b7d3d268-18ff-4f30-ab25-51076e202dc0",
        matchday: 31,
        startDate: "",
      },
      {
        endDate: "",
        fixtures: {
          "076dda79-8cd9-46b7-9cc5-2ffb5603cb07": {
            awayTeamId: "d1c1940c-2fae-4aab-81cd-7355bc2c9d85",
            goalsAway: 3,
            goalsHome: 0,
            homeTeamId: "52aa8f01-478f-4efc-be06-5472237d7fc9",
            id: "076dda79-8cd9-46b7-9cc5-2ffb5603cb07",
            kickOffTime: "2020-07-11T17:30:18.057Z",
          },
          "1afc5feb-a98b-4569-b494-22171e763890": {
            awayTeamId: "ed4244af-01d2-4c79-92b9-2f77149615cd",
            goalsAway: 2,
            goalsHome: 2,
            homeTeamId: "fd626290-dd26-4768-acae-1f3770304ff6",
            id: "1afc5feb-a98b-4569-b494-22171e763890",
            kickOffTime: "2020-07-12T17:45:19.385Z",
          },
          "2157c8c5-17a3-4d95-84f3-bf6c28606d92": {
            awayTeamId: "1869c021-2191-49cf-b671-ea9ea08cd0fb",
            goalsAway: 2,
            goalsHome: 2,
            homeTeamId: "4a7d7192-288d-4185-8d46-a337129c6e77",
            id: "2157c8c5-17a3-4d95-84f3-bf6c28606d92",
            kickOffTime: "2020-07-12T20:00:17.459Z",
          },
          "2f2557f3-e282-4649-a016-69f04b697224": {
            awayTeamId: "6ab88ce9-af44-4299-9675-0b0598c8aba0",
            goalsAway: 3,
            goalsHome: 1,
            homeTeamId: "2e52cbda-e75d-4420-9406-35b48f4393d7",
            id: "2f2557f3-e282-4649-a016-69f04b697224",
            kickOffTime: "2020-07-12T17:45:19.386Z",
          },
          "408cfd4a-a440-4334-b815-36530a859dbc": {
            awayTeamId: "553160b8-3b85-400d-b295-4c3212c2014f",
            goalsAway: 0,
            goalsHome: 0,
            homeTeamId: "174e65e5-6d72-4f53-b4be-9d139715c89a",
            id: "408cfd4a-a440-4334-b815-36530a859dbc",
            kickOffTime: "2020-07-12T17:45:19.385Z",
          },
          "8e8ebfd9-40b1-40ac-8407-00339a7bf135": {
            awayTeamId: "83ab7af4-0410-4670-9398-844a1c251336",
            goalsAway: 2,
            goalsHome: 2,
            homeTeamId: "8b3c665f-6738-4744-81a7-91dbce1c58f7",
            id: "8e8ebfd9-40b1-40ac-8407-00339a7bf135",
            kickOffTime: "2020-07-11T19:45:19.161Z",
          },
          "922bc1d8-3dea-49b4-8e53-fdc3f6f4bc9f": {
            awayTeamId: "69007dc2-fb11-43ba-8b60-321960051e67",
            goalsAway: 1,
            goalsHome: 3,
            homeTeamId: "3f45562f-f848-41e5-83ba-5f1a1e4e285f",
            id: "922bc1d8-3dea-49b4-8e53-fdc3f6f4bc9f",
            kickOffTime: "2020-07-13T19:45:12.761Z",
          },
          "94471fc5-8d2c-496c-ae19-3e433ed93174": {
            awayTeamId: "b59106f0-dd86-4e9d-8dc9-fd074aece6ee",
            goalsAway: 2,
            goalsHome: 1,
            homeTeamId: "17dc6c9a-4f3b-4ebc-b3a4-bcb6eda1a30a",
            id: "94471fc5-8d2c-496c-ae19-3e433ed93174",
            kickOffTime: "2020-07-11T15:30:16.376Z",
          },
          "c71da8c1-9a05-4790-8e08-ae84b1ddbe0f": {
            awayTeamId: "619fbd53-4382-441f-a664-31c2dc5507b2",
            goalsAway: 1,
            goalsHome: 1,
            homeTeamId: "9bc4bbfc-5b00-40b6-9ba4-e398114ec130",
            id: "c71da8c1-9a05-4790-8e08-ae84b1ddbe0f",
            kickOffTime: "2020-07-12T17:45:19.385Z",
          },
          "d6ef3bc6-15f0-4876-8075-1c6ada3e1442": {
            awayTeamId: "6d7b6c20-1bae-4439-8762-f52144812dc3",
            goalsAway: 0,
            goalsHome: 2,
            homeTeamId: "5afd6cb9-f14f-431a-a0c0-22e4d9424a8f",
            id: "d6ef3bc6-15f0-4876-8075-1c6ada3e1442",
            kickOffTime: "2020-07-12T15:15:20.852Z",
          },
        },
        id: "2809eb7a-da64-4c21-a7fe-7e39c4e58755",
        matchday: 32,
        startDate: "",
      },
      {
        endDate: "",
        fixtures: {
          "00db3247-7bd1-4f51-92fb-7f84e6c9bb58": {
            awayTeamId: "fd626290-dd26-4768-acae-1f3770304ff6",
            goalsAway: 1,
            goalsHome: 3,
            homeTeamId: "1869c021-2191-49cf-b671-ea9ea08cd0fb",
            id: "00db3247-7bd1-4f51-92fb-7f84e6c9bb58",
            kickOffTime: "2020-07-15T17:30:14.168Z",
          },
          "221ebb2a-0852-456d-84b9-db8f03a1850a": {
            awayTeamId: "4a7d7192-288d-4185-8d46-a337129c6e77",
            goalsAway: 1,
            goalsHome: 1,
            homeTeamId: "ed4244af-01d2-4c79-92b9-2f77149615cd",
            id: "221ebb2a-0852-456d-84b9-db8f03a1850a",
            kickOffTime: "2020-07-15T17:30:14.167Z",
          },
          "38f42deb-a481-43bd-a8f2-075c08ca2e7d": {
            awayTeamId: "9bc4bbfc-5b00-40b6-9ba4-e398114ec130",
            goalsAway: 3,
            goalsHome: 1,
            homeTeamId: "553160b8-3b85-400d-b295-4c3212c2014f",
            id: "38f42deb-a481-43bd-a8f2-075c08ca2e7d",
            kickOffTime: "2020-07-15T19:45:16.268Z",
          },
          "410a6e02-15f0-4ab6-afc6-33bc4cebf94b": {
            awayTeamId: "619fbd53-4382-441f-a664-31c2dc5507b2",
            goalsAway: 1,
            goalsHome: 2,
            homeTeamId: "d1c1940c-2fae-4aab-81cd-7355bc2c9d85",
            id: "410a6e02-15f0-4ab6-afc6-33bc4cebf94b",
            kickOffTime: "2020-07-15T20:00:16.685Z",
          },
          "46fab587-1cc3-41fa-948f-1bf73b0d08f8": {
            awayTeamId: "8b3c665f-6738-4744-81a7-91dbce1c58f7",
            goalsAway: 3,
            goalsHome: 3,
            homeTeamId: "b59106f0-dd86-4e9d-8dc9-fd074aece6ee",
            id: "46fab587-1cc3-41fa-948f-1bf73b0d08f8",
            kickOffTime: "2020-07-15T19:45:16.268Z",
          },
          "4720f3a5-878e-4598-8704-af265eec53af": {
            awayTeamId: "17dc6c9a-4f3b-4ebc-b3a4-bcb6eda1a30a",
            goalsAway: 0,
            goalsHome: 0,
            homeTeamId: "2e52cbda-e75d-4420-9406-35b48f4393d7",
            id: "4720f3a5-878e-4598-8704-af265eec53af",
            kickOffTime: "2020-07-15T19:45:16.268Z",
          },
          "5c915272-bc04-45f3-9d36-4f47b8f88e53": {
            awayTeamId: "3f45562f-f848-41e5-83ba-5f1a1e4e285f",
            goalsAway: 4,
            goalsHome: 0,
            homeTeamId: "6d7b6c20-1bae-4439-8762-f52144812dc3",
            id: "5c915272-bc04-45f3-9d36-4f47b8f88e53",
            kickOffTime: "2020-07-16T19:45:11.760Z",
          },
          "87b863e3-e38d-4260-b225-d4d4f993a2fc": {
            awayTeamId: "52aa8f01-478f-4efc-be06-5472237d7fc9",
            goalsAway: 2,
            goalsHome: 6,
            homeTeamId: "83ab7af4-0410-4670-9398-844a1c251336",
            id: "87b863e3-e38d-4260-b225-d4d4f993a2fc",
            kickOffTime: "2020-07-14T19:45:12.061Z",
          },
          "a5511180-940b-4e9e-b302-7e320f5ab602": {
            awayTeamId: "174e65e5-6d72-4f53-b4be-9d139715c89a",
            goalsAway: 0,
            goalsHome: 3,
            homeTeamId: "6ab88ce9-af44-4299-9675-0b0598c8aba0",
            id: "a5511180-940b-4e9e-b302-7e320f5ab602",
            kickOffTime: "2020-07-15T17:30:14.167Z",
          },
          "f08dec7e-4e55-4ad3-a426-cd066ad35d53": {
            awayTeamId: "5afd6cb9-f14f-431a-a0c0-22e4d9424a8f",
            goalsAway: 0,
            goalsHome: 3,
            homeTeamId: "69007dc2-fb11-43ba-8b60-321960051e67",
            id: "f08dec7e-4e55-4ad3-a426-cd066ad35d53",
            kickOffTime: "2020-07-16T17:30:13.464Z",
          },
        },
        id: "663d8a5f-e5cd-4839-bb5c-9f53cb2d8e00",
        matchday: 33,
        startDate: "",
      },
      {
        endDate: "",
        fixtures: {
          "06ba05e7-4f23-4ace-8f4d-933d801e5e43": {
            awayTeamId: "553160b8-3b85-400d-b295-4c3212c2014f",
            goalsAway: 1,
            goalsHome: 2,
            homeTeamId: "5afd6cb9-f14f-431a-a0c0-22e4d9424a8f",
            id: "06ba05e7-4f23-4ace-8f4d-933d801e5e43",
            kickOffTime: "2020-07-19T18:00:20.188Z",
          },
          "7ea6ec44-42ff-4164-913a-4bff9f64e30a": {
            awayTeamId: "3f45562f-f848-41e5-83ba-5f1a1e4e285f",
            goalsAway: 2,
            goalsHome: 2,
            homeTeamId: "d1c1940c-2fae-4aab-81cd-7355bc2c9d85",
            id: "7ea6ec44-42ff-4164-913a-4bff9f64e30a",
            kickOffTime: "2020-07-19T19:45:17.546Z",
          },
          "88af67f3-1b75-46f2-af19-3e300107a2ae": {
            awayTeamId: "2e52cbda-e75d-4420-9406-35b48f4393d7",
            goalsAway: 1,
            goalsHome: 2,
            homeTeamId: "4a7d7192-288d-4185-8d46-a337129c6e77",
            id: "88af67f3-1b75-46f2-af19-3e300107a2ae",
            kickOffTime: "2020-07-19T17:45:18.077Z",
          },
          "93ebd7f5-c302-4b6d-9a81-1cc6a2375aac": {
            awayTeamId: "6ab88ce9-af44-4299-9675-0b0598c8aba0",
            goalsAway: 3,
            goalsHome: 2,
            homeTeamId: "fd626290-dd26-4768-acae-1f3770304ff6",
            id: "93ebd7f5-c302-4b6d-9a81-1cc6a2375aac",
            kickOffTime: "2020-07-19T15:45:19.954Z",
          },
          "bfd34c40-c265-40f4-b347-cfa0ad4d298f": {
            awayTeamId: "83ab7af4-0410-4670-9398-844a1c251336",
            goalsAway: 1,
            goalsHome: 1,
            homeTeamId: "619fbd53-4382-441f-a664-31c2dc5507b2",
            id: "bfd34c40-c265-40f4-b347-cfa0ad4d298f",
            kickOffTime: "2020-07-18T15:15:14.535Z",
          },
          "c8494bae-5da8-4204-91a7-915577e028df": {
            awayTeamId: "6d7b6c20-1bae-4439-8762-f52144812dc3",
            goalsAway: 1,
            goalsHome: 2,
            homeTeamId: "52aa8f01-478f-4efc-be06-5472237d7fc9",
            id: "c8494bae-5da8-4204-91a7-915577e028df",
            kickOffTime: "2020-07-19T17:30:21.052Z",
          },
          "cb028433-2c11-4bbb-91fc-be38410f7e81": {
            awayTeamId: "ed4244af-01d2-4c79-92b9-2f77149615cd",
            goalsAway: 1,
            goalsHome: 5,
            homeTeamId: "1869c021-2191-49cf-b671-ea9ea08cd0fb",
            id: "cb028433-2c11-4bbb-91fc-be38410f7e81",
            kickOffTime: "2020-07-18T19:45:15.847Z",
          },
          "ebed30d2-4d58-4e1b-b438-1b982a530967": {
            awayTeamId: "b59106f0-dd86-4e9d-8dc9-fd074aece6ee",
            goalsAway: 1,
            goalsHome: 1,
            homeTeamId: "174e65e5-6d72-4f53-b4be-9d139715c89a",
            id: "ebed30d2-4d58-4e1b-b438-1b982a530967",
            kickOffTime: "2020-07-18T17:30:19.039Z",
          },
          "f93ae8ec-8de5-4846-a707-d2b40da33b8b": {
            awayTeamId: "17dc6c9a-4f3b-4ebc-b3a4-bcb6eda1a30a",
            goalsAway: 1,
            goalsHome: 2,
            homeTeamId: "8b3c665f-6738-4744-81a7-91dbce1c58f7",
            id: "f93ae8ec-8de5-4846-a707-d2b40da33b8b",
            kickOffTime: "2020-07-20T19:45:13.572Z",
          },
          "fe7dcdc6-20ad-4d53-b571-a6fea97d495b": {
            awayTeamId: "69007dc2-fb11-43ba-8b60-321960051e67",
            goalsAway: 0,
            goalsHome: 2,
            homeTeamId: "9bc4bbfc-5b00-40b6-9ba4-e398114ec130",
            id: "fe7dcdc6-20ad-4d53-b571-a6fea97d495b",
            kickOffTime: "2020-07-19T17:30:21.052Z",
          },
        },
        id: "f0b552d0-8d02-4941-97e2-8f94117a0f37",
        matchday: 34,
        startDate: "",
      },
      {
        endDate: "",
        fixtures: {
          "0716e3e2-e8d0-49b7-8f9f-3f3a1616cdd6": {
            awayTeamId: "9bc4bbfc-5b00-40b6-9ba4-e398114ec130",
            goalsAway: 0,
            goalsHome: 0,
            homeTeamId: "3f45562f-f848-41e5-83ba-5f1a1e4e285f",
            id: "0716e3e2-e8d0-49b7-8f9f-3f3a1616cdd6",
            kickOffTime: "2020-07-22T19:45:11.822Z",
          },
          "1964e601-865d-4f9b-8f38-77c96a710ac4": {
            awayTeamId: "ed4244af-01d2-4c79-92b9-2f77149615cd",
            goalsAway: 0,
            goalsHome: 1,
            homeTeamId: "83ab7af4-0410-4670-9398-844a1c251336",
            id: "1964e601-865d-4f9b-8f38-77c96a710ac4",
            kickOffTime: "2020-07-21T17:30:10.575Z",
          },
          "1e0ad481-d1ae-45d3-8fca-c1a3d6353450": {
            awayTeamId: "619fbd53-4382-441f-a664-31c2dc5507b2",
            goalsAway: 1,
            goalsHome: 1,
            homeTeamId: "69007dc2-fb11-43ba-8b60-321960051e67",
            id: "1e0ad481-d1ae-45d3-8fca-c1a3d6353450",
            kickOffTime: "2020-07-22T19:45:11.822Z",
          },
          "3c84d8a5-3f25-4de2-9c84-fe657dad61cb": {
            awayTeamId: "174e65e5-6d72-4f53-b4be-9d139715c89a",
            goalsAway: 1,
            goalsHome: 2,
            homeTeamId: "17dc6c9a-4f3b-4ebc-b3a4-bcb6eda1a30a",
            id: "3c84d8a5-3f25-4de2-9c84-fe657dad61cb",
            kickOffTime: "2020-07-23T19:45:12.060Z",
          },
          "573d086d-2db3-4b1a-a38f-cce843500a79": {
            awayTeamId: "8b3c665f-6738-4744-81a7-91dbce1c58f7",
            goalsAway: 1,
            goalsHome: 2,
            homeTeamId: "2e52cbda-e75d-4420-9406-35b48f4393d7",
            id: "573d086d-2db3-4b1a-a38f-cce843500a79",
            kickOffTime: "2020-07-23T17:30:13.833Z",
          },
          "9d74981e-b7f8-4f9f-a876-aba0d4066b25": {
            awayTeamId: "d1c1940c-2fae-4aab-81cd-7355bc2c9d85",
            goalsAway: 6,
            goalsHome: 1,
            homeTeamId: "6d7b6c20-1bae-4439-8762-f52144812dc3",
            id: "9d74981e-b7f8-4f9f-a876-aba0d4066b25",
            kickOffTime: "2020-07-22T19:45:11.822Z",
          },
          "bfcd0999-5136-4402-a06b-2a1c1cbe1ff8": {
            awayTeamId: "1869c021-2191-49cf-b671-ea9ea08cd0fb",
            goalsAway: 2,
            goalsHome: 1,
            homeTeamId: "b59106f0-dd86-4e9d-8dc9-fd074aece6ee",
            id: "bfcd0999-5136-4402-a06b-2a1c1cbe1ff8",
            kickOffTime: "2020-07-21T19:45:09.869Z",
          },
          "e0f67bca-10f3-463f-bd90-7724fb9b5840": {
            awayTeamId: "4a7d7192-288d-4185-8d46-a337129c6e77",
            goalsAway: 1,
            goalsHome: 2,
            homeTeamId: "fd626290-dd26-4768-acae-1f3770304ff6",
            id: "e0f67bca-10f3-463f-bd90-7724fb9b5840",
            kickOffTime: "2020-07-22T17:30:13.295Z",
          },
          "ea7e21d2-35e9-4736-877c-7e6a3fff04da": {
            awayTeamId: "5afd6cb9-f14f-431a-a0c0-22e4d9424a8f",
            goalsAway: 2,
            goalsHome: 1,
            homeTeamId: "6ab88ce9-af44-4299-9675-0b0598c8aba0",
            id: "ea7e21d2-35e9-4736-877c-7e6a3fff04da",
            kickOffTime: "2020-07-22T19:45:11.822Z",
          },
        },
        id: "b1871a6a-18b5-4bd8-b4d4-81aee8158993",
        matchday: 35,
        startDate: "",
      },
      {
        endDate: "",
        fixtures: {
          "03fb9f9e-b6a4-40bf-b0d8-6e93d6b7f2bd": {
            awayTeamId: "fd626290-dd26-4768-acae-1f3770304ff6",
            goalsAway: 2,
            goalsHome: 1,
            homeTeamId: "52aa8f01-478f-4efc-be06-5472237d7fc9",
            id: "03fb9f9e-b6a4-40bf-b0d8-6e93d6b7f2bd",
            kickOffTime: "2020-07-25T15:15:13.473Z",
          },
          "3caf06f5-b07a-47d8-98d3-5b583441d3a7": {
            awayTeamId: "17dc6c9a-4f3b-4ebc-b3a4-bcb6eda1a30a",
            goalsAway: 5,
            goalsHome: 1,
            homeTeamId: "619fbd53-4382-441f-a664-31c2dc5507b2",
            id: "3caf06f5-b07a-47d8-98d3-5b583441d3a7",
            kickOffTime: "2020-07-26T17:45:12.238Z",
          },
          "4d41da38-b10e-443e-a8f9-31cbda4e6b41": {
            awayTeamId: "83ab7af4-0410-4670-9398-844a1c251336",
            goalsAway: 1,
            goalsHome: 1,
            homeTeamId: "1869c021-2191-49cf-b671-ea9ea08cd0fb",
            id: "4d41da38-b10e-443e-a8f9-31cbda4e6b41",
            kickOffTime: "2020-07-24T19:45:11.838Z",
          },
          "61b1f5e6-1182-4078-955f-4d20f6035323": {
            awayTeamId: "9bc4bbfc-5b00-40b6-9ba4-e398114ec130",
            goalsAway: 1,
            goalsHome: 2,
            homeTeamId: "d1c1940c-2fae-4aab-81cd-7355bc2c9d85",
            id: "61b1f5e6-1182-4078-955f-4d20f6035323",
            kickOffTime: "2020-07-26T17:30:16.333Z",
          },
          "68794b81-0c58-41eb-92d0-dd4de2cae65a": {
            awayTeamId: "b59106f0-dd86-4e9d-8dc9-fd074aece6ee",
            goalsAway: 0,
            goalsHome: 2,
            homeTeamId: "4a7d7192-288d-4185-8d46-a337129c6e77",
            id: "68794b81-0c58-41eb-92d0-dd4de2cae65a",
            kickOffTime: "2020-07-25T20:00:15.077Z",
          },
          "68a8f656-5583-42d9-bbf0-ff0233c01401": {
            awayTeamId: "553160b8-3b85-400d-b295-4c3212c2014f",
            goalsAway: 2,
            goalsHome: 3,
            homeTeamId: "ed4244af-01d2-4c79-92b9-2f77149615cd",
            id: "68a8f656-5583-42d9-bbf0-ff0233c01401",
            kickOffTime: "2020-07-26T15:15:16.109Z",
          },
          "6fd13056-33f8-48f5-b3b6-c281af78c5ad": {
            awayTeamId: "69007dc2-fb11-43ba-8b60-321960051e67",
            goalsAway: 1,
            goalsHome: 1,
            homeTeamId: "6d7b6c20-1bae-4439-8762-f52144812dc3",
            id: "6fd13056-33f8-48f5-b3b6-c281af78c5ad",
            kickOffTime: "2020-07-26T17:30:16.334Z",
          },
          "d1381dca-71e4-40df-ab80-eee1acb62e6f": {
            awayTeamId: "3f45562f-f848-41e5-83ba-5f1a1e4e285f",
            goalsAway: 3,
            goalsHome: 0,
            homeTeamId: "5afd6cb9-f14f-431a-a0c0-22e4d9424a8f",
            id: "d1381dca-71e4-40df-ab80-eee1acb62e6f",
            kickOffTime: "2020-07-25T17:30:16.482Z",
          },
          "d27eb9e0-3476-4dfc-9f5b-92bdbfaa25df": {
            awayTeamId: "2e52cbda-e75d-4420-9406-35b48f4393d7",
            goalsAway: 1,
            goalsHome: 0,
            homeTeamId: "174e65e5-6d72-4f53-b4be-9d139715c89a",
            id: "d27eb9e0-3476-4dfc-9f5b-92bdbfaa25df",
            kickOffTime: "2020-07-26T17:30:16.334Z",
          },
          "d64995c2-3304-4c08-8f46-482ebaaf4799": {
            awayTeamId: "6ab88ce9-af44-4299-9675-0b0598c8aba0",
            goalsAway: 0,
            goalsHome: 2,
            homeTeamId: "8b3c665f-6738-4744-81a7-91dbce1c58f7",
            id: "d64995c2-3304-4c08-8f46-482ebaaf4799",
            kickOffTime: "2020-07-26T19:45:17.341Z",
          },
        },
        id: "480eb182-9c44-4855-a9fc-b5118beb8e38",
        matchday: 36,
        startDate: "",
      },
      {
        endDate: "",
        fixtures: {
          "23044403-f95e-4b9f-a0e4-5d913ed8e497": {
            awayTeamId: "83ab7af4-0410-4670-9398-844a1c251336",
            goalsAway: 2,
            goalsHome: 1,
            homeTeamId: "fd626290-dd26-4768-acae-1f3770304ff6",
            id: "23044403-f95e-4b9f-a0e4-5d913ed8e497",
            kickOffTime: "2020-07-28T17:30:09.625Z",
          },
          "8e30f3df-5dac-4f62-b103-3c6f1a0dd8a6": {
            awayTeamId: "52aa8f01-478f-4efc-be06-5472237d7fc9",
            goalsAway: 0,
            goalsHome: 2,
            homeTeamId: "17dc6c9a-4f3b-4ebc-b3a4-bcb6eda1a30a",
            id: "8e30f3df-5dac-4f62-b103-3c6f1a0dd8a6",
            kickOffTime: "2020-07-29T17:30:12.910Z",
          },
          "90043622-be99-4f6a-a0f9-f21424f34212": {
            awayTeamId: "5afd6cb9-f14f-431a-a0c0-22e4d9424a8f",
            goalsAway: 0,
            goalsHome: 5,
            homeTeamId: "b59106f0-dd86-4e9d-8dc9-fd074aece6ee",
            id: "90043622-be99-4f6a-a0f9-f21424f34212",
            kickOffTime: "2020-07-29T17:30:12.913Z",
          },
          "9962e9a4-076d-4911-84cb-f24636c8d16c": {
            awayTeamId: "6d7b6c20-1bae-4439-8762-f52144812dc3",
            goalsAway: 0,
            goalsHome: 3,
            homeTeamId: "619fbd53-4382-441f-a664-31c2dc5507b2",
            id: "9962e9a4-076d-4911-84cb-f24636c8d16c",
            kickOffTime: "2020-07-29T17:30:12.914Z",
          },
          "9bf66c63-1778-4166-aa25-d7ae4e0d88ea": {
            awayTeamId: "1869c021-2191-49cf-b671-ea9ea08cd0fb",
            goalsAway: 4,
            goalsHome: 1,
            homeTeamId: "6ab88ce9-af44-4299-9675-0b0598c8aba0",
            id: "9bf66c63-1778-4166-aa25-d7ae4e0d88ea",
            kickOffTime: "2020-07-29T17:45:11.614Z",
          },
          "9fb01262-bc3f-452c-91fa-11d2714d6036": {
            awayTeamId: "8b3c665f-6738-4744-81a7-91dbce1c58f7",
            goalsAway: 0,
            goalsHome: 2,
            homeTeamId: "174e65e5-6d72-4f53-b4be-9d139715c89a",
            id: "9fb01262-bc3f-452c-91fa-11d2714d6036",
            kickOffTime: "2020-07-29T19:45:11.908Z",
          },
          "a08e3537-ea5a-40af-b0f1-cbd94424f566": {
            awayTeamId: "ed4244af-01d2-4c79-92b9-2f77149615cd",
            goalsAway: 0,
            goalsHome: 4,
            homeTeamId: "9bc4bbfc-5b00-40b6-9ba4-e398114ec130",
            id: "a08e3537-ea5a-40af-b0f1-cbd94424f566",
            kickOffTime: "2020-07-29T19:45:11.907Z",
          },
          "aa700bfb-6628-4edb-98e6-5131efc002d6": {
            awayTeamId: "553160b8-3b85-400d-b295-4c3212c2014f",
            goalsAway: 2,
            goalsHome: 1,
            homeTeamId: "2e52cbda-e75d-4420-9406-35b48f4393d7",
            id: "aa700bfb-6628-4edb-98e6-5131efc002d6",
            kickOffTime: "2020-07-29T17:30:12.913Z",
          },
          "aef8c90e-5b13-4d03-8de0-f9c63a4e571d": {
            awayTeamId: "d1c1940c-2fae-4aab-81cd-7355bc2c9d85",
            goalsAway: 3,
            goalsHome: 2,
            homeTeamId: "69007dc2-fb11-43ba-8b60-321960051e67",
            id: "aef8c90e-5b13-4d03-8de0-f9c63a4e571d",
            kickOffTime: "2020-07-29T20:00:12.003Z",
          },
        },
        id: "df7ed244-ea13-42ee-a1c0-cae65ccc8b09",
        matchday: 37,
        startDate: "",
      },
      {
        endDate: "",
        fixtures: {
          "1f9a1c28-68c7-4ea2-b9ee-28f3c10ec180": {
            awayTeamId: "6ab88ce9-af44-4299-9675-0b0598c8aba0",
            goalsAway: 1,
            goalsHome: 1,
            homeTeamId: "52aa8f01-478f-4efc-be06-5472237d7fc9",
            id: "1f9a1c28-68c7-4ea2-b9ee-28f3c10ec180",
            kickOffTime: "2020-08-01T16:15:16.599Z",
          },
        },
        id: "ce670015-9513-48fa-8e53-290d3c1ae09b",
        matchday: 38,
        startDate: "",
      },
    ],
  },
  spain: {
    "2019": [
      {
        endDate: "2019-08-18T11:59:59.999+02:00",
        fixtures: {
          "0f86f405-ab26-49b7-b458-4a1a65885187": {
            awayTeamId: "b205285c-f6c4-4265-86b9-d312e4cf9926",
            goalsAway: 2,
            goalsHome: 0,
            homeTeamId: "e2ddb049-085e-4455-b009-335c392e0787",
            id: "0f86f405-ab26-49b7-b458-4a1a65885187",
            kickOffTime: "2019-08-18T19:00:00.000+02:00",
          },
          "4f88ab7b-ae58-45e6-be4b-5d1a3295f112": {
            awayTeamId: "bf8c467b-ab50-4e35-b5f1-27f010d78608",
            goalsAway: 1,
            goalsHome: 2,
            homeTeamId: "87023cb8-23d5-43db-8397-999c7f2f960d",
            id: "4f88ab7b-ae58-45e6-be4b-5d1a3295f112",
            kickOffTime: "2019-08-17T20:00:00.000+02:00",
          },
          "5bcde79d-da23-4386-9fe3-53e166eedfbe": {
            awayTeamId: "ac5720ba-0460-4c66-9315-5c5dcc2c4527",
            goalsAway: 2,
            goalsHome: 1,
            homeTeamId: "b2050b89-0525-4eb3-8b98-e0239d12de1a",
            id: "5bcde79d-da23-4386-9fe3-53e166eedfbe",
            kickOffTime: "2019-08-18T21:00:00.000+02:00",
          },
          "630ac924-07fb-435a-ac51-1984155e8b7d": {
            awayTeamId: "07cb5cdb-7b74-4191-82c4-4a3a8ab2fdcb",
            goalsAway: 0,
            goalsHome: 1,
            homeTeamId: "9ced15e0-9f7f-41c7-974d-eda6c88142d9",
            id: "630ac924-07fb-435a-ac51-1984155e8b7d",
            kickOffTime: "2019-08-16T21:00:00.000+02:00",
          },
          "6de359e2-a2e0-496e-8c7a-93a3ffb24458": {
            awayTeamId: "b3517535-0384-48b4-a10c-020f6e792639",
            goalsAway: 1,
            goalsHome: 0,
            homeTeamId: "25c76dca-8b35-48f9-93fa-1057265b964e",
            id: "6de359e2-a2e0-496e-8c7a-93a3ffb24458",
            kickOffTime: "2019-08-17T21:00:00.000+02:00",
          },
          "afcf12f7-6c1c-46ac-8f9d-e55a27457205": {
            awayTeamId: "ef2e000c-3dac-463a-8988-d783511f526f",
            goalsAway: 3,
            goalsHome: 1,
            homeTeamId: "abe2b8c8-26ca-48b8-9cc4-57e74b140bac",
            id: "afcf12f7-6c1c-46ac-8f9d-e55a27457205",
            kickOffTime: "2019-08-17T17:00:00.000+02:00",
          },
          "c9b25b31-1f61-4b1b-9b2c-f973b9ee25d6": {
            awayTeamId: "889c061a-cdd1-4d23-8df9-4595317d77cf",
            goalsAway: 4,
            goalsHome: 4,
            homeTeamId: "f52b68d4-4097-44ec-9cbf-b254fdb5bec3",
            id: "c9b25b31-1f61-4b1b-9b2c-f973b9ee25d6",
            kickOffTime: "2019-08-17T21:00:00.000+02:00",
          },
          "cf7434e8-ae72-4afa-9e23-aafddaf8fc88": {
            awayTeamId: "0fa3d8dc-862d-4c3d-80fe-314055fe21f5",
            goalsAway: 0,
            goalsHome: 1,
            homeTeamId: "6cbce2d3-4a91-4f0e-b799-b70ed1196566",
            id: "cf7434e8-ae72-4afa-9e23-aafddaf8fc88",
            kickOffTime: "2019-08-18T22:00:00.000+02:00",
          },
          "d60196c9-8856-456f-9534-9483544cf256": {
            awayTeamId: "5d7c2cfc-0ff1-42b6-a562-b4930cca3daf",
            goalsAway: 1,
            goalsHome: 1,
            homeTeamId: "2a734618-cf1b-44cb-be80-b1ce3d8937d4",
            id: "d60196c9-8856-456f-9534-9483544cf256",
            kickOffTime: "2019-08-17T19:00:00.000+02:00",
          },
          "e858e03d-1138-4de0-a6fd-bedb9f8051d6": {
            awayTeamId: "28ab7b13-84a6-4fa4-b645-e30ee5d005c9",
            goalsAway: 0,
            goalsHome: 1,
            homeTeamId: "462eaa09-3935-4b21-83d9-7a684b0ca1c0",
            id: "a2d847f62-6a24-4bde-b9e6-8eefba150026",
            kickOffTime: "2019-08-18T17:00:00.000+02:00",
          },
        },
        id: "36c1412c-615b-4db0-beb0-85a9285da8f6",
        matchday: 1,
        startDate: "2019-08-16T21:00:00.000+02:00",
      },
      {
        endDate: "2019-08-25T23:00:00.000+02:00",
        fixtures: {
          "032c8852-a293-4f81-abbd-45d516559c3f": {
            awayTeamId: "e2ddb049-085e-4455-b009-335c392e0787",
            goalsAway: 0,
            goalsHome: 0,
            homeTeamId: "462eaa09-3935-4b21-83d9-7a684b0ca1c0",
            id: "032c8852-a293-4f81-abbd-45d516559c3f",
            kickOffTime: "2019-08-25T17:00:00.000+02:00",
          },
          "179fba18-3e13-423b-aa1e-69a4e6cbad2a": {
            awayTeamId: "2a734618-cf1b-44cb-be80-b1ce3d8937d4",
            goalsAway: 0,
            goalsHome: 1,
            homeTeamId: "abe2b8c8-26ca-48b8-9cc4-57e74b140bac",
            id: "179fba18-3e13-423b-aa1e-69a4e6cbad2a",
            kickOffTime: "2019-08-24T21:00:00.000+02:00",
          },
          "200f46fb-9d9d-45dc-a346-fa07bc902ae2": {
            awayTeamId: "b205285c-f6c4-4265-86b9-d312e4cf9926",
            goalsAway: 1,
            goalsHome: 0,
            homeTeamId: "889c061a-cdd1-4d23-8df9-4595317d77cf",
            id: "200f46fb-9d9d-45dc-a346-fa07bc902ae2",
            kickOffTime: "2019-08-23T20:00:00.000+02:00",
          },
          "84ffa202-bff1-4c81-b8eb-8dddabdf158d": {
            awayTeamId: "ac5720ba-0460-4c66-9315-5c5dcc2c4527",
            goalsAway: 1,
            goalsHome: 1,
            homeTeamId: "ef2e000c-3dac-463a-8988-d783511f526f",
            id: "84ffa202-bff1-4c81-b8eb-8dddabdf158d",
            kickOffTime: "2019-08-24T19:00:00.000+02:00",
          },
          "a2d847f62-6a24-4bde-b9e6-8eefba150026": {
            awayTeamId: "b2050b89-0525-4eb3-8b98-e0239d12de1a",
            goalsAway: 2,
            goalsHome: 5,
            homeTeamId: "07cb5cdb-7b74-4191-82c4-4a3a8ab2fdcb",
            id: "a2d847f62-6a24-4bde-b9e6-8eefba150026",
            kickOffTime: "2019-08-25T21:00:00.000+02:00",
          },
          "a6829cc3-096d-40dc-b86f-55b0fa39bdd2": {
            awayTeamId: "5d7c2cfc-0ff1-42b6-a562-b4930cca3daf",
            goalsAway: 1,
            goalsHome: 0,
            homeTeamId: "87023cb8-23d5-43db-8397-999c7f2f960d",
            id: "a6829cc3-096d-40dc-b86f-55b0fa39bdd2",
            kickOffTime: "2019-08-25T17:00:00.000+02:00",
          },
          "ac7da5d4-455b-407c-b77e-5364b5d3cbb0": {
            awayTeamId: "f52b68d4-4097-44ec-9cbf-b254fdb5bec3",
            goalsAway: 1,
            goalsHome: 2,
            homeTeamId: "28ab7b13-84a6-4fa4-b645-e30ee5d005c9",
            id: "ac7da5d4-455b-407c-b77e-5364b5d3cbb0",
            kickOffTime: "2019-08-23T22:00:00.000+02:00",
          },
          "afd6b6a6-709b-41bc-b160-567c3d34d11b": {
            awayTeamId: "6cbce2d3-4a91-4f0e-b799-b70ed1196566",
            goalsAway: 1,
            goalsHome: 0,
            homeTeamId: "25c76dca-8b35-48f9-93fa-1057265b964e",
            id: "afd6b6a6-709b-41bc-b160-567c3d34d11b",
            kickOffTime: "2019-08-25T19:00:00.000+02:00",
          },
          "d32cc77d-5ada-494d-bf19-72a91b2ff64a": {
            awayTeamId: "9ced15e0-9f7f-41c7-974d-eda6c88142d9",
            goalsAway: 1,
            goalsHome: 1,
            homeTeamId: "0fa3d8dc-862d-4c3d-80fe-314055fe21f5",
            id: "d32cc77d-5ada-494d-bf19-72a91b2ff64a",
            kickOffTime: "2019-08-24T21:00:00.000+02:00",
          },
          "daf4bda6-b170-4b76-a2aa-ca2a8cfe1c76": {
            awayTeamId: "bf8c467b-ab50-4e35-b5f1-27f010d78608",
            goalsAway: 0,
            goalsHome: 0,
            homeTeamId: "b3517535-0384-48b4-a10c-020f6e792639",
            id: "daf4bda6-b170-4b76-a2aa-ca2a8cfe1c76",
            kickOffTime: "2019-08-24T17:00:00.000+02:00",
          },
        },
        id: "df3bdf65-7bac-4e16-a789-47d2d1943429",
        matchday: 2,
        startDate: "2019-08-23T20:00:00.000+02:00",
      },
      {
        endDate: "2019-09-01T23:00:00.000+02:00",
        fixtures: {
          "2726d9cc-7a80-4adb-8194-342fb77644fa": {
            awayTeamId: "87023cb8-23d5-43db-8397-999c7f2f960d",
            goalsAway: 0,
            goalsHome: 2,
            homeTeamId: "2a734618-cf1b-44cb-be80-b1ce3d8937d4",
            id: "2726d9cc-7a80-4adb-8194-342fb77644fa",
            kickOffTime: "2019-09-01T17:00:00.000+02:00",
          },
          "3be6994b-0965-4d90-aa3d-3584c42e0b1d": {
            awayTeamId: "462eaa09-3935-4b21-83d9-7a684b0ca1c0",
            goalsAway: 1,
            goalsHome: 1,
            homeTeamId: "0fa3d8dc-862d-4c3d-80fe-314055fe21f5",
            id: "3be6994b-0965-4d90-aa3d-3584c42e0b1d",
            kickOffTime: "2019-08-31T19:00:00.000+02:00",
          },
          "4c2375ca-045a-4c6f-9e03-a9a3dc9ef53d": {
            awayTeamId: "ef2e000c-3dac-463a-8988-d783511f526f",
            goalsAway: 2,
            goalsHome: 2,
            homeTeamId: "f52b68d4-4097-44ec-9cbf-b254fdb5bec3",
            id: "4c2375ca-045a-4c6f-9e03-a9a3dc9ef53d",
            kickOffTime: "2019-09-01T21:00:00.000+02:00",
          },
          "5ed3a15a-60e7-47ee-a993-b27eea0bac06": {
            awayTeamId: "25c76dca-8b35-48f9-93fa-1057265b964e",
            goalsAway: 1,
            goalsHome: 2,
            homeTeamId: "b2050b89-0525-4eb3-8b98-e0239d12de1a",
            id: "5ed3a15a-60e7-47ee-a993-b27eea0bac06",
            kickOffTime: "2019-08-31T21:00:00.000+02:00",
          },
          "6b2bb876-a61b-4154-96e4-2f09b2dfc2b5": {
            awayTeamId: "bf8c467b-ab50-4e35-b5f1-27f010d78608",
            goalsAway: 2,
            goalsHome: 3,
            homeTeamId: "6cbce2d3-4a91-4f0e-b799-b70ed1196566",
            id: "6b2bb876-a61b-4154-96e4-2f09b2dfc2b5",
            kickOffTime: "2019-09-01T19:00:00.000+02:00",
          },
          "795a1ea7-e473-4c72-b803-72ca778b4863": {
            awayTeamId: "abe2b8c8-26ca-48b8-9cc4-57e74b140bac",
            goalsAway: 1,
            goalsHome: 1,
            homeTeamId: "b205285c-f6c4-4265-86b9-d312e4cf9926",
            id: "795a1ea7-e473-4c72-b803-72ca778b4863",
            kickOffTime: "2019-08-30T20:00:00.000+02:00",
          },
          "9d16df99-684c-4111-bd84-b11fc1590d75": {
            awayTeamId: "5d7c2cfc-0ff1-42b6-a562-b4930cca3daf",
            goalsAway: 0,
            goalsHome: 2,
            homeTeamId: "9ced15e0-9f7f-41c7-974d-eda6c88142d9",
            id: "9d16df99-684c-4111-bd84-b11fc1590d75",
            kickOffTime: "2019-08-30T22:00:00.000+02:00",
          },
          "b3df633e-4a33-4783-94cc-4a1f9532b581": {
            awayTeamId: "ac5720ba-0460-4c66-9315-5c5dcc2c4527",
            goalsAway: 0,
            goalsHome: 2,
            homeTeamId: "28ab7b13-84a6-4fa4-b645-e30ee5d005c9",
            id: "b3df633e-4a33-4783-94cc-4a1f9532b581",
            kickOffTime: "2019-08-31T19:00:00.000+02:00",
          },
          "b431f3c4-2a9b-4696-8ade-bfa0a2e0462d": {
            awayTeamId: "07cb5cdb-7b74-4191-82c4-4a3a8ab2fdcb",
            goalsAway: 2,
            goalsHome: 2,
            homeTeamId: "b3517535-0384-48b4-a10c-020f6e792639",
            id: "b431f3c4-2a9b-4696-8ade-bfa0a2e0462d",
            kickOffTime: "2019-08-31T17:00:00.000+02:00",
          },
          "f0350b16-7ac8-4c83-9c07-959541fb03d6": {
            awayTeamId: "889c061a-cdd1-4d23-8df9-4595317d77cf",
            goalsAway: 3,
            goalsHome: 0,
            homeTeamId: "e2ddb049-085e-4455-b009-335c392e0787",
            id: "f0350b16-7ac8-4c83-9c07-959541fb03d6",
            kickOffTime: "2019-09-01T19:00:00.000+02:00",
          },
        },
        id: "6b22a128-2423-434d-8af2-671b427b8e02",
        matchday: 3,
        startDate: "2019-08-30T20:00:00.000+02:00",
      },
      {
        endDate: "2019-09-15T23:00:00.000+02:00",
        fixtures: {
          "1c9a7c8b-7bb7-4eab-b2d5-279d77b43c4e": {
            awayTeamId: "b3517535-0384-48b4-a10c-020f6e792639",
            goalsAway: 1,
            goalsHome: 1,
            homeTeamId: "ac5720ba-0460-4c66-9315-5c5dcc2c4527",
            id: "1c9a7c8b-7bb7-4eab-b2d5-279d77b43c4e",
            kickOffTime: "2019-09-15T18:30:00.000+02:00",
          },
          "4a39c139-3ba4-4525-8cc9-e497f6067e41": {
            awayTeamId: "f52b68d4-4097-44ec-9cbf-b254fdb5bec3",
            goalsAway: 3,
            goalsHome: 0,
            homeTeamId: "25c76dca-8b35-48f9-93fa-1057265b964e",
            id: "4a39c139-3ba4-4525-8cc9-e497f6067e41",
            kickOffTime: "2019-09-14T16:00:00.000+02:00",
          },
          "5c2265a5-4f13-4853-9369-54ee10525b0a": {
            awayTeamId: "b205285c-f6c4-4265-86b9-d312e4cf9926",
            goalsAway: 1,
            goalsHome: 0,
            homeTeamId: "462eaa09-3935-4b21-83d9-7a684b0ca1c0",
            id: "5c2265a5-4f13-4853-9369-54ee10525b0a",
            kickOffTime: "2019-09-15T14:00:00.000+02:00",
          },
          "85b51c34-2658-43b7-a294-8bfe45ab255b": {
            awayTeamId: "2a734618-cf1b-44cb-be80-b1ce3d8937d4",
            goalsAway: 2,
            goalsHome: 5,
            homeTeamId: "07cb5cdb-7b74-4191-82c4-4a3a8ab2fdcb",
            id: "85b51c34-2658-43b7-a294-8bfe45ab255b",
            kickOffTime: "2019-09-14T21:00:00.000+02:00",
          },
          "95cc1ab6-49e5-4cfd-9175-0348e1ade5fe": {
            awayTeamId: "0fa3d8dc-862d-4c3d-80fe-314055fe21f5",
            goalsAway: 1,
            goalsHome: 1,
            homeTeamId: "b2050b89-0525-4eb3-8b98-e0239d12de1a",
            id: "95cc1ab6-49e5-4cfd-9175-0348e1ade5fe",
            kickOffTime: "2019-09-15T21:00:00.000+02:00",
          },
          "95f6618d-dec0-4f1a-bcba-df34fc8e154e": {
            awayTeamId: "e2ddb049-085e-4455-b009-335c392e0787",
            goalsAway: 2,
            goalsHome: 1,
            homeTeamId: "bf8c467b-ab50-4e35-b5f1-27f010d78608",
            id: "95f6618d-dec0-4f1a-bcba-df34fc8e154e",
            kickOffTime: "2019-09-15T12:00:00.000+02:00",
          },
          "a67ee6cc-ef4d-495d-a35f-1520fb0e46a5": {
            awayTeamId: "9ced15e0-9f7f-41c7-974d-eda6c88142d9",
            goalsAway: 0,
            goalsHome: 0,
            homeTeamId: "87023cb8-23d5-43db-8397-999c7f2f960d",
            id: "a67ee6cc-ef4d-495d-a35f-1520fb0e46a5",
            kickOffTime: "2019-09-13T21:00:00.000+02:00",
          },
          "b5b31ad9-a1d8-407c-9751-13efa3e1f238": {
            awayTeamId: "889c061a-cdd1-4d23-8df9-4595317d77cf",
            goalsAway: 2,
            goalsHome: 0,
            homeTeamId: "abe2b8c8-26ca-48b8-9cc4-57e74b140bac",
            id: "b5b31ad9-a1d8-407c-9751-13efa3e1f238",
            kickOffTime: "2019-09-15T16:00:00.000+02:00",
          },
          "ce03de1a-d26d-4bc0-8c7f-462af5079145": {
            awayTeamId: "28ab7b13-84a6-4fa4-b645-e30ee5d005c9",
            goalsAway: 2,
            goalsHome: 3,
            homeTeamId: "ef2e000c-3dac-463a-8988-d783511f526f",
            id: "ce03de1a-d26d-4bc0-8c7f-462af5079145",
            kickOffTime: "2019-09-14T13:00:00.000+02:00",
          },
          "ea110325-49d1-46da-bbcb-1b6325be908c": {
            awayTeamId: "6cbce2d3-4a91-4f0e-b799-b70ed1196566",
            goalsAway: 0,
            goalsHome: 2,
            homeTeamId: "5d7c2cfc-0ff1-42b6-a562-b4930cca3daf",
            id: "ea110325-49d1-46da-bbcb-1b6325be908c",
            kickOffTime: "2019-09-14T18:30:00.000+02:00",
          },
        },
        id: "7997aa49-9eb3-4d7e-a9dc-1867520bbdbf",
        matchday: 4,
        startDate: "2019-09-13T21:00:00.000+02:00",
      },
      {
        endDate: "2019-09-22T23:00:00.000+02:00",
        fixtures: {
          "014193c6-0056-4ab0-8c2d-67caeed7e1c3": {
            awayTeamId: "07cb5cdb-7b74-4191-82c4-4a3a8ab2fdcb",
            goalsAway: 0,
            goalsHome: 2,
            homeTeamId: "889c061a-cdd1-4d23-8df9-4595317d77cf",
            id: "014193c6-0056-4ab0-8c2d-67caeed7e1c3",
            kickOffTime: "2019-09-21T21:00:00.000+02:00",
          },
          "5cc8463b-72a3-48fa-bffd-8fd47699decd": {
            awayTeamId: "25c76dca-8b35-48f9-93fa-1057265b964e",
            goalsAway: 1,
            goalsHome: 1,
            homeTeamId: "2a734618-cf1b-44cb-be80-b1ce3d8937d4",
            id: "5cc8463b-72a3-48fa-bffd-8fd47699decd",
            kickOffTime: "2019-09-22T16:00:00.000+02:00",
          },
          "7a7166a3-31ff-49af-8662-ae5ed4a52b90": {
            awayTeamId: "ac5720ba-0460-4c66-9315-5c5dcc2c4527",
            goalsAway: 0,
            goalsHome: 2,
            homeTeamId: "f52b68d4-4097-44ec-9cbf-b254fdb5bec3",
            id: "7a7166a3-31ff-49af-8662-ae5ed4a52b90",
            kickOffTime: "2019-09-21T13:00:00.000+02:00",
          },
          "93f9d7b0-aca7-471a-b930-c62f5eaf278f": {
            awayTeamId: "ef2e000c-3dac-463a-8988-d783511f526f",
            goalsAway: 1,
            goalsHome: 0,
            homeTeamId: "b205285c-f6c4-4265-86b9-d312e4cf9926",
            id: "93f9d7b0-aca7-471a-b930-c62f5eaf278f",
            kickOffTime: "2019-09-22T21:00:00.000+02:00",
          },
          "a13ecd73-1ba1-4963-8d6d-91b65f4d7af9": {
            awayTeamId: "abe2b8c8-26ca-48b8-9cc4-57e74b140bac",
            goalsAway: 0,
            goalsHome: 0,
            homeTeamId: "6cbce2d3-4a91-4f0e-b799-b70ed1196566",
            id: "a13ecd73-1ba1-4963-8d6d-91b65f4d7af9",
            kickOffTime: "2019-09-21T18:30:00.000+02:00",
          },
          "b5d8ae20-b1c6-4ed2-b97d-1c5101a6f34b": {
            awayTeamId: "5d7c2cfc-0ff1-42b6-a562-b4930cca3daf",
            goalsAway: 3,
            goalsHome: 1,
            homeTeamId: "e2ddb049-085e-4455-b009-335c392e0787",
            id: "b5d8ae20-b1c6-4ed2-b97d-1c5101a6f34b",
            kickOffTime: "2019-09-22T14:00:00.000+02:00",
          },
          "bff2ff93-4291-45e0-bd42-58dc2b6ac2eb": {
            awayTeamId: "87023cb8-23d5-43db-8397-999c7f2f960d",
            goalsAway: 2,
            goalsHome: 4,
            homeTeamId: "0fa3d8dc-862d-4c3d-80fe-314055fe21f5",
            id: "bff2ff93-4291-45e0-bd42-58dc2b6ac2eb",
            kickOffTime: "2019-09-22T12:00:00.000+02:00",
          },
          "da746f3d-2171-4d8a-ac41-829940f49bd9": {
            awayTeamId: "462eaa09-3935-4b21-83d9-7a684b0ca1c0",
            goalsAway: 0,
            goalsHome: 2,
            homeTeamId: "9ced15e0-9f7f-41c7-974d-eda6c88142d9",
            id: "da746f3d-2171-4d8a-ac41-829940f49bd9",
            kickOffTime: "2019-09-22T18:30:00.000+02:00",
          },
          "f1cb52dc-29df-458b-916a-65378a7c7c6e": {
            awayTeamId: "bf8c467b-ab50-4e35-b5f1-27f010d78608",
            goalsAway: 0,
            goalsHome: 0,
            homeTeamId: "28ab7b13-84a6-4fa4-b645-e30ee5d005c9",
            id: "f1cb52dc-29df-458b-916a-65378a7c7c6e",
            kickOffTime: "2019-09-21T16:00:00.000+02:00",
          },
          "f4ec9a1b-680b-49e5-a60c-1fbe76572763": {
            awayTeamId: "b2050b89-0525-4eb3-8b98-e0239d12de1a",
            goalsAway: 0,
            goalsHome: 0,
            homeTeamId: "b3517535-0384-48b4-a10c-020f6e792639",
            id: "f4ec9a1b-680b-49e5-a60c-1fbe76572763",
            kickOffTime: "2019-09-20T21:00:00.000+02:00",
          },
        },
        id: "9c10531e-7603-4f69-9938-7d1bb63b3e56",
        matchday: 5,
        startDate: "2019-09-20T21:00:00.000+02:00",
      },
      {
        endDate: "2019-09-26T23:00:00.000+02:00",
        fixtures: {
          "0c62fd2c-8cee-4ef6-b10c-98b12e51dff3": {
            awayTeamId: "6cbce2d3-4a91-4f0e-b799-b70ed1196566",
            goalsAway: 2,
            goalsHome: 0,
            homeTeamId: "87023cb8-23d5-43db-8397-999c7f2f960d",
            kickOffTime: "2019-09-25T19:00:00.000+02:00",
          },
          "0dbe9a1e-84a6-4c86-8ad7-f9ccf1c93b9c": {
            awayTeamId: "28ab7b13-84a6-4fa4-b645-e30ee5d005c9",
            goalsAway: 1,
            goalsHome: 3,
            homeTeamId: "b2050b89-0525-4eb3-8b98-e0239d12de1a",
            kickOffTime: "2019-09-24T20:00:00.000+02:00",
          },
          "31f6e57f-812b-48f4-b7b2-867c67af2b8f": {
            awayTeamId: "b3517535-0384-48b4-a10c-020f6e792639",
            goalsAway: 0,
            goalsHome: 2,
            homeTeamId: "ef2e000c-3dac-463a-8988-d783511f526f",
            kickOffTime: "2019-09-25T21:00:00.000+02:00",
          },
          "3455dab6-7043-4183-99df-1318c6c91305": {
            awayTeamId: "889c061a-cdd1-4d23-8df9-4595317d77cf",
            goalsAway: 1,
            goalsHome: 1,
            homeTeamId: "ac5720ba-0460-4c66-9315-5c5dcc2c4527",
            kickOffTime: "2019-09-24T19:00:00.000+02:00",
          },
          "34ddac94-98c8-4c59-b301-c88e36bba5b2": {
            awayTeamId: "462eaa09-3935-4b21-83d9-7a684b0ca1c0",
            goalsAway: 0,
            goalsHome: 3,
            homeTeamId: "5d7c2cfc-0ff1-42b6-a562-b4930cca3daf",
            kickOffTime: "2019-09-26T21:00:00.000+02:00",
          },
          "38ab3d20-a63e-4403-b646-f5e6b0eacb1f": {
            awayTeamId: "b205285c-f6c4-4265-86b9-d312e4cf9926",
            goalsAway: 2,
            goalsHome: 3,
            homeTeamId: "bf8c467b-ab50-4e35-b5f1-27f010d78608",
            kickOffTime: "2019-09-26T19:00:00.000+02:00",
          },
          "3a6d9ffc-7d65-4441-87af-dfae27eabec9": {
            awayTeamId: "f52b68d4-4097-44ec-9cbf-b254fdb5bec3",
            goalsAway: 1,
            goalsHome: 2,
            homeTeamId: "07cb5cdb-7b74-4191-82c4-4a3a8ab2fdcb",
            kickOffTime: "2019-09-24T21:00:00.000+02:00",
          },
          "790064b7-506f-4415-a512-b443331a5ff7": {
            awayTeamId: "0fa3d8dc-862d-4c3d-80fe-314055fe21f5",
            goalsAway: 3,
            goalsHome: 3,
            homeTeamId: "2a734618-cf1b-44cb-be80-b1ce3d8937d4",
            kickOffTime: "2019-09-25T20:00:00.000+02:00",
          },
          "af881e79-cbaa-47a3-9c8e-800a0c43f402": {
            awayTeamId: "9ced15e0-9f7f-41c7-974d-eda6c88142d9",
            goalsAway: 1,
            goalsHome: 1,
            homeTeamId: "25c76dca-8b35-48f9-93fa-1057265b964e",
            kickOffTime: "2019-09-25T19:00:00.000+02:00",
          },
          "cbc5b492-6b7c-48aa-a3f0-9c204190185b": {
            awayTeamId: "e2ddb049-085e-4455-b009-335c392e0787",
            goalsAway: 1,
            goalsHome: 1,
            homeTeamId: "abe2b8c8-26ca-48b8-9cc4-57e74b140bac",
            kickOffTime: "2019-09-26T20:00:00.000+02:00",
          },
        },
        id: "e82f7060-ebcb-484a-8217-2f637b90967f",
        matchday: 6,
        startDate: "2019-09-24T19:00:00.000+02:00",
      },
      {
        endDate: "2019-09-29T23:00:00.000+02:00",
        fixtures: {
          "0f03b1a5-c355-4eb2-9610-4fbefe7ff4ad": {
            awayTeamId: "b3517535-0384-48b4-a10c-020f6e792639",
            goalsAway: 1,
            goalsHome: 1,
            homeTeamId: "28ab7b13-84a6-4fa4-b645-e30ee5d005c9",
            kickOffTime: "2019-09-29T18:30:00.000+02:00",
          },
          "2ebd6618-5809-4271-ac6e-98512bd22224": {
            awayTeamId: "07cb5cdb-7b74-4191-82c4-4a3a8ab2fdcb",
            goalsAway: 2,
            goalsHome: 0,
            homeTeamId: "0fa3d8dc-862d-4c3d-80fe-314055fe21f5",
            kickOffTime: "2019-09-28T15:00:00.000+02:00",
          },
          "6c5e7374-57ff-4b4a-a0a6-db303a27a4b5": {
            awayTeamId: "abe2b8c8-26ca-48b8-9cc4-57e74b140bac",
            goalsAway: 0,
            goalsHome: 2,
            homeTeamId: "bf8c467b-ab50-4e35-b5f1-27f010d78608",
            kickOffTime: "2019-09-29T14:00:00.000+02:00",
          },
          "78ed5175-2623-48e4-8f01-6cdaf02a565e": {
            awayTeamId: "87023cb8-23d5-43db-8397-999c7f2f960d",
            goalsAway: 0,
            goalsHome: 2,
            homeTeamId: "462eaa09-3935-4b21-83d9-7a684b0ca1c0",
            kickOffTime: "2019-09-29T16:00:00.000+02:00",
          },
          "8660aca9-9219-42a0-afe4-d9420a59264d": {
            awayTeamId: "2a734618-cf1b-44cb-be80-b1ce3d8937d4",
            goalsAway: 1,
            goalsHome: 0,
            homeTeamId: "9ced15e0-9f7f-41c7-974d-eda6c88142d9",
            kickOffTime: "2019-09-28T13:00:00.000+02:00",
          },
          "ce9940f6-90e5-49c5-ae4f-2535fc06d2d8": {
            awayTeamId: "25c76dca-8b35-48f9-93fa-1057265b964e",
            goalsAway: 0,
            goalsHome: 1,
            homeTeamId: "889c061a-cdd1-4d23-8df9-4595317d77cf",
            kickOffTime: "2019-09-14T18:30:00.000+02:00",
          },
          "d677c2c8-0e20-4ac8-a14f-5b84a9746862": {
            awayTeamId: "ac5720ba-0460-4c66-9315-5c5dcc2c4527",
            goalsAway: 2,
            goalsHome: 0,
            homeTeamId: "e2ddb049-085e-4455-b009-335c392e0787",
            kickOffTime: "2019-09-29T12:00:00.000+02:00",
          },
          "da29054a-9112-48fa-bc20-bb262363895e": {
            awayTeamId: "5d7c2cfc-0ff1-42b6-a562-b4930cca3daf",
            goalsAway: 2,
            goalsHome: 3,
            homeTeamId: "b205285c-f6c4-4265-86b9-d312e4cf9926",
            kickOffTime: "2019-09-29T21:00:00.000+02:00",
          },
          "df31ea70-256b-4e56-9cd0-d7a0f30a9ed8": {
            awayTeamId: "b2050b89-0525-4eb3-8b98-e0239d12de1a",
            goalsAway: 1,
            goalsHome: 5,
            homeTeamId: "f52b68d4-4097-44ec-9cbf-b254fdb5bec3",
            kickOffTime: "2019-09-27T21:00:00.000+02:00",
          },
          "ec482bad-1f16-4326-80f9-241622f20783": {
            awayTeamId: "ef2e000c-3dac-463a-8988-d783511f526f",
            goalsAway: 0,
            goalsHome: 0,
            homeTeamId: "6cbce2d3-4a91-4f0e-b799-b70ed1196566",
            kickOffTime: "2019-09-28T21:00:00.000+02:00",
          },
        },
        id: "6fd3934b-7a54-4e63-b8f8-ea90e3299a48",
        matchday: 7,
        startDate: "2019-09-27T21:00:00.000+02:00",
      },
      {
        endDate: "2019-10-06T23:00:00.000+02:00",
        fixtures: {
          "21e476c4-f2df-40f3-a09d-664956e3f334": {
            awayTeamId: "889c061a-cdd1-4d23-8df9-4595317d77cf",
            goalsAway: 2,
            goalsHome: 4,
            homeTeamId: "ef2e000c-3dac-463a-8988-d783511f526f",
            kickOffTime: "2019-10-05T16:00:00.000+02:00",
          },
          "24d21f48-0ab3-450d-aebe-343a99f86922": {
            awayTeamId: "f52b68d4-4097-44ec-9cbf-b254fdb5bec3",
            goalsAway: 1,
            goalsHome: 2,
            homeTeamId: "b3517535-0384-48b4-a10c-020f6e792639",
            kickOffTime: "2019-10-05T21:00:00.000+02:00",
          },
          "536ebed0-abaf-41d2-a173-5ded3d81fdab": {
            awayTeamId: "bf8c467b-ab50-4e35-b5f1-27f010d78608",
            goalsAway: 1,
            goalsHome: 1,
            homeTeamId: "b2050b89-0525-4eb3-8b98-e0239d12de1a",
            kickOffTime: "2019-10-04T21:00:00.000+02:00",
          },
          "54668cef-b821-4d8d-a469-794621b65869": {
            awayTeamId: "6cbce2d3-4a91-4f0e-b799-b70ed1196566",
            goalsAway: 0,
            goalsHome: 0,
            homeTeamId: "ac5720ba-0460-4c66-9315-5c5dcc2c4527",
            kickOffTime: "2019-10-06T16:00:00.000+02:00",
          },
          "73c34e9f-f9b1-4a6d-b417-6f542f05de25": {
            awayTeamId: "b205285c-f6c4-4265-86b9-d312e4cf9926",
            goalsAway: 0,
            goalsHome: 4,
            homeTeamId: "07cb5cdb-7b74-4191-82c4-4a3a8ab2fdcb",
            kickOffTime: "2019-10-06T21:00:00.000+02:00",
          },
          "74a7836a-adb1-4b04-82a6-93f58baf2565": {
            awayTeamId: "0fa3d8dc-862d-4c3d-80fe-314055fe21f5",
            goalsAway: 2,
            goalsHome: 1,
            homeTeamId: "5d7c2cfc-0ff1-42b6-a562-b4930cca3daf",
            kickOffTime: "2019-10-06T18:30:00.000+02:00",
          },
          "83223bd1-d71f-4ada-9310-654dc76ea891": {
            awayTeamId: "9ced15e0-9f7f-41c7-974d-eda6c88142d9",
            goalsAway: 0,
            goalsHome: 1,
            homeTeamId: "abe2b8c8-26ca-48b8-9cc4-57e74b140bac",
            kickOffTime: "2019-10-06T14:00:00.000+02:00",
          },
          "9c7be35c-cf48-4d92-8579-7ae3a3a92551": {
            awayTeamId: "e2ddb049-085e-4455-b009-335c392e0787",
            goalsAway: 0,
            goalsHome: 2,
            homeTeamId: "87023cb8-23d5-43db-8397-999c7f2f960d",
            kickOffTime: "2019-10-06T12:00:00.000+02:00",
          },
          "de55a345-d5e0-4973-ba60-5b9860d95854": {
            awayTeamId: "28ab7b13-84a6-4fa4-b645-e30ee5d005c9",
            goalsAway: 2,
            goalsHome: 1,
            homeTeamId: "25c76dca-8b35-48f9-93fa-1057265b964e",
            kickOffTime: "2019-10-05T13:00:00.000+02:00",
          },
          "e86179c8-963d-494d-88b6-d1e07a001a00": {
            awayTeamId: "462eaa09-3935-4b21-83d9-7a684b0ca1c0",
            goalsAway: 1,
            goalsHome: 2,
            homeTeamId: "2a734618-cf1b-44cb-be80-b1ce3d8937d4",
            kickOffTime: "2019-10-05T18:30:00.000+02:00",
          },
        },
        id: "f0a1a2a2-d2cd-4e36-badf-0b8c3be4838d",
        matchday: 8,
        startDate: "2019-10-04T21:00:00.000+02:00",
      },
      {
        endDate: "2019-10-20T23:00:00.000+02:00",
        fixtures: {
          "136ba77e-16e6-4172-adb5-ef5d2d443c02": {
            awayTeamId: "abe2b8c8-26ca-48b8-9cc4-57e74b140bac",
            goalsAway: 0,
            goalsHome: 2,
            homeTeamId: "462eaa09-3935-4b21-83d9-7a684b0ca1c0",
            kickOffTime: "2019-10-20T12:00:00.000+02:00",
          },
          "4d48bd4d-2e8b-4657-9718-2564214a357e": {
            awayTeamId: "07cb5cdb-7b74-4191-82c4-4a3a8ab2fdcb",
            goalsAway: 3,
            goalsHome: 0,
            homeTeamId: "bf8c467b-ab50-4e35-b5f1-27f010d78608",
            kickOffTime: "2019-10-19T13:00:00.000+02:00",
          },
          "6ff6e8de-10ec-4397-9e02-fd25b2260473": {
            awayTeamId: "28ab7b13-84a6-4fa4-b645-e30ee5d005c9",
            goalsAway: 0,
            goalsHome: 1,
            homeTeamId: "b205285c-f6c4-4265-86b9-d312e4cf9926",
            kickOffTime: "2019-10-20T21:00:00.000+02:00",
          },
          "76b42fdf-7bc1-444b-ab6d-a87a3b31c44d": {
            awayTeamId: "f52b68d4-4097-44ec-9cbf-b254fdb5bec3",
            goalsAway: 1,
            goalsHome: 0,
            homeTeamId: "e2ddb049-085e-4455-b009-335c392e0787",
            kickOffTime: "2019-10-20T16:00:00.000+02:00",
          },
          "972c5fe9-25e6-4b48-85fa-c564be3b5bf0": {
            awayTeamId: "25c76dca-8b35-48f9-93fa-1057265b964e",
            goalsAway: 0,
            goalsHome: 2,
            homeTeamId: "0fa3d8dc-862d-4c3d-80fe-314055fe21f5",
            kickOffTime: "2019-10-19T18:30:00.000+02:00",
          },
          "a87165b3-b3bc-4488-b8c2-d30f0dfbd1f3": {
            awayTeamId: "ac5720ba-0460-4c66-9315-5c5dcc2c4527",
            goalsAway: 1,
            goalsHome: 1,
            homeTeamId: "9ced15e0-9f7f-41c7-974d-eda6c88142d9",
            kickOffTime: "2019-10-20T18:30:00.000+02:00",
          },
          "aefd7f75-e50c-4e45-a7a2-1b15d9cb8621": {
            awayTeamId: "2a734618-cf1b-44cb-be80-b1ce3d8937d4",
            goalsAway: 1,
            goalsHome: 1,
            homeTeamId: "6cbce2d3-4a91-4f0e-b799-b70ed1196566",
            kickOffTime: "2019-10-19T16:00:00.000+02:00",
          },
          "b1649c1b-b895-4ba9-8396-eb495226f4a3": {
            awayTeamId: "b2050b89-0525-4eb3-8b98-e0239d12de1a",
            goalsAway: 1,
            goalsHome: 3,
            homeTeamId: "5d7c2cfc-0ff1-42b6-a562-b4930cca3daf",
            kickOffTime: "2019-10-20T14:00:00.000+02:00",
          },
          "ed3f2893-f08e-40a7-b8bc-4f82be6ad52f": {
            awayTeamId: "ef2e000c-3dac-463a-8988-d783511f526f",
            goalsAway: 0,
            goalsHome: 1,
            homeTeamId: "87023cb8-23d5-43db-8397-999c7f2f960d",
            kickOffTime: "2019-10-19T21:00:00.000+02:00",
          },
          "f347fbbf-c4d2-43d5-85bb-2f9e1af68f24": {
            awayTeamId: "b3517535-0384-48b4-a10c-020f6e792639",
            goalsAway: 0,
            goalsHome: 1,
            homeTeamId: "889c061a-cdd1-4d23-8df9-4595317d77cf",
            kickOffTime: "2019-10-18T21:00:00.000+02:00",
          },
        },
        id: "bd1129d9-19e2-47ae-9997-dc080aeef59a",
        matchday: 9,
        startDate: "2019-10-18T21:00:00.000+02:00",
      },
      {
        endDate: "2019-10-27T23:00:00.000+01:00",
        fixtures: {
          "0b2f62f7-a333-404e-b91f-2e484ccb6466": {
            awayTeamId: "b2050b89-0525-4eb3-8b98-e0239d12de1a",
            goalsAway: 0,
            goalsHome: 1,
            homeTeamId: "889c061a-cdd1-4d23-8df9-4595317d77cf",
            kickOffTime: "2019-10-27T14:00:00.000+01:00",
          },
          "3c95b998-9e47-40f3-bc27-a9cc4a87dad5": {
            awayTeamId: "9ced15e0-9f7f-41c7-974d-eda6c88142d9",
            goalsAway: 0,
            goalsHome: 2,
            homeTeamId: "6cbce2d3-4a91-4f0e-b799-b70ed1196566",
            kickOffTime: "2019-10-26T21:00:00.000+02:00",
          },
          "3ceb4ded-fe0f-493a-aa38-0049ac9ce445": {
            awayTeamId: "ef2e000c-3dac-463a-8988-d783511f526f",
            goalsAway: 0,
            goalsHome: 0,
            homeTeamId: "07cb5cdb-7b74-4191-82c4-4a3a8ab2fdcb",
            kickOffTime: "2019-12-18T20:00:00.000+01:00",
          },
          "58cb813c-6367-46dc-a9f0-9c61aef7d742": {
            awayTeamId: "5d7c2cfc-0ff1-42b6-a562-b4930cca3daf",
            goalsAway: 1,
            goalsHome: 0,
            homeTeamId: "abe2b8c8-26ca-48b8-9cc4-57e74b140bac",
            kickOffTime: "2019-10-27T12:00:00.000+01:00",
          },
          "591538de-2cb2-42b7-ac0d-82f6346f1401": {
            awayTeamId: "2a734618-cf1b-44cb-be80-b1ce3d8937d4",
            goalsAway: 1,
            goalsHome: 3,
            homeTeamId: "b3517535-0384-48b4-a10c-020f6e792639",
            kickOffTime: "2019-10-27T21:00:00.000+01:00",
          },
          "606010c2-ff3f-4db1-ac25-eb77a89a229a": {
            awayTeamId: "e2ddb049-085e-4455-b009-335c392e0787",
            goalsAway: 1,
            goalsHome: 0,
            homeTeamId: "28ab7b13-84a6-4fa4-b645-e30ee5d005c9",
            kickOffTime: "2019-10-27T16:00:00.000+01:00",
          },
          "60de109e-093b-402e-99b8-c24b14ca7d56": {
            awayTeamId: "87023cb8-23d5-43db-8397-999c7f2f960d",
            goalsAway: 0,
            goalsHome: 1,
            homeTeamId: "25c76dca-8b35-48f9-93fa-1057265b964e",
            kickOffTime: "2019-10-26T16:00:00.000+02:00",
          },
          "a7623662-87d2-47e0-9702-b8736be26d8f": {
            awayTeamId: "462eaa09-3935-4b21-83d9-7a684b0ca1c0",
            goalsAway: 1,
            goalsHome: 4,
            homeTeamId: "f52b68d4-4097-44ec-9cbf-b254fdb5bec3",
            kickOffTime: "2019-10-25T21:00:00.000+02:00",
          },
          "f1552ef4-9e8c-477d-bd93-ce6e3ec5fb3f": {
            awayTeamId: "bf8c467b-ab50-4e35-b5f1-27f010d78608",
            goalsAway: 0,
            goalsHome: 2,
            homeTeamId: "ac5720ba-0460-4c66-9315-5c5dcc2c4527",
            kickOffTime: "2019-10-26T18:30:00.000+02:00",
          },
          "f66059a9-4dfc-4b18-b30a-41c6551b26d2": {
            awayTeamId: "0fa3d8dc-862d-4c3d-80fe-314055fe21f5",
            goalsAway: 0,
            goalsHome: 2,
            homeTeamId: "b205285c-f6c4-4265-86b9-d312e4cf9926",
            kickOffTime: "2019-10-27T18:30:00.000+01:00",
          },
        },
        id: "7854a23a-a7fb-4a87-8d5b-d5c0c1a8f6ee",
        matchday: 10,
        startDate: "2019-10-25T21:00:00.000+02:00",
      },
      {
        endDate: "2019-10-31T23:15:00.000+01:00",
        fixtures: {
          "1ce3cf41-1c34-40ce-8688-735cd9e0b4ec": {
            awayTeamId: "25c76dca-8b35-48f9-93fa-1057265b964e",
            goalsAway: 0,
            goalsHome: 5,
            homeTeamId: "ef2e000c-3dac-463a-8988-d783511f526f",
            kickOffTime: "2019-10-30T21:15:00.000+01:00",
          },
          "3e6290b0-1005-455c-88b2-b9af8b9d36ae": {
            awayTeamId: "ac5720ba-0460-4c66-9315-5c5dcc2c4527",
            goalsAway: 1,
            goalsHome: 5,
            homeTeamId: "07cb5cdb-7b74-4191-82c4-4a3a8ab2fdcb",
            kickOffTime: "2019-10-29T21:15:00.000+01:00",
          },
          "494b633a-240c-4e77-9c6c-c370ddc3e70c": {
            awayTeamId: "e2ddb049-085e-4455-b009-335c392e0787",
            goalsAway: 0,
            goalsHome: 3,
            homeTeamId: "9ced15e0-9f7f-41c7-974d-eda6c88142d9",
            kickOffTime: "2019-10-30T20:00:00.000+01:00",
          },
          "4df5d42a-c172-45d2-9616-c06a34c50abb": {
            awayTeamId: "abe2b8c8-26ca-48b8-9cc4-57e74b140bac",
            goalsAway: 1,
            goalsHome: 2,
            homeTeamId: "b2050b89-0525-4eb3-8b98-e0239d12de1a",
            kickOffTime: "2019-10-30T21:00:00.000+01:00",
          },
          "96a1edef-9063-4128-81b6-5e9a44350379": {
            awayTeamId: "6cbce2d3-4a91-4f0e-b799-b70ed1196566",
            goalsAway: 1,
            goalsHome: 1,
            homeTeamId: "462eaa09-3935-4b21-83d9-7a684b0ca1c0",
            kickOffTime: "2019-10-29T19:00:00.000+01:00",
          },
          "9d78c1f8-e4ae-498b-bccb-a3c49060ad77": {
            awayTeamId: "b205285c-f6c4-4265-86b9-d312e4cf9926",
            goalsAway: 1,
            goalsHome: 1,
            homeTeamId: "2a734618-cf1b-44cb-be80-b1ce3d8937d4",
            kickOffTime: "2019-10-30T19:00:00.000+01:00",
          },
          "a0094804-47f8-47af-b495-1885fd93beaf": {
            awayTeamId: "b3517535-0384-48b4-a10c-020f6e792639",
            goalsAway: 2,
            goalsHome: 2,
            homeTeamId: "87023cb8-23d5-43db-8397-999c7f2f960d",
            kickOffTime: "2019-10-31T19:00:00.000+01:00",
          },
          "c16b395e-1d45-4e32-8275-f977b8ebea0a": {
            awayTeamId: "28ab7b13-84a6-4fa4-b645-e30ee5d005c9",
            goalsAway: 2,
            goalsHome: 1,
            homeTeamId: "5d7c2cfc-0ff1-42b6-a562-b4930cca3daf",
            kickOffTime: "2019-10-30T19:00:00.000+01:00",
          },
          "db9db138-d81e-4dff-b7e8-11c2328e658d": {
            awayTeamId: "f52b68d4-4097-44ec-9cbf-b254fdb5bec3",
            goalsAway: 1,
            goalsHome: 2,
            homeTeamId: "bf8c467b-ab50-4e35-b5f1-27f010d78608",
            kickOffTime: "2019-10-31T19:00:00.000+01:00",
          },
          "f58bf627-cd8b-4c75-8ebc-4bbd5763600e": {
            awayTeamId: "889c061a-cdd1-4d23-8df9-4595317d77cf",
            goalsAway: 1,
            goalsHome: 3,
            homeTeamId: "0fa3d8dc-862d-4c3d-80fe-314055fe21f5",
            kickOffTime: "2019-10-31T21:15:00.000+01:00",
          },
        },
        id: "4d85205c-b2a6-4690-a12c-a89eec0b5698",
        matchday: 11,
        startDate: "2019-10-29T19:00:00.000+01:00",
      },
      {
        endDate: "2019-11-03T23:00:00.000+01:00",
        fixtures: {
          "209e3911-692b-47e7-9ec1-d9d718616f32": {
            awayTeamId: "0fa3d8dc-862d-4c3d-80fe-314055fe21f5",
            goalsAway: 1,
            goalsHome: 0,
            homeTeamId: "abe2b8c8-26ca-48b8-9cc4-57e74b140bac",
            kickOffTime: "2019-11-03T18:30:00.000+01:00",
          },
          "4dbbc9c2-c82b-475b-9bd7-d514aac519fd": {
            awayTeamId: "07cb5cdb-7b74-4191-82c4-4a3a8ab2fdcb",
            goalsAway: 1,
            goalsHome: 3,
            homeTeamId: "28ab7b13-84a6-4fa4-b645-e30ee5d005c9",
            kickOffTime: "2019-11-02T16:00:00.000+01:00",
          },
          "6dc542ee-5de2-4343-824d-330e7ca0df70": {
            awayTeamId: "bf8c467b-ab50-4e35-b5f1-27f010d78608",
            goalsAway: 2,
            goalsHome: 1,
            homeTeamId: "25c76dca-8b35-48f9-93fa-1057265b964e",
            kickOffTime: "2019-11-03T18:30:00.000+01:00",
          },
          "85ba7d41-abc7-4d61-9cdc-fb2f1a21537e": {
            awayTeamId: "5d7c2cfc-0ff1-42b6-a562-b4930cca3daf",
            goalsAway: 2,
            goalsHome: 1,
            homeTeamId: "889c061a-cdd1-4d23-8df9-4595317d77cf",
            kickOffTime: "2019-11-03T21:00:00.000+01:00",
          },
          "bf1333f3-8da7-4caa-b38d-89a4589d80dd": {
            awayTeamId: "b2050b89-0525-4eb3-8b98-e0239d12de1a",
            goalsAway: 0,
            goalsHome: 0,
            homeTeamId: "ef2e000c-3dac-463a-8988-d783511f526f",
            kickOffTime: "2019-11-02T21:00:00.000+01:00",
          },
          "cd4fa8dc-b214-4478-88b1-63e95652ba1a": {
            awayTeamId: "2a734618-cf1b-44cb-be80-b1ce3d8937d4",
            goalsAway: 2,
            goalsHome: 1,
            homeTeamId: "e2ddb049-085e-4455-b009-335c392e0787",
            kickOffTime: "2019-11-02T13:00:00.000+01:00",
          },
          "d1570177-38a0-4d10-87dd-f261ea0a9279": {
            awayTeamId: "87023cb8-23d5-43db-8397-999c7f2f960d",
            goalsAway: 0,
            goalsHome: 3,
            homeTeamId: "ac5720ba-0460-4c66-9315-5c5dcc2c4527",
            kickOffTime: "2019-11-03T12:00:00.000+01:00",
          },
          "e6ba5acd-0342-4c1e-91e7-948c230a65f4": {
            awayTeamId: "9ced15e0-9f7f-41c7-974d-eda6c88142d9",
            goalsAway: 0,
            goalsHome: 0,
            homeTeamId: "f52b68d4-4097-44ec-9cbf-b254fdb5bec3",
            kickOffTime: "2019-11-03T14:00:00.000+01:00",
          },
          "e80e58a0-73b7-4c6f-beb9-41aace413410": {
            awayTeamId: "462eaa09-3935-4b21-83d9-7a684b0ca1c0",
            goalsAway: 2,
            goalsHome: 4,
            homeTeamId: "b3517535-0384-48b4-a10c-020f6e792639",
            kickOffTime: "2019-11-03T16:00:00.000+01:00",
          },
          "f3740997-cc25-41d2-9906-608368510e11": {
            awayTeamId: "6cbce2d3-4a91-4f0e-b799-b70ed1196566",
            goalsAway: 1,
            goalsHome: 1,
            homeTeamId: "b205285c-f6c4-4265-86b9-d312e4cf9926",
            kickOffTime: "2019-11-02T18:30:00.000+01:00",
          },
        },
        id: "28227df5-f849-4c5b-bf42-039295be2112",
        matchday: 12,
        startDate: "2019-11-02T13:00:00.000+01:00",
      },
      {
        endDate: "2019-11-10T23:00:00.000+01:00",
        fixtures: {
          "1f5416ad-da76-42c2-bf51-40341fc36f6e": {
            awayTeamId: "ef2e000c-3dac-463a-8988-d783511f526f",
            goalsAway: 4,
            goalsHome: 0,
            homeTeamId: "bf8c467b-ab50-4e35-b5f1-27f010d78608",
            kickOffTime: "2019-11-09T18:30:00.000+01:00",
          },
          "2826b059-131c-408d-b89c-0bd338d74278": {
            awayTeamId: "25c76dca-8b35-48f9-93fa-1057265b964e",
            goalsAway: 1,
            goalsHome: 1,
            homeTeamId: "5d7c2cfc-0ff1-42b6-a562-b4930cca3daf",
            kickOffTime: "2019-11-08T21:00:00.000+01:00",
          },
          "60879f41-5a15-47d2-b5f9-385f97adb831": {
            awayTeamId: "28ab7b13-84a6-4fa4-b645-e30ee5d005c9",
            goalsAway: 1,
            goalsHome: 2,
            homeTeamId: "9ced15e0-9f7f-41c7-974d-eda6c88142d9",
            kickOffTime: "2019-11-10T14:00:00.000+01:00",
          },
          "87176b4d-fcee-4a86-8fe2-c5588b262602": {
            awayTeamId: "b3517535-0384-48b4-a10c-020f6e792639",
            goalsAway: 0,
            goalsHome: 0,
            homeTeamId: "0fa3d8dc-862d-4c3d-80fe-314055fe21f5",
            kickOffTime: "2019-11-10T18:30:00.000+01:00",
          },
          "9e340e51-46a6-4524-9e84-96ba44c33ac9": {
            awayTeamId: "e2ddb049-085e-4455-b009-335c392e0787",
            goalsAway: 1,
            goalsHome: 3,
            homeTeamId: "6cbce2d3-4a91-4f0e-b799-b70ed1196566",
            kickOffTime: "2019-11-10T16:00:00.000+01:00",
          },
          "b3b4c187-6085-446e-bd9e-5a68811e2d28": {
            awayTeamId: "ac5720ba-0460-4c66-9315-5c5dcc2c4527",
            goalsAway: 0,
            goalsHome: 3,
            homeTeamId: "462eaa09-3935-4b21-83d9-7a684b0ca1c0",
            kickOffTime: "2019-11-09T13:00:00.000+01:00",
          },
          "b7db107e-e7a0-4ba2-b3a6-8fdbea43a34c": {
            awayTeamId: "abe2b8c8-26ca-48b8-9cc4-57e74b140bac",
            goalsAway: 1,
            goalsHome: 4,
            homeTeamId: "07cb5cdb-7b74-4191-82c4-4a3a8ab2fdcb",
            kickOffTime: "2019-11-09T21:00:00.000+01:00",
          },
          "b9ab34cc-ac7f-43d9-835b-8e069c232f9d": {
            awayTeamId: "889c061a-cdd1-4d23-8df9-4595317d77cf",
            goalsAway: 0,
            goalsHome: 2,
            homeTeamId: "2a734618-cf1b-44cb-be80-b1ce3d8937d4",
            kickOffTime: "2019-11-09T16:00:00.000+01:00",
          },
          "ca5d9fee-5ebc-4b86-8c20-0ff706d971ea": {
            awayTeamId: "f52b68d4-4097-44ec-9cbf-b254fdb5bec3",
            goalsAway: 1,
            goalsHome: 3,
            homeTeamId: "87023cb8-23d5-43db-8397-999c7f2f960d",
            kickOffTime: "2019-11-10T12:00:00.000+01:00",
          },
          "ccf71a99-be52-4176-92ed-250b4eb1a56c": {
            awayTeamId: "b205285c-f6c4-4265-86b9-d312e4cf9926",
            goalsAway: 2,
            goalsHome: 1,
            homeTeamId: "b2050b89-0525-4eb3-8b98-e0239d12de1a",
            kickOffTime: "2019-11-10T21:00:00.000+01:00",
          },
        },
        id: "c6f6f06b-6db5-40d6-89df-5445dfee18aa",
        matchday: 13,
        startDate: "2019-11-08T21:00:00.000+01:00",
      },
      {
        endDate: "2019-11-24T23:00:00.000+01:00",
        fixtures: {
          "38bf9c3f-8841-409b-934d-4571580d4a5c": {
            awayTeamId: "6cbce2d3-4a91-4f0e-b799-b70ed1196566",
            goalsAway: 1,
            goalsHome: 1,
            homeTeamId: "889c061a-cdd1-4d23-8df9-4595317d77cf",
            kickOffTime: "2019-11-23T18:30:00.000+01:00",
          },
          "5a69759d-6b12-44bf-854c-f7d7a93120f1": {
            awayTeamId: "462eaa09-3935-4b21-83d9-7a684b0ca1c0",
            goalsAway: 2,
            goalsHome: 0,
            homeTeamId: "bf8c467b-ab50-4e35-b5f1-27f010d78608",
            kickOffTime: "2019-11-24T16:00:00.000+01:00",
          },
          "7634b3c0-c057-4fe3-bab0-648f85cbb6b8": {
            awayTeamId: "b205285c-f6c4-4265-86b9-d312e4cf9926",
            goalsAway: 1,
            goalsHome: 0,
            homeTeamId: "ac5720ba-0460-4c66-9315-5c5dcc2c4527",
            kickOffTime: "2019-11-24T21:00:00.000+01:00",
          },
          "822ba262-be52-4f75-853c-dfb26595cabf": {
            awayTeamId: "0fa3d8dc-862d-4c3d-80fe-314055fe21f5",
            goalsAway: 1,
            goalsHome: 1,
            homeTeamId: "e2ddb049-085e-4455-b009-335c392e0787",
            kickOffTime: "2019-11-24T12:00:00.000+01:00",
          },
          "9de2491e-d7ef-45bf-badf-869cadc85256": {
            awayTeamId: "87023cb8-23d5-43db-8397-999c7f2f960d",
            goalsAway: 1,
            goalsHome: 2,
            homeTeamId: "28ab7b13-84a6-4fa4-b645-e30ee5d005c9",
            kickOffTime: "2019-11-22T22:00:00.000+01:00",
          },
          "dd619aab-b456-417f-80a1-15622e883c19": {
            awayTeamId: "5d7c2cfc-0ff1-42b6-a562-b4930cca3daf",
            goalsAway: 1,
            goalsHome: 3,
            homeTeamId: "ef2e000c-3dac-463a-8988-d783511f526f",
            kickOffTime: "2019-11-23T21:00:00.000+01:00",
          },
          "e7508fc1-665d-4fbc-8666-ad6a5e54eb0a": {
            awayTeamId: "2a734618-cf1b-44cb-be80-b1ce3d8937d4",
            goalsAway: 1,
            goalsHome: 2,
            homeTeamId: "b2050b89-0525-4eb3-8b98-e0239d12de1a",
            kickOffTime: "2019-11-23T16:00:00.000+01:00",
          },
          "ea463769-3728-4e6d-9e59-3b32519db0a6": {
            awayTeamId: "07cb5cdb-7b74-4191-82c4-4a3a8ab2fdcb",
            goalsAway: 2,
            goalsHome: 1,
            homeTeamId: "25c76dca-8b35-48f9-93fa-1057265b964e",
            kickOffTime: "2019-11-23T13:00:00.000+01:00",
          },
          "f91b8674-5587-4833-bbe6-ba922386b830": {
            awayTeamId: "9ced15e0-9f7f-41c7-974d-eda6c88142d9",
            goalsAway: 2,
            goalsHome: 1,
            homeTeamId: "b3517535-0384-48b4-a10c-020f6e792639",
            kickOffTime: "2019-11-24T14:00:00.000+01:00",
          },
          "f9d8664c-a19d-485f-9387-a14ed1138eda": {
            awayTeamId: "abe2b8c8-26ca-48b8-9cc4-57e74b140bac",
            goalsAway: 3,
            goalsHome: 1,
            homeTeamId: "f52b68d4-4097-44ec-9cbf-b254fdb5bec3",
            kickOffTime: "2019-11-24T18:30:00.000+01:00",
          },
        },
        id: "87ccab36-04ce-43e1-8da7-5c04b6d9b900",
        matchday: 14,
        startDate: "2019-11-22T22:00:00.000+01:00",
      },
      {
        endDate: "2019-12-01T23:00:00.000+01:00",
        fixtures: {
          "0ac779ef-e12e-4d59-9f5f-ef548affefe5": {
            awayTeamId: "28ab7b13-84a6-4fa4-b645-e30ee5d005c9",
            goalsAway: 0,
            goalsHome: 4,
            homeTeamId: "0fa3d8dc-862d-4c3d-80fe-314055fe21f5",
            kickOffTime: "2019-12-01T18:30:00.000+01:00",
          },
          "29b80f95-af3b-4713-9e63-037acea85816": {
            awayTeamId: "b2050b89-0525-4eb3-8b98-e0239d12de1a",
            goalsAway: 2,
            goalsHome: 1,
            homeTeamId: "87023cb8-23d5-43db-8397-999c7f2f960d",
            kickOffTime: "2019-11-30T18:30:00.000+01:00",
          },
          "47ccab91-64f3-4307-9bcd-cb3b911b9be9": {
            awayTeamId: "ef2e000c-3dac-463a-8988-d783511f526f",
            goalsAway: 2,
            goalsHome: 1,
            homeTeamId: "462eaa09-3935-4b21-83d9-7a684b0ca1c0",
            kickOffTime: "2019-11-30T13:00:00.000+01:00",
          },
          "492bd0de-e5ab-4509-bb8e-cbf86620ad6d": {
            awayTeamId: "07cb5cdb-7b74-4191-82c4-4a3a8ab2fdcb",
            goalsAway: 1,
            goalsHome: 0,
            homeTeamId: "6cbce2d3-4a91-4f0e-b799-b70ed1196566",
            kickOffTime: "2019-12-01T21:00:00.000+01:00",
          },
          "4b58c94c-65ed-49ae-ad39-bd45f87aa0a8": {
            awayTeamId: "b3517535-0384-48b4-a10c-020f6e792639",
            goalsAway: 4,
            goalsHome: 2,
            homeTeamId: "e2ddb049-085e-4455-b009-335c392e0787",
            kickOffTime: "2019-12-01T16:00:00.000+01:00",
          },
          "6cd55ca8-1ea9-484b-955b-abe2745d8c04": {
            awayTeamId: "889c061a-cdd1-4d23-8df9-4595317d77cf",
            goalsAway: 0,
            goalsHome: 2,
            homeTeamId: "9ced15e0-9f7f-41c7-974d-eda6c88142d9",
            kickOffTime: "2019-12-01T14:00:00.000+01:00",
          },
          "72edf65f-37e4-4de3-9e41-800bc069a53a": {
            awayTeamId: "ac5720ba-0460-4c66-9315-5c5dcc2c4527",
            goalsAway: 0,
            goalsHome: 0,
            homeTeamId: "abe2b8c8-26ca-48b8-9cc4-57e74b140bac",
            kickOffTime: "2019-11-29T21:00:00.000+01:00",
          },
          "a8fd8239-5e23-441d-91b9-e85ed4e5f9da": {
            awayTeamId: "bf8c467b-ab50-4e35-b5f1-27f010d78608",
            goalsAway: 1,
            goalsHome: 4,
            homeTeamId: "5d7c2cfc-0ff1-42b6-a562-b4930cca3daf",
            kickOffTime: "2019-11-30T16:00:00.000+01:00",
          },
          "c1eefd13-e8ac-4f74-aebe-5d3cbb18ce88": {
            awayTeamId: "f52b68d4-4097-44ec-9cbf-b254fdb5bec3",
            goalsAway: 1,
            goalsHome: 2,
            homeTeamId: "2a734618-cf1b-44cb-be80-b1ce3d8937d4",
            kickOffTime: "2019-11-30T21:00:00.000+01:00",
          },
          "dfe08e8a-e3d4-4cfa-8dfe-cdb0b2e368cc": {
            awayTeamId: "25c76dca-8b35-48f9-93fa-1057265b964e",
            goalsAway: 0,
            goalsHome: 1,
            homeTeamId: "b205285c-f6c4-4265-86b9-d312e4cf9926",
            kickOffTime: "2019-12-01T12:00:00.000+01:00",
          },
        },
        id: "2dafc2bb-9237-4cce-b1bb-45fd3a22658d",
        matchday: 15,
        startDate: "2019-11-29T21:00:00.000+01:00",
      },
      {
        endDate: "2019-12-08T23:00:00.000+01:00",
        fixtures: {
          "19111f5c-2baf-4a68-b363-24bde7e87db4": {
            awayTeamId: "462eaa09-3935-4b21-83d9-7a684b0ca1c0",
            goalsAway: 0,
            goalsHome: 3,
            homeTeamId: "889c061a-cdd1-4d23-8df9-4595317d77cf",
            kickOffTime: "2019-12-07T16:00:00.000+01:00",
          },
          "5626461b-fbbb-43b1-a117-dc219579c43d": {
            awayTeamId: "9ced15e0-9f7f-41c7-974d-eda6c88142d9",
            goalsAway: 2,
            goalsHome: 3,
            homeTeamId: "b2050b89-0525-4eb3-8b98-e0239d12de1a",
            kickOffTime: "2019-12-08T14:00:00.000+01:00",
          },
          "933b826a-f5bc-4725-9869-4414d6464e8d": {
            awayTeamId: "5d7c2cfc-0ff1-42b6-a562-b4930cca3daf",
            goalsAway: 0,
            goalsHome: 0,
            homeTeamId: "ac5720ba-0460-4c66-9315-5c5dcc2c4527",
            kickOffTime: "2019-12-08T16:00:00.000+01:00",
          },
          "96246910-ff87-4c53-8523-d0daceb7d188": {
            awayTeamId: "87023cb8-23d5-43db-8397-999c7f2f960d",
            goalsAway: 2,
            goalsHome: 5,
            homeTeamId: "07cb5cdb-7b74-4191-82c4-4a3a8ab2fdcb",
            kickOffTime: "2019-12-07T21:00:00.000+01:00",
          },
          "a53aa2f3-39c2-489d-bca0-dccec7cf0842": {
            awayTeamId: "abe2b8c8-26ca-48b8-9cc4-57e74b140bac",
            goalsAway: 2,
            goalsHome: 3,
            homeTeamId: "25c76dca-8b35-48f9-93fa-1057265b964e",
            kickOffTime: "2019-12-08T18:30:00.000+01:00",
          },
          "ba30d3e2-e576-452c-a28c-88437f9553b5": {
            awayTeamId: "b205285c-f6c4-4265-86b9-d312e4cf9926",
            goalsAway: 1,
            goalsHome: 1,
            homeTeamId: "b3517535-0384-48b4-a10c-020f6e792639",
            kickOffTime: "2019-12-08T21:00:00.000+01:00",
          },
          "d40892c9-70e8-4b42-b38b-1608ac2b671e": {
            awayTeamId: "0fa3d8dc-862d-4c3d-80fe-314055fe21f5",
            goalsAway: 1,
            goalsHome: 0,
            homeTeamId: "bf8c467b-ab50-4e35-b5f1-27f010d78608",
            kickOffTime: "2019-12-08T12:00:00.000+01:00",
          },
          "d74cf05c-862d-4e9d-9ae1-3a9d309136da": {
            awayTeamId: "e2ddb049-085e-4455-b009-335c392e0787",
            goalsAway: 0,
            goalsHome: 2,
            homeTeamId: "ef2e000c-3dac-463a-8988-d783511f526f",
            kickOffTime: "2019-12-07T13:00:00.000+01:00",
          },
          "df30d340-72c9-40c0-8517-9e45a2e8849d": {
            awayTeamId: "6cbce2d3-4a91-4f0e-b799-b70ed1196566",
            goalsAway: 0,
            goalsHome: 0,
            homeTeamId: "f52b68d4-4097-44ec-9cbf-b254fdb5bec3",
            kickOffTime: "2019-12-06T21:00:00.000+01:00",
          },
          "f9a036b8-1613-4d74-812e-76bed8449864": {
            awayTeamId: "2a734618-cf1b-44cb-be80-b1ce3d8937d4",
            goalsAway: 4,
            goalsHome: 2,
            homeTeamId: "28ab7b13-84a6-4fa4-b645-e30ee5d005c9",
            kickOffTime: "2019-12-07T18:30:00.000+01:00",
          },
        },
        id: "8910255a-993b-491c-86f1-bcaac958aec6",
        matchday: 16,
        startDate: "2019-12-06T21:00:00.000+01:00",
      },
      {
        endDate: "",
        fixtures: {
          "33060d51-436b-4e3e-bd83-8a6aaa14c237": {
            awayTeamId: "25c76dca-8b35-48f9-93fa-1057265b964e",
            goalsAway: 1,
            goalsHome: 1,
            homeTeamId: "462eaa09-3935-4b21-83d9-7a684b0ca1c0",
            id: "33060d51-436b-4e3e-bd83-8a6aaa14c237",
            kickOffTime: "2019-12-13T21:00:00.000Z",
          },
          "36e81367-e702-4834-8485-e59994afa44b": {
            awayTeamId: "87023cb8-23d5-43db-8397-999c7f2f960d",
            goalsAway: 2,
            goalsHome: 2,
            homeTeamId: "abe2b8c8-26ca-48b8-9cc4-57e74b140bac",
            id: "36e81367-e702-4834-8485-e59994afa44b",
            kickOffTime: "2019-12-15T14:00:36.076Z",
          },
          "3731a587-0922-4059-8db7-9abf93c36566": {
            awayTeamId: "28ab7b13-84a6-4fa4-b645-e30ee5d005c9",
            goalsAway: 2,
            goalsHome: 1,
            homeTeamId: "889c061a-cdd1-4d23-8df9-4595317d77cf",
            id: "3731a587-0922-4059-8db7-9abf93c36566",
            kickOffTime: "2019-12-14T13:00:07.496Z",
          },
          "388b921e-0f96-49b6-a771-78f2dd80fcd8": {
            awayTeamId: "b3517535-0384-48b4-a10c-020f6e792639",
            goalsAway: 0,
            goalsHome: 2,
            homeTeamId: "6cbce2d3-4a91-4f0e-b799-b70ed1196566",
            id: "388b921e-0f96-49b6-a771-78f2dd80fcd8",
            kickOffTime: "2019-12-14T21:00:07.499Z",
          },
          "3d318d48-1833-4f12-a3e3-2b105f3ab8da": {
            awayTeamId: "f52b68d4-4097-44ec-9cbf-b254fdb5bec3",
            goalsAway: 2,
            goalsHome: 1,
            homeTeamId: "b205285c-f6c4-4265-86b9-d312e4cf9926",
            id: "3d318d48-1833-4f12-a3e3-2b105f3ab8da",
            kickOffTime: "2019-12-15T18:30:36.078Z",
          },
          "4fd1a3ce-9183-4591-917a-5a23ecddc946": {
            awayTeamId: "ef2e000c-3dac-463a-8988-d783511f526f",
            goalsAway: 1,
            goalsHome: 1,
            homeTeamId: "2a734618-cf1b-44cb-be80-b1ce3d8937d4",
            id: "4fd1a3ce-9183-4591-917a-5a23ecddc946",
            kickOffTime: "2019-12-15T21:00:36.082Z",
          },
          "53d3d86e-0b2a-4c1b-af38-bd706c9f285e": {
            awayTeamId: "b2050b89-0525-4eb3-8b98-e0239d12de1a",
            goalsAway: 2,
            goalsHome: 2,
            homeTeamId: "e2ddb049-085e-4455-b009-335c392e0787",
            id: "53d3d86e-0b2a-4c1b-af38-bd706c9f285e",
            kickOffTime: "2019-12-15T16:00:36.077Z",
          },
          "aeff5a03-75cd-4d43-bf98-9b0009e74347": {
            awayTeamId: "bf8c467b-ab50-4e35-b5f1-27f010d78608",
            goalsAway: 0,
            goalsHome: 0,
            homeTeamId: "9ced15e0-9f7f-41c7-974d-eda6c88142d9",
            id: "aeff5a03-75cd-4d43-bf98-9b0009e74347",
            kickOffTime: "2019-12-14T18:30:07.498Z",
          },
          "d2ae524f-c594-483f-8a48-7a9f44f824c1": {
            awayTeamId: "ac5720ba-0460-4c66-9315-5c5dcc2c4527",
            goalsAway: 0,
            goalsHome: 2,
            homeTeamId: "0fa3d8dc-862d-4c3d-80fe-314055fe21f5",
            id: "d2ae524f-c594-483f-8a48-7a9f44f824c1",
            kickOffTime: "2019-12-15T12:00:36.075Z",
          },
          "edbd4053-c9da-4ce0-8051-2cd9ddbc9e2a": {
            awayTeamId: "07cb5cdb-7b74-4191-82c4-4a3a8ab2fdcb",
            goalsAway: 2,
            goalsHome: 2,
            homeTeamId: "5d7c2cfc-0ff1-42b6-a562-b4930cca3daf",
            id: "edbd4053-c9da-4ce0-8051-2cd9ddbc9e2a",
            kickOffTime: "2019-12-14T16:00:07.497Z",
          },
        },
        id: "a9269e6e-bf64-44b7-a264-907d17db7922",
        matchday: 17,
        startDate: "",
      },
      {
        endDate: "",
        fixtures: {
          "1971e03f-a4a9-4cd6-86be-ba32efc7b6ea": {
            awayTeamId: "9ced15e0-9f7f-41c7-974d-eda6c88142d9",
            goalsAway: 0,
            goalsHome: 0,
            homeTeamId: "ef2e000c-3dac-463a-8988-d783511f526f",
            kickOffTime: "2019-12-22T21:00:00.000+01:00",
          },
          "38822e0c-84c5-45a9-8941-61de358b6ff1": {
            awayTeamId: "0fa3d8dc-862d-4c3d-80fe-314055fe21f5",
            goalsAway: 0,
            goalsHome: 1,
            homeTeamId: "f52b68d4-4097-44ec-9cbf-b254fdb5bec3",
            kickOffTime: "2019-12-21T18:30:00.000+01:00",
          },
          "5b755874-588f-4161-920f-63a7cfb05d1b": {
            awayTeamId: "b205285c-f6c4-4265-86b9-d312e4cf9926",
            goalsAway: 2,
            goalsHome: 0,
            homeTeamId: "87023cb8-23d5-43db-8397-999c7f2f960d",
            kickOffTime: "2019-12-21T13:00:00.000+01:00",
          },
          "7fe9b57e-8b65-4a57-841a-15c5cef20b15": {
            awayTeamId: "abe2b8c8-26ca-48b8-9cc4-57e74b140bac",
            goalsAway: 1,
            goalsHome: 3,
            homeTeamId: "28ab7b13-84a6-4fa4-b645-e30ee5d005c9",
            kickOffTime: "2019-12-22T18:30:00.000+01:00",
          },
          "ad381b7d-9b38-421f-86a5-1a5b02fc73eb": {
            awayTeamId: "e2ddb049-085e-4455-b009-335c392e0787",
            goalsAway: 0,
            goalsHome: 2,
            homeTeamId: "25c76dca-8b35-48f9-93fa-1057265b964e",
            kickOffTime: "2019-12-22T12:00:00.000+01:00",
          },
          "b2e11ba3-ec83-4c22-b482-e0a4de5cfcb3": {
            awayTeamId: "5d7c2cfc-0ff1-42b6-a562-b4930cca3daf",
            goalsAway: 4,
            goalsHome: 3,
            homeTeamId: "b3517535-0384-48b4-a10c-020f6e792639",
            kickOffTime: "2019-12-22T14:00:00.000+01:00",
          },
          "baed85d3-90d2-4efb-b6b1-213e7f6a5a15": {
            awayTeamId: "2a734618-cf1b-44cb-be80-b1ce3d8937d4",
            goalsAway: 1,
            goalsHome: 1,
            homeTeamId: "ac5720ba-0460-4c66-9315-5c5dcc2c4527",
            kickOffTime: "2019-12-21T21:00:00.000+01:00",
          },
          "cf1a82a8-39cb-4203-bab5-b58b571c19f4": {
            awayTeamId: "462eaa09-3935-4b21-83d9-7a684b0ca1c0",
            goalsAway: 1,
            goalsHome: 4,
            homeTeamId: "07cb5cdb-7b74-4191-82c4-4a3a8ab2fdcb",
            kickOffTime: "2019-12-21T16:00:00.000+01:00",
          },
          "e7b64d39-0e2f-470b-8acd-50baf5c4fb1b": {
            awayTeamId: "889c061a-cdd1-4d23-8df9-4595317d77cf",
            goalsAway: 0,
            goalsHome: 3,
            homeTeamId: "bf8c467b-ab50-4e35-b5f1-27f010d78608",
            kickOffTime: "2019-12-20T21:00:00.000+01:00",
          },
          "eceac74d-a5cf-47b1-b51e-91485aaf9e23": {
            awayTeamId: "6cbce2d3-4a91-4f0e-b799-b70ed1196566",
            goalsAway: 2,
            goalsHome: 1,
            homeTeamId: "b2050b89-0525-4eb3-8b98-e0239d12de1a",
            kickOffTime: "2019-12-22T16:00:00.000+01:00",
          },
        },
        id: "9184d320-7be4-467d-ba30-bb94a7c53715",
        matchday: 18,
        startDate: "",
      },
      {
        endDate: "",
        fixtures: {
          "13ec4255-aae1-40e7-bf4a-0b3eb982e1b0": {
            awayTeamId: "25c76dca-8b35-48f9-93fa-1057265b964e",
            goalsAway: 2,
            goalsHome: 2,
            homeTeamId: "ac5720ba-0460-4c66-9315-5c5dcc2c4527",
            id: "13ec4255-aae1-40e7-bf4a-0b3eb982e1b0",
            kickOffTime: "2020-01-03T18:00:57.311Z",
          },
          "283c7ce9-e184-45cc-b9e2-47764007f5f5": {
            awayTeamId: "9ced15e0-9f7f-41c7-974d-eda6c88142d9",
            goalsAway: 1,
            goalsHome: 1,
            homeTeamId: "b205285c-f6c4-4265-86b9-d312e4cf9926",
            id: "283c7ce9-e184-45cc-b9e2-47764007f5f5",
            kickOffTime: "2020-01-03T20:01:00.812Z",
          },
          "372e00c6-95b8-4a44-9db4-0b8c99ba2a73": {
            awayTeamId: "28ab7b13-84a6-4fa4-b645-e30ee5d005c9",
            goalsAway: 1,
            goalsHome: 2,
            homeTeamId: "6cbce2d3-4a91-4f0e-b799-b70ed1196566",
            id: "372e00c6-95b8-4a44-9db4-0b8c99ba2a73",
            kickOffTime: "2020-01-04T17:31:02.253Z",
          },
          "3da502f1-fbce-467a-81cf-b27bf72ebc6d": {
            awayTeamId: "bf8c467b-ab50-4e35-b5f1-27f010d78608",
            goalsAway: 0,
            goalsHome: 1,
            homeTeamId: "2a734618-cf1b-44cb-be80-b1ce3d8937d4",
            id: "3da502f1-fbce-467a-81cf-b27bf72ebc6d",
            kickOffTime: "2020-01-04T12:01:00.448Z",
          },
          "4a86c3a9-9192-4e2a-bde7-41ff8c253902": {
            awayTeamId: "f52b68d4-4097-44ec-9cbf-b254fdb5bec3",
            goalsAway: 2,
            goalsHome: 1,
            homeTeamId: "5d7c2cfc-0ff1-42b6-a562-b4930cca3daf",
            id: "4a86c3a9-9192-4e2a-bde7-41ff8c253902",
            kickOffTime: "2020-01-05T13:01:01.156Z",
          },
          "65abfe0f-aa75-4e7f-8cb7-b6fa4e6afaba": {
            awayTeamId: "b2050b89-0525-4eb3-8b98-e0239d12de1a",
            goalsAway: 1,
            goalsHome: 1,
            homeTeamId: "462eaa09-3935-4b21-83d9-7a684b0ca1c0",
            id: "65abfe0f-aa75-4e7f-8cb7-b6fa4e6afaba",
            kickOffTime: "2020-01-05T15:15:57.555Z",
          },
          "8c49ba2a-9ce0-46db-b7ee-235fcac65777": {
            awayTeamId: "b3517535-0384-48b4-a10c-020f6e792639",
            goalsAway: 1,
            goalsHome: 1,
            homeTeamId: "abe2b8c8-26ca-48b8-9cc4-57e74b140bac",
            id: "8c49ba2a-9ce0-46db-b7ee-235fcac65777",
            kickOffTime: "2020-01-05T20:01:03.676Z",
          },
          "915cbb79-2fe7-4f1b-b3ef-27f6736f5f5e": {
            awayTeamId: "07cb5cdb-7b74-4191-82c4-4a3a8ab2fdcb",
            goalsAway: 2,
            goalsHome: 2,
            homeTeamId: "e2ddb049-085e-4455-b009-335c392e0787",
            id: "915cbb79-2fe7-4f1b-b3ef-27f6736f5f5e",
            kickOffTime: "2020-01-04T20:01:00.084Z",
          },
          "df56abf8-4ee6-4c5a-a36b-5e5d8dad8a25": {
            awayTeamId: "87023cb8-23d5-43db-8397-999c7f2f960d",
            goalsAway: 0,
            goalsHome: 1,
            homeTeamId: "889c061a-cdd1-4d23-8df9-4595317d77cf",
            id: "df56abf8-4ee6-4c5a-a36b-5e5d8dad8a25",
            kickOffTime: "2020-01-05T11:01:01.346Z",
          },
          "e202e063-6c64-473d-8078-9691539ebb95": {
            awayTeamId: "ef2e000c-3dac-463a-8988-d783511f526f",
            goalsAway: 3,
            goalsHome: 0,
            homeTeamId: "0fa3d8dc-862d-4c3d-80fe-314055fe21f5",
            id: "e202e063-6c64-473d-8078-9691539ebb95",
            kickOffTime: "2020-01-04T15:01:05.759Z",
          },
        },
        id: "2e39727e-ba7e-4e00-9560-8798ea0caadf",
        matchday: 19,
        startDate: "",
      },
      {
        endDate: "",
        fixtures: {
          "5b1fbcf6-d69c-4513-aea2-334b484c0e0c": {
            awayTeamId: "6cbce2d3-4a91-4f0e-b799-b70ed1196566",
            goalsAway: 0,
            goalsHome: 2,
            homeTeamId: "bf8c467b-ab50-4e35-b5f1-27f010d78608",
            id: "5b1fbcf6-d69c-4513-aea2-334b484c0e0c",
            kickOffTime: "2020-01-18T20:01:16.150Z",
          },
          "8eab0a21-c1e9-4d5d-a95f-7a7d206504c1": {
            awayTeamId: "462eaa09-3935-4b21-83d9-7a684b0ca1c0",
            goalsAway: 1,
            goalsHome: 0,
            homeTeamId: "28ab7b13-84a6-4fa4-b645-e30ee5d005c9",
            id: "8eab0a21-c1e9-4d5d-a95f-7a7d206504c1",
            kickOffTime: "2020-01-18T12:01:05.841Z",
          },
          "bb1aa257-2067-47eb-9834-daae152725e5": {
            awayTeamId: "2a734618-cf1b-44cb-be80-b1ce3d8937d4",
            goalsAway: 1,
            goalsHome: 4,
            homeTeamId: "87023cb8-23d5-43db-8397-999c7f2f960d",
            id: "bb1aa257-2067-47eb-9834-daae152725e5",
            kickOffTime: "2020-01-19T11:00:59.350Z",
          },
          "c978bc90-e20b-4eb8-8c1e-7b35e7332d24": {
            awayTeamId: "e2ddb049-085e-4455-b009-335c392e0787",
            goalsAway: 2,
            goalsHome: 1,
            homeTeamId: "f52b68d4-4097-44ec-9cbf-b254fdb5bec3",
            id: "c978bc90-e20b-4eb8-8c1e-7b35e7332d24",
            kickOffTime: "2020-01-19T15:01:07.340Z",
          },
          "cbc6dbdc-d78d-44f1-bd44-0b8d5f92bed2": {
            awayTeamId: "b205285c-f6c4-4265-86b9-d312e4cf9926",
            goalsAway: 1,
            goalsHome: 2,
            homeTeamId: "ef2e000c-3dac-463a-8988-d783511f526f",
            id: "cbc6dbdc-d78d-44f1-bd44-0b8d5f92bed2",
            kickOffTime: "2020-01-18T15:01:06.238Z",
          },
          "cd6e268f-beff-4b4f-ad68-cb6bc6be5aa0": {
            awayTeamId: "0fa3d8dc-862d-4c3d-80fe-314055fe21f5",
            goalsAway: 3,
            goalsHome: 0,
            homeTeamId: "25c76dca-8b35-48f9-93fa-1057265b964e",
            id: "cd6e268f-beff-4b4f-ad68-cb6bc6be5aa0",
            kickOffTime: "2020-01-17T20:01:01.410Z",
          },
          "de3f9765-253b-40aa-9a82-1d7b1f565bc3": {
            awayTeamId: "ac5720ba-0460-4c66-9315-5c5dcc2c4527",
            goalsAway: 0,
            goalsHome: 0,
            homeTeamId: "b3517535-0384-48b4-a10c-020f6e792639",
            id: "de3f9765-253b-40aa-9a82-1d7b1f565bc3",
            kickOffTime: "2020-01-18T17:31:06.941Z",
          },
          "eacd263c-245a-4b07-a6bc-340174e5c3e3": {
            awayTeamId: "5d7c2cfc-0ff1-42b6-a562-b4930cca3daf",
            goalsAway: 0,
            goalsHome: 3,
            homeTeamId: "b2050b89-0525-4eb3-8b98-e0239d12de1a",
            id: "eacd263c-245a-4b07-a6bc-340174e5c3e3",
            kickOffTime: "2020-01-19T13:01:03.038Z",
          },
          "f26b2728-0faa-4468-a38e-37a535d4fabe": {
            awayTeamId: "889c061a-cdd1-4d23-8df9-4595317d77cf",
            goalsAway: 0,
            goalsHome: 1,
            homeTeamId: "07cb5cdb-7b74-4191-82c4-4a3a8ab2fdcb",
            id: "f26b2728-0faa-4468-a38e-37a535d4fabe",
            kickOffTime: "2020-01-19T20:01:04.953Z",
          },
          "fe530bfa-4b37-4602-87ba-e8b933265e8d": {
            awayTeamId: "abe2b8c8-26ca-48b8-9cc4-57e74b140bac",
            goalsAway: 1,
            goalsHome: 1,
            homeTeamId: "9ced15e0-9f7f-41c7-974d-eda6c88142d9",
            id: "fe530bfa-4b37-4602-87ba-e8b933265e8d",
            kickOffTime: "2020-01-19T17:31:05.851Z",
          },
        },
        id: "fceb7597-9b75-4ab0-9058-5a8a0d5fb676",
        matchday: 20,
        startDate: "",
      },
      {
        endDate: "",
        fixtures: {
          "0c514c19-a20f-460e-b991-c5412a823ac2": {
            awayTeamId: "28ab7b13-84a6-4fa4-b645-e30ee5d005c9",
            goalsAway: 0,
            goalsHome: 2,
            homeTeamId: "b3517535-0384-48b4-a10c-020f6e792639",
            id: "0c514c19-a20f-460e-b991-c5412a823ac2",
            kickOffTime: "2020-01-24T20:00:57.854Z",
          },
          "2d227337-f420-4e3c-a8b1-79eabb1da1d4": {
            awayTeamId: "f52b68d4-4097-44ec-9cbf-b254fdb5bec3",
            goalsAway: 2,
            goalsHome: 1,
            homeTeamId: "462eaa09-3935-4b21-83d9-7a684b0ca1c0",
            id: "2d227337-f420-4e3c-a8b1-79eabb1da1d4",
            kickOffTime: "2020-01-25T17:31:07.166Z",
          },
          "47a4fe74-9026-47dc-af3f-538ee00948c4": {
            awayTeamId: "b2050b89-0525-4eb3-8b98-e0239d12de1a",
            goalsAway: 0,
            goalsHome: 1,
            homeTeamId: "0fa3d8dc-862d-4c3d-80fe-314055fe21f5",
            id: "47a4fe74-9026-47dc-af3f-538ee00948c4",
            kickOffTime: "2020-01-26T15:01:02.114Z",
          },
          "5fb2744d-e46b-4254-9d66-0971dde66276": {
            awayTeamId: "bf8c467b-ab50-4e35-b5f1-27f010d78608",
            goalsAway: 0,
            goalsHome: 0,
            homeTeamId: "abe2b8c8-26ca-48b8-9cc4-57e74b140bac",
            id: "5fb2744d-e46b-4254-9d66-0971dde66276",
            kickOffTime: "2020-01-26T13:01:00.311Z",
          },
          "9e99ca03-9998-4dd4-82f5-ab11191f63c4": {
            awayTeamId: "ef2e000c-3dac-463a-8988-d783511f526f",
            goalsAway: 1,
            goalsHome: 0,
            homeTeamId: "ac5720ba-0460-4c66-9315-5c5dcc2c4527",
            id: "9e99ca03-9998-4dd4-82f5-ab11191f63c4",
            kickOffTime: "2020-01-26T21:00:57.854Z",
          },
          "ba4da2a2-3f0f-49b6-8699-48d1494c1a85": {
            awayTeamId: "25c76dca-8b35-48f9-93fa-1057265b964e",
            goalsAway: 0,
            goalsHome: 0,
            homeTeamId: "6cbce2d3-4a91-4f0e-b799-b70ed1196566",
            id: "ba4da2a2-3f0f-49b6-8699-48d1494c1a85",
            kickOffTime: "2020-01-26T12:15:57.958Z",
          },
          "cd6b9765-9698-4217-801a-629f9967702d": {
            awayTeamId: "9ced15e0-9f7f-41c7-974d-eda6c88142d9",
            goalsAway: 1,
            goalsHome: 1,
            homeTeamId: "e2ddb049-085e-4455-b009-335c392e0787",
            id: "cd6b9765-9698-4217-801a-629f9967702d",
            kickOffTime: "2020-01-25T12:01:02.743Z",
          },
          "d1789b6a-9be5-4a1f-882d-7c829bf8f867": {
            awayTeamId: "07cb5cdb-7b74-4191-82c4-4a3a8ab2fdcb",
            goalsAway: 0,
            goalsHome: 2,
            homeTeamId: "2a734618-cf1b-44cb-be80-b1ce3d8937d4",
            id: "d1789b6a-9be5-4a1f-882d-7c829bf8f867",
            kickOffTime: "2020-01-25T15:01:06.443Z",
          },
          "f0e20aad-3755-412f-8cb2-2b62d7caa660": {
            awayTeamId: "889c061a-cdd1-4d23-8df9-4595317d77cf",
            goalsAway: 0,
            goalsHome: 2,
            homeTeamId: "b205285c-f6c4-4265-86b9-d312e4cf9926",
            id: "f0e20aad-3755-412f-8cb2-2b62d7caa660",
            kickOffTime: "2020-01-25T21:00:57.854Z",
          },
          "ff393052-95fb-409c-b9ad-8e1fecc18d23": {
            awayTeamId: "87023cb8-23d5-43db-8397-999c7f2f960d",
            goalsAway: 0,
            goalsHome: 3,
            homeTeamId: "5d7c2cfc-0ff1-42b6-a562-b4930cca3daf",
            id: "ff393052-95fb-409c-b9ad-8e1fecc18d23",
            kickOffTime: "2020-01-26T17:31:04.067Z",
          },
        },
        id: "20b6e3e5-da61-49fa-8df0-4e7c59dc5cb9",
        matchday: 21,
        startDate: "",
      },
      {
        endDate: "",
        fixtures: {
          "00686b03-2311-45a2-88a9-d61def77cd51": {
            awayTeamId: "e2ddb049-085e-4455-b009-335c392e0787",
            goalsAway: 1,
            goalsHome: 2,
            homeTeamId: "889c061a-cdd1-4d23-8df9-4595317d77cf",
            id: "00686b03-2311-45a2-88a9-d61def77cd51",
            kickOffTime: "2020-02-01T12:01:05.200Z",
          },
          "2670169e-a480-4a85-983c-8b59ad24472d": {
            awayTeamId: "b2050b89-0525-4eb3-8b98-e0239d12de1a",
            goalsAway: 1,
            goalsHome: 1,
            homeTeamId: "bf8c467b-ab50-4e35-b5f1-27f010d78608",
            id: "2670169e-a480-4a85-983c-8b59ad24472d",
            kickOffTime: "2020-02-02T13:01:02.646Z",
          },
          "3c13b3ae-d3ae-400a-bfbd-ae327382d6fb": {
            awayTeamId: "0fa3d8dc-862d-4c3d-80fe-314055fe21f5",
            goalsAway: 2,
            goalsHome: 0,
            homeTeamId: "9ced15e0-9f7f-41c7-974d-eda6c88142d9",
            id: "3c13b3ae-d3ae-400a-bfbd-ae327382d6fb",
            kickOffTime: "2020-02-02T15:01:04.747Z",
          },
          "3f6b807d-b96a-4f7e-b0a5-32eac49bbd24": {
            awayTeamId: "b3517535-0384-48b4-a10c-020f6e792639",
            goalsAway: 1,
            goalsHome: 3,
            homeTeamId: "f52b68d4-4097-44ec-9cbf-b254fdb5bec3",
            id: "3f6b807d-b96a-4f7e-b0a5-32eac49bbd24",
            kickOffTime: "2020-02-02T17:31:06.068Z",
          },
          "55c22060-1c27-4dc9-8969-6f9ac22193b6": {
            awayTeamId: "ac5720ba-0460-4c66-9315-5c5dcc2c4527",
            goalsAway: 1,
            goalsHome: 0,
            homeTeamId: "87023cb8-23d5-43db-8397-999c7f2f960d",
            id: "55c22060-1c27-4dc9-8969-6f9ac22193b6",
            kickOffTime: "2020-02-01T17:31:12.822Z",
          },
          "68fa709c-47af-485a-a206-c56d0da70def": {
            awayTeamId: "28ab7b13-84a6-4fa4-b645-e30ee5d005c9",
            goalsAway: 1,
            goalsHome: 2,
            homeTeamId: "07cb5cdb-7b74-4191-82c4-4a3a8ab2fdcb",
            id: "68fa709c-47af-485a-a206-c56d0da70def",
            kickOffTime: "2020-02-02T20:01:07.761Z",
          },
          "6ad4f3fa-03ad-4229-b7d3-f977f9c487be": {
            awayTeamId: "5d7c2cfc-0ff1-42b6-a562-b4930cca3daf",
            goalsAway: 1,
            goalsHome: 2,
            homeTeamId: "25c76dca-8b35-48f9-93fa-1057265b964e",
            id: "6ad4f3fa-03ad-4229-b7d3-f977f9c487be",
            kickOffTime: "2020-02-02T11:01:02.891Z",
          },
          "734d6af2-9242-438c-8c15-6dad1f540fac": {
            awayTeamId: "abe2b8c8-26ca-48b8-9cc4-57e74b140bac",
            goalsAway: 0,
            goalsHome: 1,
            homeTeamId: "2a734618-cf1b-44cb-be80-b1ce3d8937d4",
            id: "734d6af2-9242-438c-8c15-6dad1f540fac",
            kickOffTime: "2020-02-01T20:01:08.310Z",
          },
          "7625407c-f07e-46d1-b562-bc0b4d6ef0a9": {
            awayTeamId: "462eaa09-3935-4b21-83d9-7a684b0ca1c0",
            goalsAway: 1,
            goalsHome: 1,
            homeTeamId: "b205285c-f6c4-4265-86b9-d312e4cf9926",
            id: "7625407c-f07e-46d1-b562-bc0b4d6ef0a9",
            kickOffTime: "2020-02-02T17:31:06.068Z",
          },
          "f6cb99cb-1ac3-4674-a942-ee54ae1b1668": {
            awayTeamId: "6cbce2d3-4a91-4f0e-b799-b70ed1196566",
            goalsAway: 0,
            goalsHome: 1,
            homeTeamId: "ef2e000c-3dac-463a-8988-d783511f526f",
            id: "f6cb99cb-1ac3-4674-a942-ee54ae1b1668",
            kickOffTime: "2020-02-01T15:01:06.221Z",
          },
        },
        id: "b1c7455a-58c7-4b53-a4fe-b8d4e6811876",
        matchday: 22,
        startDate: "",
      },
      {
        endDate: "",
        fixtures: {
          "268e2381-03a7-4a01-9bff-0165dbcc022f": {
            awayTeamId: "9ced15e0-9f7f-41c7-974d-eda6c88142d9",
            goalsAway: 1,
            goalsHome: 2,
            homeTeamId: "5d7c2cfc-0ff1-42b6-a562-b4930cca3daf",
            id: "268e2381-03a7-4a01-9bff-0165dbcc022f",
            kickOffTime: "2020-02-09T13:01:03.356Z",
          },
          "29eadfb8-3fed-4f46-8650-3f00eae17724": {
            awayTeamId: "f52b68d4-4097-44ec-9cbf-b254fdb5bec3",
            goalsAway: 1,
            goalsHome: 1,
            homeTeamId: "ac5720ba-0460-4c66-9315-5c5dcc2c4527",
            id: "29eadfb8-3fed-4f46-8650-3f00eae17724",
            kickOffTime: "2020-02-08T17:31:03.453Z",
          },
          "3bbb6cfe-eda1-4661-b2fa-8f453c50d956": {
            awayTeamId: "2a734618-cf1b-44cb-be80-b1ce3d8937d4",
            goalsAway: 0,
            goalsHome: 3,
            homeTeamId: "0fa3d8dc-862d-4c3d-80fe-314055fe21f5",
            id: "3bbb6cfe-eda1-4661-b2fa-8f453c50d956",
            kickOffTime: "2020-02-08T15:01:08.355Z",
          },
          "3db7b0a7-de24-4e57-afc2-f57c8a9d8d95": {
            awayTeamId: "889c061a-cdd1-4d23-8df9-4595317d77cf",
            goalsAway: 0,
            goalsHome: 1,
            homeTeamId: "6cbce2d3-4a91-4f0e-b799-b70ed1196566",
            id: "3db7b0a7-de24-4e57-afc2-f57c8a9d8d95",
            kickOffTime: "2020-02-08T20:01:09.121Z",
          },
          "6d48cc70-cc5d-4392-adfd-1d3cf602609a": {
            awayTeamId: "87023cb8-23d5-43db-8397-999c7f2f960d",
            goalsAway: 0,
            goalsHome: 1,
            homeTeamId: "e2ddb049-085e-4455-b009-335c392e0787",
            id: "6d48cc70-cc5d-4392-adfd-1d3cf602609a",
            kickOffTime: "2020-02-09T11:00:59.364Z",
          },
          "83e7f36d-e666-45b0-9a73-f7bfb3bd0d68": {
            awayTeamId: "b205285c-f6c4-4265-86b9-d312e4cf9926",
            goalsAway: 1,
            goalsHome: 2,
            homeTeamId: "abe2b8c8-26ca-48b8-9cc4-57e74b140bac",
            id: "83e7f36d-e666-45b0-9a73-f7bfb3bd0d68",
            kickOffTime: "2020-02-09T17:31:07.856Z",
          },
          "8777244b-a58e-4ad6-aa9b-8db757652cb4": {
            awayTeamId: "25c76dca-8b35-48f9-93fa-1057265b964e",
            goalsAway: 0,
            goalsHome: 2,
            homeTeamId: "28ab7b13-84a6-4fa4-b645-e30ee5d005c9",
            id: "8777244b-a58e-4ad6-aa9b-8db757652cb4",
            kickOffTime: "2020-02-08T12:01:01.322Z",
          },
          "96cc4b3e-aee5-4e39-9164-4172b7007789": {
            awayTeamId: "07cb5cdb-7b74-4191-82c4-4a3a8ab2fdcb",
            goalsAway: 3,
            goalsHome: 2,
            homeTeamId: "b2050b89-0525-4eb3-8b98-e0239d12de1a",
            id: "96cc4b3e-aee5-4e39-9164-4172b7007789",
            kickOffTime: "2020-02-09T20:01:08.659Z",
          },
          "be30e4e1-ccfa-42ef-802d-a4f6b4fb8601": {
            awayTeamId: "bf8c467b-ab50-4e35-b5f1-27f010d78608",
            goalsAway: 1,
            goalsHome: 2,
            homeTeamId: "462eaa09-3935-4b21-83d9-7a684b0ca1c0",
            id: "be30e4e1-ccfa-42ef-802d-a4f6b4fb8601",
            kickOffTime: "2020-02-07T20:01:01.336Z",
          },
          "e4a317c1-8a5a-4292-84d8-bf88cedfdc49": {
            awayTeamId: "ef2e000c-3dac-463a-8988-d783511f526f",
            goalsAway: 4,
            goalsHome: 1,
            homeTeamId: "b3517535-0384-48b4-a10c-020f6e792639",
            id: "e4a317c1-8a5a-4292-84d8-bf88cedfdc49",
            kickOffTime: "2020-02-09T15:01:03.556Z",
          },
        },
        id: "de575626-c901-4cd0-9fdf-864fff137619",
        matchday: 23,
        startDate: "",
      },
      {
        endDate: "",
        fixtures: {
          "148ebccf-91c2-4068-b001-7e475484728f": {
            awayTeamId: "abe2b8c8-26ca-48b8-9cc4-57e74b140bac",
            goalsAway: 2,
            goalsHome: 2,
            homeTeamId: "ef2e000c-3dac-463a-8988-d783511f526f",
            id: "148ebccf-91c2-4068-b001-7e475484728f",
            kickOffTime: "2020-02-16T20:01:06.913Z",
          },
          "232c4e58-b192-43fb-b4ec-463cc0059e5e": {
            awayTeamId: "6cbce2d3-4a91-4f0e-b799-b70ed1196566",
            goalsAway: 2,
            goalsHome: 2,
            homeTeamId: "2a734618-cf1b-44cb-be80-b1ce3d8937d4",
            id: "232c4e58-b192-43fb-b4ec-463cc0059e5e",
            kickOffTime: "2020-02-14T20:00:58.546Z",
          },
          "2698a1ef-17b2-4024-8983-6128148d063e": {
            awayTeamId: "b3517535-0384-48b4-a10c-020f6e792639",
            goalsAway: 1,
            goalsHome: 0,
            homeTeamId: "9ced15e0-9f7f-41c7-974d-eda6c88142d9",
            id: "2698a1ef-17b2-4024-8983-6128148d063e",
            kickOffTime: "2020-02-16T17:31:11.118Z",
          },
          "2cbc6151-f408-47ff-b47d-d9d3a7559abd": {
            awayTeamId: "5d7c2cfc-0ff1-42b6-a562-b4930cca3daf",
            goalsAway: 2,
            goalsHome: 1,
            homeTeamId: "bf8c467b-ab50-4e35-b5f1-27f010d78608",
            id: "2cbc6151-f408-47ff-b47d-d9d3a7559abd",
            kickOffTime: "2020-03-10T19:00:56.315Z",
          },
          "393837e8-bd9d-4a8d-a279-9f6451a18669": {
            awayTeamId: "b2050b89-0525-4eb3-8b98-e0239d12de1a",
            goalsAway: 0,
            goalsHome: 0,
            homeTeamId: "25c76dca-8b35-48f9-93fa-1057265b964e",
            id: "393837e8-bd9d-4a8d-a279-9f6451a18669",
            kickOffTime: "2020-02-16T13:01:06.210Z",
          },
          "694ab4ca-ead2-48ea-92ff-c43c6c052b37": {
            awayTeamId: "ac5720ba-0460-4c66-9315-5c5dcc2c4527",
            goalsAway: 1,
            goalsHome: 2,
            homeTeamId: "889c061a-cdd1-4d23-8df9-4595317d77cf",
            id: "694ab4ca-ead2-48ea-92ff-c43c6c052b37",
            kickOffTime: "2020-02-15T20:01:09.291Z",
          },
          "6ebc0760-0616-426d-b3dc-929320415972": {
            awayTeamId: "462eaa09-3935-4b21-83d9-7a684b0ca1c0",
            goalsAway: 0,
            goalsHome: 1,
            homeTeamId: "87023cb8-23d5-43db-8397-999c7f2f960d",
            id: "6ebc0760-0616-426d-b3dc-929320415972",
            kickOffTime: "2020-02-15T12:00:59.267Z",
          },
          "970b947a-b1c7-4b8f-aa1c-e69ac21335ef": {
            awayTeamId: "0fa3d8dc-862d-4c3d-80fe-314055fe21f5",
            goalsAway: 1,
            goalsHome: 2,
            homeTeamId: "07cb5cdb-7b74-4191-82c4-4a3a8ab2fdcb",
            id: "970b947a-b1c7-4b8f-aa1c-e69ac21335ef",
            kickOffTime: "2020-02-15T15:01:10.401Z",
          },
          "efb41d4d-7572-4048-bd29-a1f6906f1b7a": {
            awayTeamId: "e2ddb049-085e-4455-b009-335c392e0787",
            goalsAway: 2,
            goalsHome: 2,
            homeTeamId: "b205285c-f6c4-4265-86b9-d312e4cf9926",
            id: "efb41d4d-7572-4048-bd29-a1f6906f1b7a",
            kickOffTime: "2020-02-16T11:00:59.773Z",
          },
          "f62f0ac0-aa3a-4478-9ed6-29bedb21b160": {
            awayTeamId: "28ab7b13-84a6-4fa4-b645-e30ee5d005c9",
            goalsAway: 1,
            goalsHome: 2,
            homeTeamId: "f52b68d4-4097-44ec-9cbf-b254fdb5bec3",
            id: "f62f0ac0-aa3a-4478-9ed6-29bedb21b160",
            kickOffTime: "2020-02-15T17:31:03.999Z",
          },
        },
        id: "1048fcd9-2800-4b0a-81c0-3b644ce7f943",
        matchday: 24,
        startDate: "",
      },
      {
        endDate: "",
        fixtures: {
          "061425f4-3cc6-415d-b887-e400930429f2": {
            awayTeamId: "bf8c467b-ab50-4e35-b5f1-27f010d78608",
            goalsAway: 0,
            goalsHome: 5,
            homeTeamId: "07cb5cdb-7b74-4191-82c4-4a3a8ab2fdcb",
            id: "061425f4-3cc6-415d-b887-e400930429f2",
            kickOffTime: "2020-02-22T15:00:56.522Z",
          },
          "14667982-3dd7-43c3-9688-99dee028e215": {
            awayTeamId: "889c061a-cdd1-4d23-8df9-4595317d77cf",
            goalsAway: 3,
            goalsHome: 0,
            homeTeamId: "b3517535-0384-48b4-a10c-020f6e792639",
            id: "14667982-3dd7-43c3-9688-99dee028e215",
            kickOffTime: "2020-02-23T11:01:04.950Z",
          },
          "9a96697b-f353-4a79-838e-fc1f2345485f": {
            awayTeamId: "25c76dca-8b35-48f9-93fa-1057265b964e",
            goalsAway: 0,
            goalsHome: 1,
            homeTeamId: "abe2b8c8-26ca-48b8-9cc4-57e74b140bac",
            id: "9a96697b-f353-4a79-838e-fc1f2345485f",
            kickOffTime: "2020-02-22T12:00:56.663Z",
          },
          "ab76c33b-1e75-4939-81e7-ecd597d03151": {
            awayTeamId: "2a734618-cf1b-44cb-be80-b1ce3d8937d4",
            goalsAway: 0,
            goalsHome: 3,
            homeTeamId: "5d7c2cfc-0ff1-42b6-a562-b4930cca3daf",
            id: "ab76c33b-1e75-4939-81e7-ecd597d03151",
            kickOffTime: "2020-02-22T17:30:58.772Z",
          },
          "bcc5c795-0b32-49e5-a0b1-fc44de7a4867": {
            awayTeamId: "9ced15e0-9f7f-41c7-974d-eda6c88142d9",
            goalsAway: 1,
            goalsHome: 2,
            homeTeamId: "462eaa09-3935-4b21-83d9-7a684b0ca1c0",
            id: "bcc5c795-0b32-49e5-a0b1-fc44de7a4867",
            kickOffTime: "2020-02-23T13:00:56.155Z",
          },
          "c5b3e28d-fbe2-4bf3-9fff-c7bf9b667363": {
            awayTeamId: "b205285c-f6c4-4265-86b9-d312e4cf9926",
            goalsAway: 3,
            goalsHome: 0,
            homeTeamId: "0fa3d8dc-862d-4c3d-80fe-314055fe21f5",
            kickOffTime: "2020-02-23T18:30:00.000+01:00",
          },
          "c5ebb49d-88fa-4c0c-a6c8-7175323be66f": {
            awayTeamId: "e2ddb049-085e-4455-b009-335c392e0787",
            goalsAway: 1,
            goalsHome: 2,
            homeTeamId: "ac5720ba-0460-4c66-9315-5c5dcc2c4527",
            id: "c5ebb49d-88fa-4c0c-a6c8-7175323be66f",
            kickOffTime: "2020-02-23T15:00:59.864Z",
          },
          "d08068fe-46b2-4b3f-8a52-bd3106436dd1": {
            awayTeamId: "87023cb8-23d5-43db-8397-999c7f2f960d",
            goalsAway: 3,
            goalsHome: 3,
            homeTeamId: "b2050b89-0525-4eb3-8b98-e0239d12de1a",
            id: "d08068fe-46b2-4b3f-8a52-bd3106436dd1",
            kickOffTime: "2020-02-21T20:00:55.903Z",
          },
          "ea2d4fa7-84af-4524-a03a-97be404f8b1c": {
            awayTeamId: "f52b68d4-4097-44ec-9cbf-b254fdb5bec3",
            goalsAway: 1,
            goalsHome: 3,
            homeTeamId: "6cbce2d3-4a91-4f0e-b799-b70ed1196566",
            kickOffTime: "2020-02-23T21:00:00.000+01:00",
          },
          "f175c77a-f12e-4540-8202-78183ca16e8d": {
            awayTeamId: "ef2e000c-3dac-463a-8988-d783511f526f",
            goalsAway: 0,
            goalsHome: 1,
            homeTeamId: "28ab7b13-84a6-4fa4-b645-e30ee5d005c9",
            id: "f175c77a-f12e-4540-8202-78183ca16e8d",
            kickOffTime: "2020-02-22T20:01:01.868Z",
          },
        },
        id: "cd64afc2-5db1-4eb1-8b16-9bc28ad354fb",
        matchday: 25,
        startDate: "",
      },
      {
        endDate: "",
        fixtures: {
          "070ae1cd-6130-4cc2-bc7a-0c0ace8ea051": {
            awayTeamId: "f52b68d4-4097-44ec-9cbf-b254fdb5bec3",
            goalsAway: 0,
            goalsHome: 1,
            homeTeamId: "9ced15e0-9f7f-41c7-974d-eda6c88142d9",
            id: "070ae1cd-6130-4cc2-bc7a-0c0ace8ea051",
            kickOffTime: "2020-03-01T13:01:00.746Z",
          },
          "2fb3e7f8-920b-4c83-8e43-827e3436f189": {
            awayTeamId: "6cbce2d3-4a91-4f0e-b799-b70ed1196566",
            goalsAway: 1,
            goalsHome: 1,
            homeTeamId: "e2ddb049-085e-4455-b009-335c392e0787",
            id: "2fb3e7f8-920b-4c83-8e43-827e3436f189",
            kickOffTime: "2020-03-01T15:01:05.146Z",
          },
          "4045b78f-88c4-41d9-90bb-f9e616bbabbb": {
            awayTeamId: "ac5720ba-0460-4c66-9315-5c5dcc2c4527",
            goalsAway: 0,
            goalsHome: 1,
            homeTeamId: "5d7c2cfc-0ff1-42b6-a562-b4930cca3daf",
            id: "4045b78f-88c4-41d9-90bb-f9e616bbabbb",
            kickOffTime: "2020-02-28T20:00:58.792Z",
          },
          "76276062-7e19-49c6-8049-2460930bfff6": {
            awayTeamId: "abe2b8c8-26ca-48b8-9cc4-57e74b140bac",
            goalsAway: 0,
            goalsHome: 0,
            homeTeamId: "889c061a-cdd1-4d23-8df9-4595317d77cf",
            id: "76276062-7e19-49c6-8049-2460930bfff6",
            kickOffTime: "2020-02-29T20:01:13.328Z",
          },
          "a32dbce6-bd7e-41d3-8120-12fdc452916f": {
            awayTeamId: "07cb5cdb-7b74-4191-82c4-4a3a8ab2fdcb",
            goalsAway: 0,
            goalsHome: 2,
            homeTeamId: "ef2e000c-3dac-463a-8988-d783511f526f",
            id: "a32dbce6-bd7e-41d3-8120-12fdc452916f",
            kickOffTime: "2020-03-01T20:01:06.752Z",
          },
          "a6aa1274-3eb3-4eb9-af1f-04d7eb24c099": {
            awayTeamId: "462eaa09-3935-4b21-83d9-7a684b0ca1c0",
            goalsAway: 1,
            goalsHome: 1,
            homeTeamId: "25c76dca-8b35-48f9-93fa-1057265b964e",
            id: "a6aa1274-3eb3-4eb9-af1f-04d7eb24c099",
            kickOffTime: "2020-02-29T17:31:06.219Z",
          },
          "c844cb64-188f-4d63-9576-9d3e1d456ee9": {
            awayTeamId: "0fa3d8dc-862d-4c3d-80fe-314055fe21f5",
            goalsAway: 1,
            goalsHome: 0,
            homeTeamId: "87023cb8-23d5-43db-8397-999c7f2f960d",
            id: "c844cb64-188f-4d63-9576-9d3e1d456ee9",
            kickOffTime: "2020-03-01T17:31:05.948Z",
          },
          "d57ac866-4b49-4cdf-a296-96671fa029fc": {
            awayTeamId: "b2050b89-0525-4eb3-8b98-e0239d12de1a",
            goalsAway: 1,
            goalsHome: 2,
            homeTeamId: "2a734618-cf1b-44cb-be80-b1ce3d8937d4",
            id: "d57ac866-4b49-4cdf-a296-96671fa029fc",
            kickOffTime: "2020-02-29T15:01:11.001Z",
          },
          "e32a3885-109c-4af8-a16d-c112fa0bcbf3": {
            awayTeamId: "28ab7b13-84a6-4fa4-b645-e30ee5d005c9",
            goalsAway: 0,
            goalsHome: 3,
            homeTeamId: "bf8c467b-ab50-4e35-b5f1-27f010d78608",
            id: "e32a3885-109c-4af8-a16d-c112fa0bcbf3",
            kickOffTime: "2020-02-29T12:01:00.697Z",
          },
          "f6d653f8-911b-40f9-9de8-14e7252cb753": {
            awayTeamId: "b3517535-0384-48b4-a10c-020f6e792639",
            goalsAway: 2,
            goalsHome: 3,
            homeTeamId: "b205285c-f6c4-4265-86b9-d312e4cf9926",
            id: "f6d653f8-911b-40f9-9de8-14e7252cb753",
            kickOffTime: "2020-03-01T11:01:04.155Z",
          },
        },
        id: "c767c52b-f95d-46cb-9087-2ff9b5bf805d",
        matchday: 26,
        startDate: "",
      },
      {
        endDate: "",
        fixtures: {
          "2a3d8fb6-d449-4e13-a072-d09cf90caedc": {
            awayTeamId: "abe2b8c8-26ca-48b8-9cc4-57e74b140bac",
            goalsAway: 0,
            goalsHome: 0,
            homeTeamId: "0fa3d8dc-862d-4c3d-80fe-314055fe21f5",
            id: "2a3d8fb6-d449-4e13-a072-d09cf90caedc",
            kickOffTime: "2020-03-07T20:01:07.838Z",
          },
          "360ae3b1-8881-4b10-a9d8-65f0c2f5e017": {
            awayTeamId: "2a734618-cf1b-44cb-be80-b1ce3d8937d4",
            goalsAway: 1,
            goalsHome: 1,
            homeTeamId: "462eaa09-3935-4b21-83d9-7a684b0ca1c0",
            id: "360ae3b1-8881-4b10-a9d8-65f0c2f5e017",
            kickOffTime: "2020-03-06T20:00:58.795Z",
          },
          "825cc640-40b6-4590-8049-0d928f8df832": {
            awayTeamId: "e2ddb049-085e-4455-b009-335c392e0787",
            goalsAway: 0,
            goalsHome: 1,
            homeTeamId: "b3517535-0384-48b4-a10c-020f6e792639",
            id: "825cc640-40b6-4590-8049-0d928f8df832",
            kickOffTime: "2020-03-08T11:00:58.239Z",
          },
          "87565ada-d2d0-44a6-b33f-cb63933f139b": {
            awayTeamId: "9ced15e0-9f7f-41c7-974d-eda6c88142d9",
            goalsAway: 4,
            goalsHome: 1,
            homeTeamId: "ac5720ba-0460-4c66-9315-5c5dcc2c4527",
            id: "87565ada-d2d0-44a6-b33f-cb63933f139b",
            kickOffTime: "2020-03-08T13:01:00.644Z",
          },
          "8efe80bc-138e-446f-9ab6-2ef998ed1e63": {
            awayTeamId: "5d7c2cfc-0ff1-42b6-a562-b4930cca3daf",
            goalsAway: 0,
            goalsHome: 1,
            homeTeamId: "07cb5cdb-7b74-4191-82c4-4a3a8ab2fdcb",
            id: "8efe80bc-138e-446f-9ab6-2ef998ed1e63",
            kickOffTime: "2020-03-07T17:31:05.677Z",
          },
          "953716c2-8409-4ed8-b35e-3cb91c5001e9": {
            awayTeamId: "b205285c-f6c4-4265-86b9-d312e4cf9926",
            goalsAway: 2,
            goalsHome: 2,
            homeTeamId: "6cbce2d3-4a91-4f0e-b799-b70ed1196566",
            id: "953716c2-8409-4ed8-b35e-3cb91c5001e9",
            kickOffTime: "2020-03-07T15:01:16.257Z",
          },
          "9e3d5cc9-bd7e-4114-8c00-405c4c3ee7f0": {
            awayTeamId: "25c76dca-8b35-48f9-93fa-1057265b964e",
            goalsAway: 2,
            goalsHome: 1,
            homeTeamId: "f52b68d4-4097-44ec-9cbf-b254fdb5bec3",
            id: "9e3d5cc9-bd7e-4114-8c00-405c4c3ee7f0",
            kickOffTime: "2020-03-08T17:31:01.329Z",
          },
          "b1d0a806-369f-4323-bd58-5c7818ce1bbf": {
            awayTeamId: "889c061a-cdd1-4d23-8df9-4595317d77cf",
            goalsAway: 1,
            goalsHome: 1,
            homeTeamId: "28ab7b13-84a6-4fa4-b645-e30ee5d005c9",
            id: "b1d0a806-369f-4323-bd58-5c7818ce1bbf",
            kickOffTime: "2020-03-08T15:01:09.355Z",
          },
          "b947e6de-e860-4d4f-a719-edbbee3180de": {
            awayTeamId: "ef2e000c-3dac-463a-8988-d783511f526f",
            goalsAway: 1,
            goalsHome: 2,
            homeTeamId: "b2050b89-0525-4eb3-8b98-e0239d12de1a",
            id: "b947e6de-e860-4d4f-a719-edbbee3180de",
            kickOffTime: "2020-03-08T20:01:16.129Z",
          },
          "e104f886-d500-4ed2-b3dd-ebc98c50520d": {
            awayTeamId: "87023cb8-23d5-43db-8397-999c7f2f960d",
            goalsAway: 2,
            goalsHome: 1,
            homeTeamId: "bf8c467b-ab50-4e35-b5f1-27f010d78608",
            id: "e104f886-d500-4ed2-b3dd-ebc98c50520d",
            kickOffTime: "2020-03-07T12:01:02.742Z",
          },
        },
        id: "1211e8c5-be35-4160-bd6d-7d54f88c5f91",
        matchday: 27,
        startDate: "",
      },
      {
        endDate: "",
        fixtures: {
          "01d1513e-cbc9-42ce-a833-51cd21d6d127": {
            awayTeamId: "b3517535-0384-48b4-a10c-020f6e792639",
            goalsAway: 1,
            goalsHome: 1,
            homeTeamId: "5d7c2cfc-0ff1-42b6-a562-b4930cca3daf",
            id: "01d1513e-cbc9-42ce-a833-51cd21d6d127",
            kickOffTime: "2020-06-14T20:00:17.564Z",
          },
          "34ee3e3a-5488-41ca-9a9d-98d704f98216": {
            awayTeamId: "6cbce2d3-4a91-4f0e-b799-b70ed1196566",
            goalsAway: 1,
            goalsHome: 1,
            homeTeamId: "9ced15e0-9f7f-41c7-974d-eda6c88142d9",
            id: "34ee3e3a-5488-41ca-9a9d-98d704f98216",
            kickOffTime: "2020-06-14T12:00:18.262Z",
          },
          "3d3a7b0b-1484-4912-9455-dfdcd03f6c58": {
            awayTeamId: "b2050b89-0525-4eb3-8b98-e0239d12de1a",
            goalsAway: 0,
            goalsHome: 2,
            homeTeamId: "b205285c-f6c4-4265-86b9-d312e4cf9926",
            kickOffTime: "2020-06-11T22:00:00.000+02:00",
          },
          "5c66cfff-7ac5-4e4b-8eb2-03e380b2874b": {
            awayTeamId: "bf8c467b-ab50-4e35-b5f1-27f010d78608",
            goalsAway: 1,
            goalsHome: 3,
            homeTeamId: "ef2e000c-3dac-463a-8988-d783511f526f",
            id: "5c66cfff-7ac5-4e4b-8eb2-03e380b2874b",
            kickOffTime: "2020-06-14T17:30:16.758Z",
          },
          "915985be-aa82-4db4-bd22-a6a86281cdf6": {
            awayTeamId: "f52b68d4-4097-44ec-9cbf-b254fdb5bec3",
            goalsAway: 1,
            goalsHome: 0,
            homeTeamId: "abe2b8c8-26ca-48b8-9cc4-57e74b140bac",
            id: "915985be-aa82-4db4-bd22-a6a86281cdf6",
            kickOffTime: "2020-06-13T15:00:18.752Z",
          },
          "ad290212-f3a4-41d6-bad7-1703336633bc": {
            awayTeamId: "462eaa09-3935-4b21-83d9-7a684b0ca1c0",
            goalsAway: 0,
            goalsHome: 2,
            homeTeamId: "e2ddb049-085e-4455-b009-335c392e0787",
            id: "ad290212-f3a4-41d6-bad7-1703336633bc",
            kickOffTime: "2020-06-13T12:15:16.787Z",
          },
          "b4cd5e27-e121-4681-9c34-98eb7497bfb0": {
            awayTeamId: "0fa3d8dc-862d-4c3d-80fe-314055fe21f5",
            goalsAway: 1,
            goalsHome: 2,
            homeTeamId: "889c061a-cdd1-4d23-8df9-4595317d77cf",
            id: "b4cd5e27-e121-4681-9c34-98eb7497bfb0",
            kickOffTime: "2020-06-12T17:45:15.843Z",
          },
          "b7564eae-49fd-433e-b7e9-11dfada76e6c": {
            awayTeamId: "28ab7b13-84a6-4fa4-b645-e30ee5d005c9",
            goalsAway: 1,
            goalsHome: 1,
            homeTeamId: "2a734618-cf1b-44cb-be80-b1ce3d8937d4",
            kickOffTime: "2020-06-12T22:00:00.000+02:00",
          },
          "cb7b17dc-967e-4f22-bb08-232e010f2e58": {
            awayTeamId: "ac5720ba-0460-4c66-9315-5c5dcc2c4527",
            goalsAway: 2,
            goalsHome: 1,
            homeTeamId: "25c76dca-8b35-48f9-93fa-1057265b964e",
            id: "cb7b17dc-967e-4f22-bb08-232e010f2e58",
            kickOffTime: "2020-06-13T17:30:14.738Z",
          },
          "fb97653d-ce8b-4e4f-b293-0bc93b71d380": {
            awayTeamId: "07cb5cdb-7b74-4191-82c4-4a3a8ab2fdcb",
            goalsAway: 4,
            goalsHome: 0,
            homeTeamId: "87023cb8-23d5-43db-8397-999c7f2f960d",
            kickOffTime: "2020-06-13T22:00:00.000+02:00",
          },
        },
        id: "430a5061-5313-4251-8885-b4dea6908f3d",
        matchday: 28,
        startDate: "",
      },
      {
        endDate: "",
        fixtures: {
          "08705a83-80d3-43d5-a9db-dde3eb7a387c": {
            awayTeamId: "5d7c2cfc-0ff1-42b6-a562-b4930cca3daf",
            goalsAway: 0,
            goalsHome: 2,
            homeTeamId: "462eaa09-3935-4b21-83d9-7a684b0ca1c0",
            id: "08705a83-80d3-43d5-a9db-dde3eb7a387c",
            kickOffTime: "2020-06-18T17:45:12.201Z",
          },
          "0cb4a2a0-4ea0-4e9c-948e-e972d929a713": {
            awayTeamId: "2a734618-cf1b-44cb-be80-b1ce3d8937d4",
            goalsAway: 0,
            goalsHome: 3,
            homeTeamId: "ef2e000c-3dac-463a-8988-d783511f526f",
            kickOffTime: "2020-06-18T22:00:00.000+02:00",
          },
          "44d24384-12c5-4707-a4fc-9996177a017f": {
            awayTeamId: "87023cb8-23d5-43db-8397-999c7f2f960d",
            goalsAway: 0,
            goalsHome: 1,
            homeTeamId: "f52b68d4-4097-44ec-9cbf-b254fdb5bec3",
            id: "44d24384-12c5-4707-a4fc-9996177a017f",
            kickOffTime: "2020-06-16T17:30:12.608Z",
          },
          "4d4a6ae1-1536-4bcf-a852-66d7f6f5021f": {
            awayTeamId: "abe2b8c8-26ca-48b8-9cc4-57e74b140bac",
            goalsAway: 0,
            goalsHome: 0,
            homeTeamId: "ac5720ba-0460-4c66-9315-5c5dcc2c4527",
            id: "4d4a6ae1-1536-4bcf-a852-66d7f6f5021f",
            kickOffTime: "2020-06-17T17:30:17.711Z",
          },
          "673024f1-4d81-4612-9a41-ae1a8c425050": {
            awayTeamId: "6cbce2d3-4a91-4f0e-b799-b70ed1196566",
            goalsAway: 5,
            goalsHome: 0,
            homeTeamId: "b3517535-0384-48b4-a10c-020f6e792639",
            id: "673024f1-4d81-4612-9a41-ae1a8c425050",
            kickOffTime: "2020-06-17T20:00:18.212Z",
          },
          "83b79844-d559-4266-9635-10b411481106": {
            awayTeamId: "25c76dca-8b35-48f9-93fa-1057265b964e",
            goalsAway: 0,
            goalsHome: 2,
            homeTeamId: "07cb5cdb-7b74-4191-82c4-4a3a8ab2fdcb",
            kickOffTime: "2020-06-16T22:00:00.000+02:00",
          },
          "a9ecfd02-4f66-423c-8574-c4aab316b8ca": {
            awayTeamId: "b205285c-f6c4-4265-86b9-d312e4cf9926",
            goalsAway: 1,
            goalsHome: 1,
            homeTeamId: "28ab7b13-84a6-4fa4-b645-e30ee5d005c9",
            id: "a9ecfd02-4f66-423c-8574-c4aab316b8ca",
            kickOffTime: "2020-06-15T17:45:16.445Z",
          },
          "b329f525-69b4-4ae9-b96a-a7cc1273228c": {
            awayTeamId: "e2ddb049-085e-4455-b009-335c392e0787",
            goalsAway: 0,
            goalsHome: 0,
            homeTeamId: "0fa3d8dc-862d-4c3d-80fe-314055fe21f5",
            id: "b329f525-69b4-4ae9-b96a-a7cc1273228c",
            kickOffTime: "2020-06-16T17:30:12.608Z",
          },
          "f711d919-27ee-45ab-9d4d-ea3396c4909e": {
            awayTeamId: "889c061a-cdd1-4d23-8df9-4595317d77cf",
            goalsAway: 2,
            goalsHome: 2,
            homeTeamId: "b2050b89-0525-4eb3-8b98-e0239d12de1a",
            kickOffTime: "2020-06-15T22:00:00.000+02:00",
          },
          "fee1c87b-f7bd-4246-b6ed-fc1ddfdb2cc8": {
            awayTeamId: "9ced15e0-9f7f-41c7-974d-eda6c88142d9",
            goalsAway: 2,
            goalsHome: 2,
            homeTeamId: "bf8c467b-ab50-4e35-b5f1-27f010d78608",
            id: "fee1c87b-f7bd-4246-b6ed-fc1ddfdb2cc8",
            kickOffTime: "2020-06-17T17:30:17.710Z",
          },
        },
        id: "9538cdd2-c5f7-44d1-8420-7a08951330c5",
        matchday: 29,
        startDate: "",
      },
      {
        endDate: "",
        fixtures: {
          "14fe1873-8f7f-437b-8769-7747a9583631": {
            awayTeamId: "bf8c467b-ab50-4e35-b5f1-27f010d78608",
            goalsAway: 1,
            goalsHome: 1,
            homeTeamId: "0fa3d8dc-862d-4c3d-80fe-314055fe21f5",
            id: "14fe1873-8f7f-437b-8769-7747a9583631",
            kickOffTime: "2020-06-20T17:45:16.827Z",
          },
          "22be8e10-ef53-47eb-84f9-939358828979": {
            awayTeamId: "ef2e000c-3dac-463a-8988-d783511f526f",
            goalsAway: 2,
            goalsHome: 1,
            homeTeamId: "5d7c2cfc-0ff1-42b6-a562-b4930cca3daf",
            kickOffTime: "2020-06-21T22:00:00.000+02:00",
          },
          "38dee0b2-a03b-4112-922e-89ba2139b25f": {
            awayTeamId: "f52b68d4-4097-44ec-9cbf-b254fdb5bec3",
            goalsAway: 1,
            goalsHome: 0,
            homeTeamId: "889c061a-cdd1-4d23-8df9-4595317d77cf",
            id: "38dee0b2-a03b-4112-922e-89ba2139b25f",
            kickOffTime: "2020-06-19T17:30:12.854Z",
          },
          "4ef0aa6b-17ff-47ed-a5a2-1668b8318a11": {
            awayTeamId: "b2050b89-0525-4eb3-8b98-e0239d12de1a",
            goalsAway: 0,
            goalsHome: 1,
            homeTeamId: "9ced15e0-9f7f-41c7-974d-eda6c88142d9",
            id: "4ef0aa6b-17ff-47ed-a5a2-1668b8318a11",
            kickOffTime: "2020-06-20T15:00:15.429Z",
          },
          "87d7499b-b44e-44b4-a92e-57f97f7b836a": {
            awayTeamId: "07cb5cdb-7b74-4191-82c4-4a3a8ab2fdcb",
            goalsAway: 0,
            goalsHome: 0,
            homeTeamId: "b205285c-f6c4-4265-86b9-d312e4cf9926",
            kickOffTime: "2020-06-19T22:00:00.000+02:00",
          },
          "8a57f66a-3019-40c6-9f02-c6c0a71d0500": {
            awayTeamId: "25c76dca-8b35-48f9-93fa-1057265b964e",
            goalsAway: 1,
            goalsHome: 1,
            homeTeamId: "87023cb8-23d5-43db-8397-999c7f2f960d",
            id: "8a57f66a-3019-40c6-9f02-c6c0a71d0500",
            kickOffTime: "2020-06-19T17:30:12.854Z",
          },
          "acd75dbe-23b9-4842-8e17-0c8fd3e7c656": {
            awayTeamId: "28ab7b13-84a6-4fa4-b645-e30ee5d005c9",
            goalsAway: 3,
            goalsHome: 1,
            homeTeamId: "e2ddb049-085e-4455-b009-335c392e0787",
            id: "acd75dbe-23b9-4842-8e17-0c8fd3e7c656",
            kickOffTime: "2020-06-20T12:15:16.368Z",
          },
          "afd834e8-c0bc-4d81-9573-83c15cd9ffa9": {
            awayTeamId: "462eaa09-3935-4b21-83d9-7a684b0ca1c0",
            goalsAway: 0,
            goalsHome: 6,
            homeTeamId: "abe2b8c8-26ca-48b8-9cc4-57e74b140bac",
            id: "afd834e8-c0bc-4d81-9573-83c15cd9ffa9",
            kickOffTime: "2020-06-21T12:00:17.521Z",
          },
          "d90f2585-6bb8-4c82-9bf9-d2feaff89832": {
            awayTeamId: "ac5720ba-0460-4c66-9315-5c5dcc2c4527",
            goalsAway: 0,
            goalsHome: 1,
            homeTeamId: "6cbce2d3-4a91-4f0e-b799-b70ed1196566",
            id: "d90f2585-6bb8-4c82-9bf9-d2feaff89832",
            kickOffTime: "2020-06-20T20:00:17.018Z",
          },
          "fa7d2c53-a48a-4fd6-b25e-ed405b62f8f3": {
            awayTeamId: "b3517535-0384-48b4-a10c-020f6e792639",
            goalsAway: 0,
            goalsHome: 2,
            homeTeamId: "2a734618-cf1b-44cb-be80-b1ce3d8937d4",
            id: "fa7d2c53-a48a-4fd6-b25e-ed405b62f8f3",
            kickOffTime: "2020-06-21T17:30:17.457Z",
          },
        },
        id: "2abe8143-8e01-4113-b185-b353db59b2b6",
        matchday: 30,
        startDate: "",
      },
      {
        endDate: "",
        fixtures: {
          "170f49f5-7fd2-4fea-9cef-ad5e3192af3b": {
            awayTeamId: "6cbce2d3-4a91-4f0e-b799-b70ed1196566",
            goalsAway: 1,
            goalsHome: 0,
            homeTeamId: "28ab7b13-84a6-4fa4-b645-e30ee5d005c9",
            id: "170f49f5-7fd2-4fea-9cef-ad5e3192af3b",
            kickOffTime: "2020-06-23T17:30:16.223Z",
          },
          "36347064-57cb-46ab-b214-50e5499cc3d1": {
            awayTeamId: "b205285c-f6c4-4265-86b9-d312e4cf9926",
            goalsAway: 2,
            goalsHome: 2,
            homeTeamId: "f52b68d4-4097-44ec-9cbf-b254fdb5bec3",
            id: "36347064-57cb-46ab-b214-50e5499cc3d1",
            kickOffTime: "2020-06-22T17:30:12.220Z",
          },
          "38692aa9-100f-4d78-85b1-aca397070e7d": {
            awayTeamId: "2a734618-cf1b-44cb-be80-b1ce3d8937d4",
            goalsAway: 0,
            goalsHome: 1,
            homeTeamId: "bf8c467b-ab50-4e35-b5f1-27f010d78608",
            id: "38692aa9-100f-4d78-85b1-aca397070e7d",
            kickOffTime: "2020-06-25T17:45:12.005Z",
          },
          "65794c21-073e-4a54-bf21-15386fe826cd": {
            awayTeamId: "9ced15e0-9f7f-41c7-974d-eda6c88142d9",
            goalsAway: 0,
            goalsHome: 1,
            homeTeamId: "07cb5cdb-7b74-4191-82c4-4a3a8ab2fdcb",
            id: "65794c21-073e-4a54-bf21-15386fe826cd",
            kickOffTime: "2020-06-23T20:00:18.466Z",
          },
          "676b631d-224a-43e6-a9ee-795b511d3ffc": {
            awayTeamId: "e2ddb049-085e-4455-b009-335c392e0787",
            goalsAway: 0,
            goalsHome: 1,
            homeTeamId: "b2050b89-0525-4eb3-8b98-e0239d12de1a",
            id: "676b631d-224a-43e6-a9ee-795b511d3ffc",
            kickOffTime: "2020-06-25T20:00:14.820Z",
          },
          "7edf8e5b-96d6-49d4-bc7b-7b14d7e71f8c": {
            awayTeamId: "abe2b8c8-26ca-48b8-9cc4-57e74b140bac",
            goalsAway: 1,
            goalsHome: 0,
            homeTeamId: "5d7c2cfc-0ff1-42b6-a562-b4930cca3daf",
            id: "7edf8e5b-96d6-49d4-bc7b-7b14d7e71f8c",
            kickOffTime: "2020-06-24T17:30:19.008Z",
          },
          "afd1a648-aaa1-491d-a557-e44569575dc5": {
            awayTeamId: "b3517535-0384-48b4-a10c-020f6e792639",
            goalsAway: 1,
            goalsHome: 0,
            homeTeamId: "462eaa09-3935-4b21-83d9-7a684b0ca1c0",
            id: "afd1a648-aaa1-491d-a557-e44569575dc5",
            kickOffTime: "2020-06-24T17:30:19.006Z",
          },
          "d3214f71-3199-4c5d-9112-513bd5d5fdc7": {
            awayTeamId: "87023cb8-23d5-43db-8397-999c7f2f960d",
            goalsAway: 0,
            goalsHome: 2,
            homeTeamId: "ef2e000c-3dac-463a-8988-d783511f526f",
            kickOffTime: "2020-06-24T22:00:00.000+02:00",
          },
          "d97a103b-894d-4741-9884-f3ba5825df24": {
            awayTeamId: "889c061a-cdd1-4d23-8df9-4595317d77cf",
            goalsAway: 0,
            goalsHome: 0,
            homeTeamId: "25c76dca-8b35-48f9-93fa-1057265b964e",
            kickOffTime: "2020-06-22T22:00:00.000+02:00",
          },
          "e83f4088-fc2e-4591-8a31-b897e9fde145": {
            awayTeamId: "0fa3d8dc-862d-4c3d-80fe-314055fe21f5",
            goalsAway: 1,
            goalsHome: 1,
            homeTeamId: "ac5720ba-0460-4c66-9315-5c5dcc2c4527",
            id: "e83f4088-fc2e-4591-8a31-b897e9fde145",
            kickOffTime: "2020-06-23T17:30:16.225Z",
          },
        },
        id: "ab2582aa-1ae3-4d94-960c-ccbed8cc19f8",
        matchday: 31,
        startDate: "",
      },
      {
        endDate: "",
        fixtures: {
          "0eb6e16d-8d97-4c61-a482-0f7ce24d12fa": {
            awayTeamId: "07cb5cdb-7b74-4191-82c4-4a3a8ab2fdcb",
            goalsAway: 2,
            goalsHome: 2,
            homeTeamId: "abe2b8c8-26ca-48b8-9cc4-57e74b140bac",
            id: "0eb6e16d-8d97-4c61-a482-0f7ce24d12fa",
            kickOffTime: "2020-06-27T15:00:13.877Z",
          },
          "17257fd6-4ea0-4b1c-899a-419194e40fec": {
            awayTeamId: "25c76dca-8b35-48f9-93fa-1057265b964e",
            goalsAway: 1,
            goalsHome: 2,
            homeTeamId: "b3517535-0384-48b4-a10c-020f6e792639",
            id: "17257fd6-4ea0-4b1c-899a-419194e40fec",
            kickOffTime: "2020-06-27T17:30:15.754Z",
          },
          "1b752f63-5e11-4c29-a9a3-4f0007b0ed43": {
            awayTeamId: "ef2e000c-3dac-463a-8988-d783511f526f",
            goalsAway: 1,
            goalsHome: 0,
            homeTeamId: "e2ddb049-085e-4455-b009-335c392e0787",
            kickOffTime: "2020-06-28T22:00:00.000+02:00",
          },
          "1faaa812-9e82-45ad-a336-51fa2d6a88c7": {
            awayTeamId: "ac5720ba-0460-4c66-9315-5c5dcc2c4527",
            goalsAway: 1,
            goalsHome: 1,
            homeTeamId: "b205285c-f6c4-4265-86b9-d312e4cf9926",
            id: "1faaa812-9e82-45ad-a336-51fa2d6a88c7",
            kickOffTime: "2020-06-26T20:00:15.404Z",
          },
          "88447454-a3ce-4552-aadb-5c63c6503934": {
            awayTeamId: "462eaa09-3935-4b21-83d9-7a684b0ca1c0",
            goalsAway: 1,
            goalsHome: 2,
            id: "88447454-a3ce-4552-aadb-5c63c6503934",
            homeTeamId: "6cbce2d3-4a91-4f0e-b799-b70ed1196566",
            kickOffTime: "2020-06-27T22:00:00.000+02:00",
          },
          "92a39f7e-edf2-47fe-893f-e56c11eed1ba": {
            awayTeamId: "2a734618-cf1b-44cb-be80-b1ce3d8937d4",
            goalsAway: 0,
            goalsHome: 2,
            homeTeamId: "f52b68d4-4097-44ec-9cbf-b254fdb5bec3",
            id: "92a39f7e-edf2-47fe-893f-e56c11eed1ba",
            kickOffTime: "2020-06-28T15:00:15.234Z",
          },
          "a0a6a4e8-9aba-42bc-aa45-99570cdbd32e": {
            awayTeamId: "b2050b89-0525-4eb3-8b98-e0239d12de1a",
            goalsAway: 2,
            goalsHome: 4,
            homeTeamId: "28ab7b13-84a6-4fa4-b645-e30ee5d005c9",
            id: "a0a6a4e8-9aba-42bc-aa45-99570cdbd32e",
            kickOffTime: "2020-06-28T12:15:14.322Z",
          },
          "a4ba53dd-6804-4161-8155-d4b5591144d1": {
            awayTeamId: "87023cb8-23d5-43db-8397-999c7f2f960d",
            goalsAway: 1,
            goalsHome: 3,
            homeTeamId: "9ced15e0-9f7f-41c7-974d-eda6c88142d9",
            id: "a4ba53dd-6804-4161-8155-d4b5591144d1",
            kickOffTime: "2020-06-27T12:00:15.994Z",
          },
          "ae2d7470-c8f6-4041-9811-351973398e84": {
            awayTeamId: "bf8c467b-ab50-4e35-b5f1-27f010d78608",
            goalsAway: 2,
            goalsHome: 1,
            homeTeamId: "889c061a-cdd1-4d23-8df9-4595317d77cf",
            id: "ae2d7470-c8f6-4041-9811-351973398e84",
            kickOffTime: "2020-06-28T17:45:17.256Z",
          },
          "b904d4f8-68f9-4ed1-aed4-e38c04f879a6": {
            awayTeamId: "5d7c2cfc-0ff1-42b6-a562-b4930cca3daf",
            goalsAway: 1,
            goalsHome: 2,
            id: "b904d4f8-68f9-4ed1-aed4-e38c04f879a6",
            homeTeamId: "0fa3d8dc-862d-4c3d-80fe-314055fe21f5",
            kickOffTime: "2020-06-29T22:00:00.000+02:00",
          },
        },
        id: "38f969ec-6a21-496c-b6b7-1fef1addeb7e",
        matchday: 32,
        startDate: "",
      },
      {
        endDate: "",
        fixtures: {
          "4f6d8714-efc7-4356-a21a-72f7d554d889": {
            awayTeamId: "abe2b8c8-26ca-48b8-9cc4-57e74b140bac",
            goalsAway: 1,
            goalsHome: 5,
            homeTeamId: "87023cb8-23d5-43db-8397-999c7f2f960d",
            id: "4f6d8714-efc7-4356-a21a-72f7d554d889",
            kickOffTime: "2020-06-30T17:45:13.366Z",
          },
          "8c566691-51bf-4a8f-9067-aff321dfe292": {
            awayTeamId: "f52b68d4-4097-44ec-9cbf-b254fdb5bec3",
            goalsAway: 2,
            goalsHome: 0,
            homeTeamId: "b2050b89-0525-4eb3-8b98-e0239d12de1a",
            id: "8c566691-51bf-4a8f-9067-aff321dfe292",
            kickOffTime: "2020-07-01T20:00:17.540Z",
          },
          "975f544f-730b-4650-a39c-43786fafc418": {
            awayTeamId: "0fa3d8dc-862d-4c3d-80fe-314055fe21f5",
            goalsAway: 0,
            goalsHome: 1,
            homeTeamId: "ef2e000c-3dac-463a-8988-d783511f526f",
            id: "975f544f-730b-4650-a39c-43786fafc418",
            kickOffTime: "2020-07-02T20:00:18.967Z",
          },
          "abdbbaf0-32c5-4f0d-aab6-f388eae1ef03": {
            awayTeamId: "6cbce2d3-4a91-4f0e-b799-b70ed1196566",
            goalsAway: 2,
            goalsHome: 2,
            homeTeamId: "07cb5cdb-7b74-4191-82c4-4a3a8ab2fdcb",
            id: "abdbbaf0-32c5-4f0d-aab6-f388eae1ef03",
            kickOffTime: "2020-06-30T20:00:17.491Z",
          },
          "ae47134c-3001-472b-809d-962c07ef80cc": {
            awayTeamId: "9ced15e0-9f7f-41c7-974d-eda6c88142d9",
            goalsAway: 2,
            goalsHome: 0,
            homeTeamId: "2a734618-cf1b-44cb-be80-b1ce3d8937d4",
            id: "ae47134c-3001-472b-809d-962c07ef80cc",
            kickOffTime: "2020-07-01T17:30:18.563Z",
          },
          "b79ccb99-b842-4787-8988-9e2529470417": {
            awayTeamId: "b3517535-0384-48b4-a10c-020f6e792639",
            goalsAway: 2,
            goalsHome: 0,
            homeTeamId: "bf8c467b-ab50-4e35-b5f1-27f010d78608",
            id: "b79ccb99-b842-4787-8988-9e2529470417",
            kickOffTime: "2020-07-02T17:30:19.920Z",
          },
          "e3cfff55-542a-4a1f-8f93-addba5a26d6a": {
            awayTeamId: "e2ddb049-085e-4455-b009-335c392e0787",
            goalsAway: 1,
            goalsHome: 2,
            homeTeamId: "5d7c2cfc-0ff1-42b6-a562-b4930cca3daf",
            id: "e3cfff55-542a-4a1f-8f93-addba5a26d6a",
            kickOffTime: "2020-07-02T17:30:19.922Z",
          },
          "f0e5bace-9dfb-46c2-bdcd-019e07174b80": {
            awayTeamId: "b205285c-f6c4-4265-86b9-d312e4cf9926",
            goalsAway: 3,
            goalsHome: 0,
            homeTeamId: "25c76dca-8b35-48f9-93fa-1057265b964e",
            id: "f0e5bace-9dfb-46c2-bdcd-019e07174b80",
            kickOffTime: "2020-06-30T19:00:17.916Z",
          },
          "f4a4f4d2-594f-4538-a705-4d410aa97151": {
            awayTeamId: "889c061a-cdd1-4d23-8df9-4595317d77cf",
            goalsAway: 2,
            goalsHome: 0,
            homeTeamId: "462eaa09-3935-4b21-83d9-7a684b0ca1c0",
            id: "f4a4f4d2-594f-4538-a705-4d410aa97151",
            kickOffTime: "2020-07-01T17:45:15.458Z",
          },
        },
        id: "8e9839a4-432b-4c1a-8003-701a4b45eed3",
        matchday: 33,
        startDate: "",
      },
      {
        endDate: "",
        fixtures: {
          "10430f65-3073-4a72-955e-775f5c401c1b": {
            awayTeamId: "ef2e000c-3dac-463a-8988-d783511f526f",
            goalsAway: 1,
            goalsHome: 0,
            homeTeamId: "9ced15e0-9f7f-41c7-974d-eda6c88142d9",
            id: "10430f65-3073-4a72-955e-775f5c401c1b",
            kickOffTime: "2020-07-05T19:45:17.286Z",
          },
          "29f9b614-6ef2-4f4d-9bfe-7cc16eec2c1a": {
            awayTeamId: "25c76dca-8b35-48f9-93fa-1057265b964e",
            goalsAway: 1,
            goalsHome: 0,
            homeTeamId: "e2ddb049-085e-4455-b009-335c392e0787",
            id: "29f9b614-6ef2-4f4d-9bfe-7cc16eec2c1a",
            kickOffTime: "2020-07-05T19:45:17.286Z",
          },
          "4a48e3d1-f7b2-4e37-bb31-19c98b46bb37": {
            awayTeamId: "b2050b89-0525-4eb3-8b98-e0239d12de1a",
            goalsAway: 1,
            goalsHome: 1,
            homeTeamId: "abe2b8c8-26ca-48b8-9cc4-57e74b140bac",
            id: "4a48e3d1-f7b2-4e37-bb31-19c98b46bb37",
            kickOffTime: "2020-07-04T15:15:17.740Z",
          },
          "8aef06e7-9e1c-40e4-8865-b99aa2c7123a": {
            awayTeamId: "462eaa09-3935-4b21-83d9-7a684b0ca1c0",
            goalsAway: 0,
            goalsHome: 1,
            homeTeamId: "ac5720ba-0460-4c66-9315-5c5dcc2c4527",
            id: "8aef06e7-9e1c-40e4-8865-b99aa2c7123a",
            kickOffTime: "2020-07-04T17:30:22.228Z",
          },
          "8e203e05-c1de-43d6-8d63-0534dd679380": {
            awayTeamId: "07cb5cdb-7b74-4191-82c4-4a3a8ab2fdcb",
            goalsAway: 4,
            goalsHome: 1,
            homeTeamId: "f52b68d4-4097-44ec-9cbf-b254fdb5bec3",
            id: "8e203e05-c1de-43d6-8d63-0534dd679380",
            kickOffTime: "2020-07-05T20:00:19.323Z",
          },
          "c4aa5789-5273-4d7c-a6c5-2db32678ca7f": {
            awayTeamId: "0fa3d8dc-862d-4c3d-80fe-314055fe21f5",
            goalsAway: 0,
            goalsHome: 0,
            homeTeamId: "b3517535-0384-48b4-a10c-020f6e792639",
            id: "c4aa5789-5273-4d7c-a6c5-2db32678ca7f",
            kickOffTime: "2020-07-05T19:45:17.287Z",
          },
          "e0321fef-8a35-47ef-9660-7e96b5425be8": {
            awayTeamId: "5d7c2cfc-0ff1-42b6-a562-b4930cca3daf",
            goalsAway: 1,
            goalsHome: 1,
            homeTeamId: "28ab7b13-84a6-4fa4-b645-e30ee5d005c9",
            id: "e0321fef-8a35-47ef-9660-7e96b5425be8",
            kickOffTime: "2020-07-06T17:45:13.645Z",
          },
        },
        id: "c3feafbe-d83f-4808-9843-e83f98e7551c",
        matchday: 34,
        startDate: "",
      },
      {
        endDate: "",
        fixtures: {
          "2a332d45-663d-4e3b-a7d5-7864c8098ce6": {
            awayTeamId: "b3517535-0384-48b4-a10c-020f6e792639",
            goalsAway: 0,
            goalsHome: 3,
            homeTeamId: "b2050b89-0525-4eb3-8b98-e0239d12de1a",
            id: "2a332d45-663d-4e3b-a7d5-7864c8098ce6",
            kickOffTime: "2020-07-08T18:45:15.454Z",
          },
          "30edb443-5d55-48d2-9507-be72b7e9090c": {
            awayTeamId: "ac5720ba-0460-4c66-9315-5c5dcc2c4527",
            goalsAway: 1,
            goalsHome: 2,
            homeTeamId: "2a734618-cf1b-44cb-be80-b1ce3d8937d4",
            id: "30edb443-5d55-48d2-9507-be72b7e9090c",
            kickOffTime: "2020-07-07T17:30:13.243Z",
          },
          "4050ba79-249c-483c-9522-23ca2aa9c9b4": {
            awayTeamId: "28ab7b13-84a6-4fa4-b645-e30ee5d005c9",
            goalsAway: 0,
            goalsHome: 2,
            homeTeamId: "87023cb8-23d5-43db-8397-999c7f2f960d",
            id: "4050ba79-249c-483c-9522-23ca2aa9c9b4",
            kickOffTime: "2020-07-09T17:30:16.225Z",
          },
          "5a2ad5c2-2030-4980-834f-fabbccf8901a": {
            awayTeamId: "25c76dca-8b35-48f9-93fa-1057265b964e",
            goalsAway: 0,
            goalsHome: 0,
            homeTeamId: "bf8c467b-ab50-4e35-b5f1-27f010d78608",
            id: "5a2ad5c2-2030-4980-834f-fabbccf8901a",
            kickOffTime: "2020-07-09T17:30:16.225Z",
          },
          "651613f4-ed41-4ebe-9a0d-2972110e2a08": {
            awayTeamId: "462eaa09-3935-4b21-83d9-7a684b0ca1c0",
            goalsAway: 0,
            goalsHome: 2,
            homeTeamId: "ef2e000c-3dac-463a-8988-d783511f526f",
            id: "651613f4-ed41-4ebe-9a0d-2972110e2a08",
            kickOffTime: "2020-07-10T20:00:15.730Z",
          },
          "ed0eb8f1-5383-470b-9762-f237dc6b966f": {
            awayTeamId: "e2ddb049-085e-4455-b009-335c392e0787",
            goalsAway: 0,
            goalsHome: 1,
            homeTeamId: "07cb5cdb-7b74-4191-82c4-4a3a8ab2fdcb",
            id: "ed0eb8f1-5383-470b-9762-f237dc6b966f",
            kickOffTime: "2020-07-08T20:00:18.320Z",
          },
          "ee417a80-6833-403a-b19f-917004e90d4e": {
            awayTeamId: "889c061a-cdd1-4d23-8df9-4595317d77cf",
            goalsAway: 3,
            goalsHome: 2,
            homeTeamId: "5d7c2cfc-0ff1-42b6-a562-b4930cca3daf",
            id: "ee417a80-6833-403a-b19f-917004e90d4e",
            kickOffTime: "2020-07-10T17:45:16.863Z",
          },
          "fec1c77d-d9ce-49bb-9289-ceefd16f56c0": {
            awayTeamId: "f52b68d4-4097-44ec-9cbf-b254fdb5bec3",
            goalsAway: 3,
            goalsHome: 1,
            homeTeamId: "0fa3d8dc-862d-4c3d-80fe-314055fe21f5",
            id: "fec1c77d-d9ce-49bb-9289-ceefd16f56c0",
            kickOffTime: "2020-07-08T18:30:14.825Z",
          },
        },
        id: "11ff6549-c575-4cb8-a382-f07e1f0808f7",
        matchday: 35,
        startDate: "",
      },
      {
        endDate: "",
        fixtures: {
          "16ae72b6-8c13-4a7f-8548-233574a0cd44": {
            awayTeamId: "2a734618-cf1b-44cb-be80-b1ce3d8937d4",
            goalsAway: 0,
            goalsHome: 1,
            homeTeamId: "25c76dca-8b35-48f9-93fa-1057265b964e",
            id: "16ae72b6-8c13-4a7f-8548-233574a0cd44",
            kickOffTime: "2020-07-12T17:45:19.356Z",
          },
          "2fbd26d0-30d4-4c8c-8586-2443f02bb795": {
            awayTeamId: "abe2b8c8-26ca-48b8-9cc4-57e74b140bac",
            goalsAway: 1,
            goalsHome: 2,
            homeTeamId: "b3517535-0384-48b4-a10c-020f6e792639",
            id: "2fbd26d0-30d4-4c8c-8586-2443f02bb795",
            kickOffTime: "2020-07-11T15:00:17.475Z",
          },
          "7137c5c0-1187-45bb-a765-762a01d24a18": {
            awayTeamId: "bf8c467b-ab50-4e35-b5f1-27f010d78608",
            goalsAway: 2,
            goalsHome: 0,
            homeTeamId: "e2ddb049-085e-4455-b009-335c392e0787",
            id: "7137c5c0-1187-45bb-a765-762a01d24a18",
            kickOffTime: "2020-07-12T12:00:15.859Z",
          },
          "836454e6-5643-466b-b29c-7ad507027ea1": {
            awayTeamId: "5d7c2cfc-0ff1-42b6-a562-b4930cca3daf",
            goalsAway: 2,
            goalsHome: 1,
            homeTeamId: "f52b68d4-4097-44ec-9cbf-b254fdb5bec3",
            id: "836454e6-5643-466b-b29c-7ad507027ea1",
            kickOffTime: "2020-07-13T17:30:15.561Z",
          },
          "ca7069bc-5c76-4d0d-9585-ded0296a0e35": {
            awayTeamId: "0fa3d8dc-862d-4c3d-80fe-314055fe21f5",
            goalsAway: 0,
            goalsHome: 0,
            homeTeamId: "462eaa09-3935-4b21-83d9-7a684b0ca1c0",
            id: "ca7069bc-5c76-4d0d-9585-ded0296a0e35",
            kickOffTime: "2020-07-13T17:30:15.560Z",
          },
          "f452d304-65f5-4e32-b05a-bf4566266e72": {
            awayTeamId: "07cb5cdb-7b74-4191-82c4-4a3a8ab2fdcb",
            goalsAway: 1,
            goalsHome: 0,
            homeTeamId: "ac5720ba-0460-4c66-9315-5c5dcc2c4527",
            id: "f452d304-65f5-4e32-b05a-bf4566266e72",
            kickOffTime: "2020-07-11T17:30:17.964Z",
          },
          "fd6e05c9-c3b5-49aa-bc60-fa794f1106f9": {
            awayTeamId: "9ced15e0-9f7f-41c7-974d-eda6c88142d9",
            goalsAway: 2,
            goalsHome: 1,
            homeTeamId: "28ab7b13-84a6-4fa4-b645-e30ee5d005c9",
            id: "fd6e05c9-c3b5-49aa-bc60-fa794f1106f9",
            kickOffTime: "2020-07-12T15:15:20.761Z",
          },
        },
        id: "a3c00f05-8d16-49bc-9510-f799771aef30",
        matchday: 36,
        startDate: "",
      },
      {
        endDate: "",
        fixtures: {
          "27dc64ab-46f4-441e-8eda-624d7cc69c17": {
            awayTeamId: "ac5720ba-0460-4c66-9315-5c5dcc2c4527",
            goalsAway: 1,
            goalsHome: 3,
            homeTeamId: "bf8c467b-ab50-4e35-b5f1-27f010d78608",
            id: "27dc64ab-46f4-441e-8eda-624d7cc69c17",
            kickOffTime: "2020-07-16T16:30:14.549Z",
          },
          "2e6e2fc1-f927-4269-acef-3ee96fcd5eaf": {
            awayTeamId: "28ab7b13-84a6-4fa4-b645-e30ee5d005c9",
            goalsAway: 3,
            goalsHome: 2,
            homeTeamId: "abe2b8c8-26ca-48b8-9cc4-57e74b140bac",
            id: "2e6e2fc1-f927-4269-acef-3ee96fcd5eaf",
            kickOffTime: "2020-07-16T19:15:11.753Z",
          },
          "396007cc-8a06-4e1c-ad5c-93b5bcd281e4": {
            awayTeamId: "e2ddb049-085e-4455-b009-335c392e0787",
            goalsAway: 0,
            goalsHome: 1,
            homeTeamId: "2a734618-cf1b-44cb-be80-b1ce3d8937d4",
            id: "396007cc-8a06-4e1c-ad5c-93b5bcd281e4",
            kickOffTime: "2020-07-16T19:15:11.753Z",
          },
          "99437cd8-fb77-430b-9c35-625f0709cb94": {
            awayTeamId: "25c76dca-8b35-48f9-93fa-1057265b964e",
            goalsAway: 2,
            goalsHome: 0,
            homeTeamId: "9ced15e0-9f7f-41c7-974d-eda6c88142d9",
            id: "99437cd8-fb77-430b-9c35-625f0709cb94",
            kickOffTime: "2020-07-16T19:15:11.752Z",
          },
          "995dfe11-5676-4cd9-a232-995a9db20dee": {
            awayTeamId: "6cbce2d3-4a91-4f0e-b799-b70ed1196566",
            goalsAway: 2,
            goalsHome: 0,
            homeTeamId: "0fa3d8dc-862d-4c3d-80fe-314055fe21f5",
            id: "995dfe11-5676-4cd9-a232-995a9db20dee",
            kickOffTime: "2020-07-16T19:15:11.753Z",
          },
          "bd71c85f-7db8-4bd8-b657-9d6425de1255": {
            awayTeamId: "b205285c-f6c4-4265-86b9-d312e4cf9926",
            goalsAway: 0,
            goalsHome: 0,
            homeTeamId: "5d7c2cfc-0ff1-42b6-a562-b4930cca3daf",
            id: "bd71c85f-7db8-4bd8-b657-9d6425de1255",
            kickOffTime: "2020-07-16T19:15:11.753Z",
          },
          "d46c123d-3800-4bdd-a7b0-23b18c4e3c00": {
            awayTeamId: "462eaa09-3935-4b21-83d9-7a684b0ca1c0",
            goalsAway: 2,
            goalsHome: 1,
            homeTeamId: "b2050b89-0525-4eb3-8b98-e0239d12de1a",
            id: "d46c123d-3800-4bdd-a7b0-23b18c4e3c00",
            kickOffTime: "2020-07-16T19:15:11.753Z",
          },
          "e2c79635-5373-4a81-8671-fe0f37ca94dd": {
            awayTeamId: "889c061a-cdd1-4d23-8df9-4595317d77cf",
            goalsAway: 3,
            goalsHome: 1,
            homeTeamId: "87023cb8-23d5-43db-8397-999c7f2f960d",
            id: "e2c79635-5373-4a81-8671-fe0f37ca94dd",
            kickOffTime: "2020-07-16T19:15:11.752Z",
          },
          "e3cef857-6398-4688-a63d-a39c2119218b": {
            awayTeamId: "b3517535-0384-48b4-a10c-020f6e792639",
            goalsAway: 2,
            goalsHome: 1,
            homeTeamId: "07cb5cdb-7b74-4191-82c4-4a3a8ab2fdcb",
            id: "e3cef857-6398-4688-a63d-a39c2119218b",
            kickOffTime: "2020-07-16T19:15:11.752Z",
          },
          "ebd7f290-191f-4b70-bf97-da13ef349f9d": {
            awayTeamId: "f52b68d4-4097-44ec-9cbf-b254fdb5bec3",
            goalsAway: 1,
            goalsHome: 2,
            homeTeamId: "ef2e000c-3dac-463a-8988-d783511f526f",
            id: "ebd7f290-191f-4b70-bf97-da13ef349f9d",
            kickOffTime: "2020-07-16T19:15:11.753Z",
          },
        },
        id: "0ace5dc5-55c3-4376-a09f-9893f615e5b9",
        matchday: 37,
        startDate: "",
      },
      {
        endDate: "",
        fixtures: {
          "2f6eab63-e592-4f57-987d-5674238d8412": {
            awayTeamId: "b2050b89-0525-4eb3-8b98-e0239d12de1a",
            goalsAway: 0,
            goalsHome: 2,
            homeTeamId: "ac5720ba-0460-4c66-9315-5c5dcc2c4527",
            id: "2f6eab63-e592-4f57-987d-5674238d8412",
            kickOffTime: "2020-07-19T16:30:20.114Z",
          },
          "3839838f-e524-4126-9ffb-42d503374946": {
            awayTeamId: "bf8c467b-ab50-4e35-b5f1-27f010d78608",
            goalsAway: 0,
            goalsHome: 4,
            homeTeamId: "f52b68d4-4097-44ec-9cbf-b254fdb5bec3",
            id: "3839838f-e524-4126-9ffb-42d503374946",
            kickOffTime: "2020-07-19T16:30:20.114Z",
          },
          "52493a10-bd03-4cd5-a3f1-db182edae7ff": {
            awayTeamId: "5d7c2cfc-0ff1-42b6-a562-b4930cca3daf",
            goalsAway: 1,
            goalsHome: 1,
            homeTeamId: "6cbce2d3-4a91-4f0e-b799-b70ed1196566",
            id: "52493a10-bd03-4cd5-a3f1-db182edae7ff",
            kickOffTime: "2020-07-19T19:15:17.654Z",
          },
          "5b203708-ff16-4aba-9409-9d9467b4ee82": {
            awayTeamId: "9ced15e0-9f7f-41c7-974d-eda6c88142d9",
            goalsAway: 0,
            goalsHome: 4,
            homeTeamId: "889c061a-cdd1-4d23-8df9-4595317d77cf",
            id: "5b203708-ff16-4aba-9409-9d9467b4ee82",
            kickOffTime: "2020-07-19T19:15:17.653Z",
          },
          "676f15a8-73c2-433a-ac7f-082cf9e0db39": {
            awayTeamId: "abe2b8c8-26ca-48b8-9cc4-57e74b140bac",
            goalsAway: 0,
            goalsHome: 0,
            homeTeamId: "e2ddb049-085e-4455-b009-335c392e0787",
            id: "676f15a8-73c2-433a-ac7f-082cf9e0db39",
            kickOffTime: "2020-07-19T19:15:17.652Z",
          },
          "7b819018-8870-455a-85c9-104555385d3b": {
            awayTeamId: "2a734618-cf1b-44cb-be80-b1ce3d8937d4",
            goalsAway: 0,
            goalsHome: 1,
            homeTeamId: "b205285c-f6c4-4265-86b9-d312e4cf9926",
            id: "7b819018-8870-455a-85c9-104555385d3b",
            kickOffTime: "2020-07-19T19:15:17.653Z",
          },
          "853d8ffa-5601-4d12-9d61-2d9a6927900e": {
            awayTeamId: "87023cb8-23d5-43db-8397-999c7f2f960d",
            goalsAway: 2,
            goalsHome: 2,
            homeTeamId: "b3517535-0384-48b4-a10c-020f6e792639",
            id: "853d8ffa-5601-4d12-9d61-2d9a6927900e",
            kickOffTime: "2020-07-19T19:15:17.652Z",
          },
          "a9687ac1-95c3-4c15-8368-46240b3b0dc4": {
            awayTeamId: "ef2e000c-3dac-463a-8988-d783511f526f",
            goalsAway: 2,
            goalsHome: 2,
            homeTeamId: "25c76dca-8b35-48f9-93fa-1057265b964e",
            id: "a9687ac1-95c3-4c15-8368-46240b3b0dc4",
            kickOffTime: "2020-07-19T19:15:17.652Z",
          },
          "d90b818e-b144-460c-ab35-c73faa8534ed": {
            awayTeamId: "0fa3d8dc-862d-4c3d-80fe-314055fe21f5",
            goalsAway: 0,
            goalsHome: 1,
            homeTeamId: "28ab7b13-84a6-4fa4-b645-e30ee5d005c9",
            id: "d90b818e-b144-460c-ab35-c73faa8534ed",
            kickOffTime: "2020-07-19T19:15:17.653Z",
          },
          "eca1f8cf-e206-4ad3-bb9d-1cbf1d916a33": {
            awayTeamId: "07cb5cdb-7b74-4191-82c4-4a3a8ab2fdcb",
            goalsAway: 5,
            goalsHome: 0,
            homeTeamId: "462eaa09-3935-4b21-83d9-7a684b0ca1c0",
            id: "eca1f8cf-e206-4ad3-bb9d-1cbf1d916a33",
            kickOffTime: "2020-07-19T15:45:19.931Z",
          },
        },
        id: "0a47afac-d86f-45d5-8658-4be39ffcc220",
        matchday: 38,
        startDate: "",
      },
    ],
  },
};

export default matchdays;
